import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
// import 'rxjs/Rx';

import * as _ from 'lodash';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  clientLIst = {
    "Message": [
      {
        "Message": "Client Name Lookups.",
        "Type": "SUCCESS"
      }
    ],
    "Data": {
      "Client_Name_Lookup": [
        {
          "Id": 1,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Credit Balance Refund Entry",
          "Client_Name_ID": "10503",
          "SubClient_Name": "Abeo: Credit Balance Refund Entry",
          "SubClient_Name_Id": "10503"
        },
        {
          "Id": 2,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "SubClient_Name_Id": "10505"
        },
        {
          "Id": 3,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "SubClient_Name_Id": "10505"
        },
        {
          "Id": 4,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding",
          "SubClient_Name_Id": "10507"
        },
        {
          "Id": 5,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding",
          "SubClient_Name_Id": "10507"
        },
        {
          "Id": 6,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 1",
          "SubClient_Name_Id": "10505-1"
        },
        {
          "Id": 7,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 2",
          "SubClient_Name_Id": "10505-2"
        },
        {
          "Id": 8,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 3",
          "SubClient_Name_Id": "10505-3"
        },
        {
          "Id": 9,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Charge Entry",
          "Client_Name_ID": "10502",
          "SubClient_Name": "Abeo: Charge Entry",
          "SubClient_Name_Id": "10502"
        },
        {
          "Id": 10,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Charge Entry",
          "Client_Name_ID": "10502",
          "SubClient_Name": "Abeo: Charge Entry",
          "SubClient_Name_Id": "10502"
        },
        {
          "Id": 11,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Demographic Entry",
          "Client_Name_ID": "10504",
          "SubClient_Name": "Abeo: Demographic Entry",
          "SubClient_Name_Id": "10504"
        },
        {
          "Id": 12,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments",
          "SubClient_Name_Id": "10508"
        },
        {
          "Id": 13,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments",
          "SubClient_Name_Id": "10508"
        },
        {
          "Id": 14,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Demographic Entry",
          "Client_Name_ID": "10504",
          "SubClient_Name": "Abeo: Demographic Entry",
          "SubClient_Name_Id": "10504"
        },
        {
          "Id": 15,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: A/R Follow Up 2nd Level",
          "Client_Name_ID": "10501",
          "SubClient_Name": "Abeo: A/R Follow Up 2nd Level",
          "SubClient_Name_Id": "10501"
        },
        {
          "Id": 16,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: A/R Follow Up 2nd Level",
          "Client_Name_ID": "10501",
          "SubClient_Name": "Abeo: A/R Follow Up 2nd Level",
          "SubClient_Name_Id": "10501"
        },
        {
          "Id": 17,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 1",
          "SubClient_Name_Id": "10505-1"
        },
        {
          "Id": 18,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 2",
          "SubClient_Name_Id": "10505-2"
        },
        {
          "Id": 19,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding  CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 3",
          "SubClient_Name_Id": "10505-3"
        },
        {
          "Id": 20,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 1",
          "SubClient_Name_Id": "10505-1"
        },
        {
          "Id": 21,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes_SPM Pain Coding Week 2",
          "SubClient_Name_Id": "10505-2"
        },
        {
          "Id": 22,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - Lock Box Posting",
          "SubClient_Name_Id": "10508-2"
        },
        {
          "Id": 23,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - Remit Postng",
          "SubClient_Name_Id": "10508-1"
        },
        {
          "Id": 24,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - ZP Batches",
          "SubClient_Name_Id": "10508-3"
        },
        {
          "Id": 25,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - Lock Box Posting",
          "SubClient_Name_Id": "10508-2"
        },
        {
          "Id": 26,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - Remit Postng",
          "SubClient_Name_Id": "10508-1"
        },
        {
          "Id": 27,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: A/R Follow Up 2nd Level",
          "Client_Name_ID": "10501",
          "SubClient_Name": "Abeo: A/R Follow Up 2nd Level - Day",
          "SubClient_Name_Id": "10501-1"
        },
        {
          "Id": 28,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - Critical Care services",
          "SubClient_Name_Id": "10505-4"
        },
        {
          "Id": 29,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - Pain(E&M) services",
          "SubClient_Name_Id": "10505-5"
        },
        {
          "Id": 30,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Payments",
          "Client_Name_ID": "10508",
          "SubClient_Name": "Abeo: Payments - ZP Batches",
          "SubClient_Name_Id": "10508-3"
        },
        {
          "Id": 31,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pain Management",
          "Client_Name_ID": "10506",
          "SubClient_Name": "Abeo: Pain Management",
          "SubClient_Name_Id": "10506"
        },
        {
          "Id": 32,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pain Management",
          "Client_Name_ID": "10506",
          "SubClient_Name": "Abeo: Pain Management",
          "SubClient_Name_Id": "10506"
        },
        {
          "Id": 33,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - BVAMG",
          "SubClient_Name_Id": "10505-9"
        },
        {
          "Id": 34,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - BVAMG",
          "SubClient_Name_Id": "10505-9"
        },
        {
          "Id": 35,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TCA",
          "SubClient_Name_Id": "10505-10"
        },
        {
          "Id": 36,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TCA",
          "SubClient_Name_Id": "10505-10"
        },
        {
          "Id": 37,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TJX",
          "SubClient_Name_Id": "10505-11"
        },
        {
          "Id": 38,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TJX",
          "SubClient_Name_Id": "10505-11"
        },
        {
          "Id": 39,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TMF",
          "SubClient_Name_Id": "10505-12"
        },
        {
          "Id": 40,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - TMF",
          "SubClient_Name_Id": "10505-12"
        },
        {
          "Id": 41,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - ASA/ASA",
          "SubClient_Name_Id": "10505-13"
        },
        {
          "Id": 42,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - ASA/ASA",
          "SubClient_Name_Id": "10505-13"
        },
        {
          "Id": 43,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - Central Summit Coding",
          "SubClient_Name_Id": "10505-14"
        },
        {
          "Id": 44,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - Central Summit Coding",
          "SubClient_Name_Id": "10505-14"
        },
        {
          "Id": 45,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - IPS PAIN CASES Coding",
          "SubClient_Name_Id": "10505-15"
        },
        {
          "Id": 46,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - IPS PAIN CASES Coding",
          "SubClient_Name_Id": "10505-15"
        },
        {
          "Id": 47,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - LISTONE",
          "SubClient_Name_Id": "10505-16"
        },
        {
          "Id": 48,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - LISTONE",
          "SubClient_Name_Id": "10505-16"
        },
        {
          "Id": 49,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - OPS Audit",
          "SubClient_Name_Id": "10505-17"
        },
        {
          "Id": 50,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - OPS Audit",
          "SubClient_Name_Id": "10505-17"
        },
        {
          "Id": 51,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding - Laboratory Pathology",
          "SubClient_Name_Id": "10507-2"
        },
        {
          "Id": 52,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding - Laboratory Pathology",
          "SubClient_Name_Id": "10507-2"
        },
        {
          "Id": 53,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - PHYSYNERGY",
          "SubClient_Name_Id": "10505-6"
        },
        {
          "Id": 54,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - PHYSYNERGY",
          "SubClient_Name_Id": "10505-6"
        },
        {
          "Id": 55,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - PSA,ACC,CMC,Colquitte,Irwin,PHY",
          "SubClient_Name_Id": "10505-7"
        },
        {
          "Id": 56,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - PSA,ACC,CMC,Colquitte,Irwin,PHY",
          "SubClient_Name_Id": "10505-7"
        },
        {
          "Id": 57,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - MCHS,ACNC,CMB,AAL",
          "SubClient_Name_Id": "10505-8"
        },
        {
          "Id": 58,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes",
          "Client_Name_ID": "10505",
          "SubClient_Name": "Abeo: Medical coding CPT, ASA, modifiers, ICD:9 codes & PQRI codes - MCHS,ACNC,CMB,AAL",
          "SubClient_Name_Id": "10505-8"
        },
        {
          "Id": 59,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding - Surgical Pathology  - Coding",
          "SubClient_Name_Id": "10507-1"
        },
        {
          "Id": 60,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Pathology Coding",
          "Client_Name_ID": "10507",
          "SubClient_Name": "Abeo: Pathology Coding - Surgical Pathology  - Coding",
          "SubClient_Name_Id": "10507-1"
        },
        {
          "Id": 61,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: A/R Follow Up 2nd Level",
          "Client_Name_ID": "10501",
          "SubClient_Name": "Abeo: A/R Follow Up 2nd Level - Day",
          "SubClient_Name_Id": "10501-1"
        },
        {
          "Id": 62,
          "Original_Client_Name": "Abeo Management Corporation",
          "Original_Client_Name_ID": "99001",
          "Client_Name": "Abeo: Credit Balance Refund Entry",
          "Client_Name_ID": "10503",
          "SubClient_Name": "Abeo: Credit Balance Refund Entry",
          "SubClient_Name_Id": "10503"
        },
        {
          "Id": 63,
          "Original_Client_Name": "AdvancedMD, Inc",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Insurance Follow:up",
          "Client_Name_ID": "10511",
          "SubClient_Name": "AdvancedMD: Insurance Follow:up",
          "SubClient_Name_Id": "10511"
        },
        {
          "Id": 64,
          "Original_Client_Name": "AdvancedMD, Inc",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Denial Management",
          "Client_Name_ID": "11033",
          "SubClient_Name": "AdvancedMD: Denial Management",
          "SubClient_Name_Id": "11033"
        },
        {
          "Id": 65,
          "Original_Client_Name": "AdvancedMD, Inc",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Insurance Follow:up",
          "Client_Name_ID": "10511",
          "SubClient_Name": "AdvancedMD: Insurance Follow:up",
          "SubClient_Name_Id": "10511"
        },
        {
          "Id": 66,
          "Original_Client_Name": "AdvancedMD, Inc",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Denial Management",
          "Client_Name_ID": "11033",
          "SubClient_Name": "AdvancedMD: Denial Management",
          "SubClient_Name_Id": "11033"
        },
        {
          "Id": 67,
          "Original_Client_Name": "AdvancedMD, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Payment Posting",
          "Client_Name_ID": "10512",
          "SubClient_Name": "AdvancedMD: Payment Posting",
          "SubClient_Name_Id": "10512"
        },
        {
          "Id": 68,
          "Original_Client_Name": "AdvancedMD, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99002",
          "Client_Name": "AdvancedMD: Payment Posting",
          "Client_Name_ID": "10512",
          "SubClient_Name": "AdvancedMD: Payment Posting",
          "SubClient_Name_Id": "10512"
        },
        {
          "Id": 69,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial BACO",
          "SubClient_Name_Id": "10514-18"
        },
        {
          "Id": 70,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial BACO",
          "SubClient_Name_Id": "10514-18"
        },
        {
          "Id": 71,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus",
          "SubClient_Name_Id": "10514-1"
        },
        {
          "Id": 72,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus",
          "SubClient_Name_Id": "10514-1"
        },
        {
          "Id": 73,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial",
          "SubClient_Name_Id": "10514-4"
        },
        {
          "Id": 74,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial",
          "SubClient_Name_Id": "10514-4"
        },
        {
          "Id": 75,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX",
          "SubClient_Name_Id": "10514-3"
        },
        {
          "Id": 76,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX",
          "SubClient_Name_Id": "10514-3"
        },
        {
          "Id": 77,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - AR Plus",
          "SubClient_Name_Id": "10519-1"
        },
        {
          "Id": 78,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - WorX",
          "SubClient_Name_Id": "10519-3"
        },
        {
          "Id": 79,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Coding Denial",
          "SubClient_Name_Id": "10519-4"
        },
        {
          "Id": 80,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Ambulance",
          "SubClient_Name_Id": "10519-5"
        },
        {
          "Id": 81,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - E/M",
          "SubClient_Name_Id": "10514-1"
        },
        {
          "Id": 82,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Pathology iCode",
          "SubClient_Name_Id": "10514-2"
        },
        {
          "Id": 83,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus - EOB",
          "SubClient_Name_Id": "10514-3"
        },
        {
          "Id": 84,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus - ATB",
          "SubClient_Name_Id": "10514-4"
        },
        {
          "Id": 85,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM- Baco - 611",
          "SubClient_Name_Id": "10514-5"
        },
        {
          "Id": 86,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM- Baco - 613",
          "SubClient_Name_Id": "10514-6"
        },
        {
          "Id": 87,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial - Worx",
          "SubClient_Name_Id": "10514-7"
        },
        {
          "Id": 88,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial - VM",
          "SubClient_Name_Id": "10514-8"
        },
        {
          "Id": 89,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Demo",
          "SubClient_Name_Id": "10514-9"
        },
        {
          "Id": 90,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM",
          "SubClient_Name_Id": "10514-10"
        },
        {
          "Id": 91,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX - No Response",
          "SubClient_Name_Id": "10514-11"
        },
        {
          "Id": 92,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX - Denials",
          "SubClient_Name_Id": "10514-12"
        },
        {
          "Id": 93,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding - Batch Spliting",
          "SubClient_Name_Id": "10514-13"
        },
        {
          "Id": 94,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Pathology",
          "SubClient_Name_Id": "10514-15"
        },
        {
          "Id": 95,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Radiology",
          "SubClient_Name_Id": "10514-16"
        },
        {
          "Id": 96,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Surgery",
          "SubClient_Name_Id": "10514-17"
        },
        {
          "Id": 97,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - E/M",
          "SubClient_Name_Id": "10519-1"
        },
        {
          "Id": 98,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Pathology iCode",
          "SubClient_Name_Id": "10519-2"
        },
        {
          "Id": 99,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - AR Plus - EOB",
          "SubClient_Name_Id": "10519-3"
        },
        {
          "Id": 100,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - AR Plus - ATB",
          "SubClient_Name_Id": "10519-4"
        },
        {
          "Id": 101,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - VM- Baco - 611",
          "SubClient_Name_Id": "10519-5"
        },
        {
          "Id": 102,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - VM- Baco - 613",
          "SubClient_Name_Id": "10519-6"
        },
        {
          "Id": 103,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Coding Denial - Worx",
          "SubClient_Name_Id": "10519-7"
        },
        {
          "Id": 104,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Coding Denial - VM",
          "SubClient_Name_Id": "10519-8"
        },
        {
          "Id": 105,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Demo",
          "SubClient_Name_Id": "10519-9"
        },
        {
          "Id": 106,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - VM",
          "SubClient_Name_Id": "10519-10"
        },
        {
          "Id": 107,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - WorX - No Response",
          "SubClient_Name_Id": "10519-11"
        },
        {
          "Id": 108,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - WorX - Denials",
          "SubClient_Name_Id": "10519-12"
        },
        {
          "Id": 109,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Coding - Batch Spliting",
          "SubClient_Name_Id": "10519-13"
        },
        {
          "Id": 110,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Anesthesia",
          "SubClient_Name_Id": "10519-14"
        },
        {
          "Id": 111,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Surgery",
          "SubClient_Name_Id": "10519-17"
        },
        {
          "Id": 112,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - E/M",
          "SubClient_Name_Id": "10514-1"
        },
        {
          "Id": 113,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Pathology iCode",
          "SubClient_Name_Id": "10514-2"
        },
        {
          "Id": 114,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus - EOB",
          "SubClient_Name_Id": "10514-3"
        },
        {
          "Id": 115,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Plus - ATB",
          "SubClient_Name_Id": "10514-4"
        },
        {
          "Id": 116,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM- Baco - 611",
          "SubClient_Name_Id": "10514-5"
        },
        {
          "Id": 117,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM- Baco - 613",
          "SubClient_Name_Id": "10514-6"
        },
        {
          "Id": 118,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial - Worx",
          "SubClient_Name_Id": "10514-7"
        },
        {
          "Id": 119,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial - VM",
          "SubClient_Name_Id": "10514-8"
        },
        {
          "Id": 120,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Demo",
          "SubClient_Name_Id": "10514-9"
        },
        {
          "Id": 121,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM",
          "SubClient_Name_Id": "10514-10"
        },
        {
          "Id": 122,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX - No Response",
          "SubClient_Name_Id": "10514-11"
        },
        {
          "Id": 123,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - WorX - Denials",
          "SubClient_Name_Id": "10514-12"
        },
        {
          "Id": 124,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding - Batch Spliting",
          "SubClient_Name_Id": "10514-13"
        },
        {
          "Id": 125,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Anesthesia",
          "SubClient_Name_Id": "10514-14"
        },
        {
          "Id": 126,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Surgery",
          "SubClient_Name_Id": "10514-17"
        },
        {
          "Id": 127,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Radiology",
          "SubClient_Name_Id": "10519-16"
        },
        {
          "Id": 128,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Director Workstation",
          "Client_Name_ID": "10515",
          "SubClient_Name": "AdvantEdge: Director Workstation",
          "SubClient_Name_Id": "10515"
        },
        {
          "Id": 129,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Manager Workstation",
          "Client_Name_ID": "10517",
          "SubClient_Name": "AdvantEdge: Manager Workstation",
          "SubClient_Name_Id": "10517"
        },
        {
          "Id": 130,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation",
          "SubClient_Name_Id": "10519"
        },
        {
          "Id": 131,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation",
          "SubClient_Name_Id": "10514"
        },
        {
          "Id": 132,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Management Personnel Fee",
          "Client_Name_ID": "10516",
          "SubClient_Name": "AdvantEdge: Management Personnel Fee",
          "SubClient_Name_Id": "10516"
        },
        {
          "Id": 133,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Admin/Management Fee",
          "Client_Name_ID": "10513",
          "SubClient_Name": "AdvantEdge: Admin/Management Fee",
          "SubClient_Name_Id": "10513"
        },
        {
          "Id": 134,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Radiology",
          "SubClient_Name_Id": "10514-16"
        },
        {
          "Id": 135,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Director Workstation",
          "Client_Name_ID": "10515",
          "SubClient_Name": "AdvantEdge: Director Workstation",
          "SubClient_Name_Id": "10515"
        },
        {
          "Id": 136,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Manager Workstation",
          "Client_Name_ID": "10517",
          "SubClient_Name": "AdvantEdge: Manager Workstation",
          "SubClient_Name_Id": "10517"
        },
        {
          "Id": 137,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation",
          "SubClient_Name_Id": "10519"
        },
        {
          "Id": 138,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation",
          "SubClient_Name_Id": "10514"
        },
        {
          "Id": 139,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Management Personnel Fee",
          "Client_Name_ID": "10516",
          "SubClient_Name": "AdvantEdge: Management Personnel Fee",
          "SubClient_Name_Id": "10516"
        },
        {
          "Id": 140,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Admin/Management Fee",
          "Client_Name_ID": "10513",
          "SubClient_Name": "AdvantEdge: Admin/Management Fee",
          "SubClient_Name_Id": "10513"
        },
        {
          "Id": 141,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - COAR",
          "SubClient_Name_Id": "10514-19"
        },
        {
          "Id": 142,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - COAR",
          "SubClient_Name_Id": "10514-19"
        },
        {
          "Id": 143,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Anesthesia",
          "SubClient_Name_Id": "10514-14"
        },
        {
          "Id": 144,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - Pathology",
          "SubClient_Name_Id": "10519-15"
        },
        {
          "Id": 145,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Pathology",
          "SubClient_Name_Id": "10514-15"
        },
        {
          "Id": 146,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Denial-Imagine",
          "SubClient_Name_Id": "10514-21"
        },
        {
          "Id": 147,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - AR Denial-Imagine",
          "SubClient_Name_Id": "10514-21"
        },
        {
          "Id": 148,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - AR Denial-Imagine",
          "SubClient_Name_Id": "10519-18"
        },
        {
          "Id": 149,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: TL Workstation",
          "Client_Name_ID": "10519",
          "SubClient_Name": "AdvantEdge: TL Workstation - AR Denial-Imagine",
          "SubClient_Name_Id": "10519-18"
        },
        {
          "Id": 150,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM Coding Appeals",
          "SubClient_Name_Id": "10514-20"
        },
        {
          "Id": 151,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - VM Coding Appeals",
          "SubClient_Name_Id": "10514-20"
        },
        {
          "Id": 152,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial-Imagine",
          "SubClient_Name_Id": "10514-22"
        },
        {
          "Id": 153,
          "Original_Client_Name": "AdvantEdge Healthcare Solutions",
          "Original_Client_Name_ID": "99003",
          "Client_Name": "AdvantEdge: Associate Workstation",
          "Client_Name_ID": "10514",
          "SubClient_Name": "AdvantEdge: Associate Workstation - Coding Denial-Imagine",
          "SubClient_Name_Id": "10514-22"
        },
        {
          "Id": 154,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: Coding Denial Services",
          "Client_Name_ID": "11404",
          "SubClient_Name": "Advocate: Coding Denial Services",
          "SubClient_Name_Id": "11404"
        },
        {
          "Id": 155,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: Coding Denial Services",
          "Client_Name_ID": "11404",
          "SubClient_Name": "Advocate: Coding Denial Services",
          "SubClient_Name_Id": "11404"
        },
        {
          "Id": 156,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: RadPartners AR Follow Up",
          "Client_Name_ID": "11403",
          "SubClient_Name": "Advocate: RadPartners AR Follow Up",
          "SubClient_Name_Id": "11403"
        },
        {
          "Id": 157,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: RadPartners AR Follow Up",
          "Client_Name_ID": "11403",
          "SubClient_Name": "Advocate: RadPartners AR Follow Up",
          "SubClient_Name_Id": "11403"
        },
        {
          "Id": 158,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: AR Follow Up Services",
          "Client_Name_ID": "10521",
          "SubClient_Name": "Advocate: AR Follow Up Services - Day",
          "SubClient_Name_Id": "10521-2"
        },
        {
          "Id": 159,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: AR Follow Up Services",
          "Client_Name_ID": "10521",
          "SubClient_Name": "Advocate: AR Follow Up Services",
          "SubClient_Name_Id": "10521"
        },
        {
          "Id": 160,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: AR Follow Up Services",
          "Client_Name_ID": "10521",
          "SubClient_Name": "Advocate: AR Follow Up Services",
          "SubClient_Name_Id": "10521"
        },
        {
          "Id": 161,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: Accounts Billable Expenses",
          "Client_Name_ID": "10520",
          "SubClient_Name": "Advocate: Accounts Billable Expenses",
          "SubClient_Name_Id": "10520"
        },
        {
          "Id": 162,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: Multi:Pages Billable Expenses",
          "Client_Name_ID": "10522",
          "SubClient_Name": "Advocate: Multi:Pages Billable Expenses",
          "SubClient_Name_Id": "10522"
        },
        {
          "Id": 163,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: AR Follow Up Services",
          "Client_Name_ID": "10521",
          "SubClient_Name": "Advocate: AR Follow Up Services - Appeals",
          "SubClient_Name_Id": "10521-1"
        },
        {
          "Id": 164,
          "Original_Client_Name": "Advocate",
          "Original_Client_Name_ID": "99004",
          "Client_Name": "Advocate: AR Follow Up Services",
          "Client_Name_ID": "10521",
          "SubClient_Name": "Advocate: AR Follow Up Services - Appeals",
          "SubClient_Name_Id": "10521-1"
        },
        {
          "Id": 165,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System",
          "SubClient_Name_Id": "10540"
        },
        {
          "Id": 166,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: IR Coding on A-life System",
          "Client_Name_ID": "10543",
          "SubClient_Name": "APS: IR Coding on A-life System",
          "SubClient_Name_Id": "10543"
        },
        {
          "Id": 167,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Certified",
          "Client_Name_ID": "10538",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Certified",
          "SubClient_Name_Id": "10538"
        },
        {
          "Id": 168,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Certified",
          "Client_Name_ID": "10538",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Certified",
          "SubClient_Name_Id": "10538"
        },
        {
          "Id": 169,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "Client_Name_ID": "10539",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "SubClient_Name_Id": "10539"
        },
        {
          "Id": 170,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "Client_Name_ID": "10539",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "SubClient_Name_Id": "10539"
        },
        {
          "Id": 171,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System",
          "SubClient_Name_Id": "10540"
        },
        {
          "Id": 172,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "Client_Name_ID": "10541",
          "SubClient_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "SubClient_Name_Id": "10541"
        },
        {
          "Id": 173,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular",
          "SubClient_Name_Id": "10542"
        },
        {
          "Id": 174,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "Client_Name_ID": "10541",
          "SubClient_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "SubClient_Name_Id": "10541"
        },
        {
          "Id": 175,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 1",
          "SubClient_Name_Id": "10542-1"
        },
        {
          "Id": 176,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 2",
          "SubClient_Name_Id": "10542-2"
        },
        {
          "Id": 177,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 3",
          "SubClient_Name_Id": "10542-3"
        },
        {
          "Id": 178,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "Client_Name_ID": "10539",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Non Certified - Paper PDF",
          "SubClient_Name_Id": "10539-1"
        },
        {
          "Id": 179,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - DR Alife",
          "SubClient_Name_Id": "10540-1"
        },
        {
          "Id": 180,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - DR Alife",
          "SubClient_Name_Id": "10540-1"
        },
        {
          "Id": 181,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 1",
          "SubClient_Name_Id": "10542-1"
        },
        {
          "Id": 182,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 2",
          "SubClient_Name_Id": "10542-2"
        },
        {
          "Id": 183,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular - Level 3",
          "SubClient_Name_Id": "10542-3"
        },
        {
          "Id": 184,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Non Vascular",
          "SubClient_Name_Id": "10540-2"
        },
        {
          "Id": 185,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Non Vascular",
          "SubClient_Name_Id": "10540-2"
        },
        {
          "Id": 186,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Vascular",
          "SubClient_Name_Id": "10540-3"
        },
        {
          "Id": 187,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Vascular",
          "SubClient_Name_Id": "10540-3"
        },
        {
          "Id": 188,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: IR Coding on A-life System",
          "Client_Name_ID": "10543",
          "SubClient_Name": "APS: IR Coding on A-life System - Non Vascular",
          "SubClient_Name_Id": "10543-1"
        },
        {
          "Id": 189,
          "Original_Client_Name": "Affiliated Professional Services Inc. - Aurangabad",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: IR Coding on A-life System",
          "Client_Name_ID": "10543",
          "SubClient_Name": "APS: IR Coding on A-life System - Non Vascular",
          "SubClient_Name_Id": "10543-1"
        },
        {
          "Id": 190,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - DR Alife",
          "SubClient_Name_Id": "10540-1"
        },
        {
          "Id": 191,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - DR Alife",
          "SubClient_Name_Id": "10540-1"
        },
        {
          "Id": 192,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Vascular",
          "SubClient_Name_Id": "10540-2"
        },
        {
          "Id": 193,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - IR Alife - Vascular",
          "SubClient_Name_Id": "10540-2"
        },
        {
          "Id": 194,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - Non Vascular",
          "SubClient_Name_Id": "10540-3"
        },
        {
          "Id": 195,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System - Non Vascular",
          "SubClient_Name_Id": "10540-3"
        },
        {
          "Id": 196,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Norwood: Demographic Entry",
          "Client_Name_ID": "10544",
          "SubClient_Name": "APS: Norwood: Demographic Entry",
          "SubClient_Name_Id": "10544"
        },
        {
          "Id": 197,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Pathology Coding",
          "Client_Name_ID": "10545",
          "SubClient_Name": "APS: Pathology Coding -Norwood - Demo & Coding",
          "SubClient_Name_Id": "10545-1"
        },
        {
          "Id": 198,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Riverside: Surgery Coding Services",
          "Client_Name_ID": "10547",
          "SubClient_Name": "APS: Riverside: Surgery Coding Services",
          "SubClient_Name_Id": "10547"
        },
        {
          "Id": 199,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Pathology Coding",
          "Client_Name_ID": "10545",
          "SubClient_Name": "APS: Pathology Coding - Norwood",
          "SubClient_Name_Id": "10545-2"
        },
        {
          "Id": 200,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Pathology Coding",
          "Client_Name_ID": "10545",
          "SubClient_Name": "APS: Pathology Coding - Norwood",
          "SubClient_Name_Id": "10545-2"
        },
        {
          "Id": 201,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Charge Entry",
          "Client_Name_ID": "10533",
          "SubClient_Name": "APS: Charge Entry",
          "SubClient_Name_Id": "10533"
        },
        {
          "Id": 202,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Demographic Entry",
          "Client_Name_ID": "10536",
          "SubClient_Name": "APS: Demographic Entry",
          "SubClient_Name_Id": "10536"
        },
        {
          "Id": 203,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Pathology Coding",
          "Client_Name_ID": "10545",
          "SubClient_Name": "APS: Pathology Coding -Norwood - Demo & Coding",
          "SubClient_Name_Id": "10545-1"
        },
        {
          "Id": 204,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Denials worked",
          "Client_Name_ID": "10537",
          "SubClient_Name": "APS: Denials worked",
          "SubClient_Name_Id": "10537"
        },
        {
          "Id": 205,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Denials worked",
          "Client_Name_ID": "10537",
          "SubClient_Name": "APS: Denials worked",
          "SubClient_Name_Id": "10537"
        },
        {
          "Id": 206,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Payment Posting",
          "Client_Name_ID": "10546",
          "SubClient_Name": "APS: Payment Posting",
          "SubClient_Name_Id": "10546"
        },
        {
          "Id": 207,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Charge Entry",
          "Client_Name_ID": "10533",
          "SubClient_Name": "APS: Charge Entry",
          "SubClient_Name_Id": "10533"
        },
        {
          "Id": 208,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Demographic Entry",
          "Client_Name_ID": "10536",
          "SubClient_Name": "APS: Demographic Entry",
          "SubClient_Name_Id": "10536"
        },
        {
          "Id": 209,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Norwood: Demographic Entry",
          "Client_Name_ID": "10544",
          "SubClient_Name": "APS: Norwood: Demographic Entry",
          "SubClient_Name_Id": "10544"
        },
        {
          "Id": 210,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Payment Posting",
          "Client_Name_ID": "10546",
          "SubClient_Name": "APS: Payment Posting",
          "SubClient_Name_Id": "10546"
        },
        {
          "Id": 211,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Credit Balance",
          "Client_Name_ID": "10535",
          "SubClient_Name": "APS: Credit Balance",
          "SubClient_Name_Id": "10535"
        },
        {
          "Id": 212,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "Task : Diagnostic Radiology Coding Services",
          "Client_Name_ID": "2777",
          "SubClient_Name": "Task : Diagnostic Radiology Coding Services",
          "SubClient_Name_Id": "2777"
        },
        {
          "Id": 213,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "Task : Diagnostic Radiology Coding Services",
          "Client_Name_ID": "2777",
          "SubClient_Name": "Task : Diagnostic Radiology Coding Services",
          "SubClient_Name_Id": "2777"
        },
        {
          "Id": 214,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "Client_Name_ID": "10539",
          "SubClient_Name": "APS: Diagnostic Radiology Coding Services - Non Certified",
          "SubClient_Name_Id": "10539"
        },
        {
          "Id": 215,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "Client_Name_ID": "10541",
          "SubClient_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "SubClient_Name_Id": "10541"
        },
        {
          "Id": 216,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "Client_Name_ID": "10541",
          "SubClient_Name": "APS: Interventional Radiology Coding - Non Vascular",
          "SubClient_Name_Id": "10541"
        },
        {
          "Id": 217,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular",
          "SubClient_Name_Id": "10542"
        },
        {
          "Id": 218,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Interventional Radiology Coding - Vascular",
          "Client_Name_ID": "10542",
          "SubClient_Name": "APS: Interventional Radiology Coding - Vascular",
          "SubClient_Name_Id": "10542"
        },
        {
          "Id": 219,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: IR Coding on A-life System",
          "Client_Name_ID": "10543",
          "SubClient_Name": "APS: IR Coding on A-life System",
          "SubClient_Name_Id": "10543"
        },
        {
          "Id": 220,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Anesthesia Coding",
          "Client_Name_ID": "11052",
          "SubClient_Name": "APS: Anesthesia Coding",
          "SubClient_Name_Id": "11052"
        },
        {
          "Id": 221,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Anesthesia Coding",
          "Client_Name_ID": "11052",
          "SubClient_Name": "APS: Anesthesia Coding",
          "SubClient_Name_Id": "11052"
        },
        {
          "Id": 222,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection)",
          "SubClient_Name_Id": "10534"
        },
        {
          "Id": 223,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection)",
          "SubClient_Name_Id": "10534"
        },
        {
          "Id": 224,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: DR Coding on A-life System",
          "Client_Name_ID": "10540",
          "SubClient_Name": "APS: DR Coding on A-life System",
          "SubClient_Name_Id": "10540"
        },
        {
          "Id": 225,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Pathology Coding",
          "Client_Name_ID": "10545",
          "SubClient_Name": "APS: Pathology Coding",
          "SubClient_Name_Id": "10545"
        },
        {
          "Id": 226,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Riverside: Surgery Coding Services",
          "Client_Name_ID": "10547",
          "SubClient_Name": "APS: Riverside: Surgery Coding Services",
          "SubClient_Name_Id": "10547"
        },
        {
          "Id": 227,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Appeals",
          "SubClient_Name_Id": "10534-3"
        },
        {
          "Id": 228,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Auth",
          "SubClient_Name_Id": "10534-4"
        },
        {
          "Id": 229,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Appeals",
          "SubClient_Name_Id": "10534-3"
        },
        {
          "Id": 230,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Auth",
          "SubClient_Name_Id": "10534-4"
        },
        {
          "Id": 231,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Correspondence",
          "SubClient_Name_Id": "10534-1"
        },
        {
          "Id": 232,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - Correspondence",
          "SubClient_Name_Id": "10534-1"
        },
        {
          "Id": 233,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: AR Follow up services (2% Collection)",
          "Client_Name_ID": "10534",
          "SubClient_Name": "APS: AR Follow up services (2% Collection) - LB Denials",
          "SubClient_Name_Id": "10534-2"
        },
        {
          "Id": 234,
          "Original_Client_Name": "Affiliated Professional Services, Inc.",
          "Original_Client_Name_ID": "99005",
          "Client_Name": "APS: Credit Balance",
          "Client_Name_ID": "10535",
          "SubClient_Name": "APS: Credit Balance",
          "SubClient_Name_Id": "10535"
        },
        {
          "Id": 235,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Adding Reffering Providers",
          "Client_Name_ID": "11587",
          "SubClient_Name": "Allergy Partners: Adding Reffering Providers",
          "SubClient_Name_Id": "11587"
        },
        {
          "Id": 236,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Adding Reffering Providers",
          "Client_Name_ID": "11587",
          "SubClient_Name": "Allergy Partners: Adding Reffering Providers",
          "SubClient_Name_Id": "11587"
        },
        {
          "Id": 237,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Patient account deletion",
          "Client_Name_ID": "11653",
          "SubClient_Name": "Allergy Partners: Patient account deletion",
          "SubClient_Name_Id": "11653"
        },
        {
          "Id": 238,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Patient account deletion",
          "Client_Name_ID": "11653",
          "SubClient_Name": "Allergy Partners: Patient account deletion",
          "SubClient_Name_Id": "11653"
        },
        {
          "Id": 239,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Patient Registration Data Entry",
          "Client_Name_ID": "11511",
          "SubClient_Name": "Allergy Partners: Patient Registration Data Entry",
          "SubClient_Name_Id": "11511"
        },
        {
          "Id": 240,
          "Original_Client_Name": "Allergy Partners, P.A,",
          "Original_Client_Name_ID": "99097",
          "Client_Name": "Allergy Partners: Patient Registration Data Entry",
          "Client_Name_ID": "11511",
          "SubClient_Name": "Allergy Partners: Patient Registration Data Entry",
          "SubClient_Name_Id": "11511"
        },
        {
          "Id": 241,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "Client_Name_ID": "11053",
          "SubClient_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "SubClient_Name_Id": "11053"
        },
        {
          "Id": 242,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "Client_Name_ID": "11053",
          "SubClient_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "SubClient_Name_Id": "11053"
        },
        {
          "Id": 243,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Medicare Health assessment Review",
          "Client_Name_ID": "11171",
          "SubClient_Name": "AltaMed: Medicare Health assessment Review",
          "SubClient_Name_Id": "11171"
        },
        {
          "Id": 244,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Medicare Health assessment Review",
          "Client_Name_ID": "11171",
          "SubClient_Name": "AltaMed: Medicare Health assessment Review",
          "SubClient_Name_Id": "11171"
        },
        {
          "Id": 245,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "Client_Name_ID": "11053",
          "SubClient_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "SubClient_Name_Id": "11053"
        },
        {
          "Id": 246,
          "Original_Client_Name": "AltaMed Health Services Corporation",
          "Original_Client_Name_ID": "99080",
          "Client_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "Client_Name_ID": "11053",
          "SubClient_Name": "AltaMed: Global Chart Reviews (HCC Coding)",
          "SubClient_Name_Id": "11053"
        },
        {
          "Id": 247,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Insurance Follow Up services",
          "Client_Name_ID": "10523",
          "SubClient_Name": "Alteon: AR Insurance Follow Up services",
          "SubClient_Name_Id": "10523"
        },
        {
          "Id": 248,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Insurance Follow Up services",
          "Client_Name_ID": "10523",
          "SubClient_Name": "Alteon: AR Insurance Follow Up services",
          "SubClient_Name_Id": "10523"
        },
        {
          "Id": 249,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon : Claim edit service",
          "Client_Name_ID": "11367",
          "SubClient_Name": "Alteon : Claim edit service",
          "SubClient_Name_Id": "11367"
        },
        {
          "Id": 250,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon : Claim edit service",
          "Client_Name_ID": "11367",
          "SubClient_Name": "Alteon : Claim edit service",
          "SubClient_Name_Id": "11367"
        },
        {
          "Id": 251,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon : Athena EDI Special Project",
          "Client_Name_ID": "11344",
          "SubClient_Name": "Alteon : Athena EDI Special Project",
          "SubClient_Name_Id": "11344"
        },
        {
          "Id": 252,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon : Athena EDI Special Project",
          "Client_Name_ID": "11344",
          "SubClient_Name": "Alteon : Athena EDI Special Project",
          "SubClient_Name_Id": "11344"
        },
        {
          "Id": 253,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services",
          "Client_Name_ID": "10525",
          "SubClient_Name": "Alteon: Hospitalist Coding Services - Pending review",
          "SubClient_Name_Id": "10525-1"
        },
        {
          "Id": 254,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services",
          "Client_Name_ID": "10525",
          "SubClient_Name": "Alteon: Hospitalist Coding Services - Pending review",
          "SubClient_Name_Id": "10525-1"
        },
        {
          "Id": 255,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Forward no post",
          "Client_Name_ID": "11339",
          "SubClient_Name": "Alteon: Forward no post",
          "SubClient_Name_Id": "11339"
        },
        {
          "Id": 256,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Forward no post",
          "Client_Name_ID": "11339",
          "SubClient_Name": "Alteon: Forward no post",
          "SubClient_Name_Id": "11339"
        },
        {
          "Id": 257,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Rejections Handling (AR EDI)",
          "Client_Name_ID": "11233",
          "SubClient_Name": "Alteon: AR Rejections Handling (AR EDI)",
          "SubClient_Name_Id": "11233"
        },
        {
          "Id": 258,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Enrolment Verification",
          "Client_Name_ID": "11234",
          "SubClient_Name": "Alteon: Enrolment Verification",
          "SubClient_Name_Id": "11234"
        },
        {
          "Id": 259,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Rejections Handling (AR EDI)",
          "Client_Name_ID": "11233",
          "SubClient_Name": "Alteon: AR Rejections Handling (AR EDI)",
          "SubClient_Name_Id": "11233"
        },
        {
          "Id": 260,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Enrolment Verification",
          "Client_Name_ID": "11234",
          "SubClient_Name": "Alteon: Enrolment Verification",
          "SubClient_Name_Id": "11234"
        },
        {
          "Id": 261,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting & reconciliation services",
          "Client_Name_ID": "11239",
          "SubClient_Name": "Alteon: Payment Posting & reconciliation services",
          "SubClient_Name_Id": "11239"
        },
        {
          "Id": 262,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting & reconciliation services",
          "Client_Name_ID": "11239",
          "SubClient_Name": "Alteon: Payment Posting & reconciliation services",
          "SubClient_Name_Id": "11239"
        },
        {
          "Id": 263,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Corrections/Adjustments",
          "Client_Name_ID": "11301",
          "SubClient_Name": "Alteon: Payment Corrections/Adjustments",
          "SubClient_Name_Id": "11301"
        },
        {
          "Id": 264,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Reconciliation & Tracking",
          "Client_Name_ID": "11302",
          "SubClient_Name": "Alteon: Payment Reconciliation & Tracking",
          "SubClient_Name_Id": "11302"
        },
        {
          "Id": 265,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Corrections/Adjustments",
          "Client_Name_ID": "11301",
          "SubClient_Name": "Alteon: Payment Corrections/Adjustments",
          "SubClient_Name_Id": "11301"
        },
        {
          "Id": 266,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Reconciliation & Tracking",
          "Client_Name_ID": "11302",
          "SubClient_Name": "Alteon: Payment Reconciliation & Tracking",
          "SubClient_Name_Id": "11302"
        },
        {
          "Id": 267,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Athena: Payment Tracking",
          "Client_Name_ID": "11311",
          "SubClient_Name": "Alteon: Athena: Payment Tracking",
          "SubClient_Name_Id": "11311"
        },
        {
          "Id": 268,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Athena: Payment Tracking",
          "Client_Name_ID": "11311",
          "SubClient_Name": "Alteon: Athena: Payment Tracking",
          "SubClient_Name_Id": "11311"
        },
        {
          "Id": 269,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Credit Balance",
          "Client_Name_ID": "11014",
          "SubClient_Name": "Alteon: Credit Balance - Patient Credit",
          "SubClient_Name_Id": "11014-1"
        },
        {
          "Id": 270,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Credit Balance",
          "Client_Name_ID": "11014",
          "SubClient_Name": "Alteon: Credit Balance - Insurance Credit",
          "SubClient_Name_Id": "11014-2"
        },
        {
          "Id": 271,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Credit Balance",
          "Client_Name_ID": "11014",
          "SubClient_Name": "Alteon: Credit Balance - Patient Credit",
          "SubClient_Name_Id": "11014-1"
        },
        {
          "Id": 272,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Credit Balance",
          "Client_Name_ID": "11014",
          "SubClient_Name": "Alteon: Credit Balance - Insurance Credit",
          "SubClient_Name_Id": "11014-2"
        },
        {
          "Id": 273,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting (Winddown)",
          "Client_Name_ID": "10528",
          "SubClient_Name": "Alteon: Payment Posting (Winddown)",
          "SubClient_Name_Id": "10528"
        },
        {
          "Id": 274,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting (Winddown)",
          "Client_Name_ID": "10528",
          "SubClient_Name": "Alteon: Payment Posting (Winddown)",
          "SubClient_Name_Id": "10528"
        },
        {
          "Id": 275,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services (SPL)",
          "Client_Name_ID": "10526",
          "SubClient_Name": "Alteon: Hospitalist Coding Services (SPL)",
          "SubClient_Name_Id": "10526"
        },
        {
          "Id": 276,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services",
          "Client_Name_ID": "10525",
          "SubClient_Name": "Alteon: Hospitalist Coding Services",
          "SubClient_Name_Id": "10525"
        },
        {
          "Id": 277,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services (SPL)",
          "Client_Name_ID": "10526",
          "SubClient_Name": "Alteon: Hospitalist Coding Services (SPL)",
          "SubClient_Name_Id": "10526"
        },
        {
          "Id": 278,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Hospitalist Coding Services",
          "Client_Name_ID": "10525",
          "SubClient_Name": "Alteon: Hospitalist Coding Services",
          "SubClient_Name_Id": "10525"
        },
        {
          "Id": 279,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: ED Coding Services",
          "Client_Name_ID": "10524",
          "SubClient_Name": "Alteon: ED Coding Services",
          "SubClient_Name_Id": "10524"
        },
        {
          "Id": 280,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: ED Coding Services",
          "Client_Name_ID": "10524",
          "SubClient_Name": "Alteon: ED Coding Services",
          "SubClient_Name_Id": "10524"
        },
        {
          "Id": 281,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Insurance Follow Up services",
          "Client_Name_ID": "10523",
          "SubClient_Name": "Alteon: AR Insurance Follow Up services",
          "SubClient_Name_Id": "10523"
        },
        {
          "Id": 282,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Insurance Follow Up services",
          "Client_Name_ID": "10523",
          "SubClient_Name": "Alteon: AR Insurance Follow Up services",
          "SubClient_Name_Id": "10523"
        },
        {
          "Id": 283,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon : Claim edit service",
          "Client_Name_ID": "11367",
          "SubClient_Name": "Alteon : Claim edit service - Denials",
          "SubClient_Name_Id": "11367-1"
        },
        {
          "Id": 284,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Denials",
          "Client_Name_ID": "11659",
          "SubClient_Name": "Alteon: Denials",
          "SubClient_Name_Id": "11659"
        },
        {
          "Id": 285,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Denials",
          "Client_Name_ID": "11659",
          "SubClient_Name": "Alteon: Denials",
          "SubClient_Name_Id": "11659"
        },
        {
          "Id": 286,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: EDI",
          "Client_Name_ID": "11660",
          "SubClient_Name": "Alteon: EDI",
          "SubClient_Name_Id": "11660"
        },
        {
          "Id": 287,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: EDI",
          "Client_Name_ID": "11660",
          "SubClient_Name": "Alteon: EDI",
          "SubClient_Name_Id": "11660"
        },
        {
          "Id": 288,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting/Verification and AR Follow up",
          "Client_Name_ID": "11549",
          "SubClient_Name": "Alteon: Payment Posting/Verification and AR Follow up",
          "SubClient_Name_Id": "11549"
        },
        {
          "Id": 289,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting/Verification and AR Follow up",
          "Client_Name_ID": "11549",
          "SubClient_Name": "Alteon: Payment Posting/Verification and AR Follow up",
          "SubClient_Name_Id": "11549"
        },
        {
          "Id": 290,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Insurance update and write off",
          "Client_Name_ID": "11592",
          "SubClient_Name": "Alteon: Insurance update and write off",
          "SubClient_Name_Id": "11592"
        },
        {
          "Id": 291,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Insurance update and write off",
          "Client_Name_ID": "11592",
          "SubClient_Name": "Alteon: Insurance update and write off",
          "SubClient_Name_Id": "11592"
        },
        {
          "Id": 292,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Follow up: EDI: Denials: Callable Claims",
          "Client_Name_ID": "11698",
          "SubClient_Name": "Alteon: AR Follow up: EDI: Denials: Callable Claims",
          "SubClient_Name_Id": "11698"
        },
        {
          "Id": 293,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Follow up: EDI: Denials: Callable Claims",
          "Client_Name_ID": "11698",
          "SubClient_Name": "Alteon: AR Follow up: EDI: Denials: Callable Claims",
          "SubClient_Name_Id": "11698"
        },
        {
          "Id": 294,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Follow up: EDI: Denials: Non Callable Claims",
          "Client_Name_ID": "11699",
          "SubClient_Name": "Alteon: AR Follow up: EDI: Denials: Non Callable Claims",
          "SubClient_Name_Id": "11699"
        },
        {
          "Id": 295,
          "Original_Client_Name": "Alteon Health",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: AR Follow up: EDI: Denials: Non Callable Claims",
          "Client_Name_ID": "11699",
          "SubClient_Name": "Alteon: AR Follow up: EDI: Denials: Non Callable Claims",
          "SubClient_Name_Id": "11699"
        },
        {
          "Id": 296,
          "Original_Client_Name": "Alteon Health - Aurangabad",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Demo Entry",
          "Client_Name_ID": "11317",
          "SubClient_Name": "Alteon: Demo Entry",
          "SubClient_Name_Id": "11317"
        },
        {
          "Id": 297,
          "Original_Client_Name": "Alteon Health - Aurangabad",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Insurance update and rebill",
          "Client_Name_ID": "11318",
          "SubClient_Name": "Alteon: Insurance update and rebill",
          "SubClient_Name_Id": "11318"
        },
        {
          "Id": 298,
          "Original_Client_Name": "Alteon Health - Aurangabad",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Claim Correction",
          "Client_Name_ID": "11319",
          "SubClient_Name": "Alteon: Claim Correction",
          "SubClient_Name_Id": "11319"
        },
        {
          "Id": 299,
          "Original_Client_Name": "Alteon Health - Aurangabad",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting (Winddown)",
          "Client_Name_ID": "10528",
          "SubClient_Name": "Alteon: Payment Posting (Winddown)",
          "SubClient_Name_Id": "10528"
        },
        {
          "Id": 300,
          "Original_Client_Name": "Alteon Health - Aurangabad",
          "Original_Client_Name_ID": "99006",
          "Client_Name": "Alteon: Payment Posting (Winddown)",
          "Client_Name_ID": "10528",
          "SubClient_Name": "Alteon: Payment Posting (Winddown)",
          "SubClient_Name_Id": "10528"
        },
        {
          "Id": 301,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Demographics Entry",
          "Client_Name_ID": "10530",
          "SubClient_Name": "AMAC: Demographics Entry",
          "SubClient_Name_Id": "10530"
        },
        {
          "Id": 302,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Demographics Entry",
          "Client_Name_ID": "10530",
          "SubClient_Name": "AMAC: Demographics Entry - Insurance Calling",
          "SubClient_Name_Id": "10530-1"
        },
        {
          "Id": 303,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Payment Posting",
          "Client_Name_ID": "10531",
          "SubClient_Name": "AMAC: Payment Posting",
          "SubClient_Name_Id": "10531"
        },
        {
          "Id": 304,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Payment Posting",
          "Client_Name_ID": "10531",
          "SubClient_Name": "AMAC: Payment Posting",
          "SubClient_Name_Id": "10531"
        },
        {
          "Id": 305,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Demographics Entry",
          "Client_Name_ID": "10530",
          "SubClient_Name": "AMAC: Demographics Entry",
          "SubClient_Name_Id": "10530"
        },
        {
          "Id": 306,
          "Original_Client_Name": "American Medical Accounting & Consulting",
          "Original_Client_Name_ID": "99007",
          "Client_Name": "AMAC: Demographics Entry",
          "Client_Name_ID": "10530",
          "SubClient_Name": "AMAC: Demographics Entry - Insurance Calling",
          "SubClient_Name_Id": "10530-1"
        },
        {
          "Id": 307,
          "Original_Client_Name": "Anesthesia Consultants of New Jersey LLC",
          "Original_Client_Name_ID": "99008",
          "Client_Name": "ACNJ: Charge & Demographic Entry into PM",
          "Client_Name_ID": "10509",
          "SubClient_Name": "ACNJ: Charge & Demographic Entry into PM",
          "SubClient_Name_Id": "10509"
        },
        {
          "Id": 308,
          "Original_Client_Name": "Anesthesia Consultants of New Jersey LLC",
          "Original_Client_Name_ID": "99008",
          "Client_Name": "ACNJ: Charge & Demographic Entry into PM",
          "Client_Name_ID": "10509",
          "SubClient_Name": "ACNJ: Charge & Demographic Entry into PM",
          "SubClient_Name_Id": "10509"
        },
        {
          "Id": 309,
          "Original_Client_Name": "Anesthesia Consultants of New Jersey LLC",
          "Original_Client_Name_ID": "99008",
          "Client_Name": "ACNJ: Coding",
          "Client_Name_ID": "10510",
          "SubClient_Name": "ACNJ: Coding",
          "SubClient_Name_Id": "10510"
        },
        {
          "Id": 310,
          "Original_Client_Name": "Anesthesia Consultants of New Jersey LLC",
          "Original_Client_Name_ID": "99008",
          "Client_Name": "ACNJ: Coding",
          "Client_Name_ID": "10510",
          "SubClient_Name": "ACNJ: Coding",
          "SubClient_Name_Id": "10510"
        },
        {
          "Id": 311,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application",
          "SubClient_Name_Id": "10532"
        },
        {
          "Id": 312,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application",
          "SubClient_Name_Id": "10532"
        },
        {
          "Id": 313,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - NLP Coding",
          "SubClient_Name_Id": "10532-1"
        },
        {
          "Id": 314,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - Manual Coding",
          "SubClient_Name_Id": "10532-2"
        },
        {
          "Id": 315,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - NLP Coding",
          "SubClient_Name_Id": "10532-1"
        },
        {
          "Id": 316,
          "Original_Client_Name": "Apixio Inc.",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - Manual Coding",
          "SubClient_Name_Id": "10532-2"
        },
        {
          "Id": 317,
          "Original_Client_Name": "Apixio Inc. - Aurangabad",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - NLP Coding",
          "SubClient_Name_Id": "10532-1"
        },
        {
          "Id": 318,
          "Original_Client_Name": "Apixio Inc. - Aurangabad",
          "Original_Client_Name_ID": "99009",
          "Client_Name": "Apixio: HCC Profiler application",
          "Client_Name_ID": "10532",
          "SubClient_Name": "Apixio: HCC Profiler application - NLP Coding",
          "SubClient_Name_Id": "10532-1"
        },
        {
          "Id": 319,
          "Original_Client_Name": "Arnot Health",
          "Original_Client_Name_ID": "99010",
          "Client_Name": "Arnot: Professional Multi:Specialty",
          "Client_Name_ID": "10548",
          "SubClient_Name": "Arnot: Professional Multi:Specialty - E&M",
          "SubClient_Name_Id": "10548-1"
        },
        {
          "Id": 320,
          "Original_Client_Name": "Arnot Health",
          "Original_Client_Name_ID": "99010",
          "Client_Name": "Arnot: Professional Multi:Specialty",
          "Client_Name_ID": "10548",
          "SubClient_Name": "Arnot: Professional Multi:Specialty - E&M",
          "SubClient_Name_Id": "10548-1"
        },
        {
          "Id": 321,
          "Original_Client_Name": "Arnot Health",
          "Original_Client_Name_ID": "99010",
          "Client_Name": "Arnot: Professional Multi:Specialty",
          "Client_Name_ID": "10548",
          "SubClient_Name": "Arnot: Professional Multi:Specialty",
          "SubClient_Name_Id": "10548"
        },
        {
          "Id": 322,
          "Original_Client_Name": "Arnot Health",
          "Original_Client_Name_ID": "99010",
          "Client_Name": "Arnot: Professional Multi:Specialty",
          "Client_Name_ID": "10548",
          "SubClient_Name": "Arnot: Professional Multi:Specialty",
          "SubClient_Name_Id": "10548"
        },
        {
          "Id": 323,
          "Original_Client_Name": "AVP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 324,
          "Original_Client_Name": "AVP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 325,
          "Original_Client_Name": "AVP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 326,
          "Original_Client_Name": "BE BAT team",
          "Original_Client_Name_ID": "NA",
          "Client_Name": "BE BAT team",
          "Client_Name_ID": "10138",
          "SubClient_Name": "BE BAT team",
          "SubClient_Name_Id": "10138"
        },
        {
          "Id": 327,
          "Original_Client_Name": "BE- Quality Compliance",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "ISO",
          "Client_Name_ID": "General",
          "SubClient_Name": "ISO",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 328,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: ED Facility Charges",
          "Client_Name_ID": "10549",
          "SubClient_Name": "Bingham: ED Facility Charges",
          "SubClient_Name_Id": "10549"
        },
        {
          "Id": 329,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: ED Facility Charges",
          "Client_Name_ID": "10549",
          "SubClient_Name": "Bingham: ED Facility Charges",
          "SubClient_Name_Id": "10549"
        },
        {
          "Id": 330,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: ED Professional Charges Only",
          "Client_Name_ID": "10550",
          "SubClient_Name": "Bingham: ED Professional Charges Only",
          "SubClient_Name_Id": "10550"
        },
        {
          "Id": 331,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: ED Professional Charges Only",
          "Client_Name_ID": "10550",
          "SubClient_Name": "Bingham: ED Professional Charges Only",
          "SubClient_Name_Id": "10550"
        },
        {
          "Id": 332,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Inpatient",
          "Client_Name_ID": "10552",
          "SubClient_Name": "Bingham: Inpatient",
          "SubClient_Name_Id": "10552"
        },
        {
          "Id": 333,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Inpatient",
          "Client_Name_ID": "10552",
          "SubClient_Name": "Bingham: Inpatient",
          "SubClient_Name_Id": "10552"
        },
        {
          "Id": 334,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Observation",
          "Client_Name_ID": "10553",
          "SubClient_Name": "Bingham: Observation",
          "SubClient_Name_Id": "10553"
        },
        {
          "Id": 335,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Observation",
          "Client_Name_ID": "10553",
          "SubClient_Name": "Bingham: Observation",
          "SubClient_Name_Id": "10553"
        },
        {
          "Id": 336,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Outpatient Ancillaries",
          "Client_Name_ID": "10554",
          "SubClient_Name": "Bingham: Outpatient Ancillaries",
          "SubClient_Name_Id": "10554"
        },
        {
          "Id": 337,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Outpatient Ancillaries",
          "Client_Name_ID": "10554",
          "SubClient_Name": "Bingham: Outpatient Ancillaries",
          "SubClient_Name_Id": "10554"
        },
        {
          "Id": 338,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Same Day Surgeries",
          "Client_Name_ID": "10555",
          "SubClient_Name": "Bingham: Same Day Surgeries",
          "SubClient_Name_Id": "10555"
        },
        {
          "Id": 339,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Same Day Surgeries",
          "Client_Name_ID": "10555",
          "SubClient_Name": "Bingham: Same Day Surgeries",
          "SubClient_Name_Id": "10555"
        },
        {
          "Id": 340,
          "Original_Client_Name": "Bingham Memorial Hospital",
          "Original_Client_Name_ID": "99011",
          "Client_Name": "Bingham: Facility Coding (Research/Account Reconciliation/Consulting) (Global)",
          "Client_Name_ID": "10551",
          "SubClient_Name": "Bingham: Facility Coding (Research/Account Reconciliation/Consulting) (Global)",
          "SubClient_Name_Id": "10551"
        },
        {
          "Id": 341,
          "Original_Client_Name": "BioScrip, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Appeal Refunds",
          "Client_Name_ID": "10557",
          "SubClient_Name": "BioScrip: Appeal Refunds",
          "SubClient_Name_Id": "10557"
        },
        {
          "Id": 342,
          "Original_Client_Name": "BioScrip, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Appeal Refunds",
          "Client_Name_ID": "10557",
          "SubClient_Name": "BioScrip: Appeal Refunds",
          "SubClient_Name_Id": "10557"
        },
        {
          "Id": 343,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding",
          "SubClient_Name_Id": "11296"
        },
        {
          "Id": 344,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "SubClient_Name_Id": "11297"
        },
        {
          "Id": 345,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding",
          "SubClient_Name_Id": "11296"
        },
        {
          "Id": 346,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "SubClient_Name_Id": "11297"
        },
        {
          "Id": 347,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding - Intake",
          "SubClient_Name_Id": "11296-1"
        },
        {
          "Id": 348,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS - Intake",
          "SubClient_Name_Id": "11297-1"
        },
        {
          "Id": 349,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding - Record QA",
          "SubClient_Name_Id": "11296-2"
        },
        {
          "Id": 350,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS - Record QA",
          "SubClient_Name_Id": "11297-2"
        },
        {
          "Id": 351,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: AHA: HCC Coding",
          "Client_Name_ID": "11605",
          "SubClient_Name": "Brown & Toland: AHA: HCC Coding",
          "SubClient_Name_Id": "11605"
        },
        {
          "Id": 352,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: AHA: HCC Coding",
          "Client_Name_ID": "11605",
          "SubClient_Name": "Brown & Toland: AHA: HCC Coding",
          "SubClient_Name_Id": "11605"
        },
        {
          "Id": 353,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Electronic/Global)",
          "Client_Name_ID": "11342",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Electronic/Global) - Intake",
          "SubClient_Name_Id": "11342-1"
        },
        {
          "Id": 354,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Electronic/Global)",
          "Client_Name_ID": "11342",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Electronic/Global) - Record QA",
          "SubClient_Name_Id": "11342-2"
        },
        {
          "Id": 355,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Onsite)",
          "Client_Name_ID": "11343",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Onsite) - Intake",
          "SubClient_Name_Id": "11343-1"
        },
        {
          "Id": 356,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Onsite)",
          "Client_Name_ID": "11343",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Onsite) - Record QA",
          "SubClient_Name_Id": "11343-2"
        },
        {
          "Id": 357,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Electronic/Global)",
          "Client_Name_ID": "11342",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Electronic/Global) - Intake",
          "SubClient_Name_Id": "11342-1"
        },
        {
          "Id": 358,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Electronic/Global)",
          "Client_Name_ID": "11342",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Electronic/Global) - Record QA",
          "SubClient_Name_Id": "11342-2"
        },
        {
          "Id": 359,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Onsite)",
          "Client_Name_ID": "11343",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Onsite) - Intake",
          "SubClient_Name_Id": "11343-1"
        },
        {
          "Id": 360,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc.",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Chart Retrieval (Onsite)",
          "Client_Name_ID": "11343",
          "SubClient_Name": "Brown & Toland: Chart Retrieval (Onsite) - Record QA",
          "SubClient_Name_Id": "11343-2"
        },
        {
          "Id": 361,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding",
          "SubClient_Name_Id": "11296"
        },
        {
          "Id": 362,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "SubClient_Name_Id": "11297"
        },
        {
          "Id": 363,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding",
          "Client_Name_ID": "11296",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding",
          "SubClient_Name_Id": "11296"
        },
        {
          "Id": 364,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "Client_Name_ID": "11297",
          "SubClient_Name": "Brown & Toland: Retrospective HCC Coding With HEDIS",
          "SubClient_Name_Id": "11297"
        },
        {
          "Id": 365,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: AHA: HCC Coding",
          "Client_Name_ID": "11605",
          "SubClient_Name": "Brown & Toland: AHA: HCC Coding",
          "SubClient_Name_Id": "11605"
        },
        {
          "Id": 366,
          "Original_Client_Name": "Brown & Toland Physician Services Organisation, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99096",
          "Client_Name": "Brown & Toland: AHA: HCC Coding",
          "Client_Name_ID": "11605",
          "SubClient_Name": "Brown & Toland: AHA: HCC Coding",
          "SubClient_Name_Id": "11605"
        },
        {
          "Id": 367,
          "Original_Client_Name": "CAC - iCode Assurance",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Coding HO",
          "Client_Name_ID": "21002",
          "SubClient_Name": "Coding HO - CAC - ED/EM",
          "SubClient_Name_Id": "21002-1"
        },
        {
          "Id": 368,
          "Original_Client_Name": "CAC - iCode Assurance",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Coding HO",
          "Client_Name_ID": "21002",
          "SubClient_Name": "Coding HO - CAC - Anesthesia",
          "SubClient_Name_Id": "21002-2"
        },
        {
          "Id": 369,
          "Original_Client_Name": "CAC - iCode Assurance",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Coding HO",
          "Client_Name_ID": "21002",
          "SubClient_Name": "Coding HO - CAC - Pathology",
          "SubClient_Name_Id": "21002-3"
        },
        {
          "Id": 370,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology - Merge Financials - Imagine",
          "SubClient_Name_Id": "10576-1"
        },
        {
          "Id": 371,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology - Merge Financials - Imagine",
          "SubClient_Name_Id": "10576-1"
        },
        {
          "Id": 372,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 1",
          "SubClient_Name_Id": "10577-4"
        },
        {
          "Id": 373,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 1",
          "SubClient_Name_Id": "10577-4"
        },
        {
          "Id": 374,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 2",
          "SubClient_Name_Id": "10577-5"
        },
        {
          "Id": 375,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 2",
          "SubClient_Name_Id": "10577-5"
        },
        {
          "Id": 376,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 3",
          "SubClient_Name_Id": "10577-6"
        },
        {
          "Id": 377,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 3",
          "SubClient_Name_Id": "10577-6"
        },
        {
          "Id": 378,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Merge Finantial",
          "SubClient_Name_Id": "10577-2"
        },
        {
          "Id": 379,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Merge Finantial",
          "SubClient_Name_Id": "10577-2"
        },
        {
          "Id": 380,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Merge Finantial Denails",
          "SubClient_Name_Id": "10577-3"
        },
        {
          "Id": 381,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Merge Finantial Denails",
          "SubClient_Name_Id": "10577-3"
        },
        {
          "Id": 382,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Coding Denial Services",
          "Client_Name_ID": "10575",
          "SubClient_Name": "Canopy: Coding Denial Services",
          "SubClient_Name_Id": "10575"
        },
        {
          "Id": 383,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Non Vascular",
          "SubClient_Name_Id": "10577-1"
        },
        {
          "Id": 384,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Non Vascular",
          "SubClient_Name_Id": "10577-1"
        },
        {
          "Id": 385,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Coding Denial Services",
          "Client_Name_ID": "10575",
          "SubClient_Name": "Canopy: Coding Denial Services",
          "SubClient_Name_Id": "10575"
        },
        {
          "Id": 386,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology",
          "SubClient_Name_Id": "10576"
        },
        {
          "Id": 387,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology",
          "SubClient_Name_Id": "10576"
        },
        {
          "Id": 388,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology",
          "SubClient_Name_Id": "10577"
        },
        {
          "Id": 389,
          "Original_Client_Name": "Canopy Partners",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology",
          "SubClient_Name_Id": "10577"
        },
        {
          "Id": 390,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology",
          "SubClient_Name_Id": "10576"
        },
        {
          "Id": 391,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology",
          "SubClient_Name_Id": "10576"
        },
        {
          "Id": 392,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Non Vascular",
          "SubClient_Name_Id": "10577-2"
        },
        {
          "Id": 393,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Non Vascular",
          "SubClient_Name_Id": "10577-2"
        },
        {
          "Id": 394,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 1",
          "SubClient_Name_Id": "10577-1"
        },
        {
          "Id": 395,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Interventional Radiology",
          "Client_Name_ID": "10577",
          "SubClient_Name": "Canopy: Interventional Radiology - Level 1",
          "SubClient_Name_Id": "10577-1"
        },
        {
          "Id": 396,
          "Original_Client_Name": "Canopy Partners - Aurangabad",
          "Original_Client_Name_ID": "99014",
          "Client_Name": "Canopy: Diagnostic Radiology",
          "Client_Name_ID": "10576",
          "SubClient_Name": "Canopy: Diagnostic Radiology - AI coding",
          "SubClient_Name_Id": "10576-1"
        },
        {
          "Id": 397,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding",
          "SubClient_Name_Id": "11151"
        },
        {
          "Id": 398,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC Secondary review - non blinded",
          "Client_Name_ID": "11152",
          "SubClient_Name": "Centene: HCC Secondary review - non blinded",
          "SubClient_Name_Id": "11152"
        },
        {
          "Id": 399,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding",
          "SubClient_Name_Id": "11151"
        },
        {
          "Id": 400,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC Secondary review - non blinded",
          "Client_Name_ID": "11152",
          "SubClient_Name": "Centene: HCC Secondary review - non blinded",
          "SubClient_Name_Id": "11152"
        },
        {
          "Id": 401,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding - Auto Coding",
          "SubClient_Name_Id": "11151-1"
        },
        {
          "Id": 402,
          "Original_Client_Name": "Centene Corporation",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding - Auto Coding",
          "SubClient_Name_Id": "11151-1"
        },
        {
          "Id": 403,
          "Original_Client_Name": "Centene Corporation - Aurangabad",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding",
          "SubClient_Name_Id": "11151"
        },
        {
          "Id": 404,
          "Original_Client_Name": "Centene Corporation - Aurangabad",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC Secondary review - non blinded",
          "Client_Name_ID": "11152",
          "SubClient_Name": "Centene: HCC Secondary review - non blinded",
          "SubClient_Name_Id": "11152"
        },
        {
          "Id": 405,
          "Original_Client_Name": "Centene Corporation - Aurangabad",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding",
          "SubClient_Name_Id": "11151"
        },
        {
          "Id": 406,
          "Original_Client_Name": "Centene Corporation - Aurangabad",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC Secondary review - non blinded",
          "Client_Name_ID": "11152",
          "SubClient_Name": "Centene: HCC Secondary review - non blinded",
          "SubClient_Name_Id": "11152"
        },
        {
          "Id": 407,
          "Original_Client_Name": "Centene Corporation - Aurangabad",
          "Original_Client_Name_ID": "99015",
          "Client_Name": "Centene: HCC/RxCHH coding",
          "Client_Name_ID": "11151",
          "SubClient_Name": "Centene: HCC/Rx HCC coding - Auto Coding",
          "SubClient_Name_Id": "11151-1"
        },
        {
          "Id": 408,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: PANA_IL: RCM Support Services",
          "Client_Name_ID": "11255",
          "SubClient_Name": "Cerner: PANA_IL: RCM Support Services",
          "SubClient_Name_Id": "11255"
        },
        {
          "Id": 409,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: PANA_IL: RCM Support Services",
          "Client_Name_ID": "11255",
          "SubClient_Name": "Cerner: PANA_IL: RCM Support Services",
          "SubClient_Name_Id": "11255"
        },
        {
          "Id": 410,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services",
          "SubClient_Name_Id": "11256"
        },
        {
          "Id": 411,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services",
          "SubClient_Name_Id": "11256"
        },
        {
          "Id": 412,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - ALTCHN - AR-FU Online",
          "SubClient_Name_Id": "10612-9"
        },
        {
          "Id": 413,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: AR Services (TIFT_GA)",
          "Client_Name_ID": "11245",
          "SubClient_Name": "Cerner: AR Services (TIFT_GA)",
          "SubClient_Name_Id": "11245"
        },
        {
          "Id": 414,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: AR Services (TIFT_GA)",
          "Client_Name_ID": "11245",
          "SubClient_Name": "Cerner: AR Services (TIFT_GA)",
          "SubClient_Name_Id": "11245"
        },
        {
          "Id": 415,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: AR Services (TIFT_GA)",
          "Client_Name_ID": "11245",
          "SubClient_Name": "Cerner: AR Services (TIFT_GA)",
          "SubClient_Name_Id": "11245"
        },
        {
          "Id": 416,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: AR Services (TIFT_GA)",
          "Client_Name_ID": "11245",
          "SubClient_Name": "Cerner: AR Services (TIFT_GA)",
          "SubClient_Name_Id": "11245"
        },
        {
          "Id": 417,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - Edits",
          "SubClient_Name_Id": "11256-1"
        },
        {
          "Id": 418,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - Edits",
          "SubClient_Name_Id": "11256-1"
        },
        {
          "Id": 419,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: IND_PA: Follow up-Acute",
          "Client_Name_ID": "11316",
          "SubClient_Name": "Cerner: IND_PA: Follow up-Acute",
          "SubClient_Name_Id": "11316"
        },
        {
          "Id": 420,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: IND_PA: Follow up-Acute",
          "Client_Name_ID": "11316",
          "SubClient_Name": "Cerner: IND_PA: Follow up-Acute",
          "SubClient_Name_Id": "11316"
        },
        {
          "Id": 421,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Credit Balance Project",
          "Client_Name_ID": "10589",
          "SubClient_Name": "Cerner: Barnabas: Credit Balance Project - Patient Refund",
          "SubClient_Name_Id": "10589-2"
        },
        {
          "Id": 422,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Credit Balance Project",
          "Client_Name_ID": "10589",
          "SubClient_Name": "Cerner: Barnabas: Credit Balance Project - Insurance Refund",
          "SubClient_Name_Id": "10589-3"
        },
        {
          "Id": 423,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Credit Balance Project",
          "Client_Name_ID": "10589",
          "SubClient_Name": "Cerner: Barnabas: Credit Balance Project - Insurance Refund",
          "SubClient_Name_Id": "10589-3"
        },
        {
          "Id": 424,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Credit Balance Project",
          "Client_Name_ID": "10589",
          "SubClient_Name": "Cerner: Barnabas: Credit Balance Project - Patient Refund",
          "SubClient_Name_Id": "10589-2"
        },
        {
          "Id": 425,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KERN_CA: RCM Support Services",
          "Client_Name_ID": "11298",
          "SubClient_Name": "Cerner: KERN_CA: RCM Support Services",
          "SubClient_Name_Id": "11298"
        },
        {
          "Id": 426,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KERN_CA: RCM Support Services",
          "Client_Name_ID": "11298",
          "SubClient_Name": "Cerner: KERN_CA: RCM Support Services",
          "SubClient_Name_Id": "11298"
        },
        {
          "Id": 427,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - ALTCHN - Concluder",
          "SubClient_Name_Id": "10594-9"
        },
        {
          "Id": 428,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Task : Claims Follow up/Appeals (Barnabas) - ALTCHN - Concluder",
          "SubClient_Name_Id": "10600-6"
        },
        {
          "Id": 429,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Task : Claims Follow up/Appeals (CHLD_FL) - ALTCHN - Concluder",
          "SubClient_Name_Id": "10597-9"
        },
        {
          "Id": 430,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - ALTCHN - Concluder",
          "SubClient_Name_Id": "10600-6"
        },
        {
          "Id": 431,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - ALTCHN - Concluder",
          "SubClient_Name_Id": "10597-9"
        },
        {
          "Id": 432,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services- ALTCHN - Concluder",
          "SubClient_Name_Id": "10607-8"
        },
        {
          "Id": 433,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - ALTCHN - Concluder",
          "SubClient_Name_Id": "10601-7"
        },
        {
          "Id": 434,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up - ALTCHN - Concluder",
          "SubClient_Name_Id": "10592-2"
        },
        {
          "Id": 435,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - ALTCHN - Concluder",
          "SubClient_Name_Id": "10612-10"
        },
        {
          "Id": 436,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: IND_PA: Follow up-Acute",
          "Client_Name_ID": "11316",
          "SubClient_Name": "Cerner: IND_PA: Follow up-Acute - ALTCHN - Concluder",
          "SubClient_Name_Id": "11316-1"
        },
        {
          "Id": 437,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals",
          "Client_Name_ID": "10618",
          "SubClient_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals - ALTCHN - Concluder",
          "SubClient_Name_Id": "10618-1"
        },
        {
          "Id": 438,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - ALTCHN - Concluder",
          "SubClient_Name_Id": "10621-7"
        },
        {
          "Id": 439,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RCM Support Services (Vail Health Hospital)",
          "Client_Name_ID": "11185",
          "SubClient_Name": "Cerner: RCM Support Services (Vail Health Hospital) - ALTCHN - Concluder",
          "SubClient_Name_Id": "11185-1"
        },
        {
          "Id": 440,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - SHDV",
          "SubClient_Name_Id": "11256-2"
        },
        {
          "Id": 441,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - HDV",
          "SubClient_Name_Id": "11256-3"
        },
        {
          "Id": 442,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - Appeal",
          "SubClient_Name_Id": "11256-4"
        },
        {
          "Id": 443,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_MO: RCM Support Services",
          "Client_Name_ID": "11256",
          "SubClient_Name": "Cerner: CHLD_MO: RCM Support Services - Non Voice",
          "SubClient_Name_Id": "11256-5"
        },
        {
          "Id": 444,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory",
          "Client_Name_ID": "11385",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory - Appeal",
          "SubClient_Name_Id": "11385-1"
        },
        {
          "Id": 445,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Acute",
          "Client_Name_ID": "11386",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Acute - Appeal",
          "SubClient_Name_Id": "11386-1"
        },
        {
          "Id": 446,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MVHO_WA : Clinic",
          "Client_Name_ID": "11426",
          "SubClient_Name": "Cerner: MVHO_WA : Clinic",
          "SubClient_Name_Id": "11426"
        },
        {
          "Id": 447,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MVHO_WA : Inpatient",
          "Client_Name_ID": "11427",
          "SubClient_Name": "Cerner: MVHO_WA : Inpatient",
          "SubClient_Name_Id": "11427"
        },
        {
          "Id": 448,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "Client_Name_ID": "11428",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "SubClient_Name_Id": "11428"
        },
        {
          "Id": 449,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "Client_Name_ID": "11429",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "SubClient_Name_Id": "11429"
        },
        {
          "Id": 450,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "Client_Name_ID": "11428",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "SubClient_Name_Id": "11428"
        },
        {
          "Id": 451,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "Client_Name_ID": "11429",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "SubClient_Name_Id": "11429"
        },
        {
          "Id": 452,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services-Charity Care",
          "SubClient_Name_Id": "10613-8"
        },
        {
          "Id": 453,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory",
          "Client_Name_ID": "11385",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory",
          "SubClient_Name_Id": "11385"
        },
        {
          "Id": 454,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Acute",
          "Client_Name_ID": "11386",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Acute",
          "SubClient_Name_Id": "11386"
        },
        {
          "Id": 455,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory",
          "Client_Name_ID": "11385",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Ambulatory",
          "SubClient_Name_Id": "11385"
        },
        {
          "Id": 456,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: St Lukes: RCM Support Services - Acute",
          "Client_Name_ID": "11386",
          "SubClient_Name": "Cerner: St Lukes: RCM Support Services - Acute",
          "SubClient_Name_Id": "11386"
        },
        {
          "Id": 457,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Observation Coding",
          "Client_Name_ID": "11410",
          "SubClient_Name": "Cerner: MCLD_SC: Observation Coding",
          "SubClient_Name_Id": "11410"
        },
        {
          "Id": 458,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Observation Coding",
          "Client_Name_ID": "11410",
          "SubClient_Name": "Cerner: MCLD_SC: Observation Coding",
          "SubClient_Name_Id": "11410"
        },
        {
          "Id": 459,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Same Day Surgery Coding",
          "Client_Name_ID": "11411",
          "SubClient_Name": "Cerner: MCLD_SC: Same Day Surgery Coding",
          "SubClient_Name_Id": "11411"
        },
        {
          "Id": 460,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Same Day Surgery Coding",
          "Client_Name_ID": "11411",
          "SubClient_Name": "Cerner: MCLD_SC: Same Day Surgery Coding",
          "SubClient_Name_Id": "11411"
        },
        {
          "Id": 461,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: SchoolCraft: RCM Support Services",
          "Client_Name_ID": "11409",
          "SubClient_Name": "Cerner: SchoolCraft: RCM Support Services",
          "SubClient_Name_Id": "11409"
        },
        {
          "Id": 462,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: SchoolCraft: RCM Support Services",
          "Client_Name_ID": "11409",
          "SubClient_Name": "Cerner: SchoolCraft: RCM Support Services",
          "SubClient_Name_Id": "11409"
        },
        {
          "Id": 463,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: JEFF_AR: RCM Support Services",
          "Client_Name_ID": "11034",
          "SubClient_Name": "Cerner: JEFF_AR: RCM Support Services",
          "SubClient_Name_Id": "11034"
        },
        {
          "Id": 464,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals",
          "Client_Name_ID": "10618",
          "SubClient_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals",
          "SubClient_Name_Id": "10618"
        },
        {
          "Id": 465,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - WC/No Fault",
          "SubClient_Name_Id": "10613-7"
        },
        {
          "Id": 466,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - ALTCHN - IVR",
          "SubClient_Name_Id": "10612-7"
        },
        {
          "Id": 467,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - ALTCHN - IP2PINDEXING",
          "SubClient_Name_Id": "10612-8"
        },
        {
          "Id": 468,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - ALTCHN - IVR",
          "SubClient_Name_Id": "10584-22"
        },
        {
          "Id": 469,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - ALTCHN - IP2PINDEXING",
          "SubClient_Name_Id": "10584-23"
        },
        {
          "Id": 470,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - ALTCHN - IVR",
          "SubClient_Name_Id": "10607-5"
        },
        {
          "Id": 471,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - ALTCHN - IP2PINDEXING",
          "SubClient_Name_Id": "10607-6"
        },
        {
          "Id": 472,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up",
          "SubClient_Name_Id": "10612-2"
        },
        {
          "Id": 473,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Patient Registration Update",
          "Client_Name_ID": "11019",
          "SubClient_Name": "Cerner: Patient Registration Update",
          "SubClient_Name_Id": "11019"
        },
        {
          "Id": 474,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Patient Registration Update",
          "Client_Name_ID": "11019",
          "SubClient_Name": "Cerner: Patient Registration Update",
          "SubClient_Name_Id": "11019"
        },
        {
          "Id": 475,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services - HDV Encounters",
          "SubClient_Name_Id": "11037-2"
        },
        {
          "Id": 476,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services - HDV Encounters",
          "SubClient_Name_Id": "11037-2"
        },
        {
          "Id": 477,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RCM Support Services (Vail Health Hospital)",
          "Client_Name_ID": "11185",
          "SubClient_Name": "Cerner: RCM Support Services (Vail Health Hospital)",
          "SubClient_Name_Id": "11185"
        },
        {
          "Id": 478,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RCM Support Services (Vail Health Hospital)",
          "Client_Name_ID": "11185",
          "SubClient_Name": "Cerner: RCM Support Services (Vail Health Hospital)",
          "SubClient_Name_Id": "11185"
        },
        {
          "Id": 479,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balance Correction & Money Movement",
          "Client_Name_ID": "11122",
          "SubClient_Name": "Cerner: Balance Correction & Money Movement",
          "SubClient_Name_Id": "11122"
        },
        {
          "Id": 480,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balance Correction & Money Movement",
          "Client_Name_ID": "11122",
          "SubClient_Name": "Cerner: Balance Correction & Money Movement",
          "SubClient_Name_Id": "11122"
        },
        {
          "Id": 481,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services",
          "SubClient_Name_Id": "10613"
        },
        {
          "Id": 482,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services",
          "SubClient_Name_Id": "10613"
        },
        {
          "Id": 483,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Web - Acute",
          "SubClient_Name_Id": "10584-5"
        },
        {
          "Id": 484,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Call - Acute",
          "SubClient_Name_Id": "10584-6"
        },
        {
          "Id": 485,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up IVR - Acute",
          "SubClient_Name_Id": "10584-7"
        },
        {
          "Id": 486,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Q1 & Q2 - Acute",
          "SubClient_Name_Id": "10584-8"
        },
        {
          "Id": 487,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Web - Ambulatory",
          "SubClient_Name_Id": "10584-9"
        },
        {
          "Id": 488,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Call - Ambulatory",
          "SubClient_Name_Id": "10584-10"
        },
        {
          "Id": 489,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up IVR - Ambulatory",
          "SubClient_Name_Id": "10584-11"
        },
        {
          "Id": 490,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Q1 & Q2 - Ambulatory",
          "SubClient_Name_Id": "10584-12"
        },
        {
          "Id": 491,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Web - Acute",
          "SubClient_Name_Id": "10584-13"
        },
        {
          "Id": 492,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Call - Acute",
          "SubClient_Name_Id": "10584-14"
        },
        {
          "Id": 493,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials IVR - Acute",
          "SubClient_Name_Id": "10584-15"
        },
        {
          "Id": 494,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Q1 & Q2 - Acute",
          "SubClient_Name_Id": "10584-16"
        },
        {
          "Id": 495,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Web - Ambulatory",
          "SubClient_Name_Id": "10584-17"
        },
        {
          "Id": 496,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Call - Ambulatory",
          "SubClient_Name_Id": "10584-18"
        },
        {
          "Id": 497,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials IVR - Ambulatory",
          "SubClient_Name_Id": "10584-19"
        },
        {
          "Id": 498,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Appeals/Mail",
          "SubClient_Name_Id": "10584-20"
        },
        {
          "Id": 499,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Fax/Patient Letter",
          "SubClient_Name_Id": "10584-21"
        },
        {
          "Id": 500,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Web - Acute",
          "SubClient_Name_Id": "10584-5"
        },
        {
          "Id": 501,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Call - Acute",
          "SubClient_Name_Id": "10584-6"
        },
        {
          "Id": 502,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up IVR - Acute",
          "SubClient_Name_Id": "10584-7"
        },
        {
          "Id": 503,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Q1 & Q2 - Acute",
          "SubClient_Name_Id": "10584-8"
        },
        {
          "Id": 504,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Web - Ambulatory",
          "SubClient_Name_Id": "10584-9"
        },
        {
          "Id": 505,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Call - Ambulatory",
          "SubClient_Name_Id": "10584-10"
        },
        {
          "Id": 506,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up IVR - Ambulatory",
          "SubClient_Name_Id": "10584-11"
        },
        {
          "Id": 507,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Follow Up Q1 & Q2 - Ambulatory",
          "SubClient_Name_Id": "10584-12"
        },
        {
          "Id": 508,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Web - Acute",
          "SubClient_Name_Id": "10584-13"
        },
        {
          "Id": 509,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Call - Acute",
          "SubClient_Name_Id": "10584-14"
        },
        {
          "Id": 510,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials IVR - Acute",
          "SubClient_Name_Id": "10584-15"
        },
        {
          "Id": 511,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Q1 & Q2 - Acute",
          "SubClient_Name_Id": "10584-16"
        },
        {
          "Id": 512,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Web - Ambulatory",
          "SubClient_Name_Id": "10584-17"
        },
        {
          "Id": 513,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials Call - Ambulatory",
          "SubClient_Name_Id": "10584-18"
        },
        {
          "Id": 514,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials IVR - Ambulatory",
          "SubClient_Name_Id": "10584-19"
        },
        {
          "Id": 515,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Appeals/Mail",
          "SubClient_Name_Id": "10584-20"
        },
        {
          "Id": 516,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Fax/Patient Letter",
          "SubClient_Name_Id": "10584-21"
        },
        {
          "Id": 517,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Patient Registration Update",
          "Client_Name_ID": "11019",
          "SubClient_Name": "Cerner: Patient Registration Update",
          "SubClient_Name_Id": "11019"
        },
        {
          "Id": 518,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Patient Registration Update",
          "Client_Name_ID": "11019",
          "SubClient_Name": "Cerner: Patient Registration Update",
          "SubClient_Name_Id": "11019"
        },
        {
          "Id": 519,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - Appeals",
          "SubClient_Name_Id": "10612-1"
        },
        {
          "Id": 520,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - AR Follow Up",
          "SubClient_Name_Id": "10612-2"
        },
        {
          "Id": 521,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - Correspondence",
          "SubClient_Name_Id": "10612-3"
        },
        {
          "Id": 522,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - Denials",
          "SubClient_Name_Id": "10612-4"
        },
        {
          "Id": 523,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - Special Project",
          "SubClient_Name_Id": "10612-5"
        },
        {
          "Id": 524,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up - Referral",
          "SubClient_Name_Id": "10612-6"
        },
        {
          "Id": 525,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10610-1"
        },
        {
          "Id": 526,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services - AR Follow_Queue",
          "SubClient_Name_Id": "10610-2"
        },
        {
          "Id": 527,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services - AR Follow ATB",
          "SubClient_Name_Id": "10610-3"
        },
        {
          "Id": 528,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services - Special Project",
          "SubClient_Name_Id": "10610-4"
        },
        {
          "Id": 529,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services - Appeal",
          "SubClient_Name_Id": "10604-1"
        },
        {
          "Id": 530,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services - AR Follow_Queue",
          "SubClient_Name_Id": "10604-2"
        },
        {
          "Id": 531,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services - AR Follow ATB",
          "SubClient_Name_Id": "10604-3"
        },
        {
          "Id": 532,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services - Special Project",
          "SubClient_Name_Id": "10604-4"
        },
        {
          "Id": 533,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services - Elegibility",
          "SubClient_Name_Id": "10604-5"
        },
        {
          "Id": 534,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MUNS_MI: RCM Support Services",
          "Client_Name_ID": "10609",
          "SubClient_Name": "Cerner: MUNS_MI: RCM Support Services - Denial Queue Management",
          "SubClient_Name_Id": "10609-1"
        },
        {
          "Id": 535,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MUNS_MI: RCM Support Services",
          "Client_Name_ID": "10609",
          "SubClient_Name": "Cerner: MUNS_MI: RCM Support Services - Appeals - Review Websites",
          "SubClient_Name_Id": "10609-2"
        },
        {
          "Id": 536,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Invalids Edits Rejections",
          "SubClient_Name_Id": "10607-1"
        },
        {
          "Id": 537,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Old Aging",
          "SubClient_Name_Id": "10607-2"
        },
        {
          "Id": 538,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Financial Class Focus",
          "SubClient_Name_Id": "10607-3"
        },
        {
          "Id": 539,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10607-4"
        },
        {
          "Id": 540,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - AR",
          "SubClient_Name_Id": "10597-1"
        },
        {
          "Id": 541,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Edits",
          "SubClient_Name_Id": "10597-2"
        },
        {
          "Id": 542,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Correspondence",
          "SubClient_Name_Id": "10597-3"
        },
        {
          "Id": 543,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Rejections",
          "SubClient_Name_Id": "10597-4"
        },
        {
          "Id": 544,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Referrals",
          "SubClient_Name_Id": "10597-5"
        },
        {
          "Id": 545,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - HDV",
          "SubClient_Name_Id": "10597-6"
        },
        {
          "Id": 546,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Special Projects",
          "SubClient_Name_Id": "10597-7"
        },
        {
          "Id": 547,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals - Appeals",
          "SubClient_Name_Id": "10597-8"
        },
        {
          "Id": 548,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - AR Voice",
          "SubClient_Name_Id": "10594-1"
        },
        {
          "Id": 549,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - AR Non-Voice",
          "SubClient_Name_Id": "10594-2"
        },
        {
          "Id": 550,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Edits",
          "SubClient_Name_Id": "10594-3"
        },
        {
          "Id": 551,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Correspondence",
          "SubClient_Name_Id": "10594-4"
        },
        {
          "Id": 552,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Rejections",
          "SubClient_Name_Id": "10594-5"
        },
        {
          "Id": 553,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Special Project",
          "SubClient_Name_Id": "10594-6"
        },
        {
          "Id": 554,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10594-7"
        },
        {
          "Id": 555,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services - Denials",
          "SubClient_Name_Id": "10594-8"
        },
        {
          "Id": 556,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - AR",
          "SubClient_Name_Id": "10584-1"
        },
        {
          "Id": 557,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Denials",
          "SubClient_Name_Id": "10584-2"
        },
        {
          "Id": 558,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Appeals",
          "SubClient_Name_Id": "10584-3"
        },
        {
          "Id": 559,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services - Webstatus",
          "SubClient_Name_Id": "10584-4"
        },
        {
          "Id": 560,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services - AR Voice",
          "SubClient_Name_Id": "10593-1"
        },
        {
          "Id": 561,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services - Edits",
          "SubClient_Name_Id": "10593-2"
        },
        {
          "Id": 562,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services - Rejections",
          "SubClient_Name_Id": "10593-3"
        },
        {
          "Id": 563,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10593-4"
        },
        {
          "Id": 564,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - AR",
          "SubClient_Name_Id": "10591-1"
        },
        {
          "Id": 565,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Edits",
          "SubClient_Name_Id": "10591-2"
        },
        {
          "Id": 566,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Rejections",
          "SubClient_Name_Id": "10591-3"
        },
        {
          "Id": 567,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Referrals",
          "SubClient_Name_Id": "10591-4"
        },
        {
          "Id": 568,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Special Projects",
          "SubClient_Name_Id": "10591-5"
        },
        {
          "Id": 569,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Denials",
          "SubClient_Name_Id": "10591-6"
        },
        {
          "Id": 570,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10591-7"
        },
        {
          "Id": 571,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - AR",
          "SubClient_Name_Id": "10616-1"
        },
        {
          "Id": 572,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - EOB Variance",
          "SubClient_Name_Id": "10616-2"
        },
        {
          "Id": 573,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - Referrals",
          "SubClient_Name_Id": "10616-4"
        },
        {
          "Id": 574,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - Edits",
          "SubClient_Name_Id": "10621-6"
        },
        {
          "Id": 575,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - Rebill/Appeals",
          "SubClient_Name_Id": "10621-5"
        },
        {
          "Id": 576,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services - Edits",
          "SubClient_Name_Id": "10611-6"
        },
        {
          "Id": 577,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - AR",
          "SubClient_Name_Id": "3658-1"
        },
        {
          "Id": 578,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Edits",
          "SubClient_Name_Id": "3658-2"
        },
        {
          "Id": 579,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services - Rejection",
          "SubClient_Name_Id": "3658-3"
        },
        {
          "Id": 580,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services",
          "SubClient_Name_Id": "10621"
        },
        {
          "Id": 581,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services - Edits",
          "SubClient_Name_Id": "10611-6"
        },
        {
          "Id": 582,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MUNS_MI: RCM Support Services",
          "Client_Name_ID": "10609",
          "SubClient_Name": "Cerner: MUNS_MI: RCM Support Services",
          "SubClient_Name_Id": "10609"
        },
        {
          "Id": 583,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MUNS_MI: RCM Support Services",
          "Client_Name_ID": "10609",
          "SubClient_Name": "Cerner: MUNS_MI: RCM Support Services",
          "SubClient_Name_Id": "10609"
        },
        {
          "Id": 584,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward Health Care System: Credit Balances Patient Credit",
          "Client_Name_ID": "11018",
          "SubClient_Name": "Cerner: Steward Health Care System: Credit Balances Patient Credit",
          "SubClient_Name_Id": "11018"
        },
        {
          "Id": 585,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward Health Care System: Credit Balances Insurance Credit",
          "Client_Name_ID": "11017",
          "SubClient_Name": "Cerner: Steward Health Care System: Credit Balances Insurance Credit",
          "SubClient_Name_Id": "11017"
        },
        {
          "Id": 586,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward Health Care System: Credit Balances Patient Credit",
          "Client_Name_ID": "11018",
          "SubClient_Name": "Cerner: Steward Health Care System: Credit Balances Patient Credit",
          "SubClient_Name_Id": "11018"
        },
        {
          "Id": 587,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward Health Care System: Credit Balances Insurance Credit",
          "Client_Name_ID": "11017",
          "SubClient_Name": "Cerner: Steward Health Care System: Credit Balances Insurance Credit",
          "SubClient_Name_Id": "11017"
        },
        {
          "Id": 588,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services",
          "SubClient_Name_Id": "11037"
        },
        {
          "Id": 589,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services",
          "SubClient_Name_Id": "11037"
        },
        {
          "Id": 590,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CH_VA: NCCI coding edits and denial recoding",
          "Client_Name_ID": "10596",
          "SubClient_Name": "Cerner: CH_VA: NCCI coding edits and denial recoding",
          "SubClient_Name_Id": "10596"
        },
        {
          "Id": 591,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CH_VA: NCCI coding edits and denial recoding",
          "Client_Name_ID": "10596",
          "SubClient_Name": "Cerner: CH_VA: NCCI coding edits and denial recoding",
          "SubClient_Name_Id": "10596"
        },
        {
          "Id": 592,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: Credit Balances Patient Credit",
          "Client_Name_ID": "11016",
          "SubClient_Name": "Cerner: CHSI_TN: Credit Balances Patient Credit",
          "SubClient_Name_Id": "11016"
        },
        {
          "Id": 593,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: Credit Balances Insurance Credit",
          "Client_Name_ID": "11015",
          "SubClient_Name": "Cerner: CHSI_TN: Credit Balances Insurance Credit",
          "SubClient_Name_Id": "11015"
        },
        {
          "Id": 594,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: Credit Balances Patient Credit",
          "Client_Name_ID": "11016",
          "SubClient_Name": "Cerner: CHSI_TN: Credit Balances Patient Credit",
          "SubClient_Name_Id": "11016"
        },
        {
          "Id": 595,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: Credit Balances Insurance Credit",
          "Client_Name_ID": "11015",
          "SubClient_Name": "Cerner: CHSI_TN: Credit Balances Insurance Credit",
          "SubClient_Name_Id": "11015"
        },
        {
          "Id": 596,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - Rejection",
          "SubClient_Name_Id": "10616-1"
        },
        {
          "Id": 597,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - AM",
          "SubClient_Name_Id": "10616-2"
        },
        {
          "Id": 598,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - APP",
          "SubClient_Name_Id": "10616-3"
        },
        {
          "Id": 599,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals - Appeals",
          "SubClient_Name_Id": "10616-4"
        },
        {
          "Id": 600,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up",
          "SubClient_Name_Id": "10592"
        },
        {
          "Id": 601,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up",
          "SubClient_Name_Id": "10592"
        },
        {
          "Id": 602,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_AR",
          "SubClient_Name_Id": "10611-1"
        },
        {
          "Id": 603,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Payment Posting",
          "SubClient_Name_Id": "10611-2"
        },
        {
          "Id": 604,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Charge Submission",
          "SubClient_Name_Id": "10611-3"
        },
        {
          "Id": 605,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Patient Statement",
          "SubClient_Name_Id": "10611-4"
        },
        {
          "Id": 606,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Rejection",
          "SubClient_Name_Id": "10611-5"
        },
        {
          "Id": 607,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_AR",
          "SubClient_Name_Id": "10611-1"
        },
        {
          "Id": 608,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Payment Posting",
          "SubClient_Name_Id": "10611-2"
        },
        {
          "Id": 609,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Charge Submission",
          "SubClient_Name_Id": "10611-3"
        },
        {
          "Id": 610,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Patient Statement",
          "SubClient_Name_Id": "10611-4"
        },
        {
          "Id": 611,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services",
          "Client_Name_ID": "10611",
          "SubClient_Name": "Cerner: RevWorks Associates Podiatrists: RCM Services_Rejection",
          "SubClient_Name_Id": "10611-5"
        },
        {
          "Id": 612,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services",
          "SubClient_Name_Id": "10595"
        },
        {
          "Id": 613,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services",
          "SubClient_Name_Id": "10595"
        },
        {
          "Id": 614,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: JEFF_AR: RCM Support Services",
          "Client_Name_ID": "11034",
          "SubClient_Name": "Cerner: JEFF_AR: RCM Support Services",
          "SubClient_Name_Id": "11034"
        },
        {
          "Id": 615,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: SANJ_NM: San Juan",
          "Client_Name_ID": "11038",
          "SubClient_Name": "Cerner: SANJ_NM: San Juan",
          "SubClient_Name_Id": "11038"
        },
        {
          "Id": 616,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: SANJ_NM: San Juan",
          "Client_Name_ID": "11038",
          "SubClient_Name": "Cerner: SANJ_NM: San Juan",
          "SubClient_Name_Id": "11038"
        },
        {
          "Id": 617,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services - Appeals/Mail/Fax/Patient Letter",
          "SubClient_Name_Id": "10595-1"
        },
        {
          "Id": 618,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services - Online",
          "SubClient_Name_Id": "10595-2"
        },
        {
          "Id": 619,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Invalids",
          "SubClient_Name_Id": "10585-1"
        },
        {
          "Id": 620,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Medicaid Online claims project",
          "SubClient_Name_Id": "10585-2"
        },
        {
          "Id": 621,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10585-3"
        },
        {
          "Id": 622,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Edits",
          "SubClient_Name_Id": "10585-4"
        },
        {
          "Id": 623,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - WC/NF",
          "SubClient_Name_Id": "11036-1"
        },
        {
          "Id": 624,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - EOB Variance",
          "SubClient_Name_Id": "11036-2"
        },
        {
          "Id": 625,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "11036-3"
        },
        {
          "Id": 626,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Rejects",
          "SubClient_Name_Id": "11036-4"
        },
        {
          "Id": 627,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - AR-FU Online",
          "SubClient_Name_Id": "11036-5"
        },
        {
          "Id": 628,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - ClaimProcessing",
          "SubClient_Name_Id": "11036-6"
        },
        {
          "Id": 629,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Invalids",
          "SubClient_Name_Id": "11036-7"
        },
        {
          "Id": 630,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Correspondence",
          "SubClient_Name_Id": "11036-8"
        },
        {
          "Id": 631,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Correspondence",
          "SubClient_Name_Id": "10601-1"
        },
        {
          "Id": 632,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - WC/MVA",
          "SubClient_Name_Id": "10601-2"
        },
        {
          "Id": 633,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - AR/Denials FU Online",
          "SubClient_Name_Id": "10601-3"
        },
        {
          "Id": 634,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10601-4"
        },
        {
          "Id": 635,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - EOB Variance",
          "SubClient_Name_Id": "10601-5"
        },
        {
          "Id": 636,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Medicaid Online Claims Submission",
          "SubClient_Name_Id": "10601-6"
        },
        {
          "Id": 637,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - AR/Denials FU/Claims Submission HDV",
          "SubClient_Name_Id": "10600-1"
        },
        {
          "Id": 638,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10600-2"
        },
        {
          "Id": 639,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Client Special Project",
          "SubClient_Name_Id": "10600-3"
        },
        {
          "Id": 640,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Day",
          "SubClient_Name_Id": "10600-4"
        },
        {
          "Id": 641,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Correspondence",
          "SubClient_Name_Id": "10600-5"
        },
        {
          "Id": 642,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - AR/Denials FU/Claims Submission HD",
          "SubClient_Name_Id": "10608-1"
        },
        {
          "Id": 643,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - WC",
          "SubClient_Name_Id": "10608-2"
        },
        {
          "Id": 644,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10608-3"
        },
        {
          "Id": 645,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - AR/Denials FU - Day",
          "SubClient_Name_Id": "10608-4"
        },
        {
          "Id": 646,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up - Non Calling online",
          "SubClient_Name_Id": "10592-1"
        },
        {
          "Id": 647,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services - SSI Errors",
          "SubClient_Name_Id": "11037-1"
        },
        {
          "Id": 648,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10613-1"
        },
        {
          "Id": 649,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Rejections",
          "SubClient_Name_Id": "10613-2"
        },
        {
          "Id": 650,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - DNFB/Edit Failure",
          "SubClient_Name_Id": "10613-3"
        },
        {
          "Id": 651,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Invalids",
          "SubClient_Name_Id": "10613-4"
        },
        {
          "Id": 652,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Patient Statement",
          "SubClient_Name_Id": "10613-5"
        },
        {
          "Id": 653,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Correspondence",
          "SubClient_Name_Id": "10613-6"
        },
        {
          "Id": 654,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services - Appeals/Mail/Fax/Patient Letter",
          "SubClient_Name_Id": "10595-1"
        },
        {
          "Id": 655,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Central Maine: RCM Support Services",
          "Client_Name_ID": "10595",
          "SubClient_Name": "Cerner: Central Maine: RCM Support Services - Online",
          "SubClient_Name_Id": "10595-2"
        },
        {
          "Id": 656,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Invalids",
          "SubClient_Name_Id": "10585-1"
        },
        {
          "Id": 657,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Medicaid Online claims project",
          "SubClient_Name_Id": "10585-2"
        },
        {
          "Id": 658,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Appeals",
          "SubClient_Name_Id": "10585-3"
        },
        {
          "Id": 659,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services - Edits",
          "SubClient_Name_Id": "10585-4"
        },
        {
          "Id": 660,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - WC/NF",
          "SubClient_Name_Id": "11036-1"
        },
        {
          "Id": 661,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - EOB Variance",
          "SubClient_Name_Id": "11036-2"
        },
        {
          "Id": 662,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "11036-3"
        },
        {
          "Id": 663,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Rejects",
          "SubClient_Name_Id": "11036-4"
        },
        {
          "Id": 664,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - AR-FU Online",
          "SubClient_Name_Id": "11036-5"
        },
        {
          "Id": 665,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - ClaimProcessing",
          "SubClient_Name_Id": "11036-6"
        },
        {
          "Id": 666,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Invalids",
          "SubClient_Name_Id": "11036-7"
        },
        {
          "Id": 667,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Correspondence",
          "SubClient_Name_Id": "11036-8"
        },
        {
          "Id": 668,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Correspondence",
          "SubClient_Name_Id": "10601-1"
        },
        {
          "Id": 669,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - WC/MVA",
          "SubClient_Name_Id": "10601-2"
        },
        {
          "Id": 670,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - AR/Denials FU Online",
          "SubClient_Name_Id": "10601-3"
        },
        {
          "Id": 671,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10601-4"
        },
        {
          "Id": 672,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - EOB Variance",
          "SubClient_Name_Id": "10601-5"
        },
        {
          "Id": 673,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Medicaid Online Claims Submission",
          "SubClient_Name_Id": "10601-6"
        },
        {
          "Id": 674,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - AR/Denials FU/Claims Submission HDV",
          "SubClient_Name_Id": "10600-1"
        },
        {
          "Id": 675,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10600-2"
        },
        {
          "Id": 676,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Client Special Project",
          "SubClient_Name_Id": "10600-3"
        },
        {
          "Id": 677,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Day",
          "SubClient_Name_Id": "10600-4"
        },
        {
          "Id": 678,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals - Correspondence",
          "SubClient_Name_Id": "10600-5"
        },
        {
          "Id": 679,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - AR/Denials FU/Claims Submission HD",
          "SubClient_Name_Id": "10608-1"
        },
        {
          "Id": 680,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - WC",
          "SubClient_Name_Id": "10608-2"
        },
        {
          "Id": 681,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10608-3"
        },
        {
          "Id": 682,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services - AR/Denials FU - Day",
          "SubClient_Name_Id": "10608-4"
        },
        {
          "Id": 683,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up - Non Calling online",
          "SubClient_Name_Id": "10592-1"
        },
        {
          "Id": 684,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KDHD_CA: RCM Support Services",
          "Client_Name_ID": "11037",
          "SubClient_Name": "Cerner: KDHD_CA: RCM Support Services - SSI Errors",
          "SubClient_Name_Id": "11037-1"
        },
        {
          "Id": 685,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Appeals/Mail/Fax",
          "SubClient_Name_Id": "10613-1"
        },
        {
          "Id": 686,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Rejections",
          "SubClient_Name_Id": "10613-2"
        },
        {
          "Id": 687,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - DNFB/Edit Failure",
          "SubClient_Name_Id": "10613-3"
        },
        {
          "Id": 688,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Invalids",
          "SubClient_Name_Id": "10613-4"
        },
        {
          "Id": 689,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Patient Statement",
          "SubClient_Name_Id": "10613-5"
        },
        {
          "Id": 690,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services - Correspondence",
          "SubClient_Name_Id": "10613-6"
        },
        {
          "Id": 691,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services",
          "SubClient_Name_Id": "10608"
        },
        {
          "Id": 692,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Maury: RCM Support Services",
          "Client_Name_ID": "10608",
          "SubClient_Name": "Cerner: Maury: RCM Support Services",
          "SubClient_Name_Id": "10608"
        },
        {
          "Id": 693,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Patient Credit",
          "Client_Name_ID": "10602",
          "SubClient_Name": "Cerner: Crozer: Patient Credit",
          "SubClient_Name_Id": "10602"
        },
        {
          "Id": 694,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Patient Credit",
          "Client_Name_ID": "10602",
          "SubClient_Name": "Cerner: Crozer: Patient Credit",
          "SubClient_Name_Id": "10602"
        },
        {
          "Id": 695,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Code Helpdesk",
          "SubClient_Name_Id": "11036-9"
        },
        {
          "Id": 696,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "SubClient_Name_Id": "11036"
        },
        {
          "Id": 697,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services",
          "SubClient_Name_Id": "10613"
        },
        {
          "Id": 698,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: STJO_NJ: RCM Support Services",
          "Client_Name_ID": "10613",
          "SubClient_Name": "Cerner: STJO_NJ: RCM Support Services",
          "SubClient_Name_Id": "10613"
        },
        {
          "Id": 699,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Code Helpdesk",
          "SubClient_Name_Id": "10607-7"
        },
        {
          "Id": 700,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services",
          "SubClient_Name_Id": "10607"
        },
        {
          "Id": 701,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services",
          "SubClient_Name_Id": "10591"
        },
        {
          "Id": 702,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Benewah: RCM Support Services",
          "Client_Name_ID": "10591",
          "SubClient_Name": "Cerner: Benewah: RCM Support Services",
          "SubClient_Name_Id": "10591"
        },
        {
          "Id": 703,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services",
          "SubClient_Name_Id": "10610"
        },
        {
          "Id": 704,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services",
          "SubClient_Name_Id": "10604"
        },
        {
          "Id": 705,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Regional West: RCM Support Services",
          "Client_Name_ID": "10610",
          "SubClient_Name": "Cerner: Regional West: RCM Support Services",
          "SubClient_Name_Id": "10610"
        },
        {
          "Id": 706,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services",
          "SubClient_Name_Id": "10604"
        },
        {
          "Id": 707,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Truman: RCM Support Services",
          "Client_Name_ID": "10614",
          "SubClient_Name": "Cerner: Truman: RCM Support Services",
          "SubClient_Name_Id": "10614"
        },
        {
          "Id": 708,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Truman: RCM Support Services",
          "Client_Name_ID": "10614",
          "SubClient_Name": "Cerner: Truman: RCM Support Services",
          "SubClient_Name_Id": "10614"
        },
        {
          "Id": 709,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services",
          "SubClient_Name_Id": "10593"
        },
        {
          "Id": 710,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Acute: RCM Support Services",
          "Client_Name_ID": "10593",
          "SubClient_Name": "Cerner: Centra Acute: RCM Support Services",
          "SubClient_Name_Id": "10593"
        },
        {
          "Id": 711,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "SubClient_Name_Id": "10594"
        },
        {
          "Id": 712,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "Client_Name_ID": "10594",
          "SubClient_Name": "Cerner: Centra Ambulatory: RCM Support Services",
          "SubClient_Name_Id": "10594"
        },
        {
          "Id": 713,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "SubClient_Name_Id": "10585"
        },
        {
          "Id": 714,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "Client_Name_ID": "10585",
          "SubClient_Name": "Cerner: Astria_REGH_WA: RCM Support Services",
          "SubClient_Name_Id": "10585"
        },
        {
          "Id": 715,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10601"
        },
        {
          "Id": 716,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCH_TX: RCM Services",
          "Client_Name_ID": "11051",
          "SubClient_Name": "Cerner: MCH_TX: RCM Services",
          "SubClient_Name_Id": "11051"
        },
        {
          "Id": 717,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Code Helpdesk",
          "SubClient_Name_Id": "10601-8"
        },
        {
          "Id": 718,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCH_TX: RCM Services",
          "Client_Name_ID": "11051",
          "SubClient_Name": "Cerner: MCH_TX: RCM Services",
          "SubClient_Name_Id": "11051"
        },
        {
          "Id": 719,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "SubClient_Name_Id": "10597"
        },
        {
          "Id": 720,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "Client_Name_ID": "10597",
          "SubClient_Name": "Cerner: CHLD_FL: Follow up/Appeals",
          "SubClient_Name_Id": "10597"
        },
        {
          "Id": 721,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Additional Pages",
          "Client_Name_ID": "10587",
          "SubClient_Name": "Cerner: Barnabas: Additional Pages",
          "SubClient_Name_Id": "10587"
        },
        {
          "Id": 722,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ViaChristi: Additional Pages",
          "Client_Name_ID": "10617",
          "SubClient_Name": "Cerner: ViaChristi: Additional Pages",
          "SubClient_Name_Id": "10617"
        },
        {
          "Id": 723,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Additional Pages",
          "Client_Name_ID": "10619",
          "SubClient_Name": "Cerner: Wisdom: Additional Pages",
          "SubClient_Name_Id": "10619"
        },
        {
          "Id": 724,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Auditing Services",
          "Client_Name_ID": "11035",
          "SubClient_Name": "Cerner: Auditing Services",
          "SubClient_Name_Id": "11035"
        },
        {
          "Id": 725,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10600"
        },
        {
          "Id": 726,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10600"
        },
        {
          "Id": 727,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10616"
        },
        {
          "Id": 728,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "Client_Name_ID": "10616",
          "SubClient_Name": "Cerner: VCRM_KS: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10616"
        },
        {
          "Id": 729,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Flexcode OP Ancillary",
          "Client_Name_ID": "10581",
          "SubClient_Name": "Cerner: Flexcode OP Ancillary",
          "SubClient_Name_Id": "10581"
        },
        {
          "Id": 730,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Flexcode OP Ancillary",
          "Client_Name_ID": "10581",
          "SubClient_Name": "Cerner: Flexcode OP Ancillary",
          "SubClient_Name_Id": "10581"
        },
        {
          "Id": 731,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Paper Claims and Appeals",
          "Client_Name_ID": "10590",
          "SubClient_Name": "Cerner: Barnabas: Paper Claims and Appeals",
          "SubClient_Name_Id": "10590"
        },
        {
          "Id": 732,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals",
          "Client_Name_ID": "10618",
          "SubClient_Name": "Cerner: ViaChrsiti: Paper Claims and Appeals",
          "SubClient_Name_Id": "10618"
        },
        {
          "Id": 733,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Paper Claims and Appeals",
          "Client_Name_ID": "10620",
          "SubClient_Name": "Cerner: Wisdom: Paper Claims and Appeals",
          "SubClient_Name_Id": "10620"
        },
        {
          "Id": 734,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services",
          "SubClient_Name_Id": "10621"
        },
        {
          "Id": 735,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - Charge Submission",
          "SubClient_Name_Id": "10621-4"
        },
        {
          "Id": 736,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - Rejections",
          "SubClient_Name_Id": "10621-2"
        },
        {
          "Id": 737,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Steward: AR Follow up",
          "Client_Name_ID": "10612",
          "SubClient_Name": "Cerner: Steward: AR Follow up",
          "SubClient_Name_Id": "10612"
        },
        {
          "Id": 738,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services",
          "SubClient_Name_Id": "10584"
        },
        {
          "Id": 739,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Adventist: RCM Services",
          "Client_Name_ID": "10584",
          "SubClient_Name": "Cerner: Adventist: RCM Services",
          "SubClient_Name_Id": "10584"
        },
        {
          "Id": 740,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: RCM Support Services",
          "Client_Name_ID": "10598",
          "SubClient_Name": "Cerner: CHSI_TN: RCM Support Services",
          "SubClient_Name_Id": "10598"
        },
        {
          "Id": 741,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: JEFF_AR: Payment Posting",
          "Client_Name_ID": "10605",
          "SubClient_Name": "Cerner: JEFF_AR: Payment Posting",
          "SubClient_Name_Id": "10605"
        },
        {
          "Id": 742,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: KSBH_IL: Payment Posting",
          "Client_Name_ID": "10606",
          "SubClient_Name": "Cerner: KSBH_IL: Payment Posting",
          "SubClient_Name_Id": "10606"
        },
        {
          "Id": 743,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - AR",
          "SubClient_Name_Id": "10621-3"
        },
        {
          "Id": 744,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSI_TN: RCM Support Services",
          "Client_Name_ID": "10598",
          "SubClient_Name": "Cerner: CHSI_TN: RCM Support Services",
          "SubClient_Name_Id": "10598"
        },
        {
          "Id": 745,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - AR",
          "SubClient_Name_Id": "10621-3"
        },
        {
          "Id": 746,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Wisdom: Revenue cycle management services",
          "Client_Name_ID": "10621",
          "SubClient_Name": "Cerner: Wisdom: Revenue cycle management services - Payment Posting",
          "SubClient_Name_Id": "10621-1"
        },
        {
          "Id": 747,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10601"
        },
        {
          "Id": 748,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services",
          "SubClient_Name_Id": "10607"
        },
        {
          "Id": 749,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "SubClient_Name_Id": "11036"
        },
        {
          "Id": 750,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: YUMA_CO: Claim Followup/Appeals",
          "Client_Name_ID": "11527",
          "SubClient_Name": "Cerner: YUMA_CO: Claim Followup/Appeals",
          "SubClient_Name_Id": "11527"
        },
        {
          "Id": 751,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: YUMA_CO: Claim Followup/Appeals",
          "Client_Name_ID": "11527",
          "SubClient_Name": "Cerner: YUMA_CO: Claim Followup/Appeals",
          "SubClient_Name_Id": "11527"
        },
        {
          "Id": 752,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "Client_Name_ID": "11428",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory - Self Pay Review",
          "SubClient_Name_Id": "11428-1"
        },
        {
          "Id": 753,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "Client_Name_ID": "11429",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Acute - Self Pay Review",
          "SubClient_Name_Id": "11429-1"
        },
        {
          "Id": 754,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory",
          "Client_Name_ID": "11428",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Ambulatory - Self Pay Review",
          "SubClient_Name_Id": "11428-1"
        },
        {
          "Id": 755,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: ECHA_AL : RCM Support Services - Acute",
          "Client_Name_ID": "11429",
          "SubClient_Name": "Cerner: ECHA_AL : RCM Support Services - Acute - Self Pay Review",
          "SubClient_Name_Id": "11429-1"
        },
        {
          "Id": 756,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Genesis: RCM Support Services",
          "Client_Name_ID": "10604",
          "SubClient_Name": "Cerner: Genesis: RCM Support Services",
          "SubClient_Name_Id": "10604"
        },
        {
          "Id": 757,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner : MCH_TX : RCM Support Services",
          "Client_Name_ID": "11499",
          "SubClient_Name": "Cerner : MCH_TX : RCM Support Services",
          "SubClient_Name_Id": "11499"
        },
        {
          "Id": 758,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner : MCH_TX : RCM Support Services",
          "Client_Name_ID": "11499",
          "SubClient_Name": "Cerner : MCH_TX : RCM Support Services",
          "SubClient_Name_Id": "11499"
        },
        {
          "Id": 759,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Flexcode OP Ancillary",
          "Client_Name_ID": "10581",
          "SubClient_Name": "Cerner: Flexcode OP Ancillary - OP Ancilary",
          "SubClient_Name_Id": "10581-1"
        },
        {
          "Id": 760,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Flexcode OP Ancillary",
          "Client_Name_ID": "10581",
          "SubClient_Name": "Cerner: Flexcode OP Ancillary - OP Ancilary",
          "SubClient_Name_Id": "10581-1"
        },
        {
          "Id": 761,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Crozer: Claims Follow up/Appeals",
          "Client_Name_ID": "10601",
          "SubClient_Name": "Cerner: Crozer: Claims Follow up/Appeals - Code Helpdesk",
          "SubClient_Name_Id": "10601-8"
        },
        {
          "Id": 762,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services",
          "Client_Name_ID": "11036",
          "SubClient_Name": "Cerner: CHSPSC,LLC,CHSI_TN: RCM Support Services - Code Helpdesk",
          "SubClient_Name_Id": "11036-9"
        },
        {
          "Id": 763,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: LifePoint: RCM Support Services",
          "Client_Name_ID": "10607",
          "SubClient_Name": "Cerner: LifePoint: RCM Support Services - Code Helpdesk",
          "SubClient_Name_Id": "10607-7"
        },
        {
          "Id": 764,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up - Appeals/Paper Claims/Fax",
          "SubClient_Name_Id": "10592-3"
        },
        {
          "Id": 765,
          "Original_Client_Name": "Cerner Corporation",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: CAMC_WV: Claims Follow up",
          "Client_Name_ID": "10592",
          "SubClient_Name": "Cerner: CAMC_WV: Claims Follow up - Appeals/Paper Claims/Fax",
          "SubClient_Name_Id": "10592-3"
        },
        {
          "Id": 766,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Emergency Department",
          "Client_Name_ID": "11412",
          "SubClient_Name": "Cerner: MCLD_SC: Emergency Department",
          "SubClient_Name_Id": "11412"
        },
        {
          "Id": 767,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: MCLD_SC: Emergency Department",
          "Client_Name_ID": "11412",
          "SubClient_Name": "Cerner: MCLD_SC: Emergency Department",
          "SubClient_Name_Id": "11412"
        },
        {
          "Id": 768,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balancing and Voiding",
          "Client_Name_ID": "10586",
          "SubClient_Name": "Cerner: Balancing and Voiding",
          "SubClient_Name_Id": "10586"
        },
        {
          "Id": 769,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balancing and Voiding",
          "Client_Name_ID": "10586",
          "SubClient_Name": "Cerner: Balancing and Voiding",
          "SubClient_Name_Id": "10586"
        },
        {
          "Id": 770,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balancing and Voiding",
          "Client_Name_ID": "10586",
          "SubClient_Name": "Cerner: Balancing and Voiding - Credit Balance",
          "SubClient_Name_Id": "10586-1"
        },
        {
          "Id": 771,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Balancing and Voiding",
          "Client_Name_ID": "10586",
          "SubClient_Name": "Cerner: Balancing and Voiding - Credit Balance",
          "SubClient_Name_Id": "10586-1"
        },
        {
          "Id": 772,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10600"
        },
        {
          "Id": 773,
          "Original_Client_Name": "Cerner Corporation - Aurangabad",
          "Original_Client_Name_ID": "99016",
          "Client_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "Client_Name_ID": "10600",
          "SubClient_Name": "Cerner: Barnabas: Claims Follow up/Appeals",
          "SubClient_Name_Id": "10600"
        },
        {
          "Id": 774,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Credit Balance",
          "Client_Name_ID": "10623",
          "SubClient_Name": "CityOfHope: Credit Balance",
          "SubClient_Name_Id": "10623"
        },
        {
          "Id": 775,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Oncology E&M coding inpatient/Outpatient",
          "Client_Name_ID": "11039",
          "SubClient_Name": "CityOfHope: Oncology E&M coding inpatient/Outpatient",
          "SubClient_Name_Id": "11039"
        },
        {
          "Id": 776,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Oncology E&M coding inpatient/Outpatient",
          "Client_Name_ID": "11039",
          "SubClient_Name": "CityOfHope: Oncology E&M coding inpatient/Outpatient",
          "SubClient_Name_Id": "11039"
        },
        {
          "Id": 777,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Credit Balance",
          "Client_Name_ID": "10623",
          "SubClient_Name": "CityOfHope: Credit Balance",
          "SubClient_Name_Id": "10623"
        },
        {
          "Id": 778,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: IP Charges - Coding and Charge Entry",
          "Client_Name_ID": "11040",
          "SubClient_Name": "CityOfHope: IP Charges - Coding and Charge Entry",
          "SubClient_Name_Id": "11040"
        },
        {
          "Id": 779,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: IP Charges - Coding and Charge Entry",
          "Client_Name_ID": "11040",
          "SubClient_Name": "CityOfHope: IP Charges - Coding and Charge Entry",
          "SubClient_Name_Id": "11040"
        },
        {
          "Id": 780,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Credit Balance",
          "Client_Name_ID": "10623",
          "SubClient_Name": "CityOfHope: Credit Balance",
          "SubClient_Name_Id": "10623"
        },
        {
          "Id": 781,
          "Original_Client_Name": "City of Hope Medical Foundation",
          "Original_Client_Name_ID": "99019",
          "Client_Name": "CityOfHope: Credit Balance",
          "Client_Name_ID": "10623",
          "SubClient_Name": "CityOfHope: Credit Balance",
          "SubClient_Name_Id": "10623"
        },
        {
          "Id": 782,
          "Original_Client_Name": "Coding Helpdesk",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Coding Helpdesk",
          "Client_Name_ID": "21008",
          "SubClient_Name": "NonProject: Coding Helpdesk",
          "SubClient_Name_Id": "21008"
        },
        {
          "Id": 783,
          "Original_Client_Name": "Coding Helpdesk",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Coding Helpdesk",
          "Client_Name_ID": "21008",
          "SubClient_Name": "NonProject: Coding Helpdesk",
          "SubClient_Name_Id": "21008"
        },
        {
          "Id": 784,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Appeals Cases",
          "Client_Name_ID": "10629",
          "SubClient_Name": "Collect RX: Appeals Cases",
          "SubClient_Name_Id": "10629"
        },
        {
          "Id": 785,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Appeals Cases",
          "Client_Name_ID": "10629",
          "SubClient_Name": "Collect RX: Appeals Cases",
          "SubClient_Name_Id": "10629"
        },
        {
          "Id": 786,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Appeals Follow Up",
          "Client_Name_ID": "10631",
          "SubClient_Name": "Collect RX: Appeals Follow Up",
          "SubClient_Name_Id": "10631"
        },
        {
          "Id": 787,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Benefits Check",
          "Client_Name_ID": "10633",
          "SubClient_Name": "Collect RX: Benefits Check",
          "SubClient_Name_Id": "10633"
        },
        {
          "Id": 788,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Case Closure",
          "Client_Name_ID": "10635",
          "SubClient_Name": "Collect RX: Case Closure",
          "SubClient_Name_Id": "10635"
        },
        {
          "Id": 789,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CMS1500/UB",
          "Client_Name_ID": "10638",
          "SubClient_Name": "Collect RX: CMS1500/UB",
          "SubClient_Name_Id": "10638"
        },
        {
          "Id": 790,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CMS1500/UB",
          "Client_Name_ID": "10638",
          "SubClient_Name": "Collect RX: CMS1500/UB",
          "SubClient_Name_Id": "10638"
        },
        {
          "Id": 791,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Negotiations Follow Up",
          "Client_Name_ID": "10661",
          "SubClient_Name": "Collect RX: Negotiations Follow Up",
          "SubClient_Name_Id": "10661"
        },
        {
          "Id": 792,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: No Agreement Follow Up",
          "Client_Name_ID": "10662",
          "SubClient_Name": "Collect RX: No Agreement Follow Up",
          "SubClient_Name_Id": "10662"
        },
        {
          "Id": 793,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sign/Fax Back",
          "Client_Name_ID": "10675",
          "SubClient_Name": "Collect RX: Sign/Fax Back",
          "SubClient_Name_Id": "10675"
        },
        {
          "Id": 794,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Case Prep",
          "Client_Name_ID": "10636",
          "SubClient_Name": "Collect RX: Case Prep",
          "SubClient_Name_Id": "10636"
        },
        {
          "Id": 795,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: In-Take Cases",
          "Client_Name_ID": "10654",
          "SubClient_Name": "Collect RX: In-Take Cases",
          "SubClient_Name_Id": "10654"
        },
        {
          "Id": 796,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Negotiation Cases",
          "Client_Name_ID": "10660",
          "SubClient_Name": "Collect RX: Negotiation Cases",
          "SubClient_Name_Id": "10660"
        },
        {
          "Id": 797,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Negotiation Cases",
          "Client_Name_ID": "10660",
          "SubClient_Name": "Collect RX: Negotiation Cases",
          "SubClient_Name_Id": "10660"
        },
        {
          "Id": 798,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Demo",
          "SubClient_Name_Id": "10670-1"
        },
        {
          "Id": 799,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Charge",
          "SubClient_Name_Id": "10670-2"
        },
        {
          "Id": 800,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Payment posting",
          "SubClient_Name_Id": "10670-3"
        },
        {
          "Id": 801,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Rejections",
          "SubClient_Name_Id": "10670-4"
        },
        {
          "Id": 802,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "10644-1"
        },
        {
          "Id": 803,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "10644-2"
        },
        {
          "Id": 804,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Payment posting",
          "SubClient_Name_Id": "10644-3"
        },
        {
          "Id": 805,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Rejections",
          "SubClient_Name_Id": "10644-4"
        },
        {
          "Id": 806,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Demo",
          "SubClient_Name_Id": "10627-1"
        },
        {
          "Id": 807,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Charge",
          "SubClient_Name_Id": "10627-2"
        },
        {
          "Id": 808,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Payment Posting",
          "SubClient_Name_Id": "10627-3"
        },
        {
          "Id": 809,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Rejections",
          "SubClient_Name_Id": "10627-4"
        },
        {
          "Id": 810,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (AR)",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 811,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (Payment)",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 812,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (AR)",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 813,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (Payment)",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 814,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "10644-1"
        },
        {
          "Id": 815,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "10644-2"
        },
        {
          "Id": 816,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Payment posting",
          "SubClient_Name_Id": "10644-3"
        },
        {
          "Id": 817,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10644",
          "SubClient_Name": "Collect RX: DL/Provecta: Demo, Charge, Payment posting & Rejections - Rejections",
          "SubClient_Name_Id": "10644-4"
        },
        {
          "Id": 818,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB : Demo, Charge, Payment posting and Rejections",
          "Client_Name_ID": "10655",
          "SubClient_Name": "Collect RX: NB : Demo, Charge, Payment posting and Rejections - Payment posting",
          "SubClient_Name_Id": "10655-3"
        },
        {
          "Id": 819,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Payment posting",
          "SubClient_Name_Id": "10670-3"
        },
        {
          "Id": 820,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: AR Follow:up",
          "Client_Name_ID": "10643",
          "SubClient_Name": "Collect RX: DL/Provecta: AR Follow:up",
          "SubClient_Name_Id": "10643"
        },
        {
          "Id": 821,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB: AR Followup",
          "Client_Name_ID": "10657",
          "SubClient_Name": "Collect RX: NB: AR Followup",
          "SubClient_Name_Id": "10657"
        },
        {
          "Id": 822,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: AR Follow:up",
          "Client_Name_ID": "10669",
          "SubClient_Name": "Collect RX: PP: AR Follow:up",
          "SubClient_Name_Id": "10669"
        },
        {
          "Id": 823,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "SubClient_Name_Id": "10627"
        },
        {
          "Id": 824,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: AR Follow up",
          "Client_Name_ID": "10626",
          "SubClient_Name": "Collect RX: Advance OSO: AR Follow up",
          "SubClient_Name_Id": "10626"
        },
        {
          "Id": 825,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DL/Provecta: AR Follow:up",
          "Client_Name_ID": "10643",
          "SubClient_Name": "Collect RX: DL/Provecta: AR Follow:up",
          "SubClient_Name_Id": "10643"
        },
        {
          "Id": 826,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Box Follow-up",
          "Client_Name_ID": "10634",
          "SubClient_Name": "Collect RX: Box Follow-up",
          "SubClient_Name_Id": "10634"
        },
        {
          "Id": 827,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "SubClient_Name_Id": "11020"
        },
        {
          "Id": 828,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "SubClient_Name_Id": "10665"
        },
        {
          "Id": 829,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up - AR Follow-up",
          "SubClient_Name_Id": "10664"
        },
        {
          "Id": 830,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up - HCFA",
          "SubClient_Name_Id": "10665-1"
        },
        {
          "Id": 831,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up - Additional Pages",
          "SubClient_Name_Id": "10665-2"
        },
        {
          "Id": 832,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - HCFA",
          "SubClient_Name_Id": "11020-1"
        },
        {
          "Id": 833,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Additional Pages",
          "SubClient_Name_Id": "11020-2"
        },
        {
          "Id": 834,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up - HCFA",
          "SubClient_Name_Id": "10664-1"
        },
        {
          "Id": 835,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up - Additional Pages",
          "SubClient_Name_Id": "10664-2"
        },
        {
          "Id": 836,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "SubClient_Name_Id": "11020"
        },
        {
          "Id": 837,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up - AR Follow-up",
          "SubClient_Name_Id": "10665"
        },
        {
          "Id": 838,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "SubClient_Name_Id": "10664"
        },
        {
          "Id": 839,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Demo",
          "SubClient_Name_Id": "11020-1"
        },
        {
          "Id": 840,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Charge",
          "SubClient_Name_Id": "11020-2"
        },
        {
          "Id": 841,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Rejections",
          "SubClient_Name_Id": "11020-4"
        },
        {
          "Id": 842,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Payment Posting",
          "SubClient_Name_Id": "11020-3"
        },
        {
          "Id": 843,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up - HCFA",
          "SubClient_Name_Id": "10665-1"
        },
        {
          "Id": 844,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up",
          "Client_Name_ID": "10665",
          "SubClient_Name": "Collect RX: Nobilis Health Bellaire: AR Follow:up - Additional Pages",
          "SubClient_Name_Id": "10665-2"
        },
        {
          "Id": 845,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - HCFA",
          "SubClient_Name_Id": "11020-1"
        },
        {
          "Id": 846,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Riverwalk Ranch: AR Follow-up",
          "Client_Name_ID": "11020",
          "SubClient_Name": "Collect RX: Riverwalk Ranch: AR Follow-up - Additional Pages",
          "SubClient_Name_Id": "11020-2"
        },
        {
          "Id": 847,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up - HCFA",
          "SubClient_Name_Id": "10664-1"
        },
        {
          "Id": 848,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up",
          "Client_Name_ID": "10664",
          "SubClient_Name": "Collect RX: Nobilis Health ASCs: AR Follow:up - Additional Pages",
          "SubClient_Name_Id": "10664-2"
        },
        {
          "Id": 849,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "SubClient_Name_Id": "10641"
        },
        {
          "Id": 850,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: AR Follow up",
          "Client_Name_ID": "10639",
          "SubClient_Name": "Collect RX: CT: AR Follow up",
          "SubClient_Name_Id": "10639"
        },
        {
          "Id": 851,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: AR Specialist",
          "Client_Name_ID": "10632",
          "SubClient_Name": "Collect RX: AR Specialist",
          "SubClient_Name_Id": "10632"
        },
        {
          "Id": 852,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: AR Follow up",
          "Client_Name_ID": "10639",
          "SubClient_Name": "Collect RX: CT: AR Follow up",
          "SubClient_Name_Id": "10639"
        },
        {
          "Id": 853,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: AR Specialist",
          "Client_Name_ID": "10632",
          "SubClient_Name": "Collect RX: AR Specialist",
          "SubClient_Name_Id": "10632"
        },
        {
          "Id": 854,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "SubClient_Name_Id": "10653"
        },
        {
          "Id": 855,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Demo",
          "SubClient_Name_Id": "10653-1"
        },
        {
          "Id": 856,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Charge",
          "SubClient_Name_Id": "10653-2"
        },
        {
          "Id": 857,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Payment",
          "SubClient_Name_Id": "10653-3"
        },
        {
          "Id": 858,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Rejection",
          "SubClient_Name_Id": "10653-4"
        },
        {
          "Id": 859,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: AR Follow up",
          "Client_Name_ID": "10652",
          "SubClient_Name": "Collect RX: GMS: AR Follow up",
          "SubClient_Name_Id": "10652"
        },
        {
          "Id": 860,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Charge",
          "SubClient_Name_Id": "10641-1"
        },
        {
          "Id": 861,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Payment",
          "SubClient_Name_Id": "10641-2"
        },
        {
          "Id": 862,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Rejections",
          "SubClient_Name_Id": "10641-3"
        },
        {
          "Id": 863,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Data Entry",
          "Client_Name_ID": "10640",
          "SubClient_Name": "Collect RX: CT: Data Entry",
          "SubClient_Name_Id": "10640"
        },
        {
          "Id": 864,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Prime MSO: AR Follow up",
          "Client_Name_ID": "10673",
          "SubClient_Name": "Collect RX: Prime MSO: AR Follow up",
          "SubClient_Name_Id": "10673"
        },
        {
          "Id": 865,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Demo",
          "SubClient_Name_Id": "10653-1"
        },
        {
          "Id": 866,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Charge",
          "SubClient_Name_Id": "10653-2"
        },
        {
          "Id": 867,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Payment",
          "SubClient_Name_Id": "10653-3"
        },
        {
          "Id": 868,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej.",
          "Client_Name_ID": "10653",
          "SubClient_Name": "Collect RX: GMS: Demo, Charge, Payment & Rej. - Rejection",
          "SubClient_Name_Id": "10653-4"
        },
        {
          "Id": 869,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS: AR Follow up",
          "Client_Name_ID": "10652",
          "SubClient_Name": "Collect RX: GMS: AR Follow up",
          "SubClient_Name_Id": "10652"
        },
        {
          "Id": 870,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Charge",
          "SubClient_Name_Id": "10641-1"
        },
        {
          "Id": 871,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Payment",
          "SubClient_Name_Id": "10641-2"
        },
        {
          "Id": 872,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections - Rejections",
          "SubClient_Name_Id": "10641-3"
        },
        {
          "Id": 873,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Data Entry",
          "Client_Name_ID": "10640",
          "SubClient_Name": "Collect RX: CT: Data Entry",
          "SubClient_Name_Id": "10640"
        },
        {
          "Id": 874,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Extremity Health: AR Follow:up",
          "Client_Name_ID": "10649",
          "SubClient_Name": "Collect RX: Extremity Health: AR Follow:up",
          "SubClient_Name_Id": "10649"
        },
        {
          "Id": 875,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Extremity Health: AR Follow:up",
          "Client_Name_ID": "10649",
          "SubClient_Name": "Collect RX: Extremity Health: AR Follow:up",
          "SubClient_Name_Id": "10649"
        },
        {
          "Id": 876,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Paper Claims",
          "SubClient_Name_Id": "10670-5"
        },
        {
          "Id": 877,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB : Demo, Charge, Payment posting and Rejections",
          "Client_Name_ID": "10655",
          "SubClient_Name": "Collect RX: NB : Demo, Charge, Payment posting and Rejections - Paper Claims",
          "SubClient_Name_Id": "10655-5"
        },
        {
          "Id": 878,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "SubClient_Name_Id": "10666"
        },
        {
          "Id": 879,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: AR Follow up",
          "Client_Name_ID": "10626",
          "SubClient_Name": "Collect RX: Advance OSO: AR Follow up",
          "SubClient_Name_Id": "10626"
        },
        {
          "Id": 880,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Demo",
          "SubClient_Name_Id": "10627-1"
        },
        {
          "Id": 881,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Charge",
          "SubClient_Name_Id": "10627-2"
        },
        {
          "Id": 882,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Payment Posting",
          "SubClient_Name_Id": "10627-3"
        },
        {
          "Id": 883,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Rejections",
          "SubClient_Name_Id": "10627-4"
        },
        {
          "Id": 884,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Paper Claims",
          "SubClient_Name_Id": "10627-5"
        },
        {
          "Id": 885,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - Payment Posting",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 886,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - Paper Claims",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 887,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - Payment Posting",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 888,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - Paper Claims",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 889,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11236-1"
        },
        {
          "Id": 890,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11236-2"
        },
        {
          "Id": 891,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11236-3"
        },
        {
          "Id": 892,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Rejection",
          "SubClient_Name_Id": "11236-4"
        },
        {
          "Id": 893,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: AR Follow up",
          "Client_Name_ID": "11235",
          "SubClient_Name": "Collect RX: Desert Rose: AR Follow up",
          "SubClient_Name_Id": "11235"
        },
        {
          "Id": 894,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11236-1"
        },
        {
          "Id": 895,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11236-2"
        },
        {
          "Id": 896,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11236-3"
        },
        {
          "Id": 897,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11236",
          "SubClient_Name": "Collect RX: Desert Rose: Demo, Charge, Payment & Rejections - Rejection",
          "SubClient_Name_Id": "11236-4"
        },
        {
          "Id": 898,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Desert Rose: AR Follow up",
          "Client_Name_ID": "11235",
          "SubClient_Name": "Collect RX: Desert Rose: AR Follow up",
          "SubClient_Name_Id": "11235"
        },
        {
          "Id": 899,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS: Patient Statements",
          "Client_Name_ID": "11240",
          "SubClient_Name": "Collect RX: SS: Patient Statements",
          "SubClient_Name_Id": "11240"
        },
        {
          "Id": 900,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS: Patient Statements",
          "Client_Name_ID": "11240",
          "SubClient_Name": "Collect RX: SS: Patient Statements",
          "SubClient_Name_Id": "11240"
        },
        {
          "Id": 901,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Additional Pages",
          "Client_Name_ID": "10625",
          "SubClient_Name": "Collect RX: Advance OSO: Additional Pages",
          "SubClient_Name_Id": "10625"
        },
        {
          "Id": 902,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT - Patient Statements",
          "Client_Name_ID": "11080",
          "SubClient_Name": "Collect RX: CT - Patient Statements",
          "SubClient_Name_Id": "11080"
        },
        {
          "Id": 903,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - AR Followup",
          "Client_Name_ID": "11116",
          "SubClient_Name": "Collect RX: OSC - AR Followup",
          "SubClient_Name_Id": "11116"
        },
        {
          "Id": 904,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CBC: AR Follow up",
          "Client_Name_ID": "11295",
          "SubClient_Name": "Collect RX: CBC: AR Follow up",
          "SubClient_Name_Id": "11295"
        },
        {
          "Id": 905,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CBC: AR Follow up",
          "Client_Name_ID": "11295",
          "SubClient_Name": "Collect RX: CBC: AR Follow up",
          "SubClient_Name_Id": "11295"
        },
        {
          "Id": 906,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections",
          "Client_Name_ID": "10627",
          "SubClient_Name": "Collect RX: Advance OSO: Demo, Charge, Payment Posting and Rejections - Paper Claims",
          "SubClient_Name_Id": "10627-5"
        },
        {
          "Id": 907,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "Client_Name_ID": "10641",
          "SubClient_Name": "Collect RX: CT: Demo, Charge, Payment and Rejections",
          "SubClient_Name_Id": "10641"
        },
        {
          "Id": 908,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP: HCFA",
          "Client_Name_ID": "11390",
          "SubClient_Name": "Collect RX: SP: HCFA",
          "SubClient_Name_Id": "11390"
        },
        {
          "Id": 909,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP: HCFA",
          "Client_Name_ID": "11390",
          "SubClient_Name": "Collect RX: SP: HCFA",
          "SubClient_Name_Id": "11390"
        },
        {
          "Id": 910,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP: Additional pages",
          "Client_Name_ID": "11391",
          "SubClient_Name": "Collect RX: SP: Additional pages",
          "SubClient_Name_Id": "11391"
        },
        {
          "Id": 911,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP: Additional pages",
          "Client_Name_ID": "11391",
          "SubClient_Name": "Collect RX: SP: Additional pages",
          "SubClient_Name_Id": "11391"
        },
        {
          "Id": 912,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: HCFA",
          "Client_Name_ID": "11392",
          "SubClient_Name": "Collect RX: EEPOS: HCFA",
          "SubClient_Name_Id": "11392"
        },
        {
          "Id": 913,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: HCFA",
          "Client_Name_ID": "11392",
          "SubClient_Name": "Collect RX: EEPOS: HCFA",
          "SubClient_Name_Id": "11392"
        },
        {
          "Id": 914,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: Additional pages",
          "Client_Name_ID": "11393",
          "SubClient_Name": "Collect RX: EEPOS: Additional pages",
          "SubClient_Name_Id": "11393"
        },
        {
          "Id": 915,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: Additional pages",
          "Client_Name_ID": "11393",
          "SubClient_Name": "Collect RX: EEPOS: Additional pages",
          "SubClient_Name_Id": "11393"
        },
        {
          "Id": 916,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: Patient statements",
          "Client_Name_ID": "11394",
          "SubClient_Name": "Collect RX: EEPOS: Patient statements",
          "SubClient_Name_Id": "11394"
        },
        {
          "Id": 917,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: EEPOS: Patient statements",
          "Client_Name_ID": "11394",
          "SubClient_Name": "Collect RX: EEPOS: Patient statements",
          "SubClient_Name_Id": "11394"
        },
        {
          "Id": 918,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Intake/Appeal/Negotiation Cases",
          "Client_Name_ID": "11395",
          "SubClient_Name": "Collect RX: Intake/Appeal/Negotiation Cases",
          "SubClient_Name_Id": "11395"
        },
        {
          "Id": 919,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Intake/Appeal/Negotiation Cases",
          "Client_Name_ID": "11395",
          "SubClient_Name": "Collect RX: Intake/Appeal/Negotiation Cases",
          "SubClient_Name_Id": "11395"
        },
        {
          "Id": 920,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC AR Follow up",
          "Client_Name_ID": "11179",
          "SubClient_Name": "Collect RX: PSC AR Follow up",
          "SubClient_Name_Id": "11179"
        },
        {
          "Id": 921,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC AR Follow up",
          "Client_Name_ID": "11179",
          "SubClient_Name": "Collect RX: PSC AR Follow up",
          "SubClient_Name_Id": "11179"
        },
        {
          "Id": 922,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Payment",
          "SubClient_Name_Id": "11337-3"
        },
        {
          "Id": 923,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Rejections",
          "SubClient_Name_Id": "11337-4"
        },
        {
          "Id": 924,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Demo",
          "SubClient_Name_Id": "11337-1"
        },
        {
          "Id": 925,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Charge",
          "SubClient_Name_Id": "11337-2"
        },
        {
          "Id": 926,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Payment",
          "SubClient_Name_Id": "11337-3"
        },
        {
          "Id": 927,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Rejections",
          "SubClient_Name_Id": "11337-4"
        },
        {
          "Id": 928,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Tower: Payment posting",
          "Client_Name_ID": "11338",
          "SubClient_Name": "Collect RX: Tower: Payment posting",
          "SubClient_Name_Id": "11338"
        },
        {
          "Id": 929,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Tower: Payment posting",
          "Client_Name_ID": "11338",
          "SubClient_Name": "Collect RX: Tower: Payment posting",
          "SubClient_Name_Id": "11338"
        },
        {
          "Id": 930,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Demo",
          "SubClient_Name_Id": "11337-1"
        },
        {
          "Id": 931,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11337",
          "SubClient_Name": "Collect RX: Empire/Elite/Premier/Omega/Supernova: Demo, Charge, Payment & Rejections-Charge",
          "SubClient_Name_Id": "11337-2"
        },
        {
          "Id": 932,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Lab",
          "Client_Name_ID": "11166",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Lab",
          "SubClient_Name_Id": "11166"
        },
        {
          "Id": 933,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Lab",
          "Client_Name_ID": "11166",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Lab",
          "SubClient_Name_Id": "11166"
        },
        {
          "Id": 934,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Anesthesia",
          "Client_Name_ID": "11022",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Anesthesia",
          "SubClient_Name_Id": "11022"
        },
        {
          "Id": 935,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Anesthesia",
          "Client_Name_ID": "11022",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Anesthesia",
          "SubClient_Name_Id": "11022"
        },
        {
          "Id": 936,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (AR)",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 937,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (Payment)",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 938,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (AR)",
          "SubClient_Name_Id": "10666-1"
        },
        {
          "Id": 939,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up",
          "Client_Name_ID": "10666",
          "SubClient_Name": "Collect RX: Plastic Head & Surgery institute: AR Follow:up - (Payment)",
          "SubClient_Name_Id": "10666-2"
        },
        {
          "Id": 940,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Demo",
          "SubClient_Name_Id": "11023-1"
        },
        {
          "Id": 941,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Charge",
          "SubClient_Name_Id": "11023-2"
        },
        {
          "Id": 942,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Payment",
          "SubClient_Name_Id": "11023-3"
        },
        {
          "Id": 943,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Rejections",
          "SubClient_Name_Id": "11023-4"
        },
        {
          "Id": 944,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Demo",
          "SubClient_Name_Id": "11023-1"
        },
        {
          "Id": 945,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Charge",
          "SubClient_Name_Id": "11023-2"
        },
        {
          "Id": 946,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection - Payment",
          "SubClient_Name_Id": "11023-3"
        },
        {
          "Id": 947,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "Client_Name_ID": "11023",
          "SubClient_Name": "Collect RX: SS - Demo, Charge, Payment & Rejection",
          "SubClient_Name_Id": "11023"
        },
        {
          "Id": 948,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "11083-1"
        },
        {
          "Id": 949,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "11083-2"
        },
        {
          "Id": 950,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Payment",
          "SubClient_Name_Id": "11083-3"
        },
        {
          "Id": 951,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Rejection",
          "SubClient_Name_Id": "11083-4"
        },
        {
          "Id": 952,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "SubClient_Name_Id": "11083"
        },
        {
          "Id": 953,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "11119-1"
        },
        {
          "Id": 954,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "11119-2"
        },
        {
          "Id": 955,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Payment",
          "SubClient_Name_Id": "11119-3"
        },
        {
          "Id": 956,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Rejection",
          "SubClient_Name_Id": "11119-4"
        },
        {
          "Id": 957,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "SubClient_Name_Id": "11119"
        },
        {
          "Id": 958,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "11083-1"
        },
        {
          "Id": 959,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "11083-2"
        },
        {
          "Id": 960,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Payment",
          "SubClient_Name_Id": "11083-3"
        },
        {
          "Id": 961,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections - Rejection",
          "SubClient_Name_Id": "11083-4"
        },
        {
          "Id": 962,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11083",
          "SubClient_Name": "Collect RX: OSC - Demo, Charge, Payment posting & Rejections",
          "SubClient_Name_Id": "11083"
        },
        {
          "Id": 963,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Demo",
          "SubClient_Name_Id": "11119-1"
        },
        {
          "Id": 964,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Charge",
          "SubClient_Name_Id": "11119-2"
        },
        {
          "Id": 965,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Payment",
          "SubClient_Name_Id": "11119-3"
        },
        {
          "Id": 966,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections - Rejection",
          "SubClient_Name_Id": "11119-4"
        },
        {
          "Id": 967,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "11119",
          "SubClient_Name": "Collect RX: SP - Demo, Charge, Payment posting & Rejections",
          "SubClient_Name_Id": "11119"
        },
        {
          "Id": 968,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Specialty Surgery - AR Follow-up",
          "Client_Name_ID": "11021",
          "SubClient_Name": "Collect RX: Specialty Surgery - AR Follow-up",
          "SubClient_Name_Id": "11021"
        },
        {
          "Id": 969,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Implementation - Data Entry",
          "Client_Name_ID": "11047",
          "SubClient_Name": "Collect RX: Implementation - Data Entry",
          "SubClient_Name_Id": "11047"
        },
        {
          "Id": 970,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Negotiations Follow Up",
          "Client_Name_ID": "10661",
          "SubClient_Name": "Collect RX: Negotiations Follow Up",
          "SubClient_Name_Id": "10661"
        },
        {
          "Id": 971,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT - Additional Pages",
          "Client_Name_ID": "11078",
          "SubClient_Name": "Collect RX: CT - Additional Pages",
          "SubClient_Name_Id": "11078"
        },
        {
          "Id": 972,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: CT - HCFA",
          "Client_Name_ID": "11079",
          "SubClient_Name": "Collect RX: CT - HCFA",
          "SubClient_Name_Id": "11079"
        },
        {
          "Id": 973,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DD - Additional Pages",
          "Client_Name_ID": "11194",
          "SubClient_Name": "Collect RX: DD - Additional Pages",
          "SubClient_Name_Id": "11194"
        },
        {
          "Id": 974,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS - Patient Statements",
          "Client_Name_ID": "11195",
          "SubClient_Name": "Collect RX: GMS - Patient Statements",
          "SubClient_Name_Id": "11195"
        },
        {
          "Id": 975,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Clinic",
          "Client_Name_ID": "11196",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Clinic",
          "SubClient_Name_Id": "11196"
        },
        {
          "Id": 976,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DD - Additional Pages",
          "Client_Name_ID": "11194",
          "SubClient_Name": "Collect RX: DD - Additional Pages",
          "SubClient_Name_Id": "11194"
        },
        {
          "Id": 977,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: GMS - Patient Statements",
          "Client_Name_ID": "11195",
          "SubClient_Name": "Collect RX: GMS - Patient Statements",
          "SubClient_Name_Id": "11195"
        },
        {
          "Id": 978,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - AR Follow up - Clinic",
          "Client_Name_ID": "11196",
          "SubClient_Name": "Collect RX: PPoA - AR Follow up - Clinic",
          "SubClient_Name_Id": "11196"
        },
        {
          "Id": 979,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sign/Fax Back (Client/Payor)",
          "Client_Name_ID": "11163",
          "SubClient_Name": "Collect RX: Sign/Fax Back (Client/Payor)",
          "SubClient_Name_Id": "11163"
        },
        {
          "Id": 980,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sign/Fax Back (Client/Payor)",
          "Client_Name_ID": "11163",
          "SubClient_Name": "Collect RX: Sign/Fax Back (Client/Payor)",
          "SubClient_Name_Id": "11163"
        },
        {
          "Id": 981,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DD - AR Followup",
          "Client_Name_ID": "11120",
          "SubClient_Name": "Collect RX: DD - AR Followup",
          "SubClient_Name_Id": "11120"
        },
        {
          "Id": 982,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - AR Followup",
          "Client_Name_ID": "11118",
          "SubClient_Name": "Collect RX: SP - AR Followup",
          "SubClient_Name_Id": "11118"
        },
        {
          "Id": 983,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - AR Followup",
          "Client_Name_ID": "11116",
          "SubClient_Name": "Collect RX: OSC - AR Followup",
          "SubClient_Name_Id": "11116"
        },
        {
          "Id": 984,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PPoA - Additional pages",
          "Client_Name_ID": "11117",
          "SubClient_Name": "Collect RX: PPoA - Additional pages",
          "SubClient_Name_Id": "11117"
        },
        {
          "Id": 985,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Demo",
          "SubClient_Name_Id": "11150-1"
        },
        {
          "Id": 986,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Charge",
          "SubClient_Name_Id": "11150-2"
        },
        {
          "Id": 987,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Payment Posting",
          "SubClient_Name_Id": "11150-3"
        },
        {
          "Id": 988,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Rejection",
          "SubClient_Name_Id": "11150-4"
        },
        {
          "Id": 989,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: DD - AR Followup",
          "Client_Name_ID": "11120",
          "SubClient_Name": "Collect RX: DD - AR Followup",
          "SubClient_Name_Id": "11120"
        },
        {
          "Id": 990,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: SP - AR Followup",
          "Client_Name_ID": "11118",
          "SubClient_Name": "Collect RX: SP - AR Followup",
          "SubClient_Name_Id": "11118"
        },
        {
          "Id": 991,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: OSC - AR Followup",
          "Client_Name_ID": "11116",
          "SubClient_Name": "Collect RX: OSC - AR Followup",
          "SubClient_Name_Id": "11116"
        },
        {
          "Id": 992,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Demo",
          "SubClient_Name_Id": "11150-1"
        },
        {
          "Id": 993,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Charge",
          "SubClient_Name_Id": "11150-2"
        },
        {
          "Id": 994,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Payment Posting",
          "SubClient_Name_Id": "11150-3"
        },
        {
          "Id": 995,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections",
          "Client_Name_ID": "11150",
          "SubClient_Name": "Collect RX: PSC : Demo, Charge, Payment Posting & Rejections - Rejection",
          "SubClient_Name_Id": "11150-4"
        },
        {
          "Id": 996,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Tier 1 Staffing",
          "Client_Name_ID": "11419",
          "SubClient_Name": "Collect RX: Tier 1 Staffing",
          "SubClient_Name_Id": "11419"
        },
        {
          "Id": 997,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Tier 1 Staffing",
          "Client_Name_ID": "11419",
          "SubClient_Name": "Collect RX: Tier 1 Staffing",
          "SubClient_Name_Id": "11419"
        },
        {
          "Id": 998,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Reporting",
          "Client_Name_ID": "11324",
          "SubClient_Name": "Collect RX: Reporting",
          "SubClient_Name_Id": "11324"
        },
        {
          "Id": 999,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB: HCFA",
          "Client_Name_ID": "10658",
          "SubClient_Name": "Collect RX: NB: HCFA",
          "SubClient_Name_Id": "10658"
        },
        {
          "Id": 1000,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB: Additional Pages",
          "Client_Name_ID": "10656",
          "SubClient_Name": "Collect RX: NB: Additional Pages",
          "SubClient_Name_Id": "10656"
        },
        {
          "Id": 1001,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: NB: Patient Statements",
          "Client_Name_ID": "10659",
          "SubClient_Name": "Collect RX: NB: Patient Statements",
          "SubClient_Name_Id": "10659"
        },
        {
          "Id": 1002,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Patient statements",
          "Client_Name_ID": "11474",
          "SubClient_Name": "Collect RX: BF&A: Patient statements",
          "SubClient_Name_Id": "11474"
        },
        {
          "Id": 1003,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Patient statements",
          "Client_Name_ID": "11474",
          "SubClient_Name": "Collect RX: BF&A: Patient statements",
          "SubClient_Name_Id": "11474"
        },
        {
          "Id": 1004,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Patient statements",
          "Client_Name_ID": "11475",
          "SubClient_Name": "Collect RX: Camelback: Patient statements",
          "SubClient_Name_Id": "11475"
        },
        {
          "Id": 1005,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Patient statements",
          "Client_Name_ID": "11475",
          "SubClient_Name": "Collect RX: Camelback: Patient statements",
          "SubClient_Name_Id": "11475"
        },
        {
          "Id": 1006,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Patient statements",
          "Client_Name_ID": "11476",
          "SubClient_Name": "Collect RX: Sonali Lal: Patient statements",
          "SubClient_Name_Id": "11476"
        },
        {
          "Id": 1007,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Patient statements",
          "Client_Name_ID": "11476",
          "SubClient_Name": "Collect RX: Sonali Lal: Patient statements",
          "SubClient_Name_Id": "11476"
        },
        {
          "Id": 1008,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11416-1"
        },
        {
          "Id": 1009,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11416-2"
        },
        {
          "Id": 1010,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11416-3"
        },
        {
          "Id": 1011,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11416-4"
        },
        {
          "Id": 1012,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11417-1"
        },
        {
          "Id": 1013,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11417-2"
        },
        {
          "Id": 1014,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11417-3"
        },
        {
          "Id": 1015,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11417-4"
        },
        {
          "Id": 1016,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11418-1"
        },
        {
          "Id": 1017,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11418-2"
        },
        {
          "Id": 1018,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11418-3"
        },
        {
          "Id": 1019,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11418-4"
        },
        {
          "Id": 1020,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11416-1"
        },
        {
          "Id": 1021,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11416-2"
        },
        {
          "Id": 1022,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11416-3"
        },
        {
          "Id": 1023,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11416",
          "SubClient_Name": "Collect RX: BF&A: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11416-4"
        },
        {
          "Id": 1024,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11417-1"
        },
        {
          "Id": 1025,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11417-2"
        },
        {
          "Id": 1026,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11417-3"
        },
        {
          "Id": 1027,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11417",
          "SubClient_Name": "Collect RX: Camelback: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11417-4"
        },
        {
          "Id": 1028,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Demo",
          "SubClient_Name_Id": "11418-1"
        },
        {
          "Id": 1029,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Charge",
          "SubClient_Name_Id": "11418-2"
        },
        {
          "Id": 1030,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Payment",
          "SubClient_Name_Id": "11418-3"
        },
        {
          "Id": 1031,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11418",
          "SubClient_Name": "Collect RX: Sonali Lal: Demo, Charge, Payment & Rejections - Rejections",
          "SubClient_Name_Id": "11418-4"
        },
        {
          "Id": 1032,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: UHC Online Appeals",
          "Client_Name_ID": "11520",
          "SubClient_Name": "Collect RX: UHC Online Appeals",
          "SubClient_Name_Id": "11520"
        },
        {
          "Id": 1033,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: UHC Online Appeals",
          "Client_Name_ID": "11520",
          "SubClient_Name": "Collect RX: UHC Online Appeals",
          "SubClient_Name_Id": "11520"
        },
        {
          "Id": 1034,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Implementation - Data Entry",
          "Client_Name_ID": "11047",
          "SubClient_Name": "Collect RX: Implementation - Data Entry",
          "SubClient_Name_Id": "11047"
        },
        {
          "Id": 1035,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections",
          "Client_Name_ID": "10670",
          "SubClient_Name": "Collect RX: PP: Demo, Charge, Payment posting & Rejections - Demo - Paper Claims",
          "SubClient_Name_Id": "10670-5"
        },
        {
          "Id": 1036,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Vitalus: Payment posting",
          "Client_Name_ID": "11624",
          "SubClient_Name": "Collect RX: Vitalus: Payment posting",
          "SubClient_Name_Id": "11624"
        },
        {
          "Id": 1037,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Vitalus: Payment posting",
          "Client_Name_ID": "11624",
          "SubClient_Name": "Collect RX: Vitalus: Payment posting",
          "SubClient_Name_Id": "11624"
        },
        {
          "Id": 1038,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11625",
          "SubClient_Name": "Collect RX: Valley Pain: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11625"
        },
        {
          "Id": 1039,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11625",
          "SubClient_Name": "Collect RX: Valley Pain: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11625"
        },
        {
          "Id": 1040,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: Patient statements",
          "Client_Name_ID": "11621",
          "SubClient_Name": "Collect RX: Valley Pain: Patient statements",
          "SubClient_Name_Id": "11621"
        },
        {
          "Id": 1041,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: Patient statements",
          "Client_Name_ID": "11621",
          "SubClient_Name": "Collect RX: Valley Pain: Patient statements",
          "SubClient_Name_Id": "11621"
        },
        {
          "Id": 1042,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Prime surgical center: AR Follow up",
          "Client_Name_ID": "11647",
          "SubClient_Name": "Collect RX: Prime surgical center: AR Follow up",
          "SubClient_Name_Id": "11647"
        },
        {
          "Id": 1043,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Prime surgical center: AR Follow up",
          "Client_Name_ID": "11647",
          "SubClient_Name": "Collect RX: Prime surgical center: AR Follow up",
          "SubClient_Name_Id": "11647"
        },
        {
          "Id": 1044,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Appeals Follow Up",
          "Client_Name_ID": "10631",
          "SubClient_Name": "Collect RX: Appeals Follow Up",
          "SubClient_Name_Id": "10631"
        },
        {
          "Id": 1045,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Benefits Check",
          "Client_Name_ID": "10633",
          "SubClient_Name": "Collect RX: Benefits Check",
          "SubClient_Name_Id": "10633"
        },
        {
          "Id": 1046,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Box Follow-up",
          "Client_Name_ID": "10634",
          "SubClient_Name": "Collect RX: Box Follow-up",
          "SubClient_Name_Id": "10634"
        },
        {
          "Id": 1047,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Case Closure",
          "Client_Name_ID": "10635",
          "SubClient_Name": "Collect RX: Case Closure",
          "SubClient_Name_Id": "10635"
        },
        {
          "Id": 1048,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: In-Take Cases",
          "Client_Name_ID": "10654",
          "SubClient_Name": "Collect RX: In-Take Cases",
          "SubClient_Name_Id": "10654"
        },
        {
          "Id": 1049,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: No Agreement Follow Up",
          "Client_Name_ID": "10662",
          "SubClient_Name": "Collect RX: No Agreement Follow Up",
          "SubClient_Name_Id": "10662"
        },
        {
          "Id": 1050,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Sign/Fax Back",
          "Client_Name_ID": "10675",
          "SubClient_Name": "Collect RX: Sign/Fax Back",
          "SubClient_Name_Id": "10675"
        },
        {
          "Id": 1051,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC : Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11538",
          "SubClient_Name": "Collect RX: ASTC : Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11538"
        },
        {
          "Id": 1052,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC : Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11538",
          "SubClient_Name": "Collect RX: ASTC : Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11538"
        },
        {
          "Id": 1053,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: HCFA",
          "Client_Name_ID": "11594",
          "SubClient_Name": "Collect RX: ASTC: HCFA",
          "SubClient_Name_Id": "11594"
        },
        {
          "Id": 1054,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: HCFA",
          "Client_Name_ID": "11594",
          "SubClient_Name": "Collect RX: ASTC: HCFA",
          "SubClient_Name_Id": "11594"
        },
        {
          "Id": 1055,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: Additional Pages",
          "Client_Name_ID": "11595",
          "SubClient_Name": "Collect RX: ASTC: Additional Pages",
          "SubClient_Name_Id": "11595"
        },
        {
          "Id": 1056,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: Additional Pages",
          "Client_Name_ID": "11595",
          "SubClient_Name": "Collect RX: ASTC: Additional Pages",
          "SubClient_Name_Id": "11595"
        },
        {
          "Id": 1057,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11685",
          "SubClient_Name": "Collect RX: RSAT: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11685"
        },
        {
          "Id": 1058,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11685",
          "SubClient_Name": "Collect RX: RSAT: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11685"
        },
        {
          "Id": 1059,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Patient statements",
          "Client_Name_ID": "11693",
          "SubClient_Name": "Collect RX: RSAT: Patient statements",
          "SubClient_Name_Id": "11693"
        },
        {
          "Id": 1060,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Patient statements",
          "Client_Name_ID": "11693",
          "SubClient_Name": "Collect RX: RSAT: Patient statements",
          "SubClient_Name_Id": "11693"
        },
        {
          "Id": 1061,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: HCFA",
          "Client_Name_ID": "11694",
          "SubClient_Name": "Collect RX: RSAT: HCFA",
          "SubClient_Name_Id": "11694"
        },
        {
          "Id": 1062,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: HCFA",
          "Client_Name_ID": "11694",
          "SubClient_Name": "Collect RX: RSAT: HCFA",
          "SubClient_Name_Id": "11694"
        },
        {
          "Id": 1063,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Additional Pages",
          "Client_Name_ID": "11695",
          "SubClient_Name": "Collect RX: RSAT: Additional Pages",
          "SubClient_Name_Id": "11695"
        },
        {
          "Id": 1064,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: RSAT: Additional Pages",
          "Client_Name_ID": "11695",
          "SubClient_Name": "Collect RX: RSAT: Additional Pages",
          "SubClient_Name_Id": "11695"
        },
        {
          "Id": 1065,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: AR Follow up",
          "Client_Name_ID": "11717",
          "SubClient_Name": "Collect RX: Valley Pain: AR Follow up",
          "SubClient_Name_Id": "11717"
        },
        {
          "Id": 1066,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: Valley Pain: AR Follow up",
          "Client_Name_ID": "11717",
          "SubClient_Name": "Collect RX: Valley Pain: AR Follow up",
          "SubClient_Name_Id": "11717"
        },
        {
          "Id": 1067,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: AR Follow up",
          "Client_Name_ID": "11718",
          "SubClient_Name": "Collect RX: ASTC: AR Follow up",
          "SubClient_Name_Id": "11718"
        },
        {
          "Id": 1068,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: ASTC: AR Follow up",
          "Client_Name_ID": "11718",
          "SubClient_Name": "Collect RX: ASTC: AR Follow up",
          "SubClient_Name_Id": "11718"
        },
        {
          "Id": 1069,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: FBMC: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11719",
          "SubClient_Name": "Collect RX: FBMC: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11719"
        },
        {
          "Id": 1070,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: FBMC: Demo, Charge, Payment & Rejections",
          "Client_Name_ID": "11719",
          "SubClient_Name": "Collect RX: FBMC: Demo, Charge, Payment & Rejections",
          "SubClient_Name_Id": "11719"
        },
        {
          "Id": 1071,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC SC of AZ - AR Follow up",
          "Client_Name_ID": "11238",
          "SubClient_Name": "Collect RX: PSC SC of AZ - AR Follow up",
          "SubClient_Name_Id": "11238"
        },
        {
          "Id": 1072,
          "Original_Client_Name": "Collect RX, Inc.",
          "Original_Client_Name_ID": "99021",
          "Client_Name": "Collect RX: PSC SC of AZ - AR Follow up",
          "Client_Name_ID": "11238",
          "SubClient_Name": "Collect RX: PSC SC of AZ - AR Follow up",
          "SubClient_Name_Id": "11238"
        },
        {
          "Id": 1073,
          "Original_Client_Name": "Community Health Plan of Washington",
          "Original_Client_Name_ID": "99115",
          "Client_Name": "CHPW : Global Claims Validation",
          "Client_Name_ID": "11539",
          "SubClient_Name": "CHPW : Global Claims Validation",
          "SubClient_Name_Id": "11539"
        },
        {
          "Id": 1074,
          "Original_Client_Name": "Community Health Plan of Washington",
          "Original_Client_Name_ID": "99115",
          "Client_Name": "CHPW : Global Coding",
          "Client_Name_ID": "11540",
          "SubClient_Name": "CHPW : Global Coding",
          "SubClient_Name_Id": "11540"
        },
        {
          "Id": 1075,
          "Original_Client_Name": "Community Health Plan of Washington",
          "Original_Client_Name_ID": "99115",
          "Client_Name": "CHPW : Global Claims Validation",
          "Client_Name_ID": "11539",
          "SubClient_Name": "CHPW : Global Claims Validation",
          "SubClient_Name_Id": "11539"
        },
        {
          "Id": 1076,
          "Original_Client_Name": "Community Health Plan of Washington",
          "Original_Client_Name_ID": "99115",
          "Client_Name": "CHPW : Global Coding",
          "Client_Name_ID": "11540",
          "SubClient_Name": "CHPW : Global Coding",
          "SubClient_Name_Id": "11540"
        },
        {
          "Id": 1077,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: ERA Edits Process",
          "Client_Name_ID": "10679",
          "SubClient_Name": "Conifer: ERA Edits Process",
          "SubClient_Name_Id": "10679"
        },
        {
          "Id": 1078,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Patient Registration Entry",
          "Client_Name_ID": "10681",
          "SubClient_Name": "Conifer: Patient Registration Entry",
          "SubClient_Name_Id": "10681"
        },
        {
          "Id": 1079,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Payment Month End Closing",
          "Client_Name_ID": "10682",
          "SubClient_Name": "Conifer: Payment Month End Closing",
          "SubClient_Name_Id": "10682"
        },
        {
          "Id": 1080,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Barnabas: Patient Registration Entry",
          "Client_Name_ID": "10677",
          "SubClient_Name": "Conifer: Barnabas: Patient Registration Entry",
          "SubClient_Name_Id": "10677"
        },
        {
          "Id": 1081,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Barnabas: Patient Registration Entry",
          "Client_Name_ID": "10677",
          "SubClient_Name": "Conifer: Barnabas: Patient Registration Entry",
          "SubClient_Name_Id": "10677"
        },
        {
          "Id": 1082,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: ERA Edits Process",
          "Client_Name_ID": "10679",
          "SubClient_Name": "Conifer: ERA Edits Process",
          "SubClient_Name_Id": "10679"
        },
        {
          "Id": 1083,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Manual Payment Posting",
          "Client_Name_ID": "10680",
          "SubClient_Name": "Conifer: Manual Payment Posting",
          "SubClient_Name_Id": "10680"
        },
        {
          "Id": 1084,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Manual Payment Posting",
          "Client_Name_ID": "10680",
          "SubClient_Name": "Conifer: Manual Payment Posting",
          "SubClient_Name_Id": "10680"
        },
        {
          "Id": 1085,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Patient Registration Entry",
          "Client_Name_ID": "10681",
          "SubClient_Name": "Conifer: Patient Registration Entry",
          "SubClient_Name_Id": "10681"
        },
        {
          "Id": 1086,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Payment Month End Closing",
          "Client_Name_ID": "10682",
          "SubClient_Name": "Conifer: Payment Month End Closing",
          "SubClient_Name_Id": "10682"
        },
        {
          "Id": 1087,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Transplant Surgery",
          "Client_Name_ID": "11055",
          "SubClient_Name": "Conifer: Transplant Surgery",
          "SubClient_Name_Id": "11055"
        },
        {
          "Id": 1088,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Family Practice",
          "Client_Name_ID": "11049",
          "SubClient_Name": "Conifer: Family Practice",
          "SubClient_Name_Id": "11049"
        },
        {
          "Id": 1089,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Peds ED",
          "Client_Name_ID": "11048",
          "SubClient_Name": "Conifer: Peds ED",
          "SubClient_Name_Id": "11048"
        },
        {
          "Id": 1090,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Peds ED",
          "Client_Name_ID": "11048",
          "SubClient_Name": "Conifer: Peds ED",
          "SubClient_Name_Id": "11048"
        },
        {
          "Id": 1091,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: AR Contingency",
          "Client_Name_ID": "11109",
          "SubClient_Name": "Conifer: AR Contingency",
          "SubClient_Name_Id": "11109"
        },
        {
          "Id": 1092,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: AR Contingency",
          "Client_Name_ID": "11109",
          "SubClient_Name": "Conifer: AR Contingency",
          "SubClient_Name_Id": "11109"
        },
        {
          "Id": 1093,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Credit Balance",
          "Client_Name_ID": "10678",
          "SubClient_Name": "Conifer: Credit Balance",
          "SubClient_Name_Id": "10678"
        },
        {
          "Id": 1094,
          "Original_Client_Name": "Conifer Health Solutions",
          "Original_Client_Name_ID": "99022",
          "Client_Name": "Conifer: Credit Balance",
          "Client_Name_ID": "10678",
          "SubClient_Name": "Conifer: Credit Balance",
          "SubClient_Name_Id": "10678"
        },
        {
          "Id": 1095,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR Staffing Services",
          "Client_Name_ID": "10686",
          "SubClient_Name": "Continuum: AR Staffing Services",
          "SubClient_Name_Id": "10686"
        },
        {
          "Id": 1096,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Denials",
          "Client_Name_ID": "10697",
          "SubClient_Name": "Continuum: Denials",
          "SubClient_Name_Id": "10697"
        },
        {
          "Id": 1097,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response",
          "SubClient_Name_Id": "10685"
        },
        {
          "Id": 1098,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR Staffing Services",
          "Client_Name_ID": "10686",
          "SubClient_Name": "Continuum: AR Staffing Services",
          "SubClient_Name_Id": "10686"
        },
        {
          "Id": 1099,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Credit Balance",
          "Client_Name_ID": "10695",
          "SubClient_Name": "Continuum: Credit Balance",
          "SubClient_Name_Id": "10695"
        },
        {
          "Id": 1100,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Credit Balance",
          "Client_Name_ID": "10695",
          "SubClient_Name": "Continuum: Credit Balance",
          "SubClient_Name_Id": "10695"
        },
        {
          "Id": 1101,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: TES Edits",
          "Client_Name_ID": "10714",
          "SubClient_Name": "Continuum: TES Edits",
          "SubClient_Name_Id": "10714"
        },
        {
          "Id": 1102,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: EKG",
          "Client_Name_ID": "10698",
          "SubClient_Name": "Continuum: EKG",
          "SubClient_Name_Id": "10698"
        },
        {
          "Id": 1103,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Vascular Surgery",
          "Client_Name_ID": "10718",
          "SubClient_Name": "Continuum: Vascular Surgery",
          "SubClient_Name_Id": "10718"
        },
        {
          "Id": 1104,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Vascular E/M",
          "Client_Name_ID": "10716",
          "SubClient_Name": "Continuum: Vascular E/M",
          "SubClient_Name_Id": "10716"
        },
        {
          "Id": 1105,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Neurology E/M",
          "Client_Name_ID": "10705",
          "SubClient_Name": "Continuum: Neurology E/M",
          "SubClient_Name_Id": "10705"
        },
        {
          "Id": 1106,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Neurology Surgery",
          "Client_Name_ID": "10707",
          "SubClient_Name": "Continuum: Neurology Surgery",
          "SubClient_Name_Id": "10707"
        },
        {
          "Id": 1107,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response",
          "SubClient_Name_Id": "10685"
        },
        {
          "Id": 1108,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting",
          "Client_Name_ID": "10710",
          "SubClient_Name": "Continuum: Payment Posting",
          "SubClient_Name_Id": "10710"
        },
        {
          "Id": 1109,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Claim Edit",
          "Client_Name_ID": "10692",
          "SubClient_Name": "Continuum: Claim Edit",
          "SubClient_Name_Id": "10692"
        },
        {
          "Id": 1110,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Charge Entry",
          "Client_Name_ID": "10691",
          "SubClient_Name": "Continuum: Charge Entry",
          "SubClient_Name_Id": "10691"
        },
        {
          "Id": 1111,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Denials",
          "Client_Name_ID": "10697",
          "SubClient_Name": "Continuum: Denials - Adfinitas Denials",
          "SubClient_Name_Id": "10697-1"
        },
        {
          "Id": 1112,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Denials",
          "Client_Name_ID": "10697",
          "SubClient_Name": "Continuum: Denials - Atlanticare Denials",
          "SubClient_Name_Id": "10697-2"
        },
        {
          "Id": 1113,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Adfinitas AR",
          "SubClient_Name_Id": "10685-1"
        },
        {
          "Id": 1114,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Correspondence",
          "SubClient_Name_Id": "10685-2"
        },
        {
          "Id": 1115,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Appeals",
          "SubClient_Name_Id": "10685-3"
        },
        {
          "Id": 1116,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response -Atlanticare AR",
          "SubClient_Name_Id": "10685-4"
        },
        {
          "Id": 1117,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Denials",
          "Client_Name_ID": "10697",
          "SubClient_Name": "Continuum: Denials - Adfinitas Denials",
          "SubClient_Name_Id": "10697-1"
        },
        {
          "Id": 1118,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Denials",
          "Client_Name_ID": "10697",
          "SubClient_Name": "Continuum: Denials - Atlanticare Denials",
          "SubClient_Name_Id": "10697-2"
        },
        {
          "Id": 1119,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Adfinitas AR",
          "SubClient_Name_Id": "10685-1"
        },
        {
          "Id": 1120,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Correspondence",
          "SubClient_Name_Id": "10685-2"
        },
        {
          "Id": 1121,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response - Appeals",
          "SubClient_Name_Id": "10685-3"
        },
        {
          "Id": 1122,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: AR No Response",
          "Client_Name_ID": "10685",
          "SubClient_Name": "Continuum: AR No Response -Atlanticare AR",
          "SubClient_Name_Id": "10685-4"
        },
        {
          "Id": 1123,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Charge Entry",
          "Client_Name_ID": "10700",
          "SubClient_Name": "Continuum: GE Centricity: Charge Entry",
          "SubClient_Name_Id": "10700"
        },
        {
          "Id": 1124,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Practice Suite: Charge Entry",
          "Client_Name_ID": "10713",
          "SubClient_Name": "Continuum: Practice Suite: Charge Entry",
          "SubClient_Name_Id": "10713"
        },
        {
          "Id": 1125,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Charge Entry",
          "Client_Name_ID": "10700",
          "SubClient_Name": "Continuum: GE Centricity: Charge Entry",
          "SubClient_Name_Id": "10700"
        },
        {
          "Id": 1126,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Practice Suite: Charge Entry",
          "Client_Name_ID": "10713",
          "SubClient_Name": "Continuum: Practice Suite: Charge Entry",
          "SubClient_Name_Id": "10713"
        },
        {
          "Id": 1127,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Vascular E/M",
          "Client_Name_ID": "10716",
          "SubClient_Name": "Continuum: Vascular E/M",
          "SubClient_Name_Id": "10716"
        },
        {
          "Id": 1128,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IRV: AR Staffing Services",
          "Client_Name_ID": "10702",
          "SubClient_Name": "Continuum: IRV: AR Staffing Services",
          "SubClient_Name_Id": "10702"
        },
        {
          "Id": 1129,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IRV: AR Staffing Services",
          "Client_Name_ID": "10702",
          "SubClient_Name": "Continuum: IRV: AR Staffing Services",
          "SubClient_Name_Id": "10702"
        },
        {
          "Id": 1130,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Denials",
          "Client_Name_ID": "10688",
          "SubClient_Name": "Continuum: Astra: Denials",
          "SubClient_Name_Id": "10688"
        },
        {
          "Id": 1131,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: AR No Response",
          "Client_Name_ID": "10687",
          "SubClient_Name": "Continuum: Astra: AR No Response",
          "SubClient_Name_Id": "10687"
        },
        {
          "Id": 1132,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Wind Down AR",
          "Client_Name_ID": "10690",
          "SubClient_Name": "Continuum: Astra: Wind Down AR",
          "SubClient_Name_Id": "10690"
        },
        {
          "Id": 1133,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Denials",
          "Client_Name_ID": "10688",
          "SubClient_Name": "Continuum: Astra: Denials",
          "SubClient_Name_Id": "10688"
        },
        {
          "Id": 1134,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: AR No Response",
          "Client_Name_ID": "10687",
          "SubClient_Name": "Continuum: Astra: AR No Response",
          "SubClient_Name_Id": "10687"
        },
        {
          "Id": 1135,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Wind Down AR",
          "Client_Name_ID": "10690",
          "SubClient_Name": "Continuum: Astra: Wind Down AR",
          "SubClient_Name_Id": "10690"
        },
        {
          "Id": 1136,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IM Bills",
          "Client_Name_ID": "11069",
          "SubClient_Name": "Continuum: IM Bills",
          "SubClient_Name_Id": "11069"
        },
        {
          "Id": 1137,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IM Bills",
          "Client_Name_ID": "11069",
          "SubClient_Name": "Continuum: IM Bills",
          "SubClient_Name_Id": "11069"
        },
        {
          "Id": 1138,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Coding Denial",
          "Client_Name_ID": "11303",
          "SubClient_Name": "Continuum: Coding Denial",
          "SubClient_Name_Id": "11303"
        },
        {
          "Id": 1139,
          "Original_Client_Name": "Continuum Health Alliance, LLC",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Coding Denial",
          "Client_Name_ID": "11303",
          "SubClient_Name": "Continuum: Coding Denial",
          "SubClient_Name_Id": "11303"
        },
        {
          "Id": 1140,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Charge Entry",
          "Client_Name_ID": "10700",
          "SubClient_Name": "Continuum: GE Centricity: Charge Entry",
          "SubClient_Name_Id": "10700"
        },
        {
          "Id": 1141,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Charge Entry",
          "Client_Name_ID": "10700",
          "SubClient_Name": "Continuum: GE Centricity: Charge Entry",
          "SubClient_Name_Id": "10700"
        },
        {
          "Id": 1142,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Payment Posting",
          "Client_Name_ID": "10689",
          "SubClient_Name": "Continuum: Astra: Payment Posting",
          "SubClient_Name_Id": "10689"
        },
        {
          "Id": 1143,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Astra: Payment Posting",
          "Client_Name_ID": "10689",
          "SubClient_Name": "Continuum: Astra: Payment Posting",
          "SubClient_Name_Id": "10689"
        },
        {
          "Id": 1144,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Charge Entry",
          "Client_Name_ID": "10691",
          "SubClient_Name": "Continuum: Charge Entry",
          "SubClient_Name_Id": "10691"
        },
        {
          "Id": 1145,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting (Copay)",
          "Client_Name_ID": "10711",
          "SubClient_Name": "Continuum: Payment Posting (Copay)",
          "SubClient_Name_Id": "10711"
        },
        {
          "Id": 1146,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting",
          "Client_Name_ID": "10710",
          "SubClient_Name": "Continuum: Payment Posting",
          "SubClient_Name_Id": "10710"
        },
        {
          "Id": 1147,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting (Copay)",
          "Client_Name_ID": "10711",
          "SubClient_Name": "Continuum: Payment Posting (Copay)",
          "SubClient_Name_Id": "10711"
        },
        {
          "Id": 1148,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting",
          "Client_Name_ID": "10710",
          "SubClient_Name": "Continuum: Payment Posting",
          "SubClient_Name_Id": "10710"
        },
        {
          "Id": 1149,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Patient Registration",
          "Client_Name_ID": "10701",
          "SubClient_Name": "Continuum: GE Centricity: Patient Registration",
          "SubClient_Name_Id": "10701"
        },
        {
          "Id": 1150,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: GE Centricity: Patient Registration",
          "Client_Name_ID": "10701",
          "SubClient_Name": "Continuum: GE Centricity: Patient Registration",
          "SubClient_Name_Id": "10701"
        },
        {
          "Id": 1151,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting",
          "Client_Name_ID": "10710",
          "SubClient_Name": "Continuum: Payment Posting",
          "SubClient_Name_Id": "10710"
        },
        {
          "Id": 1152,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Claim Edit",
          "Client_Name_ID": "10692",
          "SubClient_Name": "Continuum: Claim Edit",
          "SubClient_Name_Id": "10692"
        },
        {
          "Id": 1153,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Charge Entry",
          "Client_Name_ID": "10691",
          "SubClient_Name": "Continuum: Charge Entry",
          "SubClient_Name_Id": "10691"
        },
        {
          "Id": 1154,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Payment Posting",
          "Client_Name_ID": "10710",
          "SubClient_Name": "Continuum: Payment Posting",
          "SubClient_Name_Id": "10710"
        },
        {
          "Id": 1155,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Aurangabad",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: Claim Edit",
          "Client_Name_ID": "10692",
          "SubClient_Name": "Continuum: Claim Edit",
          "SubClient_Name_Id": "10692"
        },
        {
          "Id": 1156,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Manila",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IVR: Online Benefits Verification",
          "Client_Name_ID": "10703",
          "SubClient_Name": "Continuum: IVR: Online Benefits Verification",
          "SubClient_Name_Id": "10703"
        },
        {
          "Id": 1157,
          "Original_Client_Name": "Continuum Health Alliance, LLC - Manila",
          "Original_Client_Name_ID": "99023",
          "Client_Name": "Continuum: IVR: Online Benefits Verification",
          "Client_Name_ID": "10703",
          "SubClient_Name": "Continuum: IVR: Online Benefits Verification",
          "SubClient_Name_Id": "10703"
        },
        {
          "Id": 1158,
          "Original_Client_Name": "DaVita Medical Services, LLC.",
          "Original_Client_Name_ID": "99024",
          "Client_Name": "DaVita: Professional Fee Coding Review",
          "Client_Name_ID": "10720",
          "SubClient_Name": "DaVita: Professional Fee Coding Review",
          "SubClient_Name_Id": "10720"
        },
        {
          "Id": 1159,
          "Original_Client_Name": "DaVita Medical Services, LLC.",
          "Original_Client_Name_ID": "99024",
          "Client_Name": "DaVita: Professional Fee Coding Review",
          "Client_Name_ID": "10720",
          "SubClient_Name": "DaVita: Professional Fee Coding Review",
          "SubClient_Name_Id": "10720"
        },
        {
          "Id": 1160,
          "Original_Client_Name": "DaVita Medical Services, LLC.",
          "Original_Client_Name_ID": "99024",
          "Client_Name": "DaVita: ACO Coding",
          "Client_Name_ID": "11162",
          "SubClient_Name": "DaVita: ACO Coding",
          "SubClient_Name_Id": "11162"
        },
        {
          "Id": 1161,
          "Original_Client_Name": "DaVita Medical Services, LLC.",
          "Original_Client_Name_ID": "99024",
          "Client_Name": "DaVita: ACO Coding",
          "Client_Name_ID": "11162",
          "SubClient_Name": "DaVita: ACO Coding",
          "SubClient_Name_Id": "11162"
        },
        {
          "Id": 1162,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Accounts Receivable Claim Status Services Client System",
          "Client_Name_ID": "11532",
          "SubClient_Name": "DCA: Accounts Receivable Claim Status Services  Client System",
          "SubClient_Name_Id": "11532"
        },
        {
          "Id": 1163,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Accounts Receivable Claim Status Services Client System",
          "Client_Name_ID": "11532",
          "SubClient_Name": "DCA: Accounts Receivable Claim Status Services  Client System",
          "SubClient_Name_Id": "11532"
        },
        {
          "Id": 1164,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Accounts Receivable Claim Status Services Excel Spreadsheet",
          "Client_Name_ID": "11533",
          "SubClient_Name": "DCA: Accounts Receivable Claim Status Services  Excel Spreadsheet",
          "SubClient_Name_Id": "11533"
        },
        {
          "Id": 1165,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Accounts Receivable Claim Status Services Excel Spreadsheet",
          "Client_Name_ID": "11533",
          "SubClient_Name": "DCA: Accounts Receivable Claim Status Services  Excel Spreadsheet",
          "SubClient_Name_Id": "11533"
        },
        {
          "Id": 1166,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11588",
          "SubClient_Name": "DCA: Payment/Cash Posting (Manual)",
          "SubClient_Name_Id": "11588"
        },
        {
          "Id": 1167,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11588",
          "SubClient_Name": "DCA: Payment/Cash Posting (Manual)",
          "SubClient_Name_Id": "11588"
        },
        {
          "Id": 1168,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Payment/Cash Posting (ERA)",
          "Client_Name_ID": "11589",
          "SubClient_Name": "DCA: Payment/Cash Posting (ERA)",
          "SubClient_Name_Id": "11589"
        },
        {
          "Id": 1169,
          "Original_Client_Name": "Dental Care Alliance, LLC.",
          "Original_Client_Name_ID": "99114",
          "Client_Name": "DCA: Payment/Cash Posting (ERA)",
          "Client_Name_ID": "11589",
          "SubClient_Name": "DCA: Payment/Cash Posting (ERA)",
          "SubClient_Name_Id": "11589"
        },
        {
          "Id": 1170,
          "Original_Client_Name": "Director",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 1171,
          "Original_Client_Name": "Director",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 1172,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Accounts Receivable Services",
          "Client_Name_ID": "10748",
          "SubClient_Name": "EMMG: Accounts Receivable Services",
          "SubClient_Name_Id": "10748"
        },
        {
          "Id": 1173,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Accounts Receivable Services",
          "Client_Name_ID": "10748",
          "SubClient_Name": "EMMG: Accounts Receivable Services",
          "SubClient_Name_Id": "10748"
        },
        {
          "Id": 1174,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Charge",
          "SubClient_Name_Id": "10750-1"
        },
        {
          "Id": 1175,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Demo",
          "SubClient_Name_Id": "10750-2"
        },
        {
          "Id": 1176,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Charge",
          "SubClient_Name_Id": "10750-1"
        },
        {
          "Id": 1177,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Demo",
          "SubClient_Name_Id": "10750-2"
        },
        {
          "Id": 1178,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Correspondences",
          "Client_Name_ID": "10749",
          "SubClient_Name": "EMMG: Correspondences",
          "SubClient_Name_Id": "10749"
        },
        {
          "Id": 1179,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Correspondences",
          "Client_Name_ID": "10749",
          "SubClient_Name": "EMMG: Correspondences",
          "SubClient_Name_Id": "10749"
        },
        {
          "Id": 1180,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: AR winddown services (Allscript System)",
          "Client_Name_ID": "11177",
          "SubClient_Name": "EMMG: AR winddown services (Allscript System)",
          "SubClient_Name_Id": "11177"
        },
        {
          "Id": 1181,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: AR winddown services (Allscript System)",
          "Client_Name_ID": "11177",
          "SubClient_Name": "EMMG: AR winddown services (Allscript System)",
          "SubClient_Name_Id": "11177"
        },
        {
          "Id": 1182,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: AR winddown services",
          "Client_Name_ID": "11178",
          "SubClient_Name": "EMMG: AR winddown services",
          "SubClient_Name_Id": "11178"
        },
        {
          "Id": 1183,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: AR winddown services",
          "Client_Name_ID": "11178",
          "SubClient_Name": "EMMG: AR winddown services",
          "SubClient_Name_Id": "11178"
        },
        {
          "Id": 1184,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: AR Follow up (Contingency)",
          "Client_Name_ID": "11332",
          "SubClient_Name": "EMMG: AR Follow up (Contingency)",
          "SubClient_Name_Id": "11332"
        },
        {
          "Id": 1185,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Accounts Receivable Services",
          "Client_Name_ID": "10748",
          "SubClient_Name": "EMMG: Accounts Receivable Services - Code Helpdesk",
          "SubClient_Name_Id": "10748-1"
        },
        {
          "Id": 1186,
          "Original_Client_Name": "East Meadow Management Group, LLC",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Accounts Receivable Services",
          "Client_Name_ID": "10748",
          "SubClient_Name": "EMMG: Accounts Receivable Services - Code Helpdesk",
          "SubClient_Name_Id": "10748-1"
        },
        {
          "Id": 1187,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Charge Entry",
          "Client_Name_ID": "11294",
          "SubClient_Name": "EMMG: Charge Entry",
          "SubClient_Name_Id": "11294"
        },
        {
          "Id": 1188,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Charge Entry",
          "Client_Name_ID": "11294",
          "SubClient_Name": "EMMG: Charge Entry",
          "SubClient_Name_Id": "11294"
        },
        {
          "Id": 1189,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting (ERA)",
          "Client_Name_ID": "11189",
          "SubClient_Name": "EMMG: Payment Posting (ERA)",
          "SubClient_Name_Id": "11189"
        },
        {
          "Id": 1190,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting (Manual)",
          "Client_Name_ID": "11190",
          "SubClient_Name": "EMMG: Payment Posting (Manual)",
          "SubClient_Name_Id": "11190"
        },
        {
          "Id": 1191,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting (ERA)",
          "Client_Name_ID": "11189",
          "SubClient_Name": "EMMG: Payment Posting (ERA)",
          "SubClient_Name_Id": "11189"
        },
        {
          "Id": 1192,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting (Manual)",
          "Client_Name_ID": "11190",
          "SubClient_Name": "EMMG: Payment Posting (Manual)",
          "SubClient_Name_Id": "11190"
        },
        {
          "Id": 1193,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Charge",
          "SubClient_Name_Id": "10750-1"
        },
        {
          "Id": 1194,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Data Entry",
          "Client_Name_ID": "10750",
          "SubClient_Name": "EMMG: Data Entry - Charge",
          "SubClient_Name_Id": "10750-1"
        },
        {
          "Id": 1195,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Write-Offs",
          "Client_Name_ID": "10752",
          "SubClient_Name": "EMMG: Write-Offs",
          "SubClient_Name_Id": "10752"
        },
        {
          "Id": 1196,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting",
          "Client_Name_ID": "10751",
          "SubClient_Name": "EMMG: Payment Posting",
          "SubClient_Name_Id": "10751"
        },
        {
          "Id": 1197,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Write-Offs",
          "Client_Name_ID": "10752",
          "SubClient_Name": "EMMG: Write-Offs",
          "SubClient_Name_Id": "10752"
        },
        {
          "Id": 1198,
          "Original_Client_Name": "East Meadow Management Group, LLC - Aurangabad",
          "Original_Client_Name_ID": "99025",
          "Client_Name": "EMMG: Payment Posting",
          "Client_Name_ID": "10751",
          "SubClient_Name": "EMMG: Payment Posting",
          "SubClient_Name_Id": "10751"
        },
        {
          "Id": 1199,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: E&M Audit",
          "Client_Name_ID": "10740",
          "SubClient_Name": "EmCare/RTI: E&M Audit",
          "SubClient_Name_Id": "10740"
        },
        {
          "Id": 1200,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1201,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Neonatology Coding",
          "Client_Name_ID": "10745",
          "SubClient_Name": "EmCare/RTI: Neonatology Coding",
          "SubClient_Name_Id": "10745"
        },
        {
          "Id": 1202,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1203,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: E&M Audit",
          "Client_Name_ID": "10740",
          "SubClient_Name": "EmCare/RTI: E&M Audit",
          "SubClient_Name_Id": "10740"
        },
        {
          "Id": 1204,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1205,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Neonatology Coding",
          "Client_Name_ID": "10745",
          "SubClient_Name": "EmCare/RTI: Neonatology Coding",
          "SubClient_Name_Id": "10745"
        },
        {
          "Id": 1206,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Neonatology Coding",
          "Client_Name_ID": "10745",
          "SubClient_Name": "EmCare/RTI: Neonatology Coding",
          "SubClient_Name_Id": "10745"
        },
        {
          "Id": 1207,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Neonatology Coding",
          "Client_Name_ID": "10745",
          "SubClient_Name": "EmCare/RTI: Neonatology Coding",
          "SubClient_Name_Id": "10745"
        },
        {
          "Id": 1208,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1209,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1210,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1211,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Coding",
          "Client_Name_ID": "10722",
          "SubClient_Name": "EmCare/RTI: Anesthesia Coding",
          "SubClient_Name_Id": "10722"
        },
        {
          "Id": 1212,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Coding",
          "Client_Name_ID": "10722",
          "SubClient_Name": "EmCare/RTI: Anesthesia Coding",
          "SubClient_Name_Id": "10722"
        },
        {
          "Id": 1213,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1214,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1215,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia AR Follow up services",
          "Client_Name_ID": "10721",
          "SubClient_Name": "EmCare/RTI: Anesthesia AR Follow up services",
          "SubClient_Name_Id": "10721"
        },
        {
          "Id": 1216,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia AR Follow up services",
          "Client_Name_ID": "10721",
          "SubClient_Name": "EmCare/RTI: Anesthesia AR Follow up services",
          "SubClient_Name_Id": "10721"
        },
        {
          "Id": 1217,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Assembly & Prepping",
          "Client_Name_ID": "10728",
          "SubClient_Name": "EmCare/RTI: Assembly & Prepping - assembly",
          "SubClient_Name_Id": "10728 -1"
        },
        {
          "Id": 1218,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up",
          "Client_Name_ID": "10724",
          "SubClient_Name": "EmCare/RTI: AR Follow up",
          "SubClient_Name_Id": "10724"
        },
        {
          "Id": 1219,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up",
          "Client_Name_ID": "10724",
          "SubClient_Name": "EmCare/RTI: AR Follow up",
          "SubClient_Name_Id": "10724"
        },
        {
          "Id": 1220,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1221,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1222,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: E&M Audit",
          "Client_Name_ID": "10740",
          "SubClient_Name": "EmCare/RTI: E&M Audit",
          "SubClient_Name_Id": "10740"
        },
        {
          "Id": 1223,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: E&M Audit",
          "Client_Name_ID": "10740",
          "SubClient_Name": "EmCare/RTI: E&M Audit",
          "SubClient_Name_Id": "10740"
        },
        {
          "Id": 1224,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1225,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1226,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1227,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1228,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1229,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1230,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1231,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation - No More Work",
          "SubClient_Name_Id": "10739-1"
        },
        {
          "Id": 1232,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Insurance Information Updating Services",
          "Client_Name_ID": "10741",
          "SubClient_Name": "EmCare/RTI: Insurance Information Updating Services - No More Work",
          "SubClient_Name_Id": "10741-1"
        },
        {
          "Id": 1233,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "SubClient_Name_Id": "10736"
        },
        {
          "Id": 1234,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "SubClient_Name_Id": "10736"
        },
        {
          "Id": 1235,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation - No More Work",
          "SubClient_Name_Id": "10739_1"
        },
        {
          "Id": 1236,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1237,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1238,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1239,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1240,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1241,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1242,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1243,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1244,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Assembly & Prepping",
          "Client_Name_ID": "10728",
          "SubClient_Name": "EmCare/RTI: Assembly & Prepping",
          "SubClient_Name_Id": "10728"
        },
        {
          "Id": 1245,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Assembly & Prepping",
          "Client_Name_ID": "10728",
          "SubClient_Name": "EmCare/RTI: Assembly & Prepping - assembly",
          "SubClient_Name_Id": "10728 -1"
        },
        {
          "Id": 1246,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Assembly & Prepping",
          "Client_Name_ID": "10728",
          "SubClient_Name": "EmCare/RTI: Assembly & Prepping - prepping",
          "SubClient_Name_Id": "10728 -2"
        },
        {
          "Id": 1247,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation",
          "SubClient_Name_Id": "10739"
        },
        {
          "Id": 1248,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation",
          "SubClient_Name_Id": "10739"
        },
        {
          "Id": 1249,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Insurance Information Updating Services",
          "Client_Name_ID": "10741",
          "SubClient_Name": "EmCare/RTI: Insurance Information Updating Services",
          "SubClient_Name_Id": "10741"
        },
        {
          "Id": 1250,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Insurance Information Updating Services",
          "Client_Name_ID": "10741",
          "SubClient_Name": "EmCare/RTI: Insurance Information Updating Services",
          "SubClient_Name_Id": "10741"
        },
        {
          "Id": 1251,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia AR - claim edits",
          "Client_Name_ID": "11164",
          "SubClient_Name": "EmCare/RTI: Anesthesia AR - claim edits",
          "SubClient_Name_Id": "11164"
        },
        {
          "Id": 1252,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Manual",
          "SubClient_Name_Id": "11165-1"
        },
        {
          "Id": 1253,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - ERA",
          "SubClient_Name_Id": "11165-2"
        },
        {
          "Id": 1254,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Manual",
          "SubClient_Name_Id": "11165-1"
        },
        {
          "Id": 1255,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - ERA",
          "SubClient_Name_Id": "11165-2"
        },
        {
          "Id": 1256,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Backlog",
          "SubClient_Name_Id": "10726-3"
        },
        {
          "Id": 1257,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Backlog",
          "SubClient_Name_Id": "10727-3"
        },
        {
          "Id": 1258,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Backlog",
          "SubClient_Name_Id": "10737-3"
        },
        {
          "Id": 1259,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Backlog",
          "SubClient_Name_Id": "10738-3"
        },
        {
          "Id": 1260,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1261,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "Client_Name_ID": "10725",
          "SubClient_Name": "EmCare/RTI: AR Follow up 360+ Legacy",
          "SubClient_Name_Id": "10725"
        },
        {
          "Id": 1262,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: POP Charge Entry",
          "Client_Name_ID": "11333",
          "SubClient_Name": "EmCare/RTI: POP Charge Entry",
          "SubClient_Name_Id": "11333"
        },
        {
          "Id": 1263,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit - QA",
          "SubClient_Name_Id": "10747-1"
        },
        {
          "Id": 1264,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit - QA",
          "SubClient_Name_Id": "10747-1"
        },
        {
          "Id": 1265,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-GS DC - Audit",
          "SubClient_Name_Id": "10733-1"
        },
        {
          "Id": 1266,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc.",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-GS DC - Audit",
          "SubClient_Name_Id": "10733-1"
        },
        {
          "Id": 1267,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1268,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1269,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Registration (Demo Entry)",
          "Client_Name_ID": "11248",
          "SubClient_Name": "EmCare/RTI: Registration (Demo Entry)",
          "SubClient_Name_Id": "11248"
        },
        {
          "Id": 1270,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Registration (Demo Entry)",
          "Client_Name_ID": "11248",
          "SubClient_Name": "EmCare/RTI: Registration (Demo Entry)",
          "SubClient_Name_Id": "11248"
        },
        {
          "Id": 1271,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1272,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - TCA",
          "SubClient_Name_Id": "10726-1"
        },
        {
          "Id": 1273,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1274,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1275,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1276,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1277,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1278,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1279,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1280,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1281,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1282,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - TCA",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1283,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1284,
          "Original_Client_Name": "EmCare/Reimbursement Technologies, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99026",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - TCA",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1285,
          "Original_Client_Name": "Employee Relations",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 1286,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1287,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1288,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Day",
          "SubClient_Name_Id": "10738-1"
        },
        {
          "Id": 1289,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Day",
          "SubClient_Name_Id": "10738-1"
        },
        {
          "Id": 1290,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Day",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1291,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Day",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1292,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Day",
          "SubClient_Name_Id": "10727-1"
        },
        {
          "Id": 1293,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Day",
          "SubClient_Name_Id": "10727-1"
        },
        {
          "Id": 1294,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Day",
          "SubClient_Name_Id": "10726-1"
        },
        {
          "Id": 1295,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Day",
          "SubClient_Name_Id": "10726-1"
        },
        {
          "Id": 1296,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Appeals",
          "SubClient_Name_Id": "10727-2"
        },
        {
          "Id": 1297,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Appeals",
          "SubClient_Name_Id": "10726-2"
        },
        {
          "Id": 1298,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - TCA",
          "SubClient_Name_Id": "10737-2"
        },
        {
          "Id": 1299,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - TCA",
          "SubClient_Name_Id": "10738-2"
        },
        {
          "Id": 1300,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Anesthesia coding",
          "Client_Name_ID": "10746",
          "SubClient_Name": "EmCare/RTI: POP Anesthesia coding",
          "SubClient_Name_Id": "10746"
        },
        {
          "Id": 1301,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Anesthesia coding",
          "Client_Name_ID": "10746",
          "SubClient_Name": "EmCare/RTI: POP Anesthesia coding",
          "SubClient_Name_Id": "10746"
        },
        {
          "Id": 1302,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1303,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1304,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1305,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1306,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1307,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1308,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR Follow-up",
          "Client_Name_ID": "11470",
          "SubClient_Name": "Envision: AR Follow-up",
          "SubClient_Name_Id": "11470"
        },
        {
          "Id": 1309,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1310,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1311,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1312,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1313,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR Follow-up",
          "Client_Name_ID": "11470",
          "SubClient_Name": "Envision: AR Follow-up",
          "SubClient_Name_Id": "11470"
        },
        {
          "Id": 1314,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1315,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1316,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1317,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1318,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Anesthesia Coding",
          "Client_Name_ID": "10722",
          "SubClient_Name": "EmCare/RTI: Anesthesia Coding",
          "SubClient_Name_Id": "10722"
        },
        {
          "Id": 1319,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation",
          "SubClient_Name_Id": "10739"
        },
        {
          "Id": 1320,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Insurance Information Updating Services",
          "Client_Name_ID": "10741",
          "SubClient_Name": "EmCare/RTI: Insurance Information Updating Services",
          "SubClient_Name_Id": "10741"
        },
        {
          "Id": 1321,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "SubClient_Name_Id": "10736"
        },
        {
          "Id": 1322,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision Healthcare: Prepping",
          "Client_Name_ID": "11469",
          "SubClient_Name": "Envision Healthcare: Prepping",
          "SubClient_Name_Id": "11469"
        },
        {
          "Id": 1323,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Document Preparation",
          "Client_Name_ID": "10739",
          "SubClient_Name": "EmCare/RTI: Document Preparation",
          "SubClient_Name_Id": "10739"
        },
        {
          "Id": 1324,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Insurance Information Updating Services",
          "Client_Name_ID": "10741",
          "SubClient_Name": "EmCare/RTI: Insurance Information Updating Services",
          "SubClient_Name_Id": "10741"
        },
        {
          "Id": 1325,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "SubClient_Name_Id": "10736"
        },
        {
          "Id": 1326,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision Healthcare: Assembly",
          "Client_Name_ID": "11468",
          "SubClient_Name": "Envision Healthcare: Assembly",
          "SubClient_Name_Id": "11468"
        },
        {
          "Id": 1327,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1328,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1329,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Anesthesia Coding",
          "Client_Name_ID": "10722",
          "SubClient_Name": "EmCare/RTI: Anesthesia Coding",
          "SubClient_Name_Id": "10722"
        },
        {
          "Id": 1330,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Insurance Refunds",
          "Client_Name_ID": "11115",
          "SubClient_Name": "EmCare/RTI: POP Insurance Refunds",
          "SubClient_Name_Id": "11115"
        },
        {
          "Id": 1331,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Patient Refunds",
          "Client_Name_ID": "11114",
          "SubClient_Name": "EmCare/RTI: POP Patient Refunds",
          "SubClient_Name_Id": "11114"
        },
        {
          "Id": 1332,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Insurance Refunds",
          "Client_Name_ID": "11115",
          "SubClient_Name": "EmCare/RTI: POP Insurance Refunds",
          "SubClient_Name_Id": "11115"
        },
        {
          "Id": 1333,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP Patient Refunds",
          "Client_Name_ID": "11114",
          "SubClient_Name": "EmCare/RTI: POP Patient Refunds",
          "SubClient_Name_Id": "11114"
        },
        {
          "Id": 1334,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR - Claim Edits",
          "Client_Name_ID": "11472",
          "SubClient_Name": "Envision: AR - Claim Edits",
          "SubClient_Name_Id": "11472"
        },
        {
          "Id": 1335,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR - Claim Edits",
          "Client_Name_ID": "11472",
          "SubClient_Name": "Envision: AR - Claim Edits",
          "SubClient_Name_Id": "11472"
        },
        {
          "Id": 1336,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Manual",
          "SubClient_Name_Id": "11165-1"
        },
        {
          "Id": 1337,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - ERA",
          "SubClient_Name_Id": "11165-2"
        },
        {
          "Id": 1338,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Manual",
          "SubClient_Name_Id": "11165-1"
        },
        {
          "Id": 1339,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - ERA",
          "SubClient_Name_Id": "11165-2"
        },
        {
          "Id": 1340,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP AR Follow up services",
          "Client_Name_ID": "11157",
          "SubClient_Name": "EmCare/RTI: POP AR Follow up services",
          "SubClient_Name_Id": "11157"
        },
        {
          "Id": 1341,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP AR Follow up services",
          "Client_Name_ID": "11157",
          "SubClient_Name": "EmCare/RTI: POP AR Follow up services",
          "SubClient_Name_Id": "11157"
        },
        {
          "Id": 1342,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Correction",
          "SubClient_Name_Id": "10731-1"
        },
        {
          "Id": 1343,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision Healthcare: Assembly",
          "Client_Name_ID": "11468",
          "SubClient_Name": "Envision Healthcare: Assembly",
          "SubClient_Name_Id": "11468"
        },
        {
          "Id": 1344,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision Healthcare: Prepping",
          "Client_Name_ID": "11469",
          "SubClient_Name": "Envision Healthcare: Prepping",
          "SubClient_Name_Id": "11469"
        },
        {
          "Id": 1345,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Insurance Verification",
          "Client_Name_ID": "11257",
          "SubClient_Name": "EmCare/RTI: Insurance Verification",
          "SubClient_Name_Id": "11257"
        },
        {
          "Id": 1346,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Insurance Verification",
          "Client_Name_ID": "11257",
          "SubClient_Name": "EmCare/RTI: Insurance Verification",
          "SubClient_Name_Id": "11257"
        },
        {
          "Id": 1347,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Resolution",
          "SubClient_Name_Id": "10726-4"
        },
        {
          "Id": 1348,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Resolution",
          "SubClient_Name_Id": "10727-4"
        },
        {
          "Id": 1349,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Resolution",
          "SubClient_Name_Id": "10737-4"
        },
        {
          "Id": 1350,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Resolution",
          "SubClient_Name_Id": "10726-4"
        },
        {
          "Id": 1351,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Resolution",
          "SubClient_Name_Id": "10727-4"
        },
        {
          "Id": 1352,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Resolution",
          "SubClient_Name_Id": "10737-4"
        },
        {
          "Id": 1353,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Resolution",
          "SubClient_Name_Id": "10738-5"
        },
        {
          "Id": 1354,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Resolution",
          "SubClient_Name_Id": "10738-5"
        },
        {
          "Id": 1355,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "SubClient_Name_Id": "11413"
        },
        {
          "Id": 1356,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "SubClient_Name_Id": "11413"
        },
        {
          "Id": 1357,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Money Move",
          "SubClient_Name_Id": "11165-4"
        },
        {
          "Id": 1358,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Review Balance",
          "SubClient_Name_Id": "11165-3"
        },
        {
          "Id": 1359,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1360,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Surgery Audit",
          "Client_Name_ID": "10747",
          "SubClient_Name": "EmCare/RTI: Surgery Audit",
          "SubClient_Name_Id": "10747"
        },
        {
          "Id": 1361,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Anesthesia: AR winddown services: Hourly",
          "Client_Name_ID": "11619",
          "SubClient_Name": "Envision: AS 400: Anesthesia: AR winddown services: Hourly",
          "SubClient_Name_Id": "11619"
        },
        {
          "Id": 1362,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Anesthesia: AR winddown services: Hourly",
          "Client_Name_ID": "11619",
          "SubClient_Name": "Envision: AS 400: Anesthesia: AR winddown services: Hourly",
          "SubClient_Name_Id": "11619"
        },
        {
          "Id": 1363,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Anesthesia: AR winddown services: Contingency",
          "Client_Name_ID": "11620",
          "SubClient_Name": "Envision: AS 400: Anesthesia: AR winddown services: Contingency",
          "SubClient_Name_Id": "11620"
        },
        {
          "Id": 1364,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Anesthesia: AR winddown services: Contingency",
          "Client_Name_ID": "11620",
          "SubClient_Name": "Envision: AS 400: Anesthesia: AR winddown services: Contingency",
          "SubClient_Name_Id": "11620"
        },
        {
          "Id": 1365,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Neonatology: AR winddown services: Hourly",
          "Client_Name_ID": "11644",
          "SubClient_Name": "Envision: AS 400: Neonatology: AR winddown services: Hourly",
          "SubClient_Name_Id": "11644"
        },
        {
          "Id": 1366,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Neonatology: AR winddown services: Hourly",
          "Client_Name_ID": "11644",
          "SubClient_Name": "Envision: AS 400: Neonatology: AR winddown services: Hourly",
          "SubClient_Name_Id": "11644"
        },
        {
          "Id": 1367,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Neonatology: AR winddown services: Contingency",
          "Client_Name_ID": "11645",
          "SubClient_Name": "Envision: AS 400: Neonatology: AR winddown services: Contingency",
          "SubClient_Name_Id": "11645"
        },
        {
          "Id": 1368,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AS 400: Neonatology: AR winddown services: Contingency",
          "Client_Name_ID": "11645",
          "SubClient_Name": "Envision: AS 400: Neonatology: AR winddown services: Contingency",
          "SubClient_Name_Id": "11645"
        },
        {
          "Id": 1369,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: New Business Dept.",
          "Client_Name_ID": "11712",
          "SubClient_Name": "Envision: New Business Dept.",
          "SubClient_Name_Id": "11712"
        },
        {
          "Id": 1370,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: New Business Dept.",
          "Client_Name_ID": "11712",
          "SubClient_Name": "Envision: New Business Dept.",
          "SubClient_Name_Id": "11712"
        },
        {
          "Id": 1371,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile - Scrubbing",
          "SubClient_Name_Id": "10736-1"
        },
        {
          "Id": 1372,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Validation services on Medi Mobile",
          "Client_Name_ID": "10736",
          "SubClient_Name": "EmCare/RTI: Data Validation services on Medi Mobile - Scrubbing",
          "SubClient_Name_Id": "10736-1"
        },
        {
          "Id": 1373,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Provider Enrolment",
          "Client_Name_ID": "11715",
          "SubClient_Name": "Envision: Provider Enrolment",
          "SubClient_Name_Id": "11715"
        },
        {
          "Id": 1374,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Provider Enrolment",
          "Client_Name_ID": "11715",
          "SubClient_Name": "Envision: Provider Enrolment",
          "SubClient_Name_Id": "11715"
        },
        {
          "Id": 1375,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Review Balance",
          "SubClient_Name_Id": "11165-3"
        },
        {
          "Id": 1376,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting",
          "Client_Name_ID": "11165",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting - Money Move",
          "SubClient_Name_Id": "11165-4"
        },
        {
          "Id": 1377,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-GS DC",
          "SubClient_Name_Id": "10733-2"
        },
        {
          "Id": 1378,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-GS DC",
          "SubClient_Name_Id": "10733-2"
        },
        {
          "Id": 1379,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-SB",
          "SubClient_Name_Id": "10733-3"
        },
        {
          "Id": 1380,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-SB",
          "SubClient_Name_Id": "10733-3"
        },
        {
          "Id": 1381,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-HRD",
          "SubClient_Name_Id": "10733-4"
        },
        {
          "Id": 1382,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-HRD",
          "SubClient_Name_Id": "10733-4"
        },
        {
          "Id": 1383,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Coding",
          "SubClient_Name_Id": "10731-2"
        },
        {
          "Id": 1384,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Coding",
          "SubClient_Name_Id": "10731-2"
        },
        {
          "Id": 1385,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Hospital coding",
          "SubClient_Name_Id": "10731-3"
        },
        {
          "Id": 1386,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Hospital coding",
          "SubClient_Name_Id": "10731-3"
        },
        {
          "Id": 1387,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Coverage Discovery",
          "Client_Name_ID": "11512",
          "SubClient_Name": "Envision: Coverage Discovery",
          "SubClient_Name_Id": "11512"
        },
        {
          "Id": 1388,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Coverage Discovery",
          "Client_Name_ID": "11512",
          "SubClient_Name": "Envision: Coverage Discovery",
          "SubClient_Name_Id": "11512"
        },
        {
          "Id": 1389,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Manual Task",
          "Client_Name_ID": "11513",
          "SubClient_Name": "Envision: Manual Task",
          "SubClient_Name_Id": "11513"
        },
        {
          "Id": 1390,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Manual Task",
          "Client_Name_ID": "11513",
          "SubClient_Name": "Envision: Manual Task",
          "SubClient_Name_Id": "11513"
        },
        {
          "Id": 1391,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH - Manual Payments",
          "SubClient_Name_Id": "11413-1"
        },
        {
          "Id": 1392,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH - Electronic payments",
          "SubClient_Name_Id": "11413-2"
        },
        {
          "Id": 1393,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH - Manual Payments",
          "SubClient_Name_Id": "11413-1"
        },
        {
          "Id": 1394,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: POP - Payment Posting NJH",
          "Client_Name_ID": "11413",
          "SubClient_Name": "EmCare/RTI: POP - Payment Posting NJH - Electronic payments",
          "SubClient_Name_Id": "11413-2"
        },
        {
          "Id": 1395,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - IDG Coding Denials",
          "SubClient_Name_Id": "10733-1"
        },
        {
          "Id": 1396,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - IDG Coding Denials",
          "SubClient_Name_Id": "10733-1"
        },
        {
          "Id": 1397,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR Denials (CAR)",
          "Client_Name_ID": "11471",
          "SubClient_Name": "Envision: AR Denials (CAR)",
          "SubClient_Name_Id": "11471"
        },
        {
          "Id": 1398,
          "Original_Client_Name": "Envision Healthcare Corporation",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: AR Denials (CAR)",
          "Client_Name_ID": "11471",
          "SubClient_Name": "Envision: AR Denials (CAR)",
          "SubClient_Name_Id": "11471"
        },
        {
          "Id": 1399,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1400,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Entry from Images (Patient Stickers)",
          "Client_Name_ID": "11473",
          "SubClient_Name": "EmCare/RTI: Data Entry from Images (Patient Stickers)",
          "SubClient_Name_Id": "11473"
        },
        {
          "Id": 1401,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Entry from Images (Patient Stickers)",
          "Client_Name_ID": "11473",
          "SubClient_Name": "EmCare/RTI: Data Entry from Images (Patient Stickers)",
          "SubClient_Name_Id": "11473"
        },
        {
          "Id": 1402,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1403,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "Client_Name_ID": "11501",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (Manual) - CB",
          "SubClient_Name_Id": "11501-1"
        },
        {
          "Id": 1404,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "Client_Name_ID": "11501",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (Manual) - CB",
          "SubClient_Name_Id": "11501-1"
        },
        {
          "Id": 1405,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding - Releaser",
          "SubClient_Name_Id": "10731-1"
        },
        {
          "Id": 1406,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "Client_Name_ID": "11501",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "SubClient_Name_Id": "11501"
        },
        {
          "Id": 1407,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (ERA)",
          "Client_Name_ID": "11500",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (ERA)",
          "SubClient_Name_Id": "11500"
        },
        {
          "Id": 1408,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "Client_Name_ID": "11501",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (Manual)",
          "SubClient_Name_Id": "11501"
        },
        {
          "Id": 1409,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia Payment Posting (ERA)",
          "Client_Name_ID": "11500",
          "SubClient_Name": "Envision: Anesthesia Payment Posting (ERA)",
          "SubClient_Name_Id": "11500"
        },
        {
          "Id": 1410,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1411,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues",
          "SubClient_Name_Id": "10733"
        },
        {
          "Id": 1412,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Resolution",
          "SubClient_Name_Id": "10726-3"
        },
        {
          "Id": 1413,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Resolution",
          "SubClient_Name_Id": "10737-2"
        },
        {
          "Id": 1414,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Resolution",
          "SubClient_Name_Id": "10727-1"
        },
        {
          "Id": 1415,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Resolution",
          "SubClient_Name_Id": "10738-1"
        },
        {
          "Id": 1416,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Appeals",
          "SubClient_Name_Id": "10727-2"
        },
        {
          "Id": 1417,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Appeals",
          "SubClient_Name_Id": "10726-2"
        },
        {
          "Id": 1418,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Resolution",
          "SubClient_Name_Id": "10726-3"
        },
        {
          "Id": 1419,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - Resolution",
          "SubClient_Name_Id": "10737-2"
        },
        {
          "Id": 1420,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Resolution",
          "SubClient_Name_Id": "10727-1"
        },
        {
          "Id": 1421,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL - Resolution",
          "SubClient_Name_Id": "10738-1"
        },
        {
          "Id": 1422,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL - Appeals",
          "SubClient_Name_Id": "10727-2"
        },
        {
          "Id": 1423,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - Appeals",
          "SubClient_Name_Id": "10726-2"
        },
        {
          "Id": 1424,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1425,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1426,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:HL",
          "Client_Name_ID": "10738",
          "SubClient_Name": "EmCare/RTI: Denial Management:HL",
          "SubClient_Name_Id": "10738"
        },
        {
          "Id": 1427,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:HL",
          "Client_Name_ID": "10727",
          "SubClient_Name": "EmCare/RTI: AR Follow up:HL",
          "SubClient_Name_Id": "10727"
        },
        {
          "Id": 1428,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Entry",
          "Client_Name_ID": "11304",
          "SubClient_Name": "EmCare/RTI: Data Entry",
          "SubClient_Name_Id": "11304"
        },
        {
          "Id": 1429,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Data Entry",
          "Client_Name_ID": "11304",
          "SubClient_Name": "EmCare/RTI: Data Entry",
          "SubClient_Name_Id": "11304"
        },
        {
          "Id": 1430,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Indexing",
          "Client_Name_ID": "11247",
          "SubClient_Name": "EmCare/RTI: Indexing",
          "SubClient_Name_Id": "11247"
        },
        {
          "Id": 1431,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Indexing",
          "Client_Name_ID": "11247",
          "SubClient_Name": "EmCare/RTI: Indexing",
          "SubClient_Name_Id": "11247"
        },
        {
          "Id": 1432,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Indexing",
          "Client_Name_ID": "10755",
          "SubClient_Name": "Envision: Indexing",
          "SubClient_Name_Id": "10755"
        },
        {
          "Id": 1433,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Indexing",
          "Client_Name_ID": "10755",
          "SubClient_Name": "Envision: Indexing",
          "SubClient_Name_Id": "10755"
        },
        {
          "Id": 1434,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1435,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - TCA",
          "SubClient_Name_Id": "10726-1"
        },
        {
          "Id": 1436,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1437,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - TCA",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1438,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED",
          "SubClient_Name_Id": "10726"
        },
        {
          "Id": 1439,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: AR Follow up:ED",
          "Client_Name_ID": "10726",
          "SubClient_Name": "EmCare/RTI: AR Follow up:ED - TCA",
          "SubClient_Name_Id": "10726-1"
        },
        {
          "Id": 1440,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED",
          "SubClient_Name_Id": "10737"
        },
        {
          "Id": 1441,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Denial Management:ED",
          "Client_Name_ID": "10737",
          "SubClient_Name": "EmCare/RTI: Denial Management:ED - TCA",
          "SubClient_Name_Id": "10737-1"
        },
        {
          "Id": 1442,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1443,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1444,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1445,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding",
          "Client_Name_ID": "10731",
          "SubClient_Name": "EmCare/RTI: Coding",
          "SubClient_Name_Id": "10731"
        },
        {
          "Id": 1446,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "Client_Name_ID": "10730",
          "SubClient_Name": "EmCare/RTI: Code E&M and professional services provided by Hospitalists",
          "SubClient_Name_Id": "10730"
        },
        {
          "Id": 1447,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Internal suspend queue",
          "Client_Name_ID": "10742",
          "SubClient_Name": "EmCare/RTI: Internal suspend queue",
          "SubClient_Name_Id": "10742"
        },
        {
          "Id": 1448,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1449,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "Client_Name_ID": "10723",
          "SubClient_Name": "EmCare/RTI: Anesthesia Payment Posting services",
          "SubClient_Name_Id": "10723"
        },
        {
          "Id": 1450,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1451,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-HRD",
          "SubClient_Name_Id": "10733-4"
        },
        {
          "Id": 1452,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "EmCare/RTI: Coding QA focused review queues",
          "Client_Name_ID": "10733",
          "SubClient_Name": "EmCare/RTI: Coding QA focused review queues - RTI-HRD",
          "SubClient_Name_Id": "10733-4"
        },
        {
          "Id": 1453,
          "Original_Client_Name": "Envision Healthcare Corporation - Aurangabad",
          "Original_Client_Name_ID": "99027",
          "Client_Name": "Envision: Anesthesia MIPS Abstraction",
          "Client_Name_ID": "10753",
          "SubClient_Name": "Envision: Anesthesia MIPS Abstraction",
          "SubClient_Name_Id": "10753"
        },
        {
          "Id": 1454,
          "Original_Client_Name": "Episource LLC.",
          "Original_Client_Name_ID": "99120",
          "Client_Name": "Episource: Second level chart review",
          "Client_Name_ID": "11643",
          "SubClient_Name": "Episource: Second level chart review",
          "SubClient_Name_Id": "11643"
        },
        {
          "Id": 1455,
          "Original_Client_Name": "Episource LLC.",
          "Original_Client_Name_ID": "99120",
          "Client_Name": "Episource: Second level chart review",
          "Client_Name_ID": "11643",
          "SubClient_Name": "Episource: Second level chart review",
          "SubClient_Name_Id": "11643"
        },
        {
          "Id": 1456,
          "Original_Client_Name": "Episource LLC. - Aurangabad",
          "Original_Client_Name_ID": "99120",
          "Client_Name": "Episource: Second level chart review",
          "Client_Name_ID": "11643",
          "SubClient_Name": "Episource: Second level chart review",
          "SubClient_Name_Id": "11643"
        },
        {
          "Id": 1457,
          "Original_Client_Name": "Episource LLC. - Aurangabad",
          "Original_Client_Name_ID": "99120",
          "Client_Name": "Episource: Second level chart review",
          "Client_Name_ID": "11643",
          "SubClient_Name": "Episource: Second level chart review",
          "SubClient_Name_Id": "11643"
        },
        {
          "Id": 1458,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11490",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (Manual) - EOB Download",
          "SubClient_Name_Id": "11490-1"
        },
        {
          "Id": 1459,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : AR Follow Up Services",
          "Client_Name_ID": "11502",
          "SubClient_Name": "EyeCare : AR Follow Up Services",
          "SubClient_Name_Id": "11502"
        },
        {
          "Id": 1460,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : AR Follow Up Services",
          "Client_Name_ID": "11502",
          "SubClient_Name": "EyeCare : AR Follow Up Services",
          "SubClient_Name_Id": "11502"
        },
        {
          "Id": 1461,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Claim/Appeals per page",
          "Client_Name_ID": "11503",
          "SubClient_Name": "EyeCare : Claim/Appeals per page",
          "SubClient_Name_Id": "11503"
        },
        {
          "Id": 1462,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Claim/Appeals per page",
          "Client_Name_ID": "11503",
          "SubClient_Name": "EyeCare : Claim/Appeals per page",
          "SubClient_Name_Id": "11503"
        },
        {
          "Id": 1463,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Additional pages",
          "Client_Name_ID": "11504",
          "SubClient_Name": "EyeCare : Additional pages",
          "SubClient_Name_Id": "11504"
        },
        {
          "Id": 1464,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Additional pages",
          "Client_Name_ID": "11504",
          "SubClient_Name": "EyeCare : Additional pages",
          "SubClient_Name_Id": "11504"
        },
        {
          "Id": 1465,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11490",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "SubClient_Name_Id": "11490"
        },
        {
          "Id": 1466,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11490",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "SubClient_Name_Id": "11490"
        },
        {
          "Id": 1467,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (ERA)",
          "Client_Name_ID": "11491",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (ERA)",
          "SubClient_Name_Id": "11491"
        },
        {
          "Id": 1468,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (ERA)",
          "Client_Name_ID": "11491",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (ERA)",
          "SubClient_Name_Id": "11491"
        },
        {
          "Id": 1469,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Charge entry services",
          "Client_Name_ID": "11514",
          "SubClient_Name": "EyeCare : Charge entry services",
          "SubClient_Name_Id": "11514"
        },
        {
          "Id": 1470,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Charge entry services",
          "Client_Name_ID": "11514",
          "SubClient_Name": "EyeCare : Charge entry services",
          "SubClient_Name_Id": "11514"
        },
        {
          "Id": 1471,
          "Original_Client_Name": "EyeCare Services Partners, LLC.",
          "Original_Client_Name_ID": "99109",
          "Client_Name": "EyeCare : Payment/Cash Posting (Manual)",
          "Client_Name_ID": "11490",
          "SubClient_Name": "EyeCare : Payment/Cash Posting (Manual) - EOB Download",
          "SubClient_Name_Id": "11490-1"
        },
        {
          "Id": 1472,
          "Original_Client_Name": "Fathom Health",
          "Original_Client_Name_ID": "99099",
          "Client_Name": "Fathom: Diagnostic Radiology",
          "Client_Name_ID": "11314",
          "SubClient_Name": "Fathom: Diagnostic Radiology",
          "SubClient_Name_Id": "11314"
        },
        {
          "Id": 1473,
          "Original_Client_Name": "Fathom Health",
          "Original_Client_Name_ID": "99099",
          "Client_Name": "Fathom: Diagnostic Radiology",
          "Client_Name_ID": "11314",
          "SubClient_Name": "Fathom: Diagnostic Radiology",
          "SubClient_Name_Id": "11314"
        },
        {
          "Id": 1474,
          "Original_Client_Name": "Florida Heart Associates, P.L",
          "Original_Client_Name_ID": "99079",
          "Client_Name": "Florida Heart: AR follow Up Services",
          "Client_Name_ID": "11011",
          "SubClient_Name": "Florida Heart: AR follow Up Services",
          "SubClient_Name_Id": "11011"
        },
        {
          "Id": 1475,
          "Original_Client_Name": "Florida Heart Associates, P.L",
          "Original_Client_Name_ID": "99079",
          "Client_Name": "Florida Heart: AR follow Up Services",
          "Client_Name_ID": "11011",
          "SubClient_Name": "Florida Heart: AR follow Up Services",
          "SubClient_Name_Id": "11011"
        },
        {
          "Id": 1476,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Eligibility Pre Check",
          "Client_Name_ID": "11169",
          "SubClient_Name": "Forefront: Eligibility Pre Check",
          "SubClient_Name_Id": "11169"
        },
        {
          "Id": 1477,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Eligibility Pre Check",
          "Client_Name_ID": "11169",
          "SubClient_Name": "Forefront: Eligibility Pre Check",
          "SubClient_Name_Id": "11169"
        },
        {
          "Id": 1478,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Pathology Report",
          "SubClient_Name_Id": "10759-4"
        },
        {
          "Id": 1479,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicare/BCBS Wrong Insurance",
          "SubClient_Name_Id": "10759-8"
        },
        {
          "Id": 1480,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Referring Provider",
          "SubClient_Name_Id": "10759-2"
        },
        {
          "Id": 1481,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Refund process",
          "Client_Name_ID": "11024",
          "SubClient_Name": "Forefront: Refund process",
          "SubClient_Name_Id": "11024"
        },
        {
          "Id": 1482,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Refund process",
          "Client_Name_ID": "11024",
          "SubClient_Name": "Forefront: Refund process",
          "SubClient_Name_Id": "11024"
        },
        {
          "Id": 1483,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Take Back (Commercial)",
          "Client_Name_ID": "11267",
          "SubClient_Name": "Forefront: Take Back (Commercial)",
          "SubClient_Name_Id": "11267"
        },
        {
          "Id": 1484,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Take Back (Commercial)",
          "Client_Name_ID": "11267",
          "SubClient_Name": "Forefront: Take Back (Commercial)",
          "SubClient_Name_Id": "11267"
        },
        {
          "Id": 1485,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Adjustment as per MSA Clause (Discount 5%)",
          "Client_Name_ID": "10758",
          "SubClient_Name": "Forefront: Adjustment as per MSA Clause (Discount 5%)",
          "SubClient_Name_Id": "10758"
        },
        {
          "Id": 1486,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Adjustment as per MSA Clause (Discount 5%)",
          "Client_Name_ID": "10758",
          "SubClient_Name": "Forefront: Adjustment as per MSA Clause (Discount 5%)",
          "SubClient_Name_Id": "10758"
        },
        {
          "Id": 1487,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Credit Resolution",
          "Client_Name_ID": "10761",
          "SubClient_Name": "Forefront: Credit Resolution - Insurance",
          "SubClient_Name_Id": "10761-2"
        },
        {
          "Id": 1488,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Credit Resolution",
          "Client_Name_ID": "10761",
          "SubClient_Name": "Forefront: Credit Resolution - Insurance",
          "SubClient_Name_Id": "10761-2"
        },
        {
          "Id": 1489,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Eligibility",
          "Client_Name_ID": "10766",
          "SubClient_Name": "Forefront: Eligibility",
          "SubClient_Name_Id": "10766"
        },
        {
          "Id": 1490,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Eligibility",
          "Client_Name_ID": "10766",
          "SubClient_Name": "Forefront: Eligibility",
          "SubClient_Name_Id": "10766"
        },
        {
          "Id": 1491,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFax requests : Medical faxes",
          "Client_Name_ID": "10765",
          "SubClient_Name": "Forefront: eFax requests : Medical faxes",
          "SubClient_Name_Id": "10765"
        },
        {
          "Id": 1492,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFax requests : Labs",
          "Client_Name_ID": "10764",
          "SubClient_Name": "Forefront: eFax requests : Labs",
          "SubClient_Name_Id": "10764"
        },
        {
          "Id": 1493,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Unapplied Payment review",
          "Client_Name_ID": "10769",
          "SubClient_Name": "Forefront: Unapplied Payment review",
          "SubClient_Name_Id": "10769"
        },
        {
          "Id": 1494,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Document Indexing",
          "Client_Name_ID": "10762",
          "SubClient_Name": "Forefront: Document Indexing",
          "SubClient_Name_Id": "10762"
        },
        {
          "Id": 1495,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFAX requests",
          "Client_Name_ID": "10763",
          "SubClient_Name": "Forefront: eFAX requests",
          "SubClient_Name_Id": "10763"
        },
        {
          "Id": 1496,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFAX requests",
          "Client_Name_ID": "10763",
          "SubClient_Name": "Forefront: eFAX requests",
          "SubClient_Name_Id": "10763"
        },
        {
          "Id": 1497,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Rejections",
          "Client_Name_ID": "10760",
          "SubClient_Name": "Forefront: Claim Rejections",
          "SubClient_Name_Id": "10760"
        },
        {
          "Id": 1498,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits",
          "SubClient_Name_Id": "10759"
        },
        {
          "Id": 1499,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Mismatched Charges",
          "SubClient_Name_Id": "10759-6"
        },
        {
          "Id": 1500,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Encounters",
          "Client_Name_ID": "10767",
          "SubClient_Name": "Forefront: Encounters",
          "SubClient_Name_Id": "10767"
        },
        {
          "Id": 1501,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Encounters",
          "Client_Name_ID": "10767",
          "SubClient_Name": "Forefront: Encounters",
          "SubClient_Name_Id": "10767"
        },
        {
          "Id": 1502,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Payments / Denials Posting",
          "Client_Name_ID": "10768",
          "SubClient_Name": "Forefront: Payments / Denials Posting",
          "SubClient_Name_Id": "10768"
        },
        {
          "Id": 1503,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Payments / Denials Posting",
          "Client_Name_ID": "10768",
          "SubClient_Name": "Forefront: Payments / Denials Posting",
          "SubClient_Name_Id": "10768"
        },
        {
          "Id": 1504,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Demographics",
          "SubClient_Name_Id": "10759-1"
        },
        {
          "Id": 1505,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Modifiers",
          "SubClient_Name_Id": "10759-3"
        },
        {
          "Id": 1506,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicaid Charge Verification",
          "SubClient_Name_Id": "10759-7"
        },
        {
          "Id": 1507,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Incorrect Encounter Guarantor",
          "SubClient_Name_Id": "10759-10"
        },
        {
          "Id": 1508,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Credit Resolution",
          "Client_Name_ID": "10761",
          "SubClient_Name": "Forefront: Credit Resolution - Patient",
          "SubClient_Name_Id": "10761-1"
        },
        {
          "Id": 1509,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Credit Resolution",
          "Client_Name_ID": "10761",
          "SubClient_Name": "Forefront: Credit Resolution - Patient",
          "SubClient_Name_Id": "10761-1"
        },
        {
          "Id": 1510,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits",
          "SubClient_Name_Id": "10759"
        },
        {
          "Id": 1511,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Demographics",
          "SubClient_Name_Id": "10759-1"
        },
        {
          "Id": 1512,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Incorrect Encounter Guarantor",
          "SubClient_Name_Id": "10759-10"
        },
        {
          "Id": 1513,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicaid Charge Verification",
          "SubClient_Name_Id": "10759-7"
        },
        {
          "Id": 1514,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicare/BCBS Wrong Insurance",
          "SubClient_Name_Id": "10759-8"
        },
        {
          "Id": 1515,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Mismatched Charges",
          "SubClient_Name_Id": "10759-6"
        },
        {
          "Id": 1516,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Modifiers",
          "SubClient_Name_Id": "10759-3"
        },
        {
          "Id": 1517,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Pathology Report",
          "SubClient_Name_Id": "10759-4"
        },
        {
          "Id": 1518,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Referring Provider",
          "SubClient_Name_Id": "10759-2"
        },
        {
          "Id": 1519,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Rejections",
          "Client_Name_ID": "10760",
          "SubClient_Name": "Forefront: Claim Rejections",
          "SubClient_Name_Id": "10760"
        },
        {
          "Id": 1520,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Document Indexing",
          "Client_Name_ID": "10762",
          "SubClient_Name": "Forefront: Document Indexing",
          "SubClient_Name_Id": "10762"
        },
        {
          "Id": 1521,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFax requests : Labs",
          "Client_Name_ID": "10764",
          "SubClient_Name": "Forefront: eFax requests : Labs",
          "SubClient_Name_Id": "10764"
        },
        {
          "Id": 1522,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: eFax requests : Medical faxes",
          "Client_Name_ID": "10765",
          "SubClient_Name": "Forefront: eFax requests : Medical faxes",
          "SubClient_Name_Id": "10765"
        },
        {
          "Id": 1523,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Unapplied Payment review",
          "Client_Name_ID": "10769",
          "SubClient_Name": "Forefront: Unapplied Payment review",
          "SubClient_Name_Id": "10769"
        },
        {
          "Id": 1524,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicare Adv Report",
          "SubClient_Name_Id": "10759-5"
        },
        {
          "Id": 1525,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Self-Pay Verification Report",
          "SubClient_Name_Id": "10759-9"
        },
        {
          "Id": 1526,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Medicare Adv Report",
          "SubClient_Name_Id": "10759-5"
        },
        {
          "Id": 1527,
          "Original_Client_Name": "Forefront Management, LLC",
          "Original_Client_Name_ID": "99029",
          "Client_Name": "Forefront: Claim Edits",
          "Client_Name_ID": "10759",
          "SubClient_Name": "Forefront: Claim Edits - Self-Pay Verification Report",
          "SubClient_Name_Id": "10759-9"
        },
        {
          "Id": 1528,
          "Original_Client_Name": "Global Healthcare Alliance",
          "Original_Client_Name_ID": "99030",
          "Client_Name": "GHA: Data Entry",
          "Client_Name_ID": "10771",
          "SubClient_Name": "GHA: Data Entry",
          "SubClient_Name_Id": "10771"
        },
        {
          "Id": 1529,
          "Original_Client_Name": "Global Healthcare Alliance",
          "Original_Client_Name_ID": "99030",
          "Client_Name": "GHA: Collections (AR Follow:up Process)",
          "Client_Name_ID": "10770",
          "SubClient_Name": "GHA: Collections (AR Follow:up Process)",
          "SubClient_Name_Id": "10770"
        },
        {
          "Id": 1530,
          "Original_Client_Name": "Global Healthcare Alliance",
          "Original_Client_Name_ID": "99030",
          "Client_Name": "GHA: Eligibility Verification (Web Checks)",
          "Client_Name_ID": "10772",
          "SubClient_Name": "GHA: Eligibility Verification (Web Checks)",
          "SubClient_Name_Id": "10772"
        },
        {
          "Id": 1531,
          "Original_Client_Name": "Global Healthcare Alliance",
          "Original_Client_Name_ID": "99030",
          "Client_Name": "GHA: Collections (AR Follow:up Process)",
          "Client_Name_ID": "10770",
          "SubClient_Name": "GHA: Collections (AR Follow:up Process)",
          "SubClient_Name_Id": "10770"
        },
        {
          "Id": 1532,
          "Original_Client_Name": "Global Healthcare Alliance",
          "Original_Client_Name_ID": "99030",
          "Client_Name": "GHA: Eligibility Verification (Web Checks)",
          "Client_Name_ID": "10772",
          "SubClient_Name": "GHA: Eligibility Verification (Web Checks)",
          "SubClient_Name_Id": "10772"
        },
        {
          "Id": 1533,
          "Original_Client_Name": "Gottlieb,LLC.",
          "Original_Client_Name_ID": "99031",
          "Client_Name": "Gottlieb: Medical Coding Emergency Medicine",
          "Client_Name_ID": "10773",
          "SubClient_Name": "Gottlieb: Medical Coding Emergency Medicine",
          "SubClient_Name_Id": "10773"
        },
        {
          "Id": 1534,
          "Original_Client_Name": "Gottlieb,LLC.",
          "Original_Client_Name_ID": "99031",
          "Client_Name": "Gottlieb: Medical Coding Emergency Medicine",
          "Client_Name_ID": "10773",
          "SubClient_Name": "Gottlieb: Medical Coding Emergency Medicine",
          "SubClient_Name_Id": "10773"
        },
        {
          "Id": 1535,
          "Original_Client_Name": "Gottlieb,LLC.",
          "Original_Client_Name_ID": "99031",
          "Client_Name": "Gottlieb: Medical Coding Hospitalist",
          "Client_Name_ID": "10774",
          "SubClient_Name": "Gottlieb: Medical Coding Hospitalist",
          "SubClient_Name_Id": "10774"
        },
        {
          "Id": 1536,
          "Original_Client_Name": "Gottlieb,LLC.",
          "Original_Client_Name_ID": "99031",
          "Client_Name": "Gottlieb: Medical Coding Hospitalist",
          "Client_Name_ID": "10774",
          "SubClient_Name": "Gottlieb: Medical Coding Hospitalist",
          "SubClient_Name_Id": "10774"
        },
        {
          "Id": 1537,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rheumatology",
          "Client_Name_ID": "10784",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rheumatology",
          "SubClient_Name_Id": "10784"
        },
        {
          "Id": 1538,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rheumatology",
          "Client_Name_ID": "10784",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rheumatology",
          "SubClient_Name_Id": "10784"
        },
        {
          "Id": 1539,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: IP - Surgery including IVR",
          "Client_Name_ID": "11232",
          "SubClient_Name": "Guam: IP - Surgery including IVR",
          "SubClient_Name_Id": "11232"
        },
        {
          "Id": 1540,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: IP - Surgery including IVR",
          "Client_Name_ID": "11232",
          "SubClient_Name": "Guam: IP - Surgery including IVR",
          "SubClient_Name_Id": "11232"
        },
        {
          "Id": 1541,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Facility Coding Same Day Surgery /Observation",
          "Client_Name_ID": "10776",
          "SubClient_Name": "Guam: Facility Coding Same Day Surgery /Observation",
          "SubClient_Name_Id": "10776"
        },
        {
          "Id": 1542,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non:Surgical Specialties Cardiology (non-surgical)",
          "Client_Name_ID": "10777",
          "SubClient_Name": "Guam: Professional Fee coding, Non:Surgical Specialties Cardiology (non-surgical)",
          "SubClient_Name_Id": "10777"
        },
        {
          "Id": 1543,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Oncology",
          "Client_Name_ID": "10780",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Oncology",
          "SubClient_Name_Id": "10780"
        },
        {
          "Id": 1544,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Podiatry",
          "Client_Name_ID": "10781",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Podiatry",
          "SubClient_Name_Id": "10781"
        },
        {
          "Id": 1545,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: ER Coding",
          "Client_Name_ID": "10775",
          "SubClient_Name": "Guam: ER Coding",
          "SubClient_Name_Id": "10775"
        },
        {
          "Id": 1546,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Radiology w/o ER Visit",
          "Client_Name_ID": "10785",
          "SubClient_Name": "Guam: Radiology w/o ER Visit",
          "SubClient_Name_Id": "10785"
        },
        {
          "Id": 1547,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Pulmonology",
          "Client_Name_ID": "10782",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Pulmonology",
          "SubClient_Name_Id": "10782"
        },
        {
          "Id": 1548,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Infectious Diseases/Wound Clinic",
          "Client_Name_ID": "10778",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Infectious Diseases/Wound Clinic",
          "SubClient_Name_Id": "10778"
        },
        {
          "Id": 1549,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rehabilitation/Physical Medicine",
          "Client_Name_ID": "10783",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rehabilitation/Physical Medicine",
          "SubClient_Name_Id": "10783"
        },
        {
          "Id": 1550,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Neurology",
          "Client_Name_ID": "10779",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Neurology",
          "SubClient_Name_Id": "10779"
        },
        {
          "Id": 1551,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: IP Facility",
          "Client_Name_ID": "11111",
          "SubClient_Name": "Guam: IP Facility",
          "SubClient_Name_Id": "11111"
        },
        {
          "Id": 1552,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: IP Facility",
          "Client_Name_ID": "11111",
          "SubClient_Name": "Guam: IP Facility",
          "SubClient_Name_Id": "11111"
        },
        {
          "Id": 1553,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Urgent Care",
          "Client_Name_ID": "11077",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Urgent Care",
          "SubClient_Name_Id": "11077"
        },
        {
          "Id": 1554,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Urgent Care",
          "Client_Name_ID": "11077",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Urgent Care",
          "SubClient_Name_Id": "11077"
        },
        {
          "Id": 1555,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: ER Coding",
          "Client_Name_ID": "10775",
          "SubClient_Name": "Guam: ER Coding",
          "SubClient_Name_Id": "10775"
        },
        {
          "Id": 1556,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Facility Coding Same Day Surgery /Observation",
          "Client_Name_ID": "10776",
          "SubClient_Name": "Guam: Facility Coding Same Day Surgery /Observation",
          "SubClient_Name_Id": "10776"
        },
        {
          "Id": 1557,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non:Surgical Specialties Cardiology (non-surgical)",
          "Client_Name_ID": "10777",
          "SubClient_Name": "Guam: Professional Fee coding, Non:Surgical Specialties Cardiology (non-surgical)",
          "SubClient_Name_Id": "10777"
        },
        {
          "Id": 1558,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Infectious Diseases/Wound Clinic",
          "Client_Name_ID": "10778",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Infectious Diseases/Wound Clinic",
          "SubClient_Name_Id": "10778"
        },
        {
          "Id": 1559,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Neurology",
          "Client_Name_ID": "10779",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Neurology",
          "SubClient_Name_Id": "10779"
        },
        {
          "Id": 1560,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Oncology",
          "Client_Name_ID": "10780",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Oncology",
          "SubClient_Name_Id": "10780"
        },
        {
          "Id": 1561,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Podiatry",
          "Client_Name_ID": "10781",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Podiatry",
          "SubClient_Name_Id": "10781"
        },
        {
          "Id": 1562,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Pulmonology",
          "Client_Name_ID": "10782",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Pulmonology",
          "SubClient_Name_Id": "10782"
        },
        {
          "Id": 1563,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rehabilitation/Physical Medicine",
          "Client_Name_ID": "10783",
          "SubClient_Name": "Guam: Professional Fee coding, Non-Surgical Specialties Rehabilitation/Physical Medicine",
          "SubClient_Name_Id": "10783"
        },
        {
          "Id": 1564,
          "Original_Client_Name": "Guam Regional Medical City",
          "Original_Client_Name_ID": "99032",
          "Client_Name": "Guam: Radiology w/o ER Visit",
          "Client_Name_ID": "10785",
          "SubClient_Name": "Guam: Radiology w/o ER Visit",
          "SubClient_Name_Id": "10785"
        },
        {
          "Id": 1565,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Pathology Coding",
          "Client_Name_ID": "10787",
          "SubClient_Name": "Hawthorn: Pathology Coding - Pathology",
          "SubClient_Name_Id": "10787-1"
        },
        {
          "Id": 1566,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Pathology Coding",
          "Client_Name_ID": "10787",
          "SubClient_Name": "Hawthorn: Pathology Coding - Pathology",
          "SubClient_Name_Id": "10787-1"
        },
        {
          "Id": 1567,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic - Diagnostic - Radiology",
          "SubClient_Name_Id": "10788-1"
        },
        {
          "Id": 1568,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic - Diagnostic - Radiology",
          "SubClient_Name_Id": "10788-1"
        },
        {
          "Id": 1569,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Anesthesia Coding Services",
          "Client_Name_ID": "10786",
          "SubClient_Name": "Hawthorn: Anesthesia Coding Services",
          "SubClient_Name_Id": "10786"
        },
        {
          "Id": 1570,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Anesthesia Coding Services",
          "Client_Name_ID": "10786",
          "SubClient_Name": "Hawthorn: Anesthesia Coding Services",
          "SubClient_Name_Id": "10786"
        },
        {
          "Id": 1571,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Pathology Coding",
          "Client_Name_ID": "10787",
          "SubClient_Name": "Hawthorn: Pathology Coding",
          "SubClient_Name_Id": "10787"
        },
        {
          "Id": 1572,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Pathology Coding",
          "Client_Name_ID": "10787",
          "SubClient_Name": "Hawthorn: Pathology Coding",
          "SubClient_Name_Id": "10787"
        },
        {
          "Id": 1573,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "SubClient_Name_Id": "10788"
        },
        {
          "Id": 1574,
          "Original_Client_Name": "Hawthorn Physician Services Corp.",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "SubClient_Name_Id": "10788"
        },
        {
          "Id": 1575,
          "Original_Client_Name": "Hawthorn Physician Services Corp. - Aurangabad",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "SubClient_Name_Id": "10788"
        },
        {
          "Id": 1576,
          "Original_Client_Name": "Hawthorn Physician Services Corp. - Aurangabad",
          "Original_Client_Name_ID": "99033",
          "Client_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "Client_Name_ID": "10788",
          "SubClient_Name": "Hawthorn: Radiology Coding - Diagnostic",
          "SubClient_Name_Id": "10788"
        },
        {
          "Id": 1577,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Surgery",
          "Client_Name_ID": "10913",
          "SubClient_Name": "Parallon: Surgery",
          "SubClient_Name_Id": "10913"
        },
        {
          "Id": 1578,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M",
          "Client_Name_ID": "10896",
          "SubClient_Name": "Parallon: E/M",
          "SubClient_Name_Id": "10896"
        },
        {
          "Id": 1579,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M & Surgery",
          "Client_Name_ID": "10897",
          "SubClient_Name": "Parallon: E/M & Surgery",
          "SubClient_Name_Id": "10897"
        },
        {
          "Id": 1580,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: IP to SDS",
          "Client_Name_ID": "10901",
          "SubClient_Name": "Parallon: IP to SDS",
          "SubClient_Name_Id": "10901"
        },
        {
          "Id": 1581,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient",
          "SubClient_Name_Id": "10899"
        },
        {
          "Id": 1582,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient",
          "SubClient_Name_Id": "10899"
        },
        {
          "Id": 1583,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: IP to OBS",
          "Client_Name_ID": "10900",
          "SubClient_Name": "Parallon: IP to OBS",
          "SubClient_Name_Id": "10900"
        },
        {
          "Id": 1584,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: IP to OBS",
          "Client_Name_ID": "10900",
          "SubClient_Name": "Parallon: IP to OBS",
          "SubClient_Name_Id": "10900"
        },
        {
          "Id": 1585,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records",
          "Client_Name_ID": "10909",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records - COVID Rebill",
          "SubClient_Name_Id": "10909-1"
        },
        {
          "Id": 1586,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records",
          "Client_Name_ID": "10909",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records",
          "SubClient_Name_Id": "10909"
        },
        {
          "Id": 1587,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records",
          "Client_Name_ID": "10910",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records",
          "SubClient_Name_Id": "10910"
        },
        {
          "Id": 1588,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records",
          "Client_Name_ID": "10910",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - COVID Rebill",
          "SubClient_Name_Id": "10910-1"
        },
        {
          "Id": 1589,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "Client_Name_ID": "10903",
          "SubClient_Name": "Parallon: Outpatient : Clinical (CLI) Records - COVID Rebill",
          "SubClient_Name_Id": "10903-1"
        },
        {
          "Id": 1590,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "Client_Name_ID": "10903",
          "SubClient_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "SubClient_Name_Id": "10903"
        },
        {
          "Id": 1591,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department",
          "SubClient_Name_Id": "10904"
        },
        {
          "Id": 1592,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - COVID Rebill",
          "SubClient_Name_Id": "10904-1"
        },
        {
          "Id": 1593,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department (RIC/CAC)",
          "Client_Name_ID": "10906",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department (RIC/CAC)",
          "SubClient_Name_Id": "10906"
        },
        {
          "Id": 1594,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department (RIC/CAC)",
          "Client_Name_ID": "10906",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department (RIC/CAC)",
          "SubClient_Name_Id": "10906"
        },
        {
          "Id": 1595,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - Query Sweep",
          "SubClient_Name_Id": "10899-1"
        },
        {
          "Id": 1596,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Denials (Profee)",
          "Client_Name_ID": "10894",
          "SubClient_Name": "Parallon: Denials (Profee)",
          "SubClient_Name_Id": "10894"
        },
        {
          "Id": 1597,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Denials (Profee)",
          "Client_Name_ID": "10894",
          "SubClient_Name": "Parallon: Denials (Profee)",
          "SubClient_Name_Id": "10894"
        },
        {
          "Id": 1598,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M",
          "Client_Name_ID": "10896",
          "SubClient_Name": "Parallon: E/M",
          "SubClient_Name_Id": "10896"
        },
        {
          "Id": 1599,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits",
          "Client_Name_ID": "10898",
          "SubClient_Name": "Parallon: ED Admits",
          "SubClient_Name_Id": "10898"
        },
        {
          "Id": 1600,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits",
          "Client_Name_ID": "10898",
          "SubClient_Name": "Parallon: ED Admits",
          "SubClient_Name_Id": "10898"
        },
        {
          "Id": 1601,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M",
          "Client_Name_ID": "10896",
          "SubClient_Name": "Parallon: E/M - UCC-PV",
          "SubClient_Name_Id": "10896-1"
        },
        {
          "Id": 1602,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon : AR Follow up",
          "Client_Name_ID": "11133",
          "SubClient_Name": "Parallon : AR Follow up",
          "SubClient_Name_Id": "11133"
        },
        {
          "Id": 1603,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon : AR Follow up above 365 DOS",
          "Client_Name_ID": "11134",
          "SubClient_Name": "Parallon : AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11134"
        },
        {
          "Id": 1604,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon : AR Follow up",
          "Client_Name_ID": "11133",
          "SubClient_Name": "Parallon : AR Follow up",
          "SubClient_Name_Id": "11133"
        },
        {
          "Id": 1605,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon : AR Follow up above 365 DOS",
          "Client_Name_ID": "11134",
          "SubClient_Name": "Parallon : AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11134"
        },
        {
          "Id": 1606,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: EKG Coding",
          "Client_Name_ID": "11172",
          "SubClient_Name": "Parallon: EKG Coding",
          "SubClient_Name_Id": "11172"
        },
        {
          "Id": 1607,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: EKG Coding",
          "Client_Name_ID": "11172",
          "SubClient_Name": "Parallon: EKG Coding",
          "SubClient_Name_Id": "11172"
        },
        {
          "Id": 1608,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Eligibility",
          "Client_Name_ID": "11043",
          "SubClient_Name": "Parallon: Tennessee CBO: Eligibility",
          "SubClient_Name_Id": "11043"
        },
        {
          "Id": 1609,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: Eligibility",
          "Client_Name_ID": "11186",
          "SubClient_Name": "Parallon: Texas CBO: Eligibility",
          "SubClient_Name_Id": "11186"
        },
        {
          "Id": 1610,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Eligibility",
          "Client_Name_ID": "11043",
          "SubClient_Name": "Parallon: Tennessee CBO: Eligibility",
          "SubClient_Name_Id": "11043"
        },
        {
          "Id": 1611,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: Eligibility",
          "Client_Name_ID": "11186",
          "SubClient_Name": "Parallon: Texas CBO: Eligibility",
          "SubClient_Name_Id": "11186"
        },
        {
          "Id": 1612,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M",
          "Client_Name_ID": "10896",
          "SubClient_Name": "Parallon: E/M - UCC-On base",
          "SubClient_Name_Id": "10896-2"
        },
        {
          "Id": 1613,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Denials (Profee)",
          "Client_Name_ID": "10894",
          "SubClient_Name": "Parallon: Denials (Profee) - UCC-On base",
          "SubClient_Name_Id": "10894-1"
        },
        {
          "Id": 1614,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "SubClient_Name_Id": "11145"
        },
        {
          "Id": 1615,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC",
          "SubClient_Name_Id": "11142"
        },
        {
          "Id": 1616,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "Client_Name_ID": "11143",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "SubClient_Name_Id": "11143"
        },
        {
          "Id": 1617,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "SubClient_Name_Id": "11144"
        },
        {
          "Id": 1618,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "SubClient_Name_Id": "11145"
        },
        {
          "Id": 1619,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC",
          "SubClient_Name_Id": "11142"
        },
        {
          "Id": 1620,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "Client_Name_ID": "11143",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "SubClient_Name_Id": "11143"
        },
        {
          "Id": 1621,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "SubClient_Name_Id": "11144"
        },
        {
          "Id": 1622,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - Edits",
          "Client_Name_ID": "11135",
          "SubClient_Name": "Parallon: Urgent Care Services - Edits",
          "SubClient_Name_Id": "11135"
        },
        {
          "Id": 1623,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - Coding",
          "Client_Name_ID": "11136",
          "SubClient_Name": "Parallon: Urgent Care Services - Coding",
          "SubClient_Name_Id": "11136"
        },
        {
          "Id": 1624,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - Edits",
          "Client_Name_ID": "11135",
          "SubClient_Name": "Parallon: Urgent Care Services - Edits",
          "SubClient_Name_Id": "11135"
        },
        {
          "Id": 1625,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - Coding",
          "Client_Name_ID": "11136",
          "SubClient_Name": "Parallon: Urgent Care Services - Coding",
          "SubClient_Name_Id": "11136"
        },
        {
          "Id": 1626,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - QV voids",
          "Client_Name_ID": "11368",
          "SubClient_Name": "Parallon: Urgent Care Services - QV voids",
          "SubClient_Name_Id": "11368"
        },
        {
          "Id": 1627,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Urgent Care Services - QV voids",
          "Client_Name_ID": "11368",
          "SubClient_Name": "Parallon: Urgent Care Services - QV voids",
          "SubClient_Name_Id": "11368"
        },
        {
          "Id": 1628,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "Client_Name_ID": "11365",
          "SubClient_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "SubClient_Name_Id": "11365"
        },
        {
          "Id": 1629,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "Client_Name_ID": "11365",
          "SubClient_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "SubClient_Name_Id": "11365"
        },
        {
          "Id": 1630,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation above 365 DOS",
          "Client_Name_ID": "11366",
          "SubClient_Name": "Parallon: Texas: Workers compensation above 365 DOS",
          "SubClient_Name_Id": "11366"
        },
        {
          "Id": 1631,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation above 365 DOS",
          "Client_Name_ID": "11366",
          "SubClient_Name": "Parallon: Texas: Workers compensation above 365 DOS",
          "SubClient_Name_Id": "11366"
        },
        {
          "Id": 1632,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits With I&I - CAC",
          "Client_Name_ID": "11388",
          "SubClient_Name": "Parallon: ED Admits With I&I - CAC",
          "SubClient_Name_Id": "11388"
        },
        {
          "Id": 1633,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits With I&I - CAC",
          "Client_Name_ID": "11388",
          "SubClient_Name": "Parallon: ED Admits With I&I - CAC",
          "SubClient_Name_Id": "11388"
        },
        {
          "Id": 1634,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits EM Only - CAC",
          "Client_Name_ID": "11389",
          "SubClient_Name": "Parallon: ED Admits EM Only - CAC",
          "SubClient_Name_Id": "11389"
        },
        {
          "Id": 1635,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits EM Only - CAC",
          "Client_Name_ID": "11389",
          "SubClient_Name": "Parallon: ED Admits EM Only - CAC",
          "SubClient_Name_Id": "11389"
        },
        {
          "Id": 1636,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "Client_Name_ID": "11273",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "SubClient_Name_Id": "11273"
        },
        {
          "Id": 1637,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "Client_Name_ID": "11281",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "SubClient_Name_Id": "11281"
        },
        {
          "Id": 1638,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "Client_Name_ID": "11273",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "SubClient_Name_Id": "11273"
        },
        {
          "Id": 1639,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "Client_Name_ID": "11281",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "SubClient_Name_Id": "11281"
        },
        {
          "Id": 1640,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC - TAM",
          "Client_Name_ID": "11271",
          "SubClient_Name": "Parallon: Inpatient CAC - TAM",
          "SubClient_Name_Id": "11271"
        },
        {
          "Id": 1641,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC - TAM",
          "Client_Name_ID": "11271",
          "SubClient_Name": "Parallon: Inpatient CAC - TAM",
          "SubClient_Name_Id": "11271"
        },
        {
          "Id": 1642,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC -RIC",
          "Client_Name_ID": "11277",
          "SubClient_Name": "Parallon: Inpatient CAC -RIC",
          "SubClient_Name_Id": "11277"
        },
        {
          "Id": 1643,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC -RIC",
          "Client_Name_ID": "11277",
          "SubClient_Name": "Parallon: Inpatient CAC -RIC",
          "SubClient_Name_Id": "11277"
        },
        {
          "Id": 1644,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up",
          "Client_Name_ID": "11362",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up",
          "SubClient_Name_Id": "11362"
        },
        {
          "Id": 1645,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up above 365 DOS",
          "Client_Name_ID": "11363",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11363"
        },
        {
          "Id": 1646,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up",
          "Client_Name_ID": "11362",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up",
          "SubClient_Name_Id": "11362"
        },
        {
          "Id": 1647,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up above 365 DOS",
          "Client_Name_ID": "11363",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11363"
        },
        {
          "Id": 1648,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Duplicate",
          "Client_Name_ID": "11320",
          "SubClient_Name": "Parallon: Tennessee CBO: Duplicate",
          "SubClient_Name_Id": "11320"
        },
        {
          "Id": 1649,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Medicaid Secondary Claims",
          "Client_Name_ID": "11321",
          "SubClient_Name": "Parallon: Tennessee CBO: Medicaid Secondary Claims",
          "SubClient_Name_Id": "11321"
        },
        {
          "Id": 1650,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: Rejections Temporary Project",
          "Client_Name_ID": "11322",
          "SubClient_Name": "Parallon: Texas CBO: Rejections Temporary Project",
          "SubClient_Name_Id": "11322"
        },
        {
          "Id": 1651,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Duplicate",
          "Client_Name_ID": "11320",
          "SubClient_Name": "Parallon: Tennessee CBO: Duplicate",
          "SubClient_Name_Id": "11320"
        },
        {
          "Id": 1652,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: Medicaid Secondary Claims",
          "Client_Name_ID": "11321",
          "SubClient_Name": "Parallon: Tennessee CBO: Medicaid Secondary Claims",
          "SubClient_Name_Id": "11321"
        },
        {
          "Id": 1653,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: Rejections Temporary Project",
          "Client_Name_ID": "11322",
          "SubClient_Name": "Parallon: Texas CBO: Rejections Temporary Project",
          "SubClient_Name_Id": "11322"
        },
        {
          "Id": 1654,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation",
          "Client_Name_ID": "11288",
          "SubClient_Name": "Parallon: Texas: Workers compensation",
          "SubClient_Name_Id": "11288"
        },
        {
          "Id": 1655,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation",
          "Client_Name_ID": "11288",
          "SubClient_Name": "Parallon: Texas: Workers compensation",
          "SubClient_Name_Id": "11288"
        },
        {
          "Id": 1656,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: EOB",
          "Client_Name_ID": "11231",
          "SubClient_Name": "Parallon: Tennessee CBO: EOB",
          "SubClient_Name_Id": "11231"
        },
        {
          "Id": 1657,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: EOB",
          "Client_Name_ID": "11231",
          "SubClient_Name": "Parallon: Tennessee CBO: EOB",
          "SubClient_Name_Id": "11231"
        },
        {
          "Id": 1658,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: AR Follow up",
          "Client_Name_ID": "11133",
          "SubClient_Name": "Parallon: Tennessee CBO: AR Follow up",
          "SubClient_Name_Id": "11133"
        },
        {
          "Id": 1659,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: AR Follow up",
          "Client_Name_ID": "11133",
          "SubClient_Name": "Parallon: Tennessee CBO: AR Follow up",
          "SubClient_Name_Id": "11133"
        },
        {
          "Id": 1660,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: AR Follow up above 365 DOS",
          "Client_Name_ID": "11134",
          "SubClient_Name": "Parallon: Tennessee CBO: AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11134"
        },
        {
          "Id": 1661,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Tennessee CBO: AR Follow up above 365 DOS",
          "Client_Name_ID": "11134",
          "SubClient_Name": "Parallon: Tennessee CBO: AR Follow up above 365 DOS",
          "SubClient_Name_Id": "11134"
        },
        {
          "Id": 1662,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - >10 Days LOS - Audit",
          "SubClient_Name_Id": "10899-4"
        },
        {
          "Id": 1663,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - Raising Query",
          "SubClient_Name_Id": "10899-5"
        },
        {
          "Id": 1664,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - IP Pending Rework - Operative report",
          "SubClient_Name_Id": "10899-6"
        },
        {
          "Id": 1665,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - IP",
          "SubClient_Name_Id": "10899-3"
        },
        {
          "Id": 1666,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records",
          "Client_Name_ID": "10910",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - SDS",
          "SubClient_Name_Id": "10910-2"
        },
        {
          "Id": 1667,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records",
          "Client_Name_ID": "10910",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - SDC",
          "SubClient_Name_Id": "10910-3"
        },
        {
          "Id": 1668,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Covid Rebill",
          "SubClient_Name_Id": "11142-8"
        },
        {
          "Id": 1669,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - Wound Care",
          "SubClient_Name_Id": "11144-3"
        },
        {
          "Id": 1670,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - Covid Rebill",
          "SubClient_Name_Id": "11144-4"
        },
        {
          "Id": 1671,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - CIT",
          "SubClient_Name_Id": "11142-1"
        },
        {
          "Id": 1672,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - CQR",
          "SubClient_Name_Id": "11142-2"
        },
        {
          "Id": 1673,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Covid 19 Correction",
          "SubClient_Name_Id": "11142-3"
        },
        {
          "Id": 1674,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - DD Audit",
          "SubClient_Name_Id": "11142-4"
        },
        {
          "Id": 1675,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Line Trainer Support Audit",
          "SubClient_Name_Id": "11142-5"
        },
        {
          "Id": 1676,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Random & Focus Audit",
          "SubClient_Name_Id": "11142-6"
        },
        {
          "Id": 1677,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - HIM C Audit",
          "SubClient_Name_Id": "11142-7"
        },
        {
          "Id": 1678,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC",
          "SubClient_Name_Id": "10904-2"
        },
        {
          "Id": 1679,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CIT",
          "SubClient_Name_Id": "10904-3"
        },
        {
          "Id": 1680,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - ED Admits",
          "SubClient_Name_Id": "10904-4"
        },
        {
          "Id": 1681,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC Audit",
          "SubClient_Name_Id": "10904-5"
        },
        {
          "Id": 1682,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC Covid Audit",
          "SubClient_Name_Id": "10904-6"
        },
        {
          "Id": 1683,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC Audit",
          "SubClient_Name_Id": "11145-1"
        },
        {
          "Id": 1684,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC Covid Audit",
          "SubClient_Name_Id": "11145-2"
        },
        {
          "Id": 1685,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "Client_Name_ID": "11143",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records - CAC - CAC CIT",
          "SubClient_Name_Id": "11143-1"
        },
        {
          "Id": 1686,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records - CAC",
          "Client_Name_ID": "11143",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records - CAC - CAC Audit",
          "SubClient_Name_Id": "11143-2"
        },
        {
          "Id": 1687,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - CAC Audit",
          "SubClient_Name_Id": "11144-1"
        },
        {
          "Id": 1688,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - CIT",
          "SubClient_Name_Id": "11144-2"
        },
        {
          "Id": 1689,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission",
          "Client_Name_ID": "11486",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11486-1"
        },
        {
          "Id": 1690,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission",
          "Client_Name_ID": "11487",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11487-1"
        },
        {
          "Id": 1691,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "Client_Name_ID": "11488",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11488-1"
        },
        {
          "Id": 1692,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "Client_Name_ID": "11489",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department Optum - Mission - Audit",
          "SubClient_Name_Id": "11489-1"
        },
        {
          "Id": 1693,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11485-2"
        },
        {
          "Id": 1694,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CIT",
          "SubClient_Name_Id": "11145-3"
        },
        {
          "Id": 1695,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC-CIT",
          "SubClient_Name_Id": "11145-4"
        },
        {
          "Id": 1696,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission - Concurrent",
          "SubClient_Name_Id": "11485-1"
        },
        {
          "Id": 1697,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Mission denial coding",
          "Client_Name_ID": "11521",
          "SubClient_Name": "Parallon: Mission denial coding",
          "SubClient_Name_Id": "11521"
        },
        {
          "Id": 1698,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Mission denial coding",
          "Client_Name_ID": "11521",
          "SubClient_Name": "Parallon: Mission denial coding",
          "SubClient_Name_Id": "11521"
        },
        {
          "Id": 1699,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: PV UC Special Project",
          "Client_Name_ID": "11522",
          "SubClient_Name": "Parallon: PV UC Special Project",
          "SubClient_Name_Id": "11522"
        },
        {
          "Id": 1700,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: PV UC Special Project",
          "Client_Name_ID": "11522",
          "SubClient_Name": "Parallon: PV UC Special Project",
          "SubClient_Name_Id": "11522"
        },
        {
          "Id": 1701,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E&M w/EKG and Device Checks",
          "Client_Name_ID": "11371",
          "SubClient_Name": "Parallon: E&M w/EKG and Device Checks",
          "SubClient_Name_Id": "11371"
        },
        {
          "Id": 1702,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E&M w/EKG and Device Checks",
          "Client_Name_ID": "11371",
          "SubClient_Name": "Parallon: E&M w/EKG and Device Checks",
          "SubClient_Name_Id": "11371"
        },
        {
          "Id": 1703,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up",
          "Client_Name_ID": "11362",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up - Code Helpdesk",
          "SubClient_Name_Id": "11362-1"
        },
        {
          "Id": 1704,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - Concurrent",
          "SubClient_Name_Id": "10899-2"
        },
        {
          "Id": 1705,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission",
          "SubClient_Name_Id": "11485"
        },
        {
          "Id": 1706,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission",
          "SubClient_Name_Id": "11485"
        },
        {
          "Id": 1707,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission",
          "Client_Name_ID": "11486",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission",
          "SubClient_Name_Id": "11486"
        },
        {
          "Id": 1708,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission",
          "Client_Name_ID": "11486",
          "SubClient_Name": "Parallon: Outpatient Observation (OBS) Records CAC Optum - Mission",
          "SubClient_Name_Id": "11486"
        },
        {
          "Id": 1709,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission",
          "Client_Name_ID": "11487",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission",
          "SubClient_Name_Id": "11487"
        },
        {
          "Id": 1710,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission",
          "Client_Name_ID": "11487",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC Optum - Mission",
          "SubClient_Name_Id": "11487"
        },
        {
          "Id": 1711,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "Client_Name_ID": "11488",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "SubClient_Name_Id": "11488"
        },
        {
          "Id": 1712,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "Client_Name_ID": "11488",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "SubClient_Name_Id": "11488"
        },
        {
          "Id": 1713,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "Client_Name_ID": "11489",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "SubClient_Name_Id": "11489"
        },
        {
          "Id": 1714,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "Client_Name_ID": "11489",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "SubClient_Name_Id": "11489"
        },
        {
          "Id": 1715,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - Covid Rebill",
          "SubClient_Name_Id": "11145-5"
        },
        {
          "Id": 1716,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: UCC Medical Records Retrieval",
          "Client_Name_ID": "11583",
          "SubClient_Name": "Parallon: UCC Medical Records Retrieval",
          "SubClient_Name_Id": "11583"
        },
        {
          "Id": 1717,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: UCC Medical Records Retrieval",
          "Client_Name_ID": "11583",
          "SubClient_Name": "Parallon: UCC Medical Records Retrieval",
          "SubClient_Name_Id": "11583"
        },
        {
          "Id": 1718,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas CBO: AR Follow up",
          "Client_Name_ID": "11362",
          "SubClient_Name": "Parallon: Texas CBO: AR Follow up - Code Helpdesk",
          "SubClient_Name_Id": "11362-1"
        },
        {
          "Id": 1719,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Surgery",
          "Client_Name_ID": "10913",
          "SubClient_Name": "Parallon: Surgery",
          "SubClient_Name_Id": "10913"
        },
        {
          "Id": 1720,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: E/M & Surgery",
          "Client_Name_ID": "10897",
          "SubClient_Name": "Parallon: E/M & Surgery",
          "SubClient_Name_Id": "10897"
        },
        {
          "Id": 1721,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "Client_Name_ID": "11365",
          "SubClient_Name": "Parallon: Texas: Workers compensation less than 365 DOS - Documents",
          "SubClient_Name_Id": "11365-1"
        },
        {
          "Id": 1722,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - Wound Care",
          "SubClient_Name_Id": "11144-3"
        },
        {
          "Id": 1723,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Claim Denials",
          "Client_Name_ID": "11667",
          "SubClient_Name": "Parallon: Claim Denials",
          "SubClient_Name_Id": "11667"
        },
        {
          "Id": 1724,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Claim Denials",
          "Client_Name_ID": "11667",
          "SubClient_Name": "Parallon: Claim Denials",
          "SubClient_Name_Id": "11667"
        },
        {
          "Id": 1725,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Texas: Workers compensation less than 365 DOS",
          "Client_Name_ID": "11365",
          "SubClient_Name": "Parallon: Texas: Workers compensation less than 365 DOS - Call Backs",
          "SubClient_Name_Id": "11365-2"
        },
        {
          "Id": 1726,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: All Script Claims",
          "Client_Name_ID": "11707",
          "SubClient_Name": "Parallon: All Script Claims",
          "SubClient_Name_Id": "11707"
        },
        {
          "Id": 1727,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: All Script Claims",
          "Client_Name_ID": "11707",
          "SubClient_Name": "Parallon: All Script Claims",
          "SubClient_Name_Id": "11707"
        },
        {
          "Id": 1728,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Epic No Response Claims",
          "Client_Name_ID": "11684",
          "SubClient_Name": "Parallon: Epic No Response Claims",
          "SubClient_Name_Id": "11684"
        },
        {
          "Id": 1729,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Epic No Response Claims",
          "Client_Name_ID": "11684",
          "SubClient_Name": "Parallon: Epic No Response Claims",
          "SubClient_Name_Id": "11684"
        },
        {
          "Id": 1730,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Standard Request",
          "Client_Name_ID": "11686",
          "SubClient_Name": "Parallon: Standard Request",
          "SubClient_Name_Id": "11686"
        },
        {
          "Id": 1731,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Standard Request",
          "Client_Name_ID": "11686",
          "SubClient_Name": "Parallon: Standard Request",
          "SubClient_Name_Id": "11686"
        },
        {
          "Id": 1732,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Legal Document Request",
          "Client_Name_ID": "11687",
          "SubClient_Name": "Parallon: Legal Document Request",
          "SubClient_Name_Id": "11687"
        },
        {
          "Id": 1733,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Legal Document Request",
          "Client_Name_ID": "11687",
          "SubClient_Name": "Parallon: Legal Document Request",
          "SubClient_Name_Id": "11687"
        },
        {
          "Id": 1734,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Cashiering",
          "Client_Name_ID": "11689",
          "SubClient_Name": "Parallon: Cashiering",
          "SubClient_Name_Id": "11689"
        },
        {
          "Id": 1735,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Cashiering",
          "Client_Name_ID": "11689",
          "SubClient_Name": "Parallon: Cashiering",
          "SubClient_Name_Id": "11689"
        },
        {
          "Id": 1736,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Secondary Billing",
          "Client_Name_ID": "11690",
          "SubClient_Name": "Parallon: Secondary Billing",
          "SubClient_Name_Id": "11690"
        },
        {
          "Id": 1737,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Secondary Billing",
          "Client_Name_ID": "11690",
          "SubClient_Name": "Parallon: Secondary Billing",
          "SubClient_Name_Id": "11690"
        },
        {
          "Id": 1738,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Clinical Denials",
          "Client_Name_ID": "11675",
          "SubClient_Name": "Parallon: Clinical Denials",
          "SubClient_Name_Id": "11675"
        },
        {
          "Id": 1739,
          "Original_Client_Name": "HCA Parallon",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Clinical Denials",
          "Client_Name_ID": "11675",
          "SubClient_Name": "Parallon: Clinical Denials",
          "SubClient_Name_Id": "11675"
        },
        {
          "Id": 1740,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - Covid Rebill",
          "SubClient_Name_Id": "11145-5"
        },
        {
          "Id": 1741,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "Client_Name_ID": "10903",
          "SubClient_Name": "Parallon: Outpatient : Clinical (CLI) Records - COVID Rebill",
          "SubClient_Name_Id": "10903-1"
        },
        {
          "Id": 1742,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - COVID Rebill",
          "SubClient_Name_Id": "10904-1"
        },
        {
          "Id": 1743,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient - Concurrent",
          "SubClient_Name_Id": "10899-1"
        },
        {
          "Id": 1744,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient",
          "Client_Name_ID": "10899",
          "SubClient_Name": "Parallon: Inpatient",
          "SubClient_Name_Id": "10899"
        },
        {
          "Id": 1745,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - CIT",
          "SubClient_Name_Id": "11142-1"
        },
        {
          "Id": 1746,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - CQR",
          "SubClient_Name_Id": "11142-2"
        },
        {
          "Id": 1747,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Covid 19 Correction",
          "SubClient_Name_Id": "11142-3"
        },
        {
          "Id": 1748,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - DD Audit",
          "SubClient_Name_Id": "11142-4"
        },
        {
          "Id": 1749,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Line Trainer Support Audit",
          "SubClient_Name_Id": "11142-5"
        },
        {
          "Id": 1750,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Random & Focus Audit",
          "SubClient_Name_Id": "11142-6"
        },
        {
          "Id": 1751,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - HIM C Audit",
          "SubClient_Name_Id": "11142-7"
        },
        {
          "Id": 1752,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC",
          "SubClient_Name_Id": "10904-2"
        },
        {
          "Id": 1753,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CIT",
          "SubClient_Name_Id": "10904-3"
        },
        {
          "Id": 1754,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - ED Admits",
          "SubClient_Name_Id": "10904-4"
        },
        {
          "Id": 1755,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC Audit",
          "SubClient_Name_Id": "10904-5"
        },
        {
          "Id": 1756,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department - CAC Covid Audit",
          "SubClient_Name_Id": "10904-6"
        },
        {
          "Id": 1757,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC Audit",
          "SubClient_Name_Id": "11145-1"
        },
        {
          "Id": 1758,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC Covid Audit",
          "SubClient_Name_Id": "11145-2"
        },
        {
          "Id": 1759,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "Client_Name_ID": "11488",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11488-1"
        },
        {
          "Id": 1760,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "Client_Name_ID": "11489",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department Optum - Mission - Audit",
          "SubClient_Name_Id": "11489-1"
        },
        {
          "Id": 1761,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission - Audit",
          "SubClient_Name_Id": "11485-1"
        },
        {
          "Id": 1762,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CIT",
          "SubClient_Name_Id": "11145-3"
        },
        {
          "Id": 1763,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC - CAC-CIT",
          "SubClient_Name_Id": "11145-4"
        },
        {
          "Id": 1764,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC",
          "SubClient_Name_Id": "11142"
        },
        {
          "Id": 1765,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC Optum - Mission",
          "Client_Name_ID": "11485",
          "SubClient_Name": "Parallon: Inpatient CAC Optum - Mission",
          "SubClient_Name_Id": "11485"
        },
        {
          "Id": 1766,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "Client_Name_ID": "11488",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC Optum - Mission",
          "SubClient_Name_Id": "11488"
        },
        {
          "Id": 1767,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "Client_Name_ID": "11489",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department Optum - Mission",
          "SubClient_Name_Id": "11489"
        },
        {
          "Id": 1768,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - Wound Care",
          "SubClient_Name_Id": "11144-1"
        },
        {
          "Id": 1769,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC",
          "Client_Name_ID": "11144",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery(SDS) Records - CAC - Covid Rebill",
          "SubClient_Name_Id": "11144-2"
        },
        {
          "Id": 1770,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient - CAC",
          "Client_Name_ID": "11142",
          "SubClient_Name": "Parallon: Inpatient - CAC - Covid Rebill",
          "SubClient_Name_Id": "11142-8"
        },
        {
          "Id": 1771,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - TAM",
          "Client_Name_ID": "11270",
          "SubClient_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - TAM",
          "SubClient_Name_Id": "11270"
        },
        {
          "Id": 1772,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "Client_Name_ID": "11273",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "SubClient_Name_Id": "11273"
        },
        {
          "Id": 1773,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path - TAM",
          "Client_Name_ID": "11274",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path - TAM",
          "SubClient_Name_Id": "11274"
        },
        {
          "Id": 1774,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - RIC",
          "Client_Name_ID": "11276",
          "SubClient_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - RIC",
          "SubClient_Name_Id": "11276"
        },
        {
          "Id": 1775,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "Client_Name_ID": "11281",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "SubClient_Name_Id": "11281"
        },
        {
          "Id": 1776,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path - RIC",
          "Client_Name_ID": "11278",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path - RIC",
          "SubClient_Name_Id": "11278"
        },
        {
          "Id": 1777,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - RIC",
          "Client_Name_ID": "11282",
          "SubClient_Name": "Parallon: ED Admits - RIC",
          "SubClient_Name_Id": "11282"
        },
        {
          "Id": 1778,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - SAN",
          "Client_Name_ID": "11283",
          "SubClient_Name": "Parallon: ED Admits - SAN",
          "SubClient_Name_Id": "11283"
        },
        {
          "Id": 1779,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - TAM",
          "Client_Name_ID": "11275",
          "SubClient_Name": "Parallon: ED Admits - TAM",
          "SubClient_Name_Id": "11275"
        },
        {
          "Id": 1780,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path SAN",
          "Client_Name_ID": "11279",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path SAN",
          "SubClient_Name_Id": "11279"
        },
        {
          "Id": 1781,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - TAM",
          "Client_Name_ID": "11270",
          "SubClient_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - TAM",
          "SubClient_Name_Id": "11270"
        },
        {
          "Id": 1782,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "Client_Name_ID": "11273",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - TAM",
          "SubClient_Name_Id": "11273"
        },
        {
          "Id": 1783,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path - TAM",
          "Client_Name_ID": "11274",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path - TAM",
          "SubClient_Name_Id": "11274"
        },
        {
          "Id": 1784,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - RIC",
          "Client_Name_ID": "11276",
          "SubClient_Name": "Parallon: Outpatient-Clinical (CLI) Records CAC - RIC",
          "SubClient_Name_Id": "11276"
        },
        {
          "Id": 1785,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "Client_Name_ID": "11281",
          "SubClient_Name": "Parallon: Outpatient Same Day Surgery (SDC) Records CAC - RIC",
          "SubClient_Name_Id": "11281"
        },
        {
          "Id": 1786,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path - RIC",
          "Client_Name_ID": "11278",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path - RIC",
          "SubClient_Name_Id": "11278"
        },
        {
          "Id": 1787,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - RIC",
          "Client_Name_ID": "11282",
          "SubClient_Name": "Parallon: ED Admits - RIC",
          "SubClient_Name_Id": "11282"
        },
        {
          "Id": 1788,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - SAN",
          "Client_Name_ID": "11283",
          "SubClient_Name": "Parallon: ED Admits - SAN",
          "SubClient_Name_Id": "11283"
        },
        {
          "Id": 1789,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits - TAM",
          "Client_Name_ID": "11275",
          "SubClient_Name": "Parallon: ED Admits - TAM",
          "SubClient_Name_Id": "11275"
        },
        {
          "Id": 1790,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient-Emergency Department Single Path SAN",
          "Client_Name_ID": "11279",
          "SubClient_Name": "Parallon: Outpatient-Emergency Department Single Path SAN",
          "SubClient_Name_Id": "11279"
        },
        {
          "Id": 1791,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC - TAM",
          "Client_Name_ID": "11271",
          "SubClient_Name": "Parallon: Inpatient CAC - TAM",
          "SubClient_Name_Id": "11271"
        },
        {
          "Id": 1792,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC - TAM",
          "Client_Name_ID": "11271",
          "SubClient_Name": "Parallon: Inpatient CAC - TAM",
          "SubClient_Name_Id": "11271"
        },
        {
          "Id": 1793,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC -RIC",
          "Client_Name_ID": "11277",
          "SubClient_Name": "Parallon: Inpatient CAC -RIC",
          "SubClient_Name_Id": "11277"
        },
        {
          "Id": 1794,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Inpatient CAC -RIC",
          "Client_Name_ID": "11277",
          "SubClient_Name": "Parallon: Inpatient CAC -RIC",
          "SubClient_Name_Id": "11277"
        },
        {
          "Id": 1795,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits EM Only - CAC",
          "Client_Name_ID": "11389",
          "SubClient_Name": "Parallon: ED Admits EM Only - CAC",
          "SubClient_Name_Id": "11389"
        },
        {
          "Id": 1796,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits With I&I - CAC",
          "Client_Name_ID": "11388",
          "SubClient_Name": "Parallon: ED Admits With I&I - CAC",
          "SubClient_Name_Id": "11388"
        },
        {
          "Id": 1797,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits With I&I - CAC",
          "Client_Name_ID": "11388",
          "SubClient_Name": "Parallon: ED Admits With I&I - CAC",
          "SubClient_Name_Id": "11388"
        },
        {
          "Id": 1798,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: ED Admits EM Only - CAC",
          "Client_Name_ID": "11389",
          "SubClient_Name": "Parallon: ED Admits EM Only - CAC",
          "SubClient_Name_Id": "11389"
        },
        {
          "Id": 1799,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "SubClient_Name_Id": "11145"
        },
        {
          "Id": 1800,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "Client_Name_ID": "11145",
          "SubClient_Name": "Parallon: Outpatient:Clinical (CLI) Records - CAC",
          "SubClient_Name_Id": "11145"
        },
        {
          "Id": 1801,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records",
          "Client_Name_ID": "10903",
          "SubClient_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "SubClient_Name_Id": "10903"
        },
        {
          "Id": 1802,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient:Clinical (CLI) Records",
          "Client_Name_ID": "10903",
          "SubClient_Name": "Parallon: Outpatient : Clinical (CLI) Records",
          "SubClient_Name_Id": "10903"
        },
        {
          "Id": 1803,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department",
          "SubClient_Name_Id": "10904"
        },
        {
          "Id": 1804,
          "Original_Client_Name": "HCA Parallon - Aurangabad",
          "Original_Client_Name_ID": "99055",
          "Client_Name": "Parallon: Outpatient : Emergency Department",
          "Client_Name_ID": "10904",
          "SubClient_Name": "Parallon: Outpatient : Emergency Department",
          "SubClient_Name_Id": "10904"
        },
        {
          "Id": 1805,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process",
          "SubClient_Name_Id": "10795"
        },
        {
          "Id": 1806,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - NON Vascular",
          "SubClient_Name_Id": "10795-1"
        },
        {
          "Id": 1807,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - NON Vascular",
          "SubClient_Name_Id": "10795-1"
        },
        {
          "Id": 1808,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 1",
          "SubClient_Name_Id": "10795-2"
        },
        {
          "Id": 1809,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 1",
          "SubClient_Name_Id": "10795-2"
        },
        {
          "Id": 1810,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 2",
          "SubClient_Name_Id": "10795-3"
        },
        {
          "Id": 1811,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 2",
          "SubClient_Name_Id": "10795-3"
        },
        {
          "Id": 1812,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 3",
          "SubClient_Name_Id": "10795-4"
        },
        {
          "Id": 1813,
          "Original_Client_Name": "Hudson Valley Radiologists PC,",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 3",
          "SubClient_Name_Id": "10795-4"
        },
        {
          "Id": 1814,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: Medical Coding (iCode)",
          "Client_Name_ID": "10796",
          "SubClient_Name": "Hudson: Medical Coding (iCode) - DRA",
          "SubClient_Name_Id": "10796-1"
        },
        {
          "Id": 1815,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: Medical Coding (iCode)",
          "Client_Name_ID": "10796",
          "SubClient_Name": "Hudson: Medical Coding (iCode) - DRA",
          "SubClient_Name_Id": "10796-1"
        },
        {
          "Id": 1816,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process",
          "SubClient_Name_Id": "10795"
        },
        {
          "Id": 1817,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - NON Vascular",
          "SubClient_Name_Id": "10795-1"
        },
        {
          "Id": 1818,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 1",
          "SubClient_Name_Id": "10795-2"
        },
        {
          "Id": 1819,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 2",
          "SubClient_Name_Id": "10795-3"
        },
        {
          "Id": 1820,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 3",
          "SubClient_Name_Id": "10795-4"
        },
        {
          "Id": 1821,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - NON Vascular",
          "SubClient_Name_Id": "10795-1"
        },
        {
          "Id": 1822,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 1",
          "SubClient_Name_Id": "10795-2"
        },
        {
          "Id": 1823,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 2",
          "SubClient_Name_Id": "10795-3"
        },
        {
          "Id": 1824,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process - Vascular Level 3",
          "SubClient_Name_Id": "10795-4"
        },
        {
          "Id": 1825,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: IR Sub Process",
          "Client_Name_ID": "10795",
          "SubClient_Name": "Hudson: IR Sub Process",
          "SubClient_Name_Id": "10795"
        },
        {
          "Id": 1826,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: Medical Coding (iCode)",
          "Client_Name_ID": "10796",
          "SubClient_Name": "Hudson: Medical Coding (iCode)",
          "SubClient_Name_Id": "10796"
        },
        {
          "Id": 1827,
          "Original_Client_Name": "Hudson Valley Radiologists PC, - Aurangabad",
          "Original_Client_Name_ID": "99036",
          "Client_Name": "Hudson: Medical Coding (iCode)",
          "Client_Name_ID": "10796",
          "SubClient_Name": "Hudson: Medical Coding (iCode)",
          "SubClient_Name_Id": "10796"
        },
        {
          "Id": 1828,
          "Original_Client_Name": "iCode Support",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Coding HO",
          "Client_Name_ID": "21002",
          "SubClient_Name": "Coding HO",
          "SubClient_Name_Id": "21002"
        },
        {
          "Id": 1829,
          "Original_Client_Name": "iCode Support",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Coding HO",
          "Client_Name_ID": "21002",
          "SubClient_Name": "Coding HO",
          "SubClient_Name_Id": "21002"
        },
        {
          "Id": 1830,
          "Original_Client_Name": "iCRA Software testing",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Payer HO",
          "Client_Name_ID": "21006",
          "SubClient_Name": "Payer HO",
          "SubClient_Name_Id": "21006"
        },
        {
          "Id": 1831,
          "Original_Client_Name": "iCRA Software testing",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Payer HO",
          "Client_Name_ID": "21006",
          "SubClient_Name": "Payer HO",
          "SubClient_Name_Id": "21006"
        },
        {
          "Id": 1832,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project",
          "SubClient_Name_Id": "10801"
        },
        {
          "Id": 1833,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Inpatient",
          "Client_Name_ID": "10802",
          "SubClient_Name": "IUH: Inpatient",
          "SubClient_Name_Id": "10802"
        },
        {
          "Id": 1834,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Inpatient",
          "Client_Name_ID": "10802",
          "SubClient_Name": "IUH: Inpatient",
          "SubClient_Name_Id": "10802"
        },
        {
          "Id": 1835,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Ancillary",
          "Client_Name_ID": "10804",
          "SubClient_Name": "IUH: Outpatient Ancillary",
          "SubClient_Name_Id": "10804"
        },
        {
          "Id": 1836,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Ancillary",
          "Client_Name_ID": "10804",
          "SubClient_Name": "IUH: Outpatient Ancillary",
          "SubClient_Name_Id": "10804"
        },
        {
          "Id": 1837,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Surgery / Observation",
          "Client_Name_ID": "10805",
          "SubClient_Name": "IUH: Outpatient Surgery / Observation",
          "SubClient_Name_Id": "10805"
        },
        {
          "Id": 1838,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Surgery / Observation",
          "Client_Name_ID": "10805",
          "SubClient_Name": "IUH: Outpatient Surgery / Observation",
          "SubClient_Name_Id": "10805"
        },
        {
          "Id": 1839,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Radiology & EKG Coding",
          "Client_Name_ID": "10808",
          "SubClient_Name": "IUH: Radiology & EKG Coding",
          "SubClient_Name_Id": "10808"
        },
        {
          "Id": 1840,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Radiology & EKG Coding",
          "Client_Name_ID": "10808",
          "SubClient_Name": "IUH: Radiology & EKG Coding",
          "SubClient_Name_Id": "10808"
        },
        {
          "Id": 1841,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Professional Multi:specialty : Diagnosis only",
          "Client_Name_ID": "10806",
          "SubClient_Name": "IUH: Professional Multi:specialty : Diagnosis only",
          "SubClient_Name_Id": "10806"
        },
        {
          "Id": 1842,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Professional Multi:Specialty : E&M or CPT",
          "Client_Name_ID": "10807",
          "SubClient_Name": "IUH: Professional Multi:Specialty : E&M or CPT",
          "SubClient_Name_Id": "10807"
        },
        {
          "Id": 1843,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Professional Multi:specialty : Diagnosis only",
          "Client_Name_ID": "10806",
          "SubClient_Name": "IUH: Professional Multi:specialty : Diagnosis only",
          "SubClient_Name_Id": "10806"
        },
        {
          "Id": 1844,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Professional Multi:Specialty : E&M or CPT",
          "Client_Name_ID": "10807",
          "SubClient_Name": "IUH: Professional Multi:Specialty : E&M or CPT",
          "SubClient_Name_Id": "10807"
        },
        {
          "Id": 1845,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - Day",
          "SubClient_Name_Id": "10801-1"
        },
        {
          "Id": 1846,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - 60 Days Metrics",
          "SubClient_Name_Id": "10801-2"
        },
        {
          "Id": 1847,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - 60 Plus AR",
          "SubClient_Name_Id": "10801-3"
        },
        {
          "Id": 1848,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - Day",
          "SubClient_Name_Id": "10801-1"
        },
        {
          "Id": 1849,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - 60 Days Metrics",
          "SubClient_Name_Id": "10801-2"
        },
        {
          "Id": 1850,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - 60 Plus AR",
          "SubClient_Name_Id": "10801-3"
        },
        {
          "Id": 1851,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Facility AR Project",
          "Client_Name_ID": "11041",
          "SubClient_Name": "IUH: Facility AR Project",
          "SubClient_Name_Id": "11041"
        },
        {
          "Id": 1852,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Facility AR Project",
          "Client_Name_ID": "11041",
          "SubClient_Name": "IUH: Facility AR Project",
          "SubClient_Name_Id": "11041"
        },
        {
          "Id": 1853,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Eskenazi AR ATB project",
          "Client_Name_ID": "10801",
          "SubClient_Name": "IUH: Eskenazi AR ATB project - 60 Plus AR - Adjustments",
          "SubClient_Name_Id": "10801-4"
        },
        {
          "Id": 1854,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Credit Balance",
          "Client_Name_ID": "11187",
          "SubClient_Name": "IUH: Credit Balance",
          "SubClient_Name_Id": "11187"
        },
        {
          "Id": 1855,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Credit Balance",
          "Client_Name_ID": "11187",
          "SubClient_Name": "IUH: Credit Balance",
          "SubClient_Name_Id": "11187"
        },
        {
          "Id": 1856,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: IUHP Rep Code 331 AR Project",
          "Client_Name_ID": "11290",
          "SubClient_Name": "IUH: IUHP Rep Code 331 AR Project",
          "SubClient_Name_Id": "11290"
        },
        {
          "Id": 1857,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: IUHP AR Special Project",
          "Client_Name_ID": "11291",
          "SubClient_Name": "IUH: IUHP AR Special Project",
          "SubClient_Name_Id": "11291"
        },
        {
          "Id": 1858,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: IUHP Rep Code 331 AR Project",
          "Client_Name_ID": "11290",
          "SubClient_Name": "IUH: IUHP Rep Code 331 AR Project",
          "SubClient_Name_Id": "11290"
        },
        {
          "Id": 1859,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: IUHP AR Special Project",
          "Client_Name_ID": "11291",
          "SubClient_Name": "IUH: IUHP AR Special Project",
          "SubClient_Name_Id": "11291"
        },
        {
          "Id": 1860,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: 2 Vacant Rep Code - Amy",
          "Client_Name_ID": "11524",
          "SubClient_Name": "IUH: 2 Vacant Rep Code - Amy",
          "SubClient_Name_Id": "11524"
        },
        {
          "Id": 1861,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: 2 Vacant Rep Code - Amy",
          "Client_Name_ID": "11524",
          "SubClient_Name": "IUH: 2 Vacant Rep Code - Amy",
          "SubClient_Name_Id": "11524"
        },
        {
          "Id": 1862,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: 6 Vacant Rep Code Toi & Craig",
          "Client_Name_ID": "11525",
          "SubClient_Name": "IUH: 6 Vacant Rep Code  Toi & Craig",
          "SubClient_Name_Id": "11525"
        },
        {
          "Id": 1863,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: 6 Vacant Rep Code Toi & Craig",
          "Client_Name_ID": "11525",
          "SubClient_Name": "IUH: 6 Vacant Rep Code  Toi & Craig",
          "SubClient_Name_Id": "11525"
        },
        {
          "Id": 1864,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: COVID-19 Project",
          "Client_Name_ID": "11457",
          "SubClient_Name": "IUH: COVID-19 Project",
          "SubClient_Name_Id": "11457"
        },
        {
          "Id": 1865,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Physician AR project",
          "Client_Name_ID": "11458",
          "SubClient_Name": "IUH: Physician AR project",
          "SubClient_Name_Id": "11458"
        },
        {
          "Id": 1866,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: COVID-19 Project",
          "Client_Name_ID": "11457",
          "SubClient_Name": "IUH: COVID-19 Project",
          "SubClient_Name_Id": "11457"
        },
        {
          "Id": 1867,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Physician AR project",
          "Client_Name_ID": "11458",
          "SubClient_Name": "IUH: Physician AR project",
          "SubClient_Name_Id": "11458"
        },
        {
          "Id": 1868,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Surgery / Observation",
          "Client_Name_ID": "10805",
          "SubClient_Name": "IUH: Outpatient Surgery / Observation - OP SDS",
          "SubClient_Name_Id": "10805-1"
        },
        {
          "Id": 1869,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Outpatient Surgery / Observation",
          "Client_Name_ID": "10805",
          "SubClient_Name": "IUH: Outpatient Surgery / Observation - OP SDS",
          "SubClient_Name_Id": "10805-1"
        },
        {
          "Id": 1870,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Surgical Integration Rundown",
          "Client_Name_ID": "11658",
          "SubClient_Name": "IUH: Surgical Integration Rundown",
          "SubClient_Name_Id": "11658"
        },
        {
          "Id": 1871,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Surgical Integration Rundown",
          "Client_Name_ID": "11658",
          "SubClient_Name": "IUH: Surgical Integration Rundown",
          "SubClient_Name_Id": "11658"
        },
        {
          "Id": 1872,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Data Entry Project",
          "Client_Name_ID": "11691",
          "SubClient_Name": "IUH: Data Entry Project",
          "SubClient_Name_Id": "11691"
        },
        {
          "Id": 1873,
          "Original_Client_Name": "Indiana University Health",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Data Entry Project",
          "Client_Name_ID": "11691",
          "SubClient_Name": "IUH: Data Entry Project",
          "SubClient_Name_Id": "11691"
        },
        {
          "Id": 1874,
          "Original_Client_Name": "Indiana University Health - Aurangabad",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Radiology & EKG Coding",
          "Client_Name_ID": "10808",
          "SubClient_Name": "IUH: Radiology & EKG Coding",
          "SubClient_Name_Id": "10808"
        },
        {
          "Id": 1875,
          "Original_Client_Name": "Indiana University Health - Aurangabad",
          "Original_Client_Name_ID": "99037",
          "Client_Name": "IUH: Radiology & EKG Coding",
          "Client_Name_ID": "10808",
          "SubClient_Name": "IUH: Radiology & EKG Coding",
          "SubClient_Name_Id": "10808"
        },
        {
          "Id": 1876,
          "Original_Client_Name": "Induction",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Induction - AR",
          "Client_Name_ID": "21009",
          "SubClient_Name": "Induction - AR",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 1877,
          "Original_Client_Name": "Induction",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Induction - CB",
          "Client_Name_ID": "21009",
          "SubClient_Name": "Induction - CB",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 1878,
          "Original_Client_Name": "Induction",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Induction - Coding",
          "Client_Name_ID": "21009",
          "SubClient_Name": "Induction - Coding",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 1879,
          "Original_Client_Name": "Induction",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Induction - Coding",
          "Client_Name_ID": "21009",
          "SubClient_Name": "Induction - Coding",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 1880,
          "Original_Client_Name": "Induction",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Induction - BS",
          "Client_Name_ID": "21009",
          "SubClient_Name": "Induction - BS",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 1881,
          "Original_Client_Name": "Innovative Management Alternatives, LLC,",
          "Original_Client_Name_ID": "99038",
          "Client_Name": "Innovative: Urgent Care Coding and Demographic Entry Services",
          "Client_Name_ID": "10797",
          "SubClient_Name": "Innovative: Urgent Care Coding and Demographic Entry Services",
          "SubClient_Name_Id": "10797"
        },
        {
          "Id": 1882,
          "Original_Client_Name": "Innovative Management Alternatives, LLC,",
          "Original_Client_Name_ID": "99038",
          "Client_Name": "Innovative: Urgent Care Coding and Demographic Entry Services",
          "Client_Name_ID": "10797",
          "SubClient_Name": "Innovative: Urgent Care Coding and Demographic Entry Services",
          "SubClient_Name_Id": "10797"
        },
        {
          "Id": 1883,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - Manual",
          "Client_Name_ID": "11183",
          "SubClient_Name": "IPS: Payment Posting - Manual",
          "SubClient_Name_Id": "11183"
        },
        {
          "Id": 1884,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - ERA",
          "Client_Name_ID": "11184",
          "SubClient_Name": "IPS: Payment Posting - ERA",
          "SubClient_Name_Id": "11184"
        },
        {
          "Id": 1885,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - Manual",
          "Client_Name_ID": "11183",
          "SubClient_Name": "IPS: Payment Posting - Manual",
          "SubClient_Name_Id": "11183"
        },
        {
          "Id": 1886,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - ERA",
          "Client_Name_ID": "11184",
          "SubClient_Name": "IPS: Payment Posting - ERA",
          "SubClient_Name_Id": "11184"
        },
        {
          "Id": 1887,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: AR follow-up/Denials management",
          "Client_Name_ID": "11400",
          "SubClient_Name": "IPS: AR follow-up/Denials management",
          "SubClient_Name_Id": "11400"
        },
        {
          "Id": 1888,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: AR follow-up/Denials management",
          "Client_Name_ID": "11400",
          "SubClient_Name": "IPS: AR follow-up/Denials management",
          "SubClient_Name_Id": "11400"
        },
        {
          "Id": 1889,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Claims Form",
          "Client_Name_ID": "11401",
          "SubClient_Name": "IPS: Claims Form",
          "SubClient_Name_Id": "11401"
        },
        {
          "Id": 1890,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Claims Form",
          "Client_Name_ID": "11401",
          "SubClient_Name": "IPS: Claims Form",
          "SubClient_Name_Id": "11401"
        },
        {
          "Id": 1891,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Additional page (Non- Claim form)",
          "Client_Name_ID": "11402",
          "SubClient_Name": "IPS: Additional page (Non- Claim form)",
          "SubClient_Name_Id": "11402"
        },
        {
          "Id": 1892,
          "Original_Client_Name": "Integrated Practice Solutions, Inc.",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Additional page (Non- Claim form)",
          "Client_Name_ID": "11402",
          "SubClient_Name": "IPS: Additional page (Non- Claim form)",
          "SubClient_Name_Id": "11402"
        },
        {
          "Id": 1893,
          "Original_Client_Name": "Integrated Practice Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - Manual",
          "Client_Name_ID": "11183",
          "SubClient_Name": "IPS: Payment Posting - Manual",
          "SubClient_Name_Id": "11183"
        },
        {
          "Id": 1894,
          "Original_Client_Name": "Integrated Practice Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - ERA",
          "Client_Name_ID": "11184",
          "SubClient_Name": "IPS: Payment Posting - ERA",
          "SubClient_Name_Id": "11184"
        },
        {
          "Id": 1895,
          "Original_Client_Name": "Integrated Practice Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - Manual",
          "Client_Name_ID": "11183",
          "SubClient_Name": "IPS: Payment Posting - Manual",
          "SubClient_Name_Id": "11183"
        },
        {
          "Id": 1896,
          "Original_Client_Name": "Integrated Practice Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99089",
          "Client_Name": "IPS: Payment Posting - ERA",
          "Client_Name_ID": "11184",
          "SubClient_Name": "IPS: Payment Posting - ERA",
          "SubClient_Name_Id": "11184"
        },
        {
          "Id": 1897,
          "Original_Client_Name": "Integrex RCM",
          "Original_Client_Name_ID": "99098",
          "Client_Name": "Integrex: AR Follow up Services",
          "Client_Name_ID": "11312",
          "SubClient_Name": "Integrex: AR Follow up Services",
          "SubClient_Name_Id": "11312"
        },
        {
          "Id": 1898,
          "Original_Client_Name": "Integrex RCM",
          "Original_Client_Name_ID": "99098",
          "Client_Name": "Integrex: AR Follow up Services",
          "Client_Name_ID": "11312",
          "SubClient_Name": "Integrex: AR Follow up Services",
          "SubClient_Name_Id": "11312"
        },
        {
          "Id": 1899,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "Client_Name_ID": "11497",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Hospital Billing - HDV",
          "SubClient_Name_Id": "11497-1"
        },
        {
          "Id": 1900,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "Client_Name_ID": "11497",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Hospital Billing - HDV",
          "SubClient_Name_Id": "11497-1"
        },
        {
          "Id": 1901,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Code Helpdesk",
          "SubClient_Name_Id": "11498-1"
        },
        {
          "Id": 1902,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Client Assistance Review",
          "SubClient_Name_Id": "11498-2"
        },
        {
          "Id": 1903,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Concluder",
          "SubClient_Name_Id": "11498-3"
        },
        {
          "Id": 1904,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Client Assistance Review Audit",
          "SubClient_Name_Id": "11498-4"
        },
        {
          "Id": 1905,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Client Assistance Review",
          "SubClient_Name_Id": "11498-2"
        },
        {
          "Id": 1906,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Concluder",
          "SubClient_Name_Id": "11498-3"
        },
        {
          "Id": 1907,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Client Assistance Review Audit",
          "SubClient_Name_Id": "11498-4"
        },
        {
          "Id": 1908,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - HDV",
          "SubClient_Name_Id": "11498-5"
        },
        {
          "Id": 1909,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - HDV",
          "SubClient_Name_Id": "11498-5"
        },
        {
          "Id": 1910,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing - Code Helpdesk",
          "SubClient_Name_Id": "11498-1"
        },
        {
          "Id": 1911,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "Client_Name_ID": "11497",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "SubClient_Name_Id": "11497"
        },
        {
          "Id": 1912,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "Client_Name_ID": "11497",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Hospital Billing",
          "SubClient_Name_Id": "11497"
        },
        {
          "Id": 1913,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "SubClient_Name_Id": "11498"
        },
        {
          "Id": 1914,
          "Original_Client_Name": "INTEGRIS Health Inc.",
          "Original_Client_Name_ID": "99111",
          "Client_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "Client_Name_ID": "11498",
          "SubClient_Name": "INTEGRIS: RCM Support Services: Professional Billing",
          "SubClient_Name_Id": "11498"
        },
        {
          "Id": 1915,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: ATB Reports - AR Reports",
          "Client_Name_ID": "10810",
          "SubClient_Name": "J & S Stark: ATB Reports - AR Reports - ERS Denials Data",
          "SubClient_Name_Id": "10810-1"
        },
        {
          "Id": 1916,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: ATB Reports - AR Reports",
          "Client_Name_ID": "10810",
          "SubClient_Name": "J & S Stark: ATB Reports - AR Reports - ERS Denials Data",
          "SubClient_Name_Id": "10810-1"
        },
        {
          "Id": 1917,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 1918,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 1919,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 1920,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10814-4"
        },
        {
          "Id": 1921,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10814-4"
        },
        {
          "Id": 1922,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "-",
          "Client_Name_ID": "3094",
          "SubClient_Name": "Task : Charge Entry - Night shift - Metro",
          "SubClient_Name_Id": "3094-1"
        },
        {
          "Id": 1923,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "-",
          "Client_Name_ID": "3094",
          "SubClient_Name": "Task : Charge Entry - Night shift - Metro",
          "SubClient_Name_Id": "3094-1"
        },
        {
          "Id": 1924,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10811-1"
        },
        {
          "Id": 1925,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Private",
          "SubClient_Name_Id": "10811-2"
        },
        {
          "Id": 1926,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 1927,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Interfaith",
          "SubClient_Name_Id": "10811-4"
        },
        {
          "Id": 1928,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10811-5"
        },
        {
          "Id": 1929,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 1930,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 1931,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 1932,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Interfaith",
          "SubClient_Name_Id": "10812-4"
        },
        {
          "Id": 1933,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Park Slope Medicine",
          "SubClient_Name_Id": "10812-5"
        },
        {
          "Id": 1934,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - OBGYN",
          "SubClient_Name_Id": "10814-1"
        },
        {
          "Id": 1935,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 1936,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 1937,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Metro",
          "SubClient_Name_Id": "10813-1"
        },
        {
          "Id": 1938,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 1939,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 1940,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 1941,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Interfaith",
          "SubClient_Name_Id": "10813-5"
        },
        {
          "Id": 1942,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Park Slope Medicine",
          "SubClient_Name_Id": "10813-6"
        },
        {
          "Id": 1943,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10811-1"
        },
        {
          "Id": 1944,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Private",
          "SubClient_Name_Id": "10811-2"
        },
        {
          "Id": 1945,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Interfaith",
          "SubClient_Name_Id": "10811-4"
        },
        {
          "Id": 1946,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10811-5"
        },
        {
          "Id": 1947,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "-",
          "Client_Name_ID": "3094",
          "SubClient_Name": "Task : Charge Entry - Night shift - Metro",
          "SubClient_Name_Id": "3094-1"
        },
        {
          "Id": 1948,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 1949,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Interfaith",
          "SubClient_Name_Id": "10812-4"
        },
        {
          "Id": 1950,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Park Slope Medicine",
          "SubClient_Name_Id": "10812-5"
        },
        {
          "Id": 1951,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - OBGYN",
          "SubClient_Name_Id": "10814-1"
        },
        {
          "Id": 1952,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 1953,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 1954,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Metro",
          "SubClient_Name_Id": "10813-1"
        },
        {
          "Id": 1955,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 1956,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 1957,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 1958,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Interfaith",
          "SubClient_Name_Id": "10813-5"
        },
        {
          "Id": 1959,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Park Slope Medicine",
          "SubClient_Name_Id": "10813-6"
        },
        {
          "Id": 1960,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - AR Calling",
          "SubClient_Name_Id": "10813-7"
        },
        {
          "Id": 1961,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - AR Calling",
          "SubClient_Name_Id": "10813-7"
        },
        {
          "Id": 1962,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: ATB Reports - AR Reports",
          "Client_Name_ID": "10810",
          "SubClient_Name": "J & S Stark: ATB Reports - AR Reports",
          "SubClient_Name_Id": "10810"
        },
        {
          "Id": 1963,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: ATB Reports - AR Reports",
          "Client_Name_ID": "10810",
          "SubClient_Name": "J & S Stark: ATB Reports - AR Reports",
          "SubClient_Name_Id": "10810"
        },
        {
          "Id": 1964,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 1965,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 1966,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification",
          "SubClient_Name_Id": "10813"
        },
        {
          "Id": 1967,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 1968,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification",
          "SubClient_Name_Id": "10813"
        },
        {
          "Id": 1969,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 1970,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 1971,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10811-1"
        },
        {
          "Id": 1972,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Private",
          "SubClient_Name_Id": "10811-2"
        },
        {
          "Id": 1973,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Cerner",
          "SubClient_Name_Id": "10811-4"
        },
        {
          "Id": 1974,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Metro",
          "SubClient_Name_Id": "10811-5"
        },
        {
          "Id": 1975,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - AR Calling",
          "SubClient_Name_Id": "10813-7"
        },
        {
          "Id": 1976,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - AR Calling",
          "SubClient_Name_Id": "10813-7"
        },
        {
          "Id": 1977,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10811-1"
        },
        {
          "Id": 1978,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Private",
          "SubClient_Name_Id": "10811-2"
        },
        {
          "Id": 1979,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 1980,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Interfaith",
          "SubClient_Name_Id": "10811-4"
        },
        {
          "Id": 1981,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10811-5"
        },
        {
          "Id": 1982,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 1983,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 1984,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 1985,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Interfaith",
          "SubClient_Name_Id": "10812-4"
        },
        {
          "Id": 1986,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Park Slope Medicine",
          "SubClient_Name_Id": "10812-5"
        },
        {
          "Id": 1987,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - OBGYN",
          "SubClient_Name_Id": "10814-1"
        },
        {
          "Id": 1988,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 1989,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 1990,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Metro",
          "SubClient_Name_Id": "10813-1"
        },
        {
          "Id": 1991,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 1992,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 1993,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 1994,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Interfaith",
          "SubClient_Name_Id": "10813-5"
        },
        {
          "Id": 1995,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Park Slope Medicine",
          "SubClient_Name_Id": "10813-6"
        },
        {
          "Id": 1996,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10811-1"
        },
        {
          "Id": 1997,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Private",
          "SubClient_Name_Id": "10811-2"
        },
        {
          "Id": 1998,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 1999,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Interfaith",
          "SubClient_Name_Id": "10811-4"
        },
        {
          "Id": 2000,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Park Slope Medicine",
          "SubClient_Name_Id": "10811-5"
        },
        {
          "Id": 2001,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "-",
          "Client_Name_ID": "3094",
          "SubClient_Name": "Task : Charge Entry - Night shift - Metro",
          "SubClient_Name_Id": "3094-1"
        },
        {
          "Id": 2002,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 2003,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 2004,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 2005,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Interfaith",
          "SubClient_Name_Id": "10812-4"
        },
        {
          "Id": 2006,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Park Slope Medicine",
          "SubClient_Name_Id": "10812-5"
        },
        {
          "Id": 2007,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - OBGYN",
          "SubClient_Name_Id": "10814-1"
        },
        {
          "Id": 2008,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 2009,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 2010,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Metro",
          "SubClient_Name_Id": "10813-1"
        },
        {
          "Id": 2011,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 2012,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 2013,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 2014,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Interfaith",
          "SubClient_Name_Id": "10813-5"
        },
        {
          "Id": 2015,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Park Slope Medicine",
          "SubClient_Name_Id": "10813-6"
        },
        {
          "Id": 2016,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification",
          "SubClient_Name_Id": "10813"
        },
        {
          "Id": 2017,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 2018,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 2019,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 2020,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 2021,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 2022,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 2023,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 2024,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 2025,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 2026,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 2027,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification",
          "SubClient_Name_Id": "10813"
        },
        {
          "Id": 2028,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift",
          "SubClient_Name_Id": "10811"
        },
        {
          "Id": 2029,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Charge Entry - Day shift",
          "Client_Name_ID": "10811",
          "SubClient_Name": "J & S Stark: Charge Entry - Day shift - Wyckoff",
          "SubClient_Name_Id": "10811-3"
        },
        {
          "Id": 2030,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift - OBGYN",
          "SubClient_Name_Id": "10812-1"
        },
        {
          "Id": 2031,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Private",
          "SubClient_Name_Id": "10812-2"
        },
        {
          "Id": 2032,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Demo Entry - Day shift",
          "Client_Name_ID": "10812",
          "SubClient_Name": "J & S Stark: Demo Entry - Day shift- Wyckoff",
          "SubClient_Name_Id": "10812-3"
        },
        {
          "Id": 2033,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - OBGYN",
          "SubClient_Name_Id": "10813-2"
        },
        {
          "Id": 2034,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Private",
          "SubClient_Name_Id": "10813-3"
        },
        {
          "Id": 2035,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Eligibility and Benefit verification",
          "Client_Name_ID": "10813",
          "SubClient_Name": "J & S Stark: Eligibility and Benefit verification - Wyckoff",
          "SubClient_Name_Id": "10813-4"
        },
        {
          "Id": 2036,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Private",
          "SubClient_Name_Id": "10814-2"
        },
        {
          "Id": 2037,
          "Original_Client_Name": "J & S Stark Billing & Consulting Inc.",
          "Original_Client_Name_ID": "99039",
          "Client_Name": "J & S Stark: Payment Posting - Day shift",
          "Client_Name_ID": "10814",
          "SubClient_Name": "J & S Stark: Payment Posting - Day shift - Wyckoff",
          "SubClient_Name_Id": "10814-3"
        },
        {
          "Id": 2038,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2039,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2040,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: Accounts",
          "Client_Name_ID": "10816",
          "SubClient_Name": "KeyMed: Accounts",
          "SubClient_Name_Id": "10816"
        },
        {
          "Id": 2041,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2042,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2043,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: Multi Pages",
          "Client_Name_ID": "10819",
          "SubClient_Name": "KeyMed: Multi Pages",
          "SubClient_Name_Id": "10819"
        },
        {
          "Id": 2044,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2045,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Payment Posting",
          "SubClient_Name_Id": "10817-4"
        },
        {
          "Id": 2046,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - AR Follow Up",
          "SubClient_Name_Id": "10817-2"
        },
        {
          "Id": 2047,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Claim Transmission",
          "SubClient_Name_Id": "10817-5"
        },
        {
          "Id": 2048,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2049,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Payment Posting",
          "SubClient_Name_Id": "10817-4"
        },
        {
          "Id": 2050,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - AR Follow Up",
          "SubClient_Name_Id": "10817-2"
        },
        {
          "Id": 2051,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Claim Transmission",
          "SubClient_Name_Id": "10817-5"
        },
        {
          "Id": 2052,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2053,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Claim Transmission",
          "SubClient_Name_Id": "10817-5"
        },
        {
          "Id": 2054,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Payment Posting",
          "SubClient_Name_Id": "10817-4"
        },
        {
          "Id": 2055,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Charge Entry",
          "SubClient_Name_Id": "10817-3"
        },
        {
          "Id": 2056,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Claim Transmission",
          "SubClient_Name_Id": "10817-5"
        },
        {
          "Id": 2057,
          "Original_Client_Name": "KeyMed Partners, Inc",
          "Original_Client_Name_ID": "99041",
          "Client_Name": "KeyMed: End to end revenue cycle management services",
          "Client_Name_ID": "10817",
          "SubClient_Name": "KeyMed: End to end revenue cycle management services - Payment Posting",
          "SubClient_Name_Id": "10817-4"
        },
        {
          "Id": 2058,
          "Original_Client_Name": "LEAD Batch 3",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2059,
          "Original_Client_Name": "LEAD Batch 3",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2060,
          "Original_Client_Name": "LEAD Batch 3",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2061,
          "Original_Client_Name": "LEAD Batch 3",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2062,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2063,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2064,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2065,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2066,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2067,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2068,
          "Original_Client_Name": "LEAD Batch 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2069,
          "Original_Client_Name": "LEAD Batch 9",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2070,
          "Original_Client_Name": "LEAD Batch 9",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2071,
          "Original_Client_Name": "LEAD Batch 9",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2072,
          "Original_Client_Name": "LEAD Batch 9",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: LEAD Training",
          "Client_Name_ID": "21010",
          "SubClient_Name": "NonProject: LEAD Training",
          "SubClient_Name_Id": "21010"
        },
        {
          "Id": 2073,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials",
          "Client_Name_ID": "11305",
          "SubClient_Name": "PMDS: Coding Denials",
          "SubClient_Name_Id": "11305"
        },
        {
          "Id": 2074,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials",
          "Client_Name_ID": "11305",
          "SubClient_Name": "PMDS: Coding Denials",
          "SubClient_Name_Id": "11305"
        },
        {
          "Id": 2075,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - KY - LPNT - Kentucky & Indiana [19475]",
          "Client_Name_ID": "11359",
          "SubClient_Name": "PMDS:Coding Denials - KY - LPNT - Kentucky & Indiana [19475]",
          "SubClient_Name_Id": "11359"
        },
        {
          "Id": 2076,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - AL - LPNT - Andalusia & Vaughan [19364]",
          "Client_Name_ID": "11360",
          "SubClient_Name": "PMDS:Coding Denials - AL - LPNT - Andalusia & Vaughan [19364]",
          "SubClient_Name_Id": "11360"
        },
        {
          "Id": 2077,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - MT - LPNT - Montana [20102]",
          "Client_Name_ID": "11361",
          "SubClient_Name": "PMDS:Coding Denials - MT - LPNT - Montana [20102]",
          "SubClient_Name_Id": "11361"
        },
        {
          "Id": 2078,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - KY - LPNT - Kentucky & Indiana [19475]",
          "Client_Name_ID": "11359",
          "SubClient_Name": "PMDS:Coding Denials - KY - LPNT - Kentucky & Indiana [19475]",
          "SubClient_Name_Id": "11359"
        },
        {
          "Id": 2079,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - AL - LPNT - Andalusia & Vaughan [19364]",
          "Client_Name_ID": "11360",
          "SubClient_Name": "PMDS:Coding Denials - AL - LPNT - Andalusia & Vaughan [19364]",
          "SubClient_Name_Id": "11360"
        },
        {
          "Id": 2080,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS:Coding Denials - MT - LPNT - Montana [20102]",
          "Client_Name_ID": "11361",
          "SubClient_Name": "PMDS:Coding Denials - MT - LPNT - Montana [20102]",
          "SubClient_Name_Id": "11361"
        },
        {
          "Id": 2081,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Payments Posting",
          "Client_Name_ID": "11354",
          "SubClient_Name": "PMDS: Payments Posting",
          "SubClient_Name_Id": "11354"
        },
        {
          "Id": 2082,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: AR wind down",
          "Client_Name_ID": "11353",
          "SubClient_Name": "PMDS: AR wind down",
          "SubClient_Name_Id": "11353"
        },
        {
          "Id": 2083,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - Unapplied",
          "SubClient_Name_Id": "11355-1"
        },
        {
          "Id": 2084,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - Refunds",
          "SubClient_Name_Id": "11355-2"
        },
        {
          "Id": 2085,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - MISC Insurance review",
          "SubClient_Name_Id": "11355-3"
        },
        {
          "Id": 2086,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Payments Posting",
          "Client_Name_ID": "11354",
          "SubClient_Name": "PMDS: Payments Posting",
          "SubClient_Name_Id": "11354"
        },
        {
          "Id": 2087,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: AR wind down",
          "Client_Name_ID": "11353",
          "SubClient_Name": "PMDS: AR wind down",
          "SubClient_Name_Id": "11353"
        },
        {
          "Id": 2088,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - Unapplied",
          "SubClient_Name_Id": "11355-1"
        },
        {
          "Id": 2089,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - Refunds",
          "SubClient_Name_Id": "11355-2"
        },
        {
          "Id": 2090,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Unapplied/Refunds/MISC insurance review",
          "Client_Name_ID": "11355",
          "SubClient_Name": "PMDS: Unapplied/Refunds/MISC insurance review - MISC Insurance review",
          "SubClient_Name_Id": "11355-3"
        },
        {
          "Id": 2091,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Winchester - Payment Posting",
          "Client_Name_ID": "11113",
          "SubClient_Name": "PMDS: Winchester - Payment Posting - Manual",
          "SubClient_Name_Id": "11113-1"
        },
        {
          "Id": 2092,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Winchester - Payment Posting",
          "Client_Name_ID": "11113",
          "SubClient_Name": "PMDS: Winchester - Payment Posting - ERA",
          "SubClient_Name_Id": "11113-2"
        },
        {
          "Id": 2093,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Winchester - Payment Posting",
          "Client_Name_ID": "11113",
          "SubClient_Name": "PMDS: Winchester - Payment Posting - Manual",
          "SubClient_Name_Id": "11113-1"
        },
        {
          "Id": 2094,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Winchester - Payment Posting",
          "Client_Name_ID": "11113",
          "SubClient_Name": "PMDS: Winchester - Payment Posting - ERA",
          "SubClient_Name_Id": "11113-2"
        },
        {
          "Id": 2095,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry - Hospital Visits",
          "SubClient_Name_Id": "11193-1"
        },
        {
          "Id": 2096,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry - Office Visits",
          "SubClient_Name_Id": "11193-2"
        },
        {
          "Id": 2097,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - PMDS-Credit Balance-Patient/Insurance",
          "SubClient_Name_Id": "10921-16"
        },
        {
          "Id": 2098,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - PMDS-Credit Balance-Patient/Insurance",
          "SubClient_Name_Id": "10921-16"
        },
        {
          "Id": 2099,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Scrubber EDIT PMDS",
          "SubClient_Name_Id": "10921-14"
        },
        {
          "Id": 2100,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing PMG - Claim Form",
          "SubClient_Name_Id": "10922-27"
        },
        {
          "Id": 2101,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing PMG - EOB",
          "SubClient_Name_Id": "10922-28"
        },
        {
          "Id": 2102,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Payment Posting Fascia",
          "SubClient_Name_Id": "11026-12"
        },
        {
          "Id": 2103,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Payment Posting Fascia",
          "SubClient_Name_Id": "11026-12"
        },
        {
          "Id": 2104,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing PMG - Claim Form",
          "SubClient_Name_Id": "10922-27"
        },
        {
          "Id": 2105,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing PMG - EOB",
          "SubClient_Name_Id": "10922-28"
        },
        {
          "Id": 2106,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "SubClient_Name_Id": "10922"
        },
        {
          "Id": 2107,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Bad Address",
          "Client_Name_ID": "10919",
          "SubClient_Name": "PMDS: Bad Address",
          "SubClient_Name_Id": "10919"
        },
        {
          "Id": 2108,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Bad Debt",
          "Client_Name_ID": "10920",
          "SubClient_Name": "PMDS: Bad Debt",
          "SubClient_Name_Id": "10920"
        },
        {
          "Id": 2109,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "SubClient_Name_Id": "10922"
        },
        {
          "Id": 2110,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services",
          "SubClient_Name_Id": "10921"
        },
        {
          "Id": 2111,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services",
          "SubClient_Name_Id": "10921"
        },
        {
          "Id": 2112,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Bad Address Return mail",
          "SubClient_Name_Id": "11026-11"
        },
        {
          "Id": 2113,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Payment posting ERA PMDS",
          "SubClient_Name_Id": "10921-11"
        },
        {
          "Id": 2114,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Payment posting Manual PMDS",
          "SubClient_Name_Id": "10921-12"
        },
        {
          "Id": 2115,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Payment posting CENCAL PMDS",
          "SubClient_Name_Id": "10921-13"
        },
        {
          "Id": 2116,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry- NON CHDP PMDS",
          "SubClient_Name_Id": "10921-2"
        },
        {
          "Id": 2117,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Charge Entry",
          "SubClient_Name_Id": "11026-2"
        },
        {
          "Id": 2118,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - Payment Posting Manual",
          "Client_Name_ID": "11027",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - Payment Posting Manual",
          "SubClient_Name_Id": "11027"
        },
        {
          "Id": 2119,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Payment Posting-ERA",
          "SubClient_Name_Id": "11026-4"
        },
        {
          "Id": 2120,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Rejection",
          "SubClient_Name_Id": "11026-6"
        },
        {
          "Id": 2121,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Scrubber",
          "SubClient_Name_Id": "11026-7"
        },
        {
          "Id": 2122,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting - Intergy - ERA",
          "SubClient_Name_Id": "10922-20"
        },
        {
          "Id": 2123,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting - Intergy - Manual",
          "SubClient_Name_Id": "10922-21"
        },
        {
          "Id": 2124,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Bad Address Return mail CMC",
          "SubClient_Name_Id": "10922-5"
        },
        {
          "Id": 2125,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Credit Balance- Patient collection PMDS",
          "SubClient_Name_Id": "10921-7"
        },
        {
          "Id": 2126,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Credit Balance- Unapplied credit PMDS",
          "SubClient_Name_Id": "10921-8"
        },
        {
          "Id": 2127,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Unapplied credit CMC",
          "SubClient_Name_Id": "10922-6"
        },
        {
          "Id": 2128,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Bad Debt CMC",
          "SubClient_Name_Id": "10922-7"
        },
        {
          "Id": 2129,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Rejection- EDI PMDS",
          "SubClient_Name_Id": "10921-3"
        },
        {
          "Id": 2130,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "SubClient_Name_Id": "11026"
        },
        {
          "Id": 2131,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - CE Electronic CMC",
          "SubClient_Name_Id": "10922-10"
        },
        {
          "Id": 2132,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Scrubber CMC",
          "SubClient_Name_Id": "10922-11"
        },
        {
          "Id": 2133,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Rejection CMC",
          "SubClient_Name_Id": "10922-12"
        },
        {
          "Id": 2134,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - TASK CE PMDS",
          "SubClient_Name_Id": "10921-1"
        },
        {
          "Id": 2135,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - TASK PP PMDS",
          "SubClient_Name_Id": "10921-9"
        },
        {
          "Id": 2136,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing CMC - Claim Form",
          "SubClient_Name_Id": "10922-17"
        },
        {
          "Id": 2137,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing CMC - EOB",
          "SubClient_Name_Id": "10922-18"
        },
        {
          "Id": 2138,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - CE Surgical PBB",
          "SubClient_Name_Id": "10922-19"
        },
        {
          "Id": 2139,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry- NON CHDP PMDS",
          "SubClient_Name_Id": "10921-2"
        },
        {
          "Id": 2140,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry- SURGERY HOSPITAL PMDS",
          "SubClient_Name_Id": "10921-4"
        },
        {
          "Id": 2141,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry-Office Nursing PMDS",
          "SubClient_Name_Id": "10921-5"
        },
        {
          "Id": 2142,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Payment posting ERA PMDS",
          "SubClient_Name_Id": "10921-11"
        },
        {
          "Id": 2143,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Intergy -Credit Balance Patient refund",
          "SubClient_Name_Id": "10922-22"
        },
        {
          "Id": 2144,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Intergy -Credit Balance Insurance refund",
          "SubClient_Name_Id": "10922-23"
        },
        {
          "Id": 2145,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - HL7",
          "SubClient_Name_Id": "10922-24"
        },
        {
          "Id": 2146,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Unbilled",
          "SubClient_Name_Id": "10922-25"
        },
        {
          "Id": 2147,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Intergy -Credit Balance Patient refund",
          "SubClient_Name_Id": "10922-22"
        },
        {
          "Id": 2148,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Intergy -Credit Balance Insurance refund",
          "SubClient_Name_Id": "10922-23"
        },
        {
          "Id": 2149,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - HL7",
          "SubClient_Name_Id": "10922-24"
        },
        {
          "Id": 2150,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Unbilled",
          "SubClient_Name_Id": "10922-25"
        },
        {
          "Id": 2151,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials - WA - RCCH-Trios Medical Groups [18485]",
          "Client_Name_ID": "11346",
          "SubClient_Name": "PMDS: Coding Denials - WA - RCCH-Trios Medical Groups [18485]",
          "SubClient_Name_Id": "11346"
        },
        {
          "Id": 2152,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials - WA - RCCH-Trios Medical Groups [18485]",
          "Client_Name_ID": "11346",
          "SubClient_Name": "PMDS: Coding Denials - WA - RCCH-Trios Medical Groups [18485]",
          "SubClient_Name_Id": "11346"
        },
        {
          "Id": 2153,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials - WA - RCCH- Lourdes Medical Groups [18485]",
          "Client_Name_ID": "11347",
          "SubClient_Name": "PMDS: Coding Denials - WA - RCCH- Lourdes Medical Groups [18485]",
          "SubClient_Name_Id": "11347"
        },
        {
          "Id": 2154,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Coding Denials - WA - RCCH- Lourdes Medical Groups [18485]",
          "Client_Name_ID": "11347",
          "SubClient_Name": "PMDS: Coding Denials - WA - RCCH- Lourdes Medical Groups [18485]",
          "SubClient_Name_Id": "11347"
        },
        {
          "Id": 2155,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "SubClient_Name_Id": "11026"
        },
        {
          "Id": 2156,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Tool Task",
          "SubClient_Name_Id": "11026-5"
        },
        {
          "Id": 2157,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Tool Task",
          "SubClient_Name_Id": "11026-5"
        },
        {
          "Id": 2158,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials - AL - LPNT - Vaughan [19364]",
          "Client_Name_ID": "11593",
          "SubClient_Name": "LifePoint: Coding Denials - AL - LPNT - Vaughan [19364]",
          "SubClient_Name_Id": "11593"
        },
        {
          "Id": 2159,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials - AL - LPNT - Vaughan [19364]",
          "Client_Name_ID": "11593",
          "SubClient_Name": "LifePoint: Coding Denials - AL - LPNT - Vaughan [19364]",
          "SubClient_Name_Id": "11593"
        },
        {
          "Id": 2160,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down",
          "SubClient_Name_Id": "11590"
        },
        {
          "Id": 2161,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down",
          "SubClient_Name_Id": "11590"
        },
        {
          "Id": 2162,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - Ageing claims(180+)",
          "SubClient_Name_Id": "11590-1"
        },
        {
          "Id": 2163,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - Ageing claims(180+)",
          "SubClient_Name_Id": "11590-1"
        },
        {
          "Id": 2164,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - High Dollar claims($1K+)",
          "SubClient_Name_Id": "11590-2"
        },
        {
          "Id": 2165,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - High Dollar claims($1K+)",
          "SubClient_Name_Id": "11590-2"
        },
        {
          "Id": 2166,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials - VA - LPNT - Virginia [19847]",
          "Client_Name_ID": "11430",
          "SubClient_Name": "LifePoint: Coding Denials - VA - LPNT - Virginia [19847]",
          "SubClient_Name_Id": "11430"
        },
        {
          "Id": 2167,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials - VA - LPNT - Virginia [19847]",
          "Client_Name_ID": "11430",
          "SubClient_Name": "LifePoint: Coding Denials - VA - LPNT - Virginia [19847]",
          "SubClient_Name_Id": "11430"
        },
        {
          "Id": 2168,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - Code Helpdesk",
          "SubClient_Name_Id": "11590-3"
        },
        {
          "Id": 2169,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Follow up Legacy Wind down",
          "Client_Name_ID": "11590",
          "SubClient_Name": "LifePoint: AR Follow up Legacy Wind down - Code Helpdesk",
          "SubClient_Name_Id": "11590-3"
        },
        {
          "Id": 2170,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Paper Printing PMG - EOB",
          "SubClient_Name_Id": "10921-17"
        },
        {
          "Id": 2171,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Paper Printing PMG - Claim Form",
          "SubClient_Name_Id": "10921-18"
        },
        {
          "Id": 2172,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Paper Printing PMG - EOB",
          "SubClient_Name_Id": "10921-17"
        },
        {
          "Id": 2173,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Paper Printing PMG - Claim Form",
          "SubClient_Name_Id": "10921-18"
        },
        {
          "Id": 2174,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: St Francis: AR Follow-up",
          "Client_Name_ID": "11737",
          "SubClient_Name": "LifePoint: St Francis: AR Follow-up",
          "SubClient_Name_Id": "11737"
        },
        {
          "Id": 2175,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: St Francis: AR Follow-up",
          "Client_Name_ID": "11737",
          "SubClient_Name": "LifePoint: St Francis: AR Follow-up",
          "SubClient_Name_Id": "11737"
        },
        {
          "Id": 2176,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: St Francis: Payment Adjustment Posting",
          "Client_Name_ID": "11738",
          "SubClient_Name": "LifePoint: St Francis: Payment Adjustment Posting",
          "SubClient_Name_Id": "11738"
        },
        {
          "Id": 2177,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: St Francis: Payment Adjustment Posting",
          "Client_Name_ID": "11738",
          "SubClient_Name": "LifePoint: St Francis: Payment Adjustment Posting",
          "SubClient_Name_Id": "11738"
        },
        {
          "Id": 2178,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point: ShortTerm Registration Correction Project",
          "Client_Name_ID": "11506",
          "SubClient_Name": "Life Point: ShortTerm Registration Correction Project",
          "SubClient_Name_Id": "11506"
        },
        {
          "Id": 2179,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point: ShortTerm Registration Correction Project",
          "Client_Name_ID": "11506",
          "SubClient_Name": "Life Point: ShortTerm Registration Correction Project",
          "SubClient_Name_Id": "11506"
        },
        {
          "Id": 2180,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Danville EKG Charge Entry",
          "Client_Name_ID": "11459",
          "SubClient_Name": "PMDS: Danville EKG Charge Entry - Charge Entry",
          "SubClient_Name_Id": "11459-1"
        },
        {
          "Id": 2181,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Danville EKG Charge Entry",
          "Client_Name_ID": "11459",
          "SubClient_Name": "PMDS: Danville EKG Charge Entry - Demo Entry",
          "SubClient_Name_Id": "11459-2"
        },
        {
          "Id": 2182,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Danville EKG Charge Entry",
          "Client_Name_ID": "11459",
          "SubClient_Name": "PMDS: Danville EKG Charge Entry - Charge Entry",
          "SubClient_Name_Id": "11459-1"
        },
        {
          "Id": 2183,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Danville EKG Charge Entry",
          "Client_Name_ID": "11459",
          "SubClient_Name": "PMDS: Danville EKG Charge Entry - Demo Entry",
          "SubClient_Name_Id": "11459-2"
        },
        {
          "Id": 2184,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials: KS -LPNT - Kansas - [20238]",
          "Client_Name_ID": "11518",
          "SubClient_Name": "LifePoint: Coding Denials: KS -LPNT - Kansas - [20238]",
          "SubClient_Name_Id": "11518"
        },
        {
          "Id": 2185,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: Coding Denials: KS -LPNT - Kansas - [20238]",
          "Client_Name_ID": "11518",
          "SubClient_Name": "LifePoint: Coding Denials: KS -LPNT - Kansas - [20238]",
          "SubClient_Name_Id": "11518"
        },
        {
          "Id": 2186,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Assistance on coding Denials",
          "Client_Name_ID": "11517",
          "SubClient_Name": "LifePoint: AR Assistance on coding Denials",
          "SubClient_Name_Id": "11517"
        },
        {
          "Id": 2187,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "LifePoint: AR Assistance on coding Denials",
          "Client_Name_ID": "11517",
          "SubClient_Name": "LifePoint: AR Assistance on coding Denials",
          "SubClient_Name_Id": "11517"
        },
        {
          "Id": 2188,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Coding Denials- SC Capella Carolina Pines [8689]",
          "Client_Name_ID": "11438",
          "SubClient_Name": "Life Point : Coding Denials- SC  Capella Carolina Pines [8689]",
          "SubClient_Name_Id": "11438"
        },
        {
          "Id": 2189,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Coding Denials- SC Capella Carolina Pines [8689]",
          "Client_Name_ID": "11438",
          "SubClient_Name": "Life Point : Coding Denials- SC  Capella Carolina Pines [8689]",
          "SubClient_Name_Id": "11438"
        },
        {
          "Id": 2190,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Coding Denials- AZ LPNT Arizona [19231]",
          "Client_Name_ID": "11439",
          "SubClient_Name": "Life Point : Coding Denials- AZ  LPNT  Arizona [19231]",
          "SubClient_Name_Id": "11439"
        },
        {
          "Id": 2191,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Coding Denials- AZ LPNT Arizona [19231]",
          "Client_Name_ID": "11439",
          "SubClient_Name": "Life Point : Coding Denials- AZ  LPNT  Arizona [19231]",
          "SubClient_Name_Id": "11439"
        },
        {
          "Id": 2192,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Demo Entry",
          "SubClient_Name_Id": "11026-1"
        },
        {
          "Id": 2193,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Demo Entry",
          "SubClient_Name_Id": "11026-1"
        },
        {
          "Id": 2194,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Cornerstone AR Follow-up Wind down",
          "Client_Name_ID": "11547",
          "SubClient_Name": "Life Point : Cornerstone AR Follow-up Wind down",
          "SubClient_Name_Id": "11547"
        },
        {
          "Id": 2195,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Cornerstone AR Follow-up Wind down",
          "Client_Name_ID": "11547",
          "SubClient_Name": "Life Point : Cornerstone AR Follow-up Wind down",
          "SubClient_Name_Id": "11547"
        },
        {
          "Id": 2196,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Cornerstone Payment Posting Wind down",
          "Client_Name_ID": "11548",
          "SubClient_Name": "Life Point : Cornerstone Payment Posting Wind down",
          "SubClient_Name_Id": "11548"
        },
        {
          "Id": 2197,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "Life Point : Cornerstone Payment Posting Wind down",
          "Client_Name_ID": "11548",
          "SubClient_Name": "Life Point : Cornerstone Payment Posting Wind down",
          "SubClient_Name_Id": "11548"
        },
        {
          "Id": 2198,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Bad Address",
          "Client_Name_ID": "10919",
          "SubClient_Name": "PMDS: Bad Address",
          "SubClient_Name_Id": "10919"
        },
        {
          "Id": 2199,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Bad Debt",
          "Client_Name_ID": "10920",
          "SubClient_Name": "PMDS: Bad Debt",
          "SubClient_Name_Id": "10920"
        },
        {
          "Id": 2200,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Bad Address Return mail",
          "SubClient_Name_Id": "11026-11"
        },
        {
          "Id": 2201,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Charge Entry",
          "SubClient_Name_Id": "11026-2"
        },
        {
          "Id": 2202,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Payment Posting-ERA",
          "SubClient_Name_Id": "11026-4"
        },
        {
          "Id": 2203,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Rejection",
          "SubClient_Name_Id": "11026-6"
        },
        {
          "Id": 2204,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - AR Current",
          "Client_Name_ID": "11026",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - AR Current - Scrubber",
          "SubClient_Name_Id": "11026-7"
        },
        {
          "Id": 2205,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Cornerstone: RCM Services - Payment Posting Manual",
          "Client_Name_ID": "11027",
          "SubClient_Name": "PMDS: Cornerstone: RCM Services - Payment Posting Manual",
          "SubClient_Name_Id": "11027"
        },
        {
          "Id": 2206,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry- SURGERY HOSPITAL PMDS",
          "SubClient_Name_Id": "10921-4"
        },
        {
          "Id": 2207,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry-Office Nursing PMDS",
          "SubClient_Name_Id": "10921-5"
        },
        {
          "Id": 2208,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Credit Balance- Patient collection PMDS",
          "SubClient_Name_Id": "10921-7"
        },
        {
          "Id": 2209,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Credit Balance- Unapplied credit PMDS",
          "SubClient_Name_Id": "10921-8"
        },
        {
          "Id": 2210,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Payment posting CENCAL PMDS",
          "SubClient_Name_Id": "10921-13"
        },
        {
          "Id": 2211,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Bad Address Return mail CMC",
          "SubClient_Name_Id": "10922-5"
        },
        {
          "Id": 2212,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Bad Debt CMC",
          "SubClient_Name_Id": "10922-7"
        },
        {
          "Id": 2213,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - CE Electronic CMC",
          "SubClient_Name_Id": "10922-10"
        },
        {
          "Id": 2214,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - CE Surgical PBB",
          "SubClient_Name_Id": "10922-19"
        },
        {
          "Id": 2215,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing CMC - Claim Form",
          "SubClient_Name_Id": "10922-17"
        },
        {
          "Id": 2216,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing CMC - EOB",
          "SubClient_Name_Id": "10922-18"
        },
        {
          "Id": 2217,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting - Intergy - ERA",
          "SubClient_Name_Id": "10922-20"
        },
        {
          "Id": 2218,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting - Intergy - Manual",
          "SubClient_Name_Id": "10922-21"
        },
        {
          "Id": 2219,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Rejection CMC",
          "SubClient_Name_Id": "10922-12"
        },
        {
          "Id": 2220,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Scrubber CMC",
          "SubClient_Name_Id": "10922-11"
        },
        {
          "Id": 2221,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Unapplied credit CMC",
          "SubClient_Name_Id": "10922-6"
        },
        {
          "Id": 2222,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry - Hospital Visits",
          "SubClient_Name_Id": "11193-1"
        },
        {
          "Id": 2223,
          "Original_Client_Name": "Life Point",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry - Office Visits",
          "SubClient_Name_Id": "11193-2"
        },
        {
          "Id": 2224,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2225,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2226,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2227,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2228,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2229,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2230,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2231,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2232,
          "Original_Client_Name": "Managers",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2233,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up",
          "SubClient_Name_Id": "10823"
        },
        {
          "Id": 2234,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up",
          "SubClient_Name_Id": "10823"
        },
        {
          "Id": 2235,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Credit Balance",
          "Client_Name_ID": "10824",
          "SubClient_Name": "MBx: Credit Balance",
          "SubClient_Name_Id": "10824"
        },
        {
          "Id": 2236,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Credit Balance",
          "Client_Name_ID": "10824",
          "SubClient_Name": "MBx: Credit Balance",
          "SubClient_Name_Id": "10824"
        },
        {
          "Id": 2237,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Coding-Denail",
          "SubClient_Name_Id": "10823-1"
        },
        {
          "Id": 2238,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "SubClient_Name_Id": "10825"
        },
        {
          "Id": 2239,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Correspondence",
          "SubClient_Name_Id": "10825-2"
        },
        {
          "Id": 2240,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Demo",
          "SubClient_Name_Id": "10825-1"
        },
        {
          "Id": 2241,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Coding-Denail",
          "SubClient_Name_Id": "10823-1"
        },
        {
          "Id": 2242,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Patient Mapping",
          "SubClient_Name_Id": "10823-2"
        },
        {
          "Id": 2243,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Patient Mapping",
          "SubClient_Name_Id": "10823-2"
        },
        {
          "Id": 2244,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Rejections",
          "SubClient_Name_Id": "10823-3"
        },
        {
          "Id": 2245,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: AR Follow Up",
          "Client_Name_ID": "10823",
          "SubClient_Name": "MBx: AR Follow Up - Rejections",
          "SubClient_Name_Id": "10823-3"
        },
        {
          "Id": 2246,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Correspondence",
          "SubClient_Name_Id": "10825-2"
        },
        {
          "Id": 2247,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Demo",
          "SubClient_Name_Id": "10825-1"
        },
        {
          "Id": 2248,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "SubClient_Name_Id": "10825"
        },
        {
          "Id": 2249,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "SubClient_Name_Id": "10825"
        },
        {
          "Id": 2250,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Correspondence",
          "SubClient_Name_Id": "10825-2"
        },
        {
          "Id": 2251,
          "Original_Client_Name": "MBx Medical Billing Experts, LLC - Aurangabad",
          "Original_Client_Name_ID": "99043",
          "Client_Name": "MBx: Demo Entry, Non:Postable and Correspondence",
          "Client_Name_ID": "10825",
          "SubClient_Name": "MBx: Demo Entry, Non:Postable and Correspondence - Demo",
          "SubClient_Name_Id": "10825-1"
        },
        {
          "Id": 2252,
          "Original_Client_Name": "Mecklenburg Radiology Associates",
          "Original_Client_Name_ID": "99044",
          "Client_Name": "Mecklenburg: Charge Capture Audit",
          "Client_Name_ID": "10826",
          "SubClient_Name": "Mecklenburg: Charge Capture Audit",
          "SubClient_Name_Id": "10826"
        },
        {
          "Id": 2253,
          "Original_Client_Name": "MedHealth Financials - Aurangabad",
          "Original_Client_Name_ID": "99123",
          "Client_Name": "MedHealth: Charge Entry",
          "Client_Name_ID": "11661",
          "SubClient_Name": "MedHealth: Charge Entry",
          "SubClient_Name_Id": "11661"
        },
        {
          "Id": 2254,
          "Original_Client_Name": "MedHealth Financials - Aurangabad",
          "Original_Client_Name_ID": "99123",
          "Client_Name": "MedHealth: Charge Entry",
          "Client_Name_ID": "11661",
          "SubClient_Name": "MedHealth: Charge Entry",
          "SubClient_Name_Id": "11661"
        },
        {
          "Id": 2255,
          "Original_Client_Name": "Medical Business Office (MBO)",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Patient Demographic Entry",
          "Client_Name_ID": "10828",
          "SubClient_Name": "Medical Business Office (MBO): Patient Demographic Entry",
          "SubClient_Name_Id": "10828"
        },
        {
          "Id": 2256,
          "Original_Client_Name": "Medical Business Office (MBO)",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Patient Demographic Entry",
          "Client_Name_ID": "10828",
          "SubClient_Name": "Medical Business Office (MBO): Patient Demographic Entry",
          "SubClient_Name_Id": "10828"
        },
        {
          "Id": 2257,
          "Original_Client_Name": "Medical Business Office (MBO)",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Payment Posting",
          "Client_Name_ID": "10829",
          "SubClient_Name": "Medical Business Office (MBO): Payment Posting",
          "SubClient_Name_Id": "10829"
        },
        {
          "Id": 2258,
          "Original_Client_Name": "Medical Business Office (MBO)",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Payment Posting",
          "Client_Name_ID": "10829",
          "SubClient_Name": "Medical Business Office (MBO): Payment Posting",
          "SubClient_Name_Id": "10829"
        },
        {
          "Id": 2259,
          "Original_Client_Name": "Medical Business Office (MBO)",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Radiology Coding",
          "Client_Name_ID": "10830",
          "SubClient_Name": "Medical Business Office (MBO): Radiology Coding",
          "SubClient_Name_Id": "10830"
        },
        {
          "Id": 2260,
          "Original_Client_Name": "Medical Business Office (MBO) - Aurangabad",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Radiology Coding",
          "Client_Name_ID": "10830",
          "SubClient_Name": "Medical Business Office (MBO): Radiology Coding",
          "SubClient_Name_Id": "10830"
        },
        {
          "Id": 2261,
          "Original_Client_Name": "Medical Business Office (MBO) - Aurangabad",
          "Original_Client_Name_ID": "99045",
          "Client_Name": "Medical Business Office (MBO): Radiology Coding",
          "Client_Name_ID": "10830",
          "SubClient_Name": "Medical Business Office (MBO): Radiology Coding",
          "SubClient_Name_Id": "10830"
        },
        {
          "Id": 2262,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Denial management (AR) services",
          "Client_Name_ID": "11654",
          "SubClient_Name": "Medical Reimbursement: Denial management (AR) services",
          "SubClient_Name_Id": "11654"
        },
        {
          "Id": 2263,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Denial management (AR) services",
          "Client_Name_ID": "11654",
          "SubClient_Name": "Medical Reimbursement: Denial management (AR) services",
          "SubClient_Name_Id": "11654"
        },
        {
          "Id": 2264,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Patient Statement",
          "Client_Name_ID": "11655",
          "SubClient_Name": "Medical Reimbursement: Patient Statement",
          "SubClient_Name_Id": "11655"
        },
        {
          "Id": 2265,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Patient Statement",
          "Client_Name_ID": "11655",
          "SubClient_Name": "Medical Reimbursement: Patient Statement",
          "SubClient_Name_Id": "11655"
        },
        {
          "Id": 2266,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Additional Pages",
          "Client_Name_ID": "11656",
          "SubClient_Name": "Medical Reimbursement: Additional Pages",
          "SubClient_Name_Id": "11656"
        },
        {
          "Id": 2267,
          "Original_Client_Name": "Medical Reimbursement Inc.",
          "Original_Client_Name_ID": "99122",
          "Client_Name": "Medical Reimbursement: Additional Pages",
          "Client_Name_ID": "11656",
          "SubClient_Name": "Medical Reimbursement: Additional Pages",
          "SubClient_Name_Id": "11656"
        },
        {
          "Id": 2268,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: Credit balance services",
          "Client_Name_ID": "11716",
          "SubClient_Name": "MediCentrix: Credit balance services - Insurance",
          "SubClient_Name_Id": "11716-2"
        },
        {
          "Id": 2269,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: Credit balance services",
          "Client_Name_ID": "11716",
          "SubClient_Name": "MediCentrix: Credit balance services - Insurance",
          "SubClient_Name_Id": "11716-2"
        },
        {
          "Id": 2270,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: Credit balance services",
          "Client_Name_ID": "11716",
          "SubClient_Name": "MediCentrix: Credit balance services - Patient",
          "SubClient_Name_Id": "11716-1"
        },
        {
          "Id": 2271,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: Credit balance services",
          "Client_Name_ID": "11716",
          "SubClient_Name": "MediCentrix: Credit balance services - Patient",
          "SubClient_Name_Id": "11716-1"
        },
        {
          "Id": 2272,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: AR Follow up Services",
          "Client_Name_ID": "11743",
          "SubClient_Name": "MediCentrix: AR Follow up Services",
          "SubClient_Name_Id": "11743"
        },
        {
          "Id": 2273,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: AR Follow up Services",
          "Client_Name_ID": "11743",
          "SubClient_Name": "MediCentrix: AR Follow up Services",
          "SubClient_Name_Id": "11743"
        },
        {
          "Id": 2274,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: AR Follow up Services: Spl Project",
          "Client_Name_ID": "11744",
          "SubClient_Name": "MediCentrix: AR Follow up Services: Spl Project",
          "SubClient_Name_Id": "11744"
        },
        {
          "Id": 2275,
          "Original_Client_Name": "MediCentrix, LLC,",
          "Original_Client_Name_ID": "99127",
          "Client_Name": "MediCentrix: AR Follow up Services: Spl Project",
          "Client_Name_ID": "11744",
          "SubClient_Name": "MediCentrix: AR Follow up Services: Spl Project",
          "SubClient_Name_Id": "11744"
        },
        {
          "Id": 2276,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "SubClient_Name_Id": "11221"
        },
        {
          "Id": 2277,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services",
          "SubClient_Name_Id": "11222"
        },
        {
          "Id": 2278,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "SubClient_Name_Id": "11221"
        },
        {
          "Id": 2279,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services",
          "SubClient_Name_Id": "11222"
        },
        {
          "Id": 2280,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Charges",
          "SubClient_Name_Id": "11221-1"
        },
        {
          "Id": 2281,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Edit Rejection",
          "SubClient_Name_Id": "11221-2"
        },
        {
          "Id": 2282,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Task Response",
          "SubClient_Name_Id": "11221-3"
        },
        {
          "Id": 2283,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - Payment ERA",
          "SubClient_Name_Id": "11221-4"
        },
        {
          "Id": 2284,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - Payment Manual",
          "SubClient_Name_Id": "11221-5"
        },
        {
          "Id": 2285,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - AR Followup",
          "SubClient_Name_Id": "11221-6"
        },
        {
          "Id": 2286,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Charges",
          "SubClient_Name_Id": "11222-1"
        },
        {
          "Id": 2287,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Edit Rejection",
          "SubClient_Name_Id": "11222-2"
        },
        {
          "Id": 2288,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Task Response",
          "SubClient_Name_Id": "11222-3"
        },
        {
          "Id": 2289,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - Payment ERA",
          "SubClient_Name_Id": "11222-4"
        },
        {
          "Id": 2290,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - Payment Manual",
          "SubClient_Name_Id": "11222-5"
        },
        {
          "Id": 2291,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - AR Followup",
          "SubClient_Name_Id": "11222-6"
        },
        {
          "Id": 2292,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Charges",
          "SubClient_Name_Id": "11221-1"
        },
        {
          "Id": 2293,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Edit Rejection",
          "SubClient_Name_Id": "11221-2"
        },
        {
          "Id": 2294,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services- Task Response",
          "SubClient_Name_Id": "11221-3"
        },
        {
          "Id": 2295,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - Payment ERA",
          "SubClient_Name_Id": "11221-4"
        },
        {
          "Id": 2296,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - Payment Manual",
          "SubClient_Name_Id": "11221-5"
        },
        {
          "Id": 2297,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Open Arms: End to End RCM Services",
          "Client_Name_ID": "11221",
          "SubClient_Name": "MedicoMD: Open Arms: End to End RCM Services - AR Followup",
          "SubClient_Name_Id": "11221-6"
        },
        {
          "Id": 2298,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Charges",
          "SubClient_Name_Id": "11222-1"
        },
        {
          "Id": 2299,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Edit Rejection",
          "SubClient_Name_Id": "11222-2"
        },
        {
          "Id": 2300,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services- Task Response",
          "SubClient_Name_Id": "11222-3"
        },
        {
          "Id": 2301,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - Payment ERA",
          "SubClient_Name_Id": "11222-4"
        },
        {
          "Id": 2302,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - Payment Manual",
          "SubClient_Name_Id": "11222-5"
        },
        {
          "Id": 2303,
          "Original_Client_Name": "Medico MD",
          "Original_Client_Name_ID": "99092",
          "Client_Name": "MedicoMD: Edge: End to End RCM Services",
          "Client_Name_ID": "11222",
          "SubClient_Name": "MedicoMD: Edge: End to End RCM Services - AR Followup",
          "SubClient_Name_Id": "11222-6"
        },
        {
          "Id": 2304,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: ERA Account Origination",
          "Client_Name_ID": "11203",
          "SubClient_Name": "MEDNAX: Arlington: ERA Account Origination",
          "SubClient_Name_Id": "11203"
        },
        {
          "Id": 2305,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: ERA Account Origination",
          "Client_Name_ID": "11204",
          "SubClient_Name": "MEDNAX: Raleigh: ERA Account Origination",
          "SubClient_Name_Id": "11204"
        },
        {
          "Id": 2306,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: ERA Account Origination",
          "Client_Name_ID": "11205",
          "SubClient_Name": "MEDNAX: Knoxville: ERA Account Origination",
          "SubClient_Name_Id": "11205"
        },
        {
          "Id": 2307,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: ERA Account Origination",
          "Client_Name_ID": "11206",
          "SubClient_Name": "MEDNAX: Sunrise: ERA Account Origination",
          "SubClient_Name_Id": "11206"
        },
        {
          "Id": 2308,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: ERA Account Origination",
          "Client_Name_ID": "11203",
          "SubClient_Name": "MEDNAX: Arlington: ERA Account Origination",
          "SubClient_Name_Id": "11203"
        },
        {
          "Id": 2309,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: ERA Account Origination",
          "Client_Name_ID": "11204",
          "SubClient_Name": "MEDNAX: Raleigh: ERA Account Origination",
          "SubClient_Name_Id": "11204"
        },
        {
          "Id": 2310,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: ERA Account Origination",
          "Client_Name_ID": "11205",
          "SubClient_Name": "MEDNAX: Knoxville: ERA Account Origination",
          "SubClient_Name_Id": "11205"
        },
        {
          "Id": 2311,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: ERA Account Origination",
          "Client_Name_ID": "11206",
          "SubClient_Name": "MEDNAX: Sunrise: ERA Account Origination",
          "SubClient_Name_Id": "11206"
        },
        {
          "Id": 2312,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting (Rad Alliance)",
          "Client_Name_ID": "11191",
          "SubClient_Name": "MEDNAX: Payment Posting (Rad Alliance)",
          "SubClient_Name_Id": "11191"
        },
        {
          "Id": 2313,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: Manual Account Origination",
          "Client_Name_ID": "11192",
          "SubClient_Name": "MEDNAX: Account Origination",
          "SubClient_Name_Id": "11192"
        },
        {
          "Id": 2314,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting (Rad Alliance)",
          "Client_Name_ID": "11191",
          "SubClient_Name": "MEDNAX: Payment Posting (Rad Alliance)",
          "SubClient_Name_Id": "11191"
        },
        {
          "Id": 2315,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: Manual Account Origination",
          "Client_Name_ID": "11192",
          "SubClient_Name": "MEDNAX: Account Origination",
          "SubClient_Name_Id": "11192"
        },
        {
          "Id": 2316,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Women and Children: Credit Balance",
          "Client_Name_ID": "11198",
          "SubClient_Name": "MEDNAX: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11198"
        },
        {
          "Id": 2317,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11199",
          "SubClient_Name": "MEDNAX: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11199"
        },
        {
          "Id": 2318,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Women and Children: Credit Balance",
          "Client_Name_ID": "11198",
          "SubClient_Name": "MEDNAX: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11198"
        },
        {
          "Id": 2319,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11199",
          "SubClient_Name": "MEDNAX: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11199"
        },
        {
          "Id": 2320,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: Manual Account Origination",
          "Client_Name_ID": "11192",
          "SubClient_Name": "MEDNAX: Arlington: Manual Account Origination",
          "SubClient_Name_Id": "11192"
        },
        {
          "Id": 2321,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: Manual Account Origination",
          "Client_Name_ID": "11200",
          "SubClient_Name": "MEDNAX: Raleigh: Manual Account Origination",
          "SubClient_Name_Id": "11200"
        },
        {
          "Id": 2322,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: Manual Account Origination",
          "Client_Name_ID": "11201",
          "SubClient_Name": "MEDNAX: Knoxville: Manual Account Origination",
          "SubClient_Name_Id": "11201"
        },
        {
          "Id": 2323,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: Manual Account Origination",
          "Client_Name_ID": "11202",
          "SubClient_Name": "MEDNAX: Sunrise: Manual Account Origination",
          "SubClient_Name_Id": "11202"
        },
        {
          "Id": 2324,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: Manual Account Origination",
          "Client_Name_ID": "11192",
          "SubClient_Name": "MEDNAX: Arlington: Manual Account Origination",
          "SubClient_Name_Id": "11192"
        },
        {
          "Id": 2325,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: Manual Account Origination",
          "Client_Name_ID": "11200",
          "SubClient_Name": "MEDNAX: Raleigh: Manual Account Origination",
          "SubClient_Name_Id": "11200"
        },
        {
          "Id": 2326,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: Manual Account Origination",
          "Client_Name_ID": "11201",
          "SubClient_Name": "MEDNAX: Knoxville: Manual Account Origination",
          "SubClient_Name_Id": "11201"
        },
        {
          "Id": 2327,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: Manual Account Origination",
          "Client_Name_ID": "11202",
          "SubClient_Name": "MEDNAX: Sunrise: Manual Account Origination",
          "SubClient_Name_Id": "11202"
        },
        {
          "Id": 2328,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Audit Services (Claim Status)",
          "Client_Name_ID": "11154",
          "SubClient_Name": "MEDNAX: AR Audit Services (Claim Status)",
          "SubClient_Name_Id": "11154"
        },
        {
          "Id": 2329,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "Client_Name_ID": "11155",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "SubClient_Name_Id": "11155"
        },
        {
          "Id": 2330,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Synergy Radiology Associates)",
          "Client_Name_ID": "11156",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Synergy Radiology Associates)",
          "SubClient_Name_Id": "11156"
        },
        {
          "Id": 2331,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Audit Services (Claim Status)",
          "Client_Name_ID": "11154",
          "SubClient_Name": "MEDNAX: AR Audit Services (Claim Status)",
          "SubClient_Name_Id": "11154"
        },
        {
          "Id": 2332,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "Client_Name_ID": "11155",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "SubClient_Name_Id": "11155"
        },
        {
          "Id": 2333,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Synergy Radiology Associates)",
          "Client_Name_ID": "11156",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Synergy Radiology Associates)",
          "SubClient_Name_Id": "11156"
        },
        {
          "Id": 2334,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: SRA: Credit Balance",
          "Client_Name_ID": "11299",
          "SubClient_Name": "MEDNAX: SRA: Credit Balance",
          "SubClient_Name_Id": "11299"
        },
        {
          "Id": 2335,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: RA: Credit Balance",
          "Client_Name_ID": "11300",
          "SubClient_Name": "MEDNAX: RA: Credit Balance",
          "SubClient_Name_Id": "11300"
        },
        {
          "Id": 2336,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: SRA: Credit Balance",
          "Client_Name_ID": "11299",
          "SubClient_Name": "MEDNAX: SRA: Credit Balance",
          "SubClient_Name_Id": "11299"
        },
        {
          "Id": 2337,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: RA: Credit Balance",
          "Client_Name_ID": "11300",
          "SubClient_Name": "MEDNAX: RA: Credit Balance",
          "SubClient_Name_Id": "11300"
        },
        {
          "Id": 2338,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11230",
          "SubClient_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11230"
        },
        {
          "Id": 2339,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11229",
          "SubClient_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11229"
        },
        {
          "Id": 2340,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11228",
          "SubClient_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11228"
        },
        {
          "Id": 2341,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11199",
          "SubClient_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11199"
        },
        {
          "Id": 2342,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11230",
          "SubClient_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11230"
        },
        {
          "Id": 2343,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11229",
          "SubClient_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11229"
        },
        {
          "Id": 2344,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11228",
          "SubClient_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11228"
        },
        {
          "Id": 2345,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11199",
          "SubClient_Name": "MEDNAX: Arlington: American Anesthesiology: Credit Balance",
          "SubClient_Name_Id": "11199"
        },
        {
          "Id": 2346,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting (Synergy Radiology Associates)",
          "Client_Name_ID": "11263",
          "SubClient_Name": "MEDNAX: Payment Posting (Synergy Radiology Associates)",
          "SubClient_Name_Id": "11263"
        },
        {
          "Id": 2347,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting (Synergy Radiology Associates)",
          "Client_Name_ID": "11263",
          "SubClient_Name": "MEDNAX: Payment Posting (Synergy Radiology Associates)",
          "SubClient_Name_Id": "11263"
        },
        {
          "Id": 2348,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Account Origination",
          "Client_Name_ID": "11262",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Account Origination",
          "SubClient_Name_Id": "11262"
        },
        {
          "Id": 2349,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Account Origination",
          "Client_Name_ID": "11262",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Account Origination",
          "SubClient_Name_Id": "11262"
        },
        {
          "Id": 2350,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: Women and Children: Credit Balance",
          "Client_Name_ID": "11225",
          "SubClient_Name": "MEDNAX: Knoxville: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11225"
        },
        {
          "Id": 2351,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: Women and Children: Credit Balance",
          "Client_Name_ID": "11226",
          "SubClient_Name": "MEDNAX: Raleigh: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11226"
        },
        {
          "Id": 2352,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: Women and Children: Credit Balance",
          "Client_Name_ID": "11227",
          "SubClient_Name": "MEDNAX: Sunrise: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11227"
        },
        {
          "Id": 2353,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11251",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11251"
        },
        {
          "Id": 2354,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "Client_Name_ID": "11252",
          "SubClient_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11252"
        },
        {
          "Id": 2355,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11253",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11253"
        },
        {
          "Id": 2356,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11254",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11254"
        },
        {
          "Id": 2357,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11251",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11251"
        },
        {
          "Id": 2358,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "Client_Name_ID": "11252",
          "SubClient_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "SubClient_Name_Id": "11252"
        },
        {
          "Id": 2359,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11253",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11253"
        },
        {
          "Id": 2360,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11254",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11254"
        },
        {
          "Id": 2361,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11381",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11381"
        },
        {
          "Id": 2362,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11381",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11381"
        },
        {
          "Id": 2363,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11382",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11382"
        },
        {
          "Id": 2364,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11382",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11382"
        },
        {
          "Id": 2365,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11383",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11383"
        },
        {
          "Id": 2366,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11383",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "SubClient_Name_Id": "11383"
        },
        {
          "Id": 2367,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix : Women and Children : Account Origination",
          "Client_Name_ID": "11420",
          "SubClient_Name": "MEDNAX: Phoenix : Women and Children : Account Origination",
          "SubClient_Name_Id": "11420"
        },
        {
          "Id": 2368,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale : Women and Children : Account Origination",
          "Client_Name_ID": "11421",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale : Women and Children : Account Origination",
          "SubClient_Name_Id": "11421"
        },
        {
          "Id": 2369,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange : Women and Children : Account Origination",
          "Client_Name_ID": "11422",
          "SubClient_Name": "MEDNAX: Orange : Women and Children : Account Origination",
          "SubClient_Name_Id": "11422"
        },
        {
          "Id": 2370,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson : Women and Children : Account Origination",
          "Client_Name_ID": "11423",
          "SubClient_Name": "MEDNAX: Richardson : Women and Children : Account Origination",
          "SubClient_Name_Id": "11423"
        },
        {
          "Id": 2371,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix : Women and Children : Account Origination",
          "Client_Name_ID": "11420",
          "SubClient_Name": "MEDNAX: Phoenix : Women and Children : Account Origination",
          "SubClient_Name_Id": "11420"
        },
        {
          "Id": 2372,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale : Women and Children : Account Origination",
          "Client_Name_ID": "11421",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale : Women and Children : Account Origination",
          "SubClient_Name_Id": "11421"
        },
        {
          "Id": 2373,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange : Women and Children : Account Origination",
          "Client_Name_ID": "11422",
          "SubClient_Name": "MEDNAX: Orange : Women and Children : Account Origination",
          "SubClient_Name_Id": "11422"
        },
        {
          "Id": 2374,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson : Women and Children : Account Origination",
          "Client_Name_ID": "11423",
          "SubClient_Name": "MEDNAX: Richardson : Women and Children : Account Origination",
          "SubClient_Name_Id": "11423"
        },
        {
          "Id": 2375,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting",
          "Client_Name_ID": "11761",
          "SubClient_Name": "MEDNAX: Payment Posting",
          "SubClient_Name_Id": "11761"
        },
        {
          "Id": 2376,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Payment Posting",
          "Client_Name_ID": "11761",
          "SubClient_Name": "MEDNAX: Payment Posting",
          "SubClient_Name_Id": "11761"
        },
        {
          "Id": 2377,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Charge Entry",
          "Client_Name_ID": "11674",
          "SubClient_Name": "MEDNAX: Charge Entry",
          "SubClient_Name_Id": "11674"
        },
        {
          "Id": 2378,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Charge Entry",
          "Client_Name_ID": "11674",
          "SubClient_Name": "MEDNAX: Charge Entry",
          "SubClient_Name_Id": "11674"
        },
        {
          "Id": 2379,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Correspondence",
          "Client_Name_ID": "11696",
          "SubClient_Name": "MEDNAX: Phoenix: Correspondence",
          "SubClient_Name_Id": "11696"
        },
        {
          "Id": 2380,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Correspondence",
          "Client_Name_ID": "11696",
          "SubClient_Name": "MEDNAX: Phoenix: Correspondence",
          "SubClient_Name_Id": "11696"
        },
        {
          "Id": 2381,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Correspondence",
          "Client_Name_ID": "11702",
          "SubClient_Name": "MEDNAX: Richardson: Correspondence",
          "SubClient_Name_Id": "11702"
        },
        {
          "Id": 2382,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Correspondence",
          "Client_Name_ID": "11702",
          "SubClient_Name": "MEDNAX: Richardson: Correspondence",
          "SubClient_Name_Id": "11702"
        },
        {
          "Id": 2383,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Correspondence",
          "Client_Name_ID": "11703",
          "SubClient_Name": "MEDNAX: Richmond: Correspondence",
          "SubClient_Name_Id": "11703"
        },
        {
          "Id": 2384,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Correspondence",
          "Client_Name_ID": "11703",
          "SubClient_Name": "MEDNAX: Richmond: Correspondence",
          "SubClient_Name_Id": "11703"
        },
        {
          "Id": 2385,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: FT.Lauderdel: Correspondence",
          "Client_Name_ID": "11704",
          "SubClient_Name": "MEDNAX: FT.Lauderdel: Correspondence",
          "SubClient_Name_Id": "11704"
        },
        {
          "Id": 2386,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: FT.Lauderdel: Correspondence",
          "Client_Name_ID": "11704",
          "SubClient_Name": "MEDNAX: FT.Lauderdel: Correspondence",
          "SubClient_Name_Id": "11704"
        },
        {
          "Id": 2387,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11230",
          "SubClient_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11230-1"
        },
        {
          "Id": 2388,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11230",
          "SubClient_Name": "MEDNAX: Sunrise: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11230-1"
        },
        {
          "Id": 2389,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11229",
          "SubClient_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11229-1"
        },
        {
          "Id": 2390,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11229",
          "SubClient_Name": "MEDNAX: Raleigh: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11229-1"
        },
        {
          "Id": 2391,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11228",
          "SubClient_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11228-1"
        },
        {
          "Id": 2392,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance",
          "Client_Name_ID": "11228",
          "SubClient_Name": "MEDNAX: Knoxville: American Anesthesiology: Credit Balance - AR Calling",
          "SubClient_Name_Id": "11228-1"
        },
        {
          "Id": 2393,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11381",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11381-1"
        },
        {
          "Id": 2394,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11381",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11381-1"
        },
        {
          "Id": 2395,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11382",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11382-1"
        },
        {
          "Id": 2396,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11382",
          "SubClient_Name": "MEDNAX: Orange: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11382-1"
        },
        {
          "Id": 2397,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11383",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11383-1"
        },
        {
          "Id": 2398,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS",
          "Client_Name_ID": "11383",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11383-1"
        },
        {
          "Id": 2399,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "Client_Name_ID": "11252",
          "SubClient_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11252-1"
        },
        {
          "Id": 2400,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance",
          "Client_Name_ID": "11252",
          "SubClient_Name": "MEDNAX: Phoenix: Women and Children: Credit Balance - NS - AR Calling",
          "SubClient_Name_Id": "11252-1"
        },
        {
          "Id": 2401,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11323",
          "SubClient_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS - AR Calling",
          "SubClient_Name_Id": "11323-1"
        },
        {
          "Id": 2402,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11323",
          "SubClient_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS - AR Calling",
          "SubClient_Name_Id": "11323-1"
        },
        {
          "Id": 2403,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Pediatrics: AR Follow up",
          "Client_Name_ID": "11614",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11614"
        },
        {
          "Id": 2404,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Ft.Lauderdale: Pediatrics: AR Follow up",
          "Client_Name_ID": "11614",
          "SubClient_Name": "MEDNAX: Ft.Lauderdale: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11614"
        },
        {
          "Id": 2405,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Pediatrics: AR Follow up",
          "Client_Name_ID": "11615",
          "SubClient_Name": "MEDNAX: Richmond: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11615"
        },
        {
          "Id": 2406,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Pediatrics: AR Follow up",
          "Client_Name_ID": "11615",
          "SubClient_Name": "MEDNAX: Richmond: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11615"
        },
        {
          "Id": 2407,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Pediatrics: AR Follow up",
          "Client_Name_ID": "11616",
          "SubClient_Name": "MEDNAX: Richardson: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11616"
        },
        {
          "Id": 2408,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Pediatrics: AR Follow up",
          "Client_Name_ID": "11616",
          "SubClient_Name": "MEDNAX: Richardson: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11616"
        },
        {
          "Id": 2409,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Pediatrics: AR Follow up",
          "Client_Name_ID": "11617",
          "SubClient_Name": "MEDNAX: Phoenix: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11617"
        },
        {
          "Id": 2410,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Phoenix: Pediatrics: AR Follow up",
          "Client_Name_ID": "11617",
          "SubClient_Name": "MEDNAX: Phoenix: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11617"
        },
        {
          "Id": 2411,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Pediatrics: AR Follow up",
          "Client_Name_ID": "11618",
          "SubClient_Name": "MEDNAX: Orange: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11618"
        },
        {
          "Id": 2412,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Pediatrics: AR Follow up",
          "Client_Name_ID": "11618",
          "SubClient_Name": "MEDNAX: Orange: Pediatrics: AR Follow up",
          "SubClient_Name_Id": "11618"
        },
        {
          "Id": 2413,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Correspondence",
          "Client_Name_ID": "11606",
          "SubClient_Name": "MEDNAX: Orange: Correspondence",
          "SubClient_Name_Id": "11606"
        },
        {
          "Id": 2414,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange: Correspondence",
          "Client_Name_ID": "11606",
          "SubClient_Name": "MEDNAX: Orange: Correspondence",
          "SubClient_Name_Id": "11606"
        },
        {
          "Id": 2415,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange : Women and Children : ER Account Origination",
          "Client_Name_ID": "11554",
          "SubClient_Name": "MEDNAX: Orange : Women and Children : ER Account Origination",
          "SubClient_Name_Id": "11554"
        },
        {
          "Id": 2416,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Orange : Women and Children : ER Account Origination",
          "Client_Name_ID": "11554",
          "SubClient_Name": "MEDNAX: Orange : Women and Children : ER Account Origination",
          "SubClient_Name_Id": "11554"
        },
        {
          "Id": 2417,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "Client_Name_ID": "11155",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Rad Alliance) - Code Helpdesk",
          "SubClient_Name_Id": "11155-1"
        },
        {
          "Id": 2418,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: AR Follow up Services (Rad Alliance)",
          "Client_Name_ID": "11155",
          "SubClient_Name": "MEDNAX: AR Follow up Services (Rad Alliance) - Code Helpdesk",
          "SubClient_Name_Id": "11155-1"
        },
        {
          "Id": 2419,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richmond: Women and Children: Account Origination",
          "Client_Name_ID": "11262",
          "SubClient_Name": "MEDNAX: Richmond: Women and Children: Account Origination - FS Download",
          "SubClient_Name_Id": "11262-1"
        },
        {
          "Id": 2420,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "Mednax : HSPD : Account Origination",
          "Client_Name_ID": "11492",
          "SubClient_Name": "Mednax : HSPD : Account Origination",
          "SubClient_Name_Id": "11492"
        },
        {
          "Id": 2421,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "Mednax : HSPD : Account Origination",
          "Client_Name_ID": "11492",
          "SubClient_Name": "Mednax : HSPD : Account Origination",
          "SubClient_Name_Id": "11492"
        },
        {
          "Id": 2422,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "Mednax : RG Federal : Account Origination",
          "Client_Name_ID": "11493",
          "SubClient_Name": "Mednax : RG Federal : Account Origination",
          "SubClient_Name_Id": "11493"
        },
        {
          "Id": 2423,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "Mednax : RG Federal : Account Origination",
          "Client_Name_ID": "11493",
          "SubClient_Name": "Mednax : RG Federal : Account Origination",
          "SubClient_Name_Id": "11493"
        },
        {
          "Id": 2424,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11323",
          "SubClient_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11323"
        },
        {
          "Id": 2425,
          "Original_Client_Name": "MEDNAX Services, Inc.",
          "Original_Client_Name_ID": "99086",
          "Client_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "Client_Name_ID": "11323",
          "SubClient_Name": "MEDNAX: Richardson: Women and Children: Credit Balance - DS",
          "SubClient_Name_Id": "11323"
        },
        {
          "Id": 2426,
          "Original_Client_Name": "Mineral King Radiological Medical Group",
          "Original_Client_Name_ID": "99047",
          "Client_Name": "MKMG: Radiology Medical Coding",
          "Client_Name_ID": "10832",
          "SubClient_Name": "MKMG: Radiology Medical Coding",
          "SubClient_Name_Id": "10832"
        },
        {
          "Id": 2427,
          "Original_Client_Name": "Mineral King Radiological Medical Group - Aurangabad",
          "Original_Client_Name_ID": "99047",
          "Client_Name": "MKMG: Radiology Medical Coding",
          "Client_Name_ID": "10832",
          "SubClient_Name": "MKMG: Radiology Medical Coding",
          "SubClient_Name_Id": "10832"
        },
        {
          "Id": 2428,
          "Original_Client_Name": "Mineral King Radiological Medical Group - Aurangabad",
          "Original_Client_Name_ID": "99047",
          "Client_Name": "MKMG: Radiology Medical Coding",
          "Client_Name_ID": "10832",
          "SubClient_Name": "MKMG: Radiology Medical Coding",
          "SubClient_Name_Id": "10832"
        },
        {
          "Id": 2429,
          "Original_Client_Name": "MIS",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "BE MIS",
          "Client_Name_ID": "10137",
          "SubClient_Name": "BE MIS",
          "SubClient_Name_Id": "10137"
        },
        {
          "Id": 2430,
          "Original_Client_Name": "MIS",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2431,
          "Original_Client_Name": "MIS",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 2432,
          "Original_Client_Name": "Molina Healthcare, Inc",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "Client_Name_ID": "11414",
          "SubClient_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "SubClient_Name_Id": "11414"
        },
        {
          "Id": 2433,
          "Original_Client_Name": "Molina Healthcare, Inc",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "Client_Name_ID": "11415",
          "SubClient_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "SubClient_Name_Id": "11415"
        },
        {
          "Id": 2434,
          "Original_Client_Name": "Molina Healthcare, Inc",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "Client_Name_ID": "11414",
          "SubClient_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "SubClient_Name_Id": "11414"
        },
        {
          "Id": 2435,
          "Original_Client_Name": "Molina Healthcare, Inc",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "Client_Name_ID": "11415",
          "SubClient_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "SubClient_Name_Id": "11415"
        },
        {
          "Id": 2436,
          "Original_Client_Name": "Molina Healthcare, Inc - Aurangabad",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "Client_Name_ID": "11415",
          "SubClient_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "SubClient_Name_Id": "11415"
        },
        {
          "Id": 2437,
          "Original_Client_Name": "Molina Healthcare, Inc - Aurangabad",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "Client_Name_ID": "11415",
          "SubClient_Name": "Molina: Retrospective Coding Services (Claims Data Validation)",
          "SubClient_Name_Id": "11415"
        },
        {
          "Id": 2438,
          "Original_Client_Name": "Molina Healthcare, Inc - Aurangabad",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "Client_Name_ID": "11414",
          "SubClient_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "SubClient_Name_Id": "11414"
        },
        {
          "Id": 2439,
          "Original_Client_Name": "Molina Healthcare, Inc - Aurangabad",
          "Original_Client_Name_ID": "99103",
          "Client_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "Client_Name_ID": "11414",
          "SubClient_Name": "Molina: Retrospective Coding Services (Manual Coding-No Claims Data Provided)",
          "SubClient_Name_Id": "11414"
        },
        {
          "Id": 2440,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2441,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2442,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2443,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2444,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2445,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2446,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2447,
          "Original_Client_Name": "MTBC-Med, Inc.",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2448,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2449,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2450,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2451,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: iCode",
          "Client_Name_ID": "10756",
          "SubClient_Name": "MTBC: iCode",
          "SubClient_Name_Id": "10756"
        },
        {
          "Id": 2452,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2453,
          "Original_Client_Name": "MTBC-Med, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99028",
          "Client_Name": "MTBC: Medinformatix Coding",
          "Client_Name_ID": "10757",
          "SubClient_Name": "MTBC: Medinformatix Coding",
          "SubClient_Name_Id": "10757"
        },
        {
          "Id": 2454,
          "Original_Client_Name": "NA",
          "Original_Client_Name_ID": "NA",
          "Client_Name": "BE - Analytics",
          "Client_Name_ID": "10141",
          "SubClient_Name": "BE - Analytics",
          "SubClient_Name_Id": "10141"
        },
        {
          "Id": 2455,
          "Original_Client_Name": "NA",
          "Original_Client_Name_ID": "NA",
          "Client_Name": "COO HO",
          "Client_Name_ID": "10212",
          "SubClient_Name": "COO HO",
          "SubClient_Name_Id": "10212"
        },
        {
          "Id": 2456,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Cash Posting",
          "Client_Name_ID": "11742",
          "SubClient_Name": "Netsmart: Cash Posting",
          "SubClient_Name_Id": "11742"
        },
        {
          "Id": 2457,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Cash Posting",
          "Client_Name_ID": "11742",
          "SubClient_Name": "Netsmart: Cash Posting",
          "SubClient_Name_Id": "11742"
        },
        {
          "Id": 2458,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Charge Entry",
          "Client_Name_ID": "11591",
          "SubClient_Name": "Netsmart: Charge Entry",
          "SubClient_Name_Id": "11591"
        },
        {
          "Id": 2459,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Charge Entry",
          "Client_Name_ID": "11591",
          "SubClient_Name": "Netsmart: Charge Entry",
          "SubClient_Name_Id": "11591"
        },
        {
          "Id": 2460,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Data Entry",
          "Client_Name_ID": "11582",
          "SubClient_Name": "Netsmart: Data Entry",
          "SubClient_Name_Id": "11582"
        },
        {
          "Id": 2461,
          "Original_Client_Name": "Netsmart Technologies Inc.",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Data Entry",
          "Client_Name_ID": "11582",
          "SubClient_Name": "Netsmart: Data Entry",
          "SubClient_Name_Id": "11582"
        },
        {
          "Id": 2462,
          "Original_Client_Name": "Netsmart Technologies Inc. - Aurangabad",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Data Entry",
          "Client_Name_ID": "11582",
          "SubClient_Name": "Netsmart: Data Entry",
          "SubClient_Name_Id": "11582"
        },
        {
          "Id": 2463,
          "Original_Client_Name": "Netsmart Technologies Inc. - Aurangabad",
          "Original_Client_Name_ID": "99117",
          "Client_Name": "Netsmart: Data Entry",
          "Client_Name_ID": "11582",
          "SubClient_Name": "Netsmart: Data Entry",
          "SubClient_Name_Id": "11582"
        },
        {
          "Id": 2464,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2465,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2466,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2467,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2468,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2469,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2470,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2471,
          "Original_Client_Name": "Non WFH",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Non WFH",
          "Client_Name_ID": "21015",
          "SubClient_Name": "NonProject: Non WFH",
          "SubClient_Name_Id": "21015"
        },
        {
          "Id": 2472,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials -  contingency 5% - Edits",
          "SubClient_Name_Id": "11351-1"
        },
        {
          "Id": 2473,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials -  contingency 5% - PP",
          "SubClient_Name_Id": "11351-2"
        },
        {
          "Id": 2474,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials -  contingency 5% - CB",
          "SubClient_Name_Id": "11351-3"
        },
        {
          "Id": 2475,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials -  contingency 5%",
          "SubClient_Name_Id": "11351"
        },
        {
          "Id": 2476,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "SubClient_Name_Id": "11351"
        },
        {
          "Id": 2477,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Code Helpdesk",
          "SubClient_Name_Id": "10859-4"
        },
        {
          "Id": 2478,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Claim Edits",
          "SubClient_Name_Id": "10859-1"
        },
        {
          "Id": 2479,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Credit Balance",
          "SubClient_Name_Id": "10859-2"
        },
        {
          "Id": 2480,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Payment Posting",
          "SubClient_Name_Id": "10859-3"
        },
        {
          "Id": 2481,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials - contingency 5% - Edits",
          "SubClient_Name_Id": "11351-1"
        },
        {
          "Id": 2482,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials - contingency 5% - PP",
          "SubClient_Name_Id": "11351-2"
        },
        {
          "Id": 2483,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC : Clinic AR management and denials - contingency 5%",
          "Client_Name_ID": "11351",
          "SubClient_Name": "NTMC : Clinic AR management and denials - contingency 5% - CB",
          "SubClient_Name_Id": "11351-3"
        },
        {
          "Id": 2484,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Code Helpdesk",
          "SubClient_Name_Id": "10859-4"
        },
        {
          "Id": 2485,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic Claim edits",
          "Client_Name_ID": "10854",
          "SubClient_Name": "NTMC: Clinic Claim edits",
          "SubClient_Name_Id": "10854"
        },
        {
          "Id": 2486,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic Credit Balance",
          "Client_Name_ID": "10855",
          "SubClient_Name": "NTMC: Clinic Credit Balance",
          "SubClient_Name_Id": "10855"
        },
        {
          "Id": 2487,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic Payment Posting",
          "Client_Name_ID": "10857",
          "SubClient_Name": "NTMC: Clinic Payment Posting",
          "SubClient_Name_Id": "10857"
        },
        {
          "Id": 2488,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic Payment Posting",
          "Client_Name_ID": "10857",
          "SubClient_Name": "NTMC: Clinic Payment Posting",
          "SubClient_Name_Id": "10857"
        },
        {
          "Id": 2489,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic- Insurance AR & Denial Management",
          "Client_Name_ID": "10856",
          "SubClient_Name": "NTMC: Clinic- Insurance AR & Denial Management",
          "SubClient_Name_Id": "10856"
        },
        {
          "Id": 2490,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "SubClient_Name_Id": "10859"
        },
        {
          "Id": 2491,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Clinic- Insurance AR & Denial Management",
          "Client_Name_ID": "10856",
          "SubClient_Name": "NTMC: Clinic- Insurance AR & Denial Management",
          "SubClient_Name_Id": "10856"
        },
        {
          "Id": 2492,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "SubClient_Name_Id": "10859"
        },
        {
          "Id": 2493,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Claim Edits",
          "SubClient_Name_Id": "10859-1"
        },
        {
          "Id": 2494,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Credit Balance",
          "SubClient_Name_Id": "10859-2"
        },
        {
          "Id": 2495,
          "Original_Client_Name": "North Texas Medical Center",
          "Original_Client_Name_ID": "99048",
          "Client_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency",
          "Client_Name_ID": "10859",
          "SubClient_Name": "NTMC: Hospital- Insurance AR & Denial Mgt 4% Contingency - Payment Posting",
          "SubClient_Name_Id": "10859-3"
        },
        {
          "Id": 2496,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : OBGYN",
          "Client_Name_ID": "10841",
          "SubClient_Name": "Norwegian: Professional Specialty : OBGYN",
          "SubClient_Name_Id": "10841"
        },
        {
          "Id": 2497,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Ancillary",
          "Client_Name_ID": "10834",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Ancillary",
          "SubClient_Name_Id": "10834"
        },
        {
          "Id": 2498,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Ancillary",
          "Client_Name_ID": "10834",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Ancillary",
          "SubClient_Name_Id": "10834"
        },
        {
          "Id": 2499,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Certified Nurse Midwife",
          "Client_Name_ID": "10837",
          "SubClient_Name": "Norwegian: Professional Specialty : Certified Nurse Midwife",
          "SubClient_Name_Id": "10837"
        },
        {
          "Id": 2500,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : General Surgery",
          "Client_Name_ID": "10839",
          "SubClient_Name": "Norwegian: Professional Specialty : General Surgery",
          "SubClient_Name_Id": "10839"
        },
        {
          "Id": 2501,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional specialty : Hospitalist",
          "Client_Name_ID": "10840",
          "SubClient_Name": "Norwegian: Professional specialty : Hospitalist",
          "SubClient_Name_Id": "10840"
        },
        {
          "Id": 2502,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional specialty : Hospitalist",
          "Client_Name_ID": "10840",
          "SubClient_Name": "Norwegian: Professional specialty : Hospitalist",
          "SubClient_Name_Id": "10840"
        },
        {
          "Id": 2503,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Neurology",
          "Client_Name_ID": "11176",
          "SubClient_Name": "Norwegian: Professional Specialty : Neurology",
          "SubClient_Name_Id": "11176"
        },
        {
          "Id": 2504,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : OBGYN",
          "Client_Name_ID": "10841",
          "SubClient_Name": "Norwegian: Professional Specialty : OBGYN",
          "SubClient_Name_Id": "10841"
        },
        {
          "Id": 2505,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Podiatry",
          "Client_Name_ID": "10844",
          "SubClient_Name": "Norwegian: Professional Specialty : Podiatry",
          "SubClient_Name_Id": "10844"
        },
        {
          "Id": 2506,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Emergency Department",
          "Client_Name_ID": "11046",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Emergency Department",
          "SubClient_Name_Id": "11046"
        },
        {
          "Id": 2507,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Inpatient",
          "Client_Name_ID": "10835",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Inpatient",
          "SubClient_Name_Id": "10835"
        },
        {
          "Id": 2508,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding: Observation",
          "Client_Name_ID": "11042",
          "SubClient_Name": "Norwegian: Hospital Based Coding: Observation",
          "SubClient_Name_Id": "11042"
        },
        {
          "Id": 2509,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding: Observation",
          "Client_Name_ID": "11042",
          "SubClient_Name": "Norwegian: Hospital Based Coding: Observation",
          "SubClient_Name_Id": "11042"
        },
        {
          "Id": 2510,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Outpatient Surgery",
          "Client_Name_ID": "10836",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Outpatient Surgery",
          "SubClient_Name_Id": "10836"
        },
        {
          "Id": 2511,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Outpatient Surgery",
          "Client_Name_ID": "10836",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Outpatient Surgery",
          "SubClient_Name_Id": "10836"
        },
        {
          "Id": 2512,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Family Medicine",
          "Client_Name_ID": "10838",
          "SubClient_Name": "Norwegian: Professional Specialty : Family Medicine",
          "SubClient_Name_Id": "10838"
        },
        {
          "Id": 2513,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Otolaryngology",
          "Client_Name_ID": "10842",
          "SubClient_Name": "Norwegian: Professional Specialty : Otolaryngology",
          "SubClient_Name_Id": "10842"
        },
        {
          "Id": 2514,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Pain Management",
          "Client_Name_ID": "10843",
          "SubClient_Name": "Norwegian: Professional Specialty : Pain Management",
          "SubClient_Name_Id": "10843"
        },
        {
          "Id": 2515,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Certified Nurse Midwife",
          "Client_Name_ID": "10837",
          "SubClient_Name": "Norwegian: Professional Specialty : Certified Nurse Midwife",
          "SubClient_Name_Id": "10837"
        },
        {
          "Id": 2516,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Family Medicine",
          "Client_Name_ID": "10838",
          "SubClient_Name": "Norwegian: Professional Specialty : Family Medicine",
          "SubClient_Name_Id": "10838"
        },
        {
          "Id": 2517,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : General Surgery",
          "Client_Name_ID": "10839",
          "SubClient_Name": "Norwegian: Professional Specialty : General Surgery",
          "SubClient_Name_Id": "10839"
        },
        {
          "Id": 2518,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Neurology",
          "Client_Name_ID": "11176",
          "SubClient_Name": "Norwegian: Professional Specialty : Neurology",
          "SubClient_Name_Id": "11176"
        },
        {
          "Id": 2519,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Otolaryngology",
          "Client_Name_ID": "10842",
          "SubClient_Name": "Norwegian: Professional Specialty : Otolaryngology",
          "SubClient_Name_Id": "10842"
        },
        {
          "Id": 2520,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Pain Management",
          "Client_Name_ID": "10843",
          "SubClient_Name": "Norwegian: Professional Specialty : Pain Management",
          "SubClient_Name_Id": "10843"
        },
        {
          "Id": 2521,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Professional Specialty : Podiatry",
          "Client_Name_ID": "10844",
          "SubClient_Name": "Norwegian: Professional Specialty : Podiatry",
          "SubClient_Name_Id": "10844"
        },
        {
          "Id": 2522,
          "Original_Client_Name": "Norwegian American Hospital",
          "Original_Client_Name_ID": "99049",
          "Client_Name": "Norwegian: Hospital Based Coding : Inpatient",
          "Client_Name_ID": "10835",
          "SubClient_Name": "Norwegian: Hospital Based Coding : Inpatient",
          "SubClient_Name_Id": "10835"
        },
        {
          "Id": 2523,
          "Original_Client_Name": "nThrive, Inc.",
          "Original_Client_Name_ID": "99050",
          "Client_Name": "nThrive: USC Appeals Remits",
          "Client_Name_ID": "11025",
          "SubClient_Name": "nThrive: USC Appeals Remits",
          "SubClient_Name_Id": "11025"
        },
        {
          "Id": 2524,
          "Original_Client_Name": "nThrive, Inc.",
          "Original_Client_Name_ID": "99050",
          "Client_Name": "nThrive: USC Commercial Remits",
          "Client_Name_ID": "10852",
          "SubClient_Name": "nThrive: USC Commercial Remits",
          "SubClient_Name_Id": "10852"
        },
        {
          "Id": 2525,
          "Original_Client_Name": "nThrive, Inc.",
          "Original_Client_Name_ID": "99050",
          "Client_Name": "nThrive: USC Commercial Remits",
          "Client_Name_ID": "10852",
          "SubClient_Name": "nThrive: USC Commercial Remits",
          "SubClient_Name_Id": "10852"
        },
        {
          "Id": 2526,
          "Original_Client_Name": "nThrive, Inc.",
          "Original_Client_Name_ID": "99050",
          "Client_Name": "nThrive: USC Commercial Remits",
          "Client_Name_ID": "10852",
          "SubClient_Name": "nThrive: USC Commercial Remits - AR calling",
          "SubClient_Name_Id": "10852-1"
        },
        {
          "Id": 2527,
          "Original_Client_Name": "nThrive, Inc.",
          "Original_Client_Name_ID": "99050",
          "Client_Name": "nThrive: USC Medicaid Remits",
          "Client_Name_ID": "10853",
          "SubClient_Name": "nThrive: USC Medicaid Remits",
          "SubClient_Name_Id": "10853"
        },
        {
          "Id": 2528,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology (Charge Edits)",
          "Client_Name_ID": "11405",
          "SubClient_Name": "NYU: AR follow up for Radiology (Charge Edits)",
          "SubClient_Name_Id": "11405"
        },
        {
          "Id": 2529,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology (Charge Edits)",
          "Client_Name_ID": "11405",
          "SubClient_Name": "NYU: AR follow up for Radiology (Charge Edits)",
          "SubClient_Name_Id": "11405"
        },
        {
          "Id": 2530,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology (Claim Edits)",
          "Client_Name_ID": "11406",
          "SubClient_Name": "NYU: AR follow up for Radiology (Claim Edits)",
          "SubClient_Name_Id": "11406"
        },
        {
          "Id": 2531,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology (Claim Edits)",
          "Client_Name_ID": "11406",
          "SubClient_Name": "NYU: AR follow up for Radiology (Claim Edits)",
          "SubClient_Name_Id": "11406"
        },
        {
          "Id": 2532,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology",
          "Client_Name_ID": "11407",
          "SubClient_Name": "NYU: AR follow up for Radiology",
          "SubClient_Name_Id": "11407"
        },
        {
          "Id": 2533,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR follow up for Radiology",
          "Client_Name_ID": "11407",
          "SubClient_Name": "NYU: AR follow up for Radiology",
          "SubClient_Name_Id": "11407"
        },
        {
          "Id": 2534,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR Follow up",
          "Client_Name_ID": "11218",
          "SubClient_Name": "NYU: AR Follow up",
          "SubClient_Name_Id": "11218"
        },
        {
          "Id": 2535,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Appeals First page",
          "Client_Name_ID": "11219",
          "SubClient_Name": "NYU: Appeals First page",
          "SubClient_Name_Id": "11219"
        },
        {
          "Id": 2536,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Appeals additional page",
          "Client_Name_ID": "11220",
          "SubClient_Name": "NYU: Appeals additional page",
          "SubClient_Name_Id": "11220"
        },
        {
          "Id": 2537,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: AR Follow up",
          "Client_Name_ID": "11218",
          "SubClient_Name": "NYU: AR Follow up",
          "SubClient_Name_Id": "11218"
        },
        {
          "Id": 2538,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Appeals First page",
          "Client_Name_ID": "11219",
          "SubClient_Name": "NYU: Appeals First page",
          "SubClient_Name_Id": "11219"
        },
        {
          "Id": 2539,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Appeals additional page",
          "Client_Name_ID": "11220",
          "SubClient_Name": "NYU: Appeals additional page",
          "SubClient_Name_Id": "11220"
        },
        {
          "Id": 2540,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Pathology",
          "Client_Name_ID": "11217",
          "SubClient_Name": "NYU: Pathology",
          "SubClient_Name_Id": "11217"
        },
        {
          "Id": 2541,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Pathology",
          "Client_Name_ID": "11217",
          "SubClient_Name": "NYU: Pathology",
          "SubClient_Name_Id": "11217"
        },
        {
          "Id": 2542,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Pathology: Charge entry & Diagnosis coding",
          "Client_Name_ID": "11648",
          "SubClient_Name": "NYU: Pathology: Charge entry & Diagnosis coding",
          "SubClient_Name_Id": "11648"
        },
        {
          "Id": 2543,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Pathology: Charge entry & Diagnosis coding",
          "Client_Name_ID": "11648",
          "SubClient_Name": "NYU: Pathology: Charge entry & Diagnosis coding",
          "SubClient_Name_Id": "11648"
        },
        {
          "Id": 2544,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: Tableau Technical Resource",
          "Client_Name_ID": "11329",
          "SubClient_Name": "NYU: Tableau Technical Resource",
          "SubClient_Name_Id": "11329"
        },
        {
          "Id": 2545,
          "Original_Client_Name": "NYU School of Medicine",
          "Original_Client_Name_ID": "99091",
          "Client_Name": "NYU: General Analyst Resource",
          "Client_Name_ID": "11330",
          "SubClient_Name": "NYU: General Analyst Resource",
          "SubClient_Name_Id": "11330"
        },
        {
          "Id": 2546,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 15 : 21 Day LOS",
          "Client_Name_ID": "10864",
          "SubClient_Name": "Oak Valley: Inpatient 15 : 21 Day LOS",
          "SubClient_Name_Id": "10864"
        },
        {
          "Id": 2547,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 29-35 Day LOS",
          "Client_Name_ID": "11180",
          "SubClient_Name": "Oak Valley: Inpatient 29-35 Day LOS",
          "SubClient_Name_Id": "11180"
        },
        {
          "Id": 2548,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 3:7 Day LOS",
          "Client_Name_ID": "10865",
          "SubClient_Name": "Oak Valley: Inpatient 3:7 Day LOS",
          "SubClient_Name_Id": "10865"
        },
        {
          "Id": 2549,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 8:14 Day LOS",
          "Client_Name_ID": "10866",
          "SubClient_Name": "Oak Valley: Inpatient 8:14 Day LOS",
          "SubClient_Name_Id": "10866"
        },
        {
          "Id": 2550,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Observation",
          "Client_Name_ID": "10867",
          "SubClient_Name": "Oak Valley: Observation",
          "SubClient_Name_Id": "10867"
        },
        {
          "Id": 2551,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Outpatient Surgery/SDS",
          "Client_Name_ID": "10868",
          "SubClient_Name": "Oak Valley: Outpatient Surgery/SDS",
          "SubClient_Name_Id": "10868"
        },
        {
          "Id": 2552,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Physician Practice with E&M or CPT",
          "Client_Name_ID": "10869",
          "SubClient_Name": "Oak Valley: Physician Practice with E&M or CPT",
          "SubClient_Name_Id": "10869"
        },
        {
          "Id": 2553,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Series/Recurring/OncRad Accounts",
          "Client_Name_ID": "10870",
          "SubClient_Name": "Oak Valley: Series/Recurring/OncRad Accounts",
          "SubClient_Name_Id": "10870"
        },
        {
          "Id": 2554,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED coding E/M and CPT + charge entry",
          "Client_Name_ID": "11292",
          "SubClient_Name": "Oak Valley: ED coding E/M and CPT + charge entry",
          "SubClient_Name_Id": "11292"
        },
        {
          "Id": 2555,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED coding E/M or CPT + charge entry",
          "Client_Name_ID": "11293",
          "SubClient_Name": "Oak Valley: ED coding E/M or CPT + charge entry",
          "SubClient_Name_Id": "11293"
        },
        {
          "Id": 2556,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED coding E/M and CPT + charge entry",
          "Client_Name_ID": "11292",
          "SubClient_Name": "Oak Valley: ED coding E/M and CPT + charge entry",
          "SubClient_Name_Id": "11292"
        },
        {
          "Id": 2557,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED coding E/M or CPT + charge entry",
          "Client_Name_ID": "11293",
          "SubClient_Name": "Oak Valley: ED coding E/M or CPT + charge entry",
          "SubClient_Name_Id": "11293"
        },
        {
          "Id": 2558,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Ancillary/Diagnostic/EKG",
          "Client_Name_ID": "10861",
          "SubClient_Name": "Oak Valley: Ancillary/Diagnostic/EKG",
          "SubClient_Name_Id": "10861"
        },
        {
          "Id": 2559,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Ancillary/Diagnostic/EKG",
          "Client_Name_ID": "10861",
          "SubClient_Name": "Oak Valley: Ancillary/Diagnostic/EKG",
          "SubClient_Name_Id": "10861"
        },
        {
          "Id": 2560,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED with CPT or E&M",
          "Client_Name_ID": "10862",
          "SubClient_Name": "Oak Valley: ED with CPT or E&M",
          "SubClient_Name_Id": "10862"
        },
        {
          "Id": 2561,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: ED with CPT or E&M",
          "Client_Name_ID": "10862",
          "SubClient_Name": "Oak Valley: ED with CPT or E&M",
          "SubClient_Name_Id": "10862"
        },
        {
          "Id": 2562,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 1:2 Day LOS",
          "Client_Name_ID": "10863",
          "SubClient_Name": "Oak Valley: Inpatient 1:2 Day LOS",
          "SubClient_Name_Id": "10863"
        },
        {
          "Id": 2563,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 1:2 Day LOS",
          "Client_Name_ID": "10863",
          "SubClient_Name": "Oak Valley: Inpatient 1:2 Day LOS",
          "SubClient_Name_Id": "10863"
        },
        {
          "Id": 2564,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 15 : 21 Day LOS",
          "Client_Name_ID": "10864",
          "SubClient_Name": "Oak Valley: Inpatient 15 : 21 Day LOS",
          "SubClient_Name_Id": "10864"
        },
        {
          "Id": 2565,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 29-35 Day LOS",
          "Client_Name_ID": "11180",
          "SubClient_Name": "Oak Valley: Inpatient 29-35 Day LOS",
          "SubClient_Name_Id": "11180"
        },
        {
          "Id": 2566,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 3:7 Day LOS",
          "Client_Name_ID": "10865",
          "SubClient_Name": "Oak Valley: Inpatient 3:7 Day LOS",
          "SubClient_Name_Id": "10865"
        },
        {
          "Id": 2567,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Inpatient 8:14 Day LOS",
          "Client_Name_ID": "10866",
          "SubClient_Name": "Oak Valley: Inpatient 8:14 Day LOS",
          "SubClient_Name_Id": "10866"
        },
        {
          "Id": 2568,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Observation",
          "Client_Name_ID": "10867",
          "SubClient_Name": "Oak Valley: Observation",
          "SubClient_Name_Id": "10867"
        },
        {
          "Id": 2569,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Outpatient Surgery/SDS",
          "Client_Name_ID": "10868",
          "SubClient_Name": "Oak Valley: Outpatient Surgery/SDS",
          "SubClient_Name_Id": "10868"
        },
        {
          "Id": 2570,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Physician Practice with E&M or CPT",
          "Client_Name_ID": "10869",
          "SubClient_Name": "Oak Valley: Physician Practice with E&M or CPT",
          "SubClient_Name_Id": "10869"
        },
        {
          "Id": 2571,
          "Original_Client_Name": "Oak Valley Hospital District",
          "Original_Client_Name_ID": "99051",
          "Client_Name": "Oak Valley: Series/Recurring/OncRad Accounts",
          "Client_Name_ID": "10870",
          "SubClient_Name": "Oak Valley: Series/Recurring/OncRad Accounts",
          "SubClient_Name_Id": "10870"
        },
        {
          "Id": 2572,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift",
          "SubClient_Name_Id": "10562"
        },
        {
          "Id": 2573,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift",
          "SubClient_Name_Id": "10562"
        },
        {
          "Id": 2574,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Claim Status Check Service",
          "Client_Name_ID": "10559",
          "SubClient_Name": "BioScrip: Claim Status Check Service",
          "SubClient_Name_Id": "10559"
        },
        {
          "Id": 2575,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Claim Status Check Service",
          "Client_Name_ID": "10559",
          "SubClient_Name": "BioScrip: Claim Status Check Service",
          "SubClient_Name_Id": "10559"
        },
        {
          "Id": 2576,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Account Receivable services",
          "Client_Name_ID": "10556",
          "SubClient_Name": "BioScrip: Account Receivable services - INF claims",
          "SubClient_Name_Id": "10556-2"
        },
        {
          "Id": 2577,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Account Receivable services",
          "Client_Name_ID": "10556",
          "SubClient_Name": "BioScrip: Account Receivable services - INF claims",
          "SubClient_Name_Id": "10556-2"
        },
        {
          "Id": 2578,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "OptionCare: Contract Uploading",
          "Client_Name_ID": "11611",
          "SubClient_Name": "OptionCare: Contract Uploading",
          "SubClient_Name_Id": "11611"
        },
        {
          "Id": 2579,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "OptionCare: Contract Uploading",
          "Client_Name_ID": "11611",
          "SubClient_Name": "OptionCare: Contract Uploading",
          "SubClient_Name_Id": "11611"
        },
        {
          "Id": 2580,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "OptionCare: Eligibility Verification",
          "Client_Name_ID": "11596",
          "SubClient_Name": "OptionCare: Eligibility Verification",
          "SubClient_Name_Id": "11596"
        },
        {
          "Id": 2581,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "OptionCare: Eligibility Verification",
          "Client_Name_ID": "11596",
          "SubClient_Name": "OptionCare: Eligibility Verification",
          "SubClient_Name_Id": "11596"
        },
        {
          "Id": 2582,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Account Receivable services",
          "Client_Name_ID": "10556",
          "SubClient_Name": "BioScrip: Account Receivable services",
          "SubClient_Name_Id": "10556"
        },
        {
          "Id": 2583,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Account Receivable services",
          "Client_Name_ID": "10556",
          "SubClient_Name": "BioScrip: Account Receivable services",
          "SubClient_Name_Id": "10556"
        },
        {
          "Id": 2584,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift",
          "SubClient_Name_Id": "10564"
        },
        {
          "Id": 2585,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift",
          "SubClient_Name_Id": "10564"
        },
        {
          "Id": 2586,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Recoupment Services",
          "Client_Name_ID": "10571",
          "SubClient_Name": "BioScrip: Recoupment Services",
          "SubClient_Name_Id": "10571"
        },
        {
          "Id": 2587,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Recoupment Services",
          "Client_Name_ID": "10571",
          "SubClient_Name": "BioScrip: Recoupment Services",
          "SubClient_Name_Id": "10571"
        },
        {
          "Id": 2588,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Money Move Project - India Day Shift",
          "Client_Name_ID": "10561",
          "SubClient_Name": "BioScrip: Money Move Project - India Day Shift",
          "SubClient_Name_Id": "10561"
        },
        {
          "Id": 2589,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Money Move Project - India Day Shift",
          "Client_Name_ID": "10561",
          "SubClient_Name": "BioScrip: Money Move Project - India Day Shift",
          "SubClient_Name_Id": "10561"
        },
        {
          "Id": 2590,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Project Business Analysis",
          "Client_Name_ID": "10570",
          "SubClient_Name": "BioScrip: Project Business Analysis",
          "SubClient_Name_Id": "10570"
        },
        {
          "Id": 2591,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Project Business Analysis",
          "Client_Name_ID": "10570",
          "SubClient_Name": "BioScrip: Project Business Analysis",
          "SubClient_Name_Id": "10570"
        },
        {
          "Id": 2592,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: AR Followup Services (Quality Analyst Service)",
          "Client_Name_ID": "11070",
          "SubClient_Name": "BioScrip: AR Followup Services (Quality Analyst Service)",
          "SubClient_Name_Id": "11070"
        },
        {
          "Id": 2593,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Claim Status Check Service (Quality Analyst Service)",
          "Client_Name_ID": "11071",
          "SubClient_Name": "BioScrip: Claim Status Check Service (Quality Analyst Service)",
          "SubClient_Name_Id": "11071"
        },
        {
          "Id": 2594,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Account Receivable services",
          "Client_Name_ID": "10556",
          "SubClient_Name": "BioScrip: Account Receivable services - SWOT Top Account",
          "SubClient_Name_Id": "10556-1"
        },
        {
          "Id": 2595,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift - Cash Triage",
          "SubClient_Name_Id": "10564-1"
        },
        {
          "Id": 2596,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift - Indexing",
          "SubClient_Name_Id": "10562-1"
        },
        {
          "Id": 2597,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift - Zero Electronic Remittance Notices",
          "SubClient_Name_Id": "10562-2"
        },
        {
          "Id": 2598,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift - Indexing",
          "SubClient_Name_Id": "10562-1"
        },
        {
          "Id": 2599,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift - Zero Electronic Remittance Notices",
          "SubClient_Name_Id": "10562-2"
        },
        {
          "Id": 2600,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift - OCH",
          "SubClient_Name_Id": "10564-2"
        },
        {
          "Id": 2601,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift - OCH",
          "SubClient_Name_Id": "10564-2"
        },
        {
          "Id": 2602,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - US Day shift",
          "Client_Name_ID": "10564",
          "SubClient_Name": "BioScrip: Payment Posting - US Day shift - Cash Triage",
          "SubClient_Name_Id": "10564-1"
        },
        {
          "Id": 2603,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Claim Status Check Service",
          "Client_Name_ID": "10559",
          "SubClient_Name": "BioScrip: Claim Status Check Service",
          "SubClient_Name_Id": "10559"
        },
        {
          "Id": 2604,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Appeal Refunds",
          "Client_Name_ID": "10557",
          "SubClient_Name": "BioScrip: Appeal Refunds",
          "SubClient_Name_Id": "10557"
        },
        {
          "Id": 2605,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Claim Status Check Service",
          "Client_Name_ID": "10559",
          "SubClient_Name": "BioScrip: Claim Status Check Service",
          "SubClient_Name_Id": "10559"
        },
        {
          "Id": 2606,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift",
          "SubClient_Name_Id": "10562"
        },
        {
          "Id": 2607,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift",
          "SubClient_Name_Id": "10562"
        },
        {
          "Id": 2608,
          "Original_Client_Name": "Option Care Enterprises, Inc.",
          "Original_Client_Name_ID": "99012",
          "Client_Name": "BioScrip: Payment Posting - India Day shift",
          "Client_Name_ID": "10562",
          "SubClient_Name": "BioScrip: Payment Posting - India Day shift",
          "SubClient_Name_Id": "10562"
        },
        {
          "Id": 2609,
          "Original_Client_Name": "Optum Technology, Inc",
          "Original_Client_Name_ID": "99100",
          "Client_Name": "Optum: Second Level Chart Review",
          "Client_Name_ID": "11331",
          "SubClient_Name": "Optum: Second Level Chart Review",
          "SubClient_Name_Id": "11331"
        },
        {
          "Id": 2610,
          "Original_Client_Name": "Optum Technology, Inc",
          "Original_Client_Name_ID": "99100",
          "Client_Name": "Optum: Second Level Chart Review",
          "Client_Name_ID": "11331",
          "SubClient_Name": "Optum: Second Level Chart Review",
          "SubClient_Name_Id": "11331"
        },
        {
          "Id": 2611,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding (Anesthesia) services",
          "Client_Name_ID": "10874",
          "SubClient_Name": "Origin/Medcon: Coding (Anesthesia) services - Charge",
          "SubClient_Name_Id": "10874-1"
        },
        {
          "Id": 2612,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding (Anesthesia) services",
          "Client_Name_ID": "10874",
          "SubClient_Name": "Origin/Medcon: Coding (Anesthesia) services",
          "SubClient_Name_Id": "10874"
        },
        {
          "Id": 2613,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding (Anesthesia) services",
          "Client_Name_ID": "10874",
          "SubClient_Name": "Origin/Medcon: Coding (Anesthesia) services",
          "SubClient_Name_Id": "10874"
        },
        {
          "Id": 2614,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding (Anesthesia) services : Demographics",
          "Client_Name_ID": "10875",
          "SubClient_Name": "Origin/Medcon: Coding (Anesthesia) services : Demographics",
          "SubClient_Name_Id": "10875"
        },
        {
          "Id": 2615,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding (Anesthesia) services : Demographics",
          "Client_Name_ID": "10875",
          "SubClient_Name": "Origin/Medcon: Coding (Anesthesia) services : Demographics",
          "SubClient_Name_Id": "10875"
        },
        {
          "Id": 2616,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Accounts Receivable",
          "Client_Name_ID": "10872",
          "SubClient_Name": "Origin/Medcon: Accounts Receivable - Appeals",
          "SubClient_Name_Id": "10872-1"
        },
        {
          "Id": 2617,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Charge Entry",
          "Client_Name_ID": "10873",
          "SubClient_Name": "Origin/Medcon: Charge Entry",
          "SubClient_Name_Id": "10873"
        },
        {
          "Id": 2618,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Charge Entry",
          "Client_Name_ID": "10873",
          "SubClient_Name": "Origin/Medcon: Charge Entry",
          "SubClient_Name_Id": "10873"
        },
        {
          "Id": 2619,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Demographics Entry",
          "Client_Name_ID": "10877",
          "SubClient_Name": "Origin/Medcon: Demographics Entry",
          "SubClient_Name_Id": "10877"
        },
        {
          "Id": 2620,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Demographics Entry",
          "Client_Name_ID": "10877",
          "SubClient_Name": "Origin/Medcon: Demographics Entry",
          "SubClient_Name_Id": "10877"
        },
        {
          "Id": 2621,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Manual PQRS Data Entry services",
          "Client_Name_ID": "10878",
          "SubClient_Name": "Origin/Medcon: Manual PQRS Data Entry services",
          "SubClient_Name_Id": "10878"
        },
        {
          "Id": 2622,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Manual PQRS Data Entry services",
          "Client_Name_ID": "10878",
          "SubClient_Name": "Origin/Medcon: Manual PQRS Data Entry services",
          "SubClient_Name_Id": "10878"
        },
        {
          "Id": 2623,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Payment Posting",
          "Client_Name_ID": "10880",
          "SubClient_Name": "Origin/Medcon: Payment Posting",
          "SubClient_Name_Id": "10880"
        },
        {
          "Id": 2624,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Payment Posting",
          "Client_Name_ID": "10880",
          "SubClient_Name": "Origin/Medcon: Payment Posting",
          "SubClient_Name_Id": "10880"
        },
        {
          "Id": 2625,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Acccounts",
          "Client_Name_ID": "10871",
          "SubClient_Name": "Origin/Medcon: Acccounts",
          "SubClient_Name_Id": "10871"
        },
        {
          "Id": 2626,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Multi Pages",
          "Client_Name_ID": "10879",
          "SubClient_Name": "Origin/Medcon: Multi Pages",
          "SubClient_Name_Id": "10879"
        },
        {
          "Id": 2627,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Accounts Receivable",
          "Client_Name_ID": "10872",
          "SubClient_Name": "Origin/Medcon: Accounts Receivable",
          "SubClient_Name_Id": "10872"
        },
        {
          "Id": 2628,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Accounts Receivable",
          "Client_Name_ID": "10872",
          "SubClient_Name": "Origin/Medcon: Accounts Receivable",
          "SubClient_Name_Id": "10872"
        },
        {
          "Id": 2629,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000",
          "SubClient_Name_Id": "10876"
        },
        {
          "Id": 2630,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000",
          "SubClient_Name_Id": "10876"
        },
        {
          "Id": 2631,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - Coding",
          "SubClient_Name_Id": "10876-1"
        },
        {
          "Id": 2632,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - Coding",
          "SubClient_Name_Id": "10876-1"
        },
        {
          "Id": 2633,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - OPS Audit",
          "SubClient_Name_Id": "10876-2"
        },
        {
          "Id": 2634,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - OPS Audit",
          "SubClient_Name_Id": "10876-2"
        },
        {
          "Id": 2635,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - Denail",
          "SubClient_Name_Id": "10876-3"
        },
        {
          "Id": 2636,
          "Original_Client_Name": "Origin Healthcare Solutions/Medcon",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/Medcon: Coding < 20000",
          "Client_Name_ID": "10876",
          "SubClient_Name": "Origin/Medcon: Coding < 20000 - Denail",
          "SubClient_Name_Id": "10876-3"
        },
        {
          "Id": 2637,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - DRA - Ebridge",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2638,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - DRA - Ebridge",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2639,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Ocean - Ebridge",
          "SubClient_Name_Id": "10883-2"
        },
        {
          "Id": 2640,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Ocean - Ebridge",
          "SubClient_Name_Id": "10883-2"
        },
        {
          "Id": 2641,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - RAH - Ebridge",
          "SubClient_Name_Id": "10883-3"
        },
        {
          "Id": 2642,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - RAH - Ebridge",
          "SubClient_Name_Id": "10883-3"
        },
        {
          "Id": 2643,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Torrington - Ebridge",
          "SubClient_Name_Id": "10883-4"
        },
        {
          "Id": 2644,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Torrington - Ebridge",
          "SubClient_Name_Id": "10883-4"
        },
        {
          "Id": 2645,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Westerly - Ebridge",
          "SubClient_Name_Id": "10883-5"
        },
        {
          "Id": 2646,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Westerly - Ebridge",
          "SubClient_Name_Id": "10883-5"
        },
        {
          "Id": 2647,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Neil Spect - Ebridge",
          "SubClient_Name_Id": "10883-6"
        },
        {
          "Id": 2648,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Neil Spect - Ebridge",
          "SubClient_Name_Id": "10883-6"
        },
        {
          "Id": 2649,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Newtown - Ebridge",
          "SubClient_Name_Id": "10883-7"
        },
        {
          "Id": 2650,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Newtown - Ebridge",
          "SubClient_Name_Id": "10883-7"
        },
        {
          "Id": 2651,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular M & B",
          "SubClient_Name_Id": "10881-1"
        },
        {
          "Id": 2652,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular M & B",
          "SubClient_Name_Id": "10881-1"
        },
        {
          "Id": 2653,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular M & B",
          "SubClient_Name_Id": "10881-2"
        },
        {
          "Id": 2654,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular M & B",
          "SubClient_Name_Id": "10881-2"
        },
        {
          "Id": 2655,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular M & B",
          "SubClient_Name_Id": "10881-4"
        },
        {
          "Id": 2656,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular M & B",
          "SubClient_Name_Id": "10881-4"
        },
        {
          "Id": 2657,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular RAM",
          "SubClient_Name_Id": "10881-5"
        },
        {
          "Id": 2658,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular RAM",
          "SubClient_Name_Id": "10881-5"
        },
        {
          "Id": 2659,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular RAM",
          "SubClient_Name_Id": "10881-6"
        },
        {
          "Id": 2660,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular RAM",
          "SubClient_Name_Id": "10881-6"
        },
        {
          "Id": 2661,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular RAM",
          "SubClient_Name_Id": "10881-7"
        },
        {
          "Id": 2662,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular RAM",
          "SubClient_Name_Id": "10881-7"
        },
        {
          "Id": 2663,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular RAM",
          "SubClient_Name_Id": "10881-8"
        },
        {
          "Id": 2664,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular RAM",
          "SubClient_Name_Id": "10881-8"
        },
        {
          "Id": 2665,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Ocean",
          "SubClient_Name_Id": "10881-9"
        },
        {
          "Id": 2666,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Ocean",
          "SubClient_Name_Id": "10881-9"
        },
        {
          "Id": 2667,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular Ocean",
          "SubClient_Name_Id": "10881-10"
        },
        {
          "Id": 2668,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular Ocean",
          "SubClient_Name_Id": "10881-10"
        },
        {
          "Id": 2669,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular Ocean",
          "SubClient_Name_Id": "10881-11"
        },
        {
          "Id": 2670,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular Ocean",
          "SubClient_Name_Id": "10881-11"
        },
        {
          "Id": 2671,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular Ocean",
          "SubClient_Name_Id": "10881-12"
        },
        {
          "Id": 2672,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular Ocean",
          "SubClient_Name_Id": "10881-12"
        },
        {
          "Id": 2673,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular RAH",
          "SubClient_Name_Id": "10881-13"
        },
        {
          "Id": 2674,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular RAH",
          "SubClient_Name_Id": "10881-13"
        },
        {
          "Id": 2675,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular RAH",
          "SubClient_Name_Id": "10881-14"
        },
        {
          "Id": 2676,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular RAH",
          "SubClient_Name_Id": "10881-14"
        },
        {
          "Id": 2677,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular RAH",
          "SubClient_Name_Id": "10881-15"
        },
        {
          "Id": 2678,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular RAH",
          "SubClient_Name_Id": "10881-15"
        },
        {
          "Id": 2679,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular RAH",
          "SubClient_Name_Id": "10881-16"
        },
        {
          "Id": 2680,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular RAH",
          "SubClient_Name_Id": "10881-16"
        },
        {
          "Id": 2681,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Torrington",
          "SubClient_Name_Id": "10881-17"
        },
        {
          "Id": 2682,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Torrington",
          "SubClient_Name_Id": "10881-17"
        },
        {
          "Id": 2683,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Vascular Torrington",
          "SubClient_Name_Id": "10881-18"
        },
        {
          "Id": 2684,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Vascular Torrington",
          "SubClient_Name_Id": "10881-18"
        },
        {
          "Id": 2685,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Westerly",
          "SubClient_Name_Id": "10881-19"
        },
        {
          "Id": 2686,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular Westerly",
          "SubClient_Name_Id": "10881-19"
        },
        {
          "Id": 2687,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Vascular Westerly",
          "SubClient_Name_Id": "10881-20"
        },
        {
          "Id": 2688,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Vascular Westerly",
          "SubClient_Name_Id": "10881-20"
        },
        {
          "Id": 2689,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular DRA",
          "SubClient_Name_Id": "10881-21"
        },
        {
          "Id": 2690,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 1 Vascular DRA",
          "SubClient_Name_Id": "10881-21"
        },
        {
          "Id": 2691,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular DRA",
          "SubClient_Name_Id": "10881-22"
        },
        {
          "Id": 2692,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 2 Vascular DRA",
          "SubClient_Name_Id": "10881-22"
        },
        {
          "Id": 2693,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular DRA",
          "SubClient_Name_Id": "10881-23"
        },
        {
          "Id": 2694,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - Level 3 Vascular DRA",
          "SubClient_Name_Id": "10881-23"
        },
        {
          "Id": 2695,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular M & B",
          "SubClient_Name_Id": "10881-24"
        },
        {
          "Id": 2696,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - NON Vascular M & B",
          "SubClient_Name_Id": "10881-24"
        },
        {
          "Id": 2697,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - NON Vascular DRA",
          "SubClient_Name_Id": "10882-1"
        },
        {
          "Id": 2698,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - NON Vascular DRA",
          "SubClient_Name_Id": "10882-1"
        },
        {
          "Id": 2699,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - RAH",
          "SubClient_Name_Id": "10882-2"
        },
        {
          "Id": 2700,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - RAH",
          "SubClient_Name_Id": "10882-2"
        },
        {
          "Id": 2701,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Westerly",
          "SubClient_Name_Id": "10882-3"
        },
        {
          "Id": 2702,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Westerly",
          "SubClient_Name_Id": "10882-3"
        },
        {
          "Id": 2703,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - M & B",
          "SubClient_Name_Id": "10882-4"
        },
        {
          "Id": 2704,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - M & B",
          "SubClient_Name_Id": "10882-4"
        },
        {
          "Id": 2705,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Neil Spect",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2706,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Neil Spect",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2707,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services",
          "SubClient_Name_Id": "10882"
        },
        {
          "Id": 2708,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services",
          "SubClient_Name_Id": "10882"
        },
        {
          "Id": 2709,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "SubClient_Name_Id": "10881"
        },
        {
          "Id": 2710,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "SubClient_Name_Id": "10881"
        },
        {
          "Id": 2711,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Interventional Radiology Coding Services",
          "Client_Name_ID": "10881",
          "SubClient_Name": "Origin/SSIMED: Interventional Radiology Coding Services - RAH - Ebridge",
          "SubClient_Name_Id": "10881-3"
        },
        {
          "Id": 2712,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "SubClient_Name_Id": "10883"
        },
        {
          "Id": 2713,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - DRA",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2714,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Ocean",
          "SubClient_Name_Id": "10883-2"
        },
        {
          "Id": 2715,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Torrington",
          "SubClient_Name_Id": "10883-3"
        },
        {
          "Id": 2716,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Newtown",
          "SubClient_Name_Id": "10883-4"
        },
        {
          "Id": 2717,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - DRA",
          "SubClient_Name_Id": "10883-1"
        },
        {
          "Id": 2718,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Ocean",
          "SubClient_Name_Id": "10883-2"
        },
        {
          "Id": 2719,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Torrington",
          "SubClient_Name_Id": "10883-3"
        },
        {
          "Id": 2720,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge - Newtown",
          "SubClient_Name_Id": "10883-4"
        },
        {
          "Id": 2721,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - DRA",
          "SubClient_Name_Id": "10882-1"
        },
        {
          "Id": 2722,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - ECIG",
          "SubClient_Name_Id": "10882-2"
        },
        {
          "Id": 2723,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - M&B",
          "SubClient_Name_Id": "10882-3"
        },
        {
          "Id": 2724,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Ocean",
          "SubClient_Name_Id": "10882-4"
        },
        {
          "Id": 2725,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Torrington",
          "SubClient_Name_Id": "10882-5"
        },
        {
          "Id": 2726,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - DRA",
          "SubClient_Name_Id": "10882-1"
        },
        {
          "Id": 2727,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - ECIG",
          "SubClient_Name_Id": "10882-2"
        },
        {
          "Id": 2728,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - M&B",
          "SubClient_Name_Id": "10882-3"
        },
        {
          "Id": 2729,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Ocean",
          "SubClient_Name_Id": "10882-4"
        },
        {
          "Id": 2730,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services - Torrington",
          "SubClient_Name_Id": "10882-5"
        },
        {
          "Id": 2731,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "Client_Name_ID": "10883",
          "SubClient_Name": "Origin/SSIMED: Coding Services : Ebridge",
          "SubClient_Name_Id": "10883"
        },
        {
          "Id": 2732,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services",
          "SubClient_Name_Id": "10882"
        },
        {
          "Id": 2733,
          "Original_Client_Name": "Origin Healthcare Solutions/SSIMED - Aurangabad",
          "Original_Client_Name_ID": "99052",
          "Client_Name": "Origin/SSIMED: Coding Services",
          "Client_Name_ID": "10882",
          "SubClient_Name": "Origin/SSIMED: Coding Services",
          "SubClient_Name_Id": "10882"
        },
        {
          "Id": 2734,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry- CCP OP CE PMDS",
          "SubClient_Name_Id": "10921-15"
        },
        {
          "Id": 2735,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting CMC - Manual",
          "SubClient_Name_Id": "10922-3"
        },
        {
          "Id": 2736,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services",
          "SubClient_Name_Id": "11028"
        },
        {
          "Id": 2737,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Additional page/Medical record",
          "Client_Name_ID": "11125",
          "SubClient_Name": "PMDS: Additional page/Medical record",
          "SubClient_Name_Id": "11125"
        },
        {
          "Id": 2738,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - EDI Secondary COB",
          "SubClient_Name_Id": "11028-14"
        },
        {
          "Id": 2739,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Scrubber",
          "SubClient_Name_Id": "11028-1"
        },
        {
          "Id": 2740,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - NG Portal Task",
          "SubClient_Name_Id": "11028-2"
        },
        {
          "Id": 2741,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Payment Posting ERA",
          "SubClient_Name_Id": "11028-3"
        },
        {
          "Id": 2742,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Payment Posting Manual",
          "SubClient_Name_Id": "11028-4"
        },
        {
          "Id": 2743,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Charge Entry Review",
          "SubClient_Name_Id": "11028-5"
        },
        {
          "Id": 2744,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Rejections",
          "SubClient_Name_Id": "11028-6"
        },
        {
          "Id": 2745,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Balance Control",
          "SubClient_Name_Id": "11028-7"
        },
        {
          "Id": 2746,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Unapplied Credit",
          "SubClient_Name_Id": "11028-8"
        },
        {
          "Id": 2747,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Claim Form",
          "SubClient_Name_Id": "11028-9"
        },
        {
          "Id": 2748,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - EOB",
          "SubClient_Name_Id": "11028-10"
        },
        {
          "Id": 2749,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Medical Record",
          "SubClient_Name_Id": "11028-11"
        },
        {
          "Id": 2750,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Manual Charge Entry",
          "SubClient_Name_Id": "11028-12"
        },
        {
          "Id": 2751,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - NG Portal Task: CMC",
          "SubClient_Name_Id": "10922-8"
        },
        {
          "Id": 2752,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Correspondence batch Posting CMC",
          "SubClient_Name_Id": "10922-9"
        },
        {
          "Id": 2753,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services",
          "Client_Name_ID": "10921",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services - Charge Entry-CHDP PMDS",
          "SubClient_Name_Id": "10921-1"
        },
        {
          "Id": 2754,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Correspondence batch Posting CMC",
          "SubClient_Name_Id": "10922-9"
        },
        {
          "Id": 2755,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services",
          "SubClient_Name_Id": "11028"
        },
        {
          "Id": 2756,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - insurance file - CMC",
          "SubClient_Name_Id": "10922-1"
        },
        {
          "Id": 2757,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Credit Balance Insurance refund",
          "SubClient_Name_Id": "10922-15"
        },
        {
          "Id": 2758,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Credit Balance Patient Refund",
          "SubClient_Name_Id": "10922-16"
        },
        {
          "Id": 2759,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Balance Control CMC",
          "SubClient_Name_Id": "10922-4"
        },
        {
          "Id": 2760,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting CMC - ERA",
          "SubClient_Name_Id": "10922-2"
        },
        {
          "Id": 2761,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Payment Posting CMC - Manual",
          "SubClient_Name_Id": "10922-3"
        },
        {
          "Id": 2762,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting",
          "SubClient_Name_Id": "11193"
        },
        {
          "Id": 2763,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting",
          "SubClient_Name_Id": "11193"
        },
        {
          "Id": 2764,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry",
          "SubClient_Name_Id": "11193"
        },
        {
          "Id": 2765,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Charge Entry",
          "Client_Name_ID": "11193",
          "SubClient_Name": "PMDS: Las Cruces - Charge Entry",
          "SubClient_Name_Id": "11193"
        },
        {
          "Id": 2766,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting - ERA",
          "SubClient_Name_Id": "11167-1"
        },
        {
          "Id": 2767,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting - Manual",
          "SubClient_Name_Id": "11167-2"
        },
        {
          "Id": 2768,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Credit Balance",
          "Client_Name_ID": "11168",
          "SubClient_Name": "PMDS: SVMG - Credit Balance",
          "SubClient_Name_Id": "11168"
        },
        {
          "Id": 2769,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting - ERA",
          "SubClient_Name_Id": "11167-1"
        },
        {
          "Id": 2770,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Las Cruces - Payment Posting",
          "Client_Name_ID": "11167",
          "SubClient_Name": "PMDS: Las Cruces - Payment Posting - Manual",
          "SubClient_Name_Id": "11167-2"
        },
        {
          "Id": 2771,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Credit Balance",
          "Client_Name_ID": "11168",
          "SubClient_Name": "PMDS: SVMG - Credit Balance",
          "SubClient_Name_Id": "11168"
        },
        {
          "Id": 2772,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing LMG - EOB",
          "SubClient_Name_Id": "10922-29"
        },
        {
          "Id": 2773,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Western Carolina - Payment Posting",
          "Client_Name_ID": "11074",
          "SubClient_Name": "PMDS: Western Carolina - Payment Posting",
          "SubClient_Name_Id": "11074"
        },
        {
          "Id": 2774,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Western Carolina - Payment Posting",
          "Client_Name_ID": "11074",
          "SubClient_Name": "PMDS: Western Carolina - Payment Posting",
          "SubClient_Name_Id": "11074"
        },
        {
          "Id": 2775,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG: RCM Services",
          "Client_Name_ID": "11028",
          "SubClient_Name": "PMDS: SVMG: RCM Services - Payment Posting ERA",
          "SubClient_Name_Id": "11028-3"
        },
        {
          "Id": 2776,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Scrubber",
          "SubClient_Name_Id": "11076-1"
        },
        {
          "Id": 2777,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - NG Portal Task",
          "SubClient_Name_Id": "11076-2"
        },
        {
          "Id": 2778,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - ERA",
          "SubClient_Name_Id": "11076-3"
        },
        {
          "Id": 2779,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Manual",
          "SubClient_Name_Id": "11076-4"
        },
        {
          "Id": 2780,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Rejections",
          "SubClient_Name_Id": "11076-5"
        },
        {
          "Id": 2781,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Balance Control",
          "SubClient_Name_Id": "11076-6"
        },
        {
          "Id": 2782,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Unapplied Credit",
          "SubClient_Name_Id": "11076-7"
        },
        {
          "Id": 2783,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Claim Form",
          "SubClient_Name_Id": "11076-8"
        },
        {
          "Id": 2784,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - EOB",
          "SubClient_Name_Id": "11076-9"
        },
        {
          "Id": 2785,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Medical Record",
          "SubClient_Name_Id": "11076-10"
        },
        {
          "Id": 2786,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - EDI Secondary COB",
          "SubClient_Name_Id": "11076-11"
        },
        {
          "Id": 2787,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Scrubber",
          "SubClient_Name_Id": "11076-1"
        },
        {
          "Id": 2788,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - NG Portal Task",
          "SubClient_Name_Id": "11076-2"
        },
        {
          "Id": 2789,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - ERA",
          "SubClient_Name_Id": "11076-3"
        },
        {
          "Id": 2790,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Manual",
          "SubClient_Name_Id": "11076-4"
        },
        {
          "Id": 2791,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Rejections",
          "SubClient_Name_Id": "11076-5"
        },
        {
          "Id": 2792,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Balance Control",
          "SubClient_Name_Id": "11076-6"
        },
        {
          "Id": 2793,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Unapplied Credit",
          "SubClient_Name_Id": "11076-7"
        },
        {
          "Id": 2794,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Claim Form",
          "SubClient_Name_Id": "11076-8"
        },
        {
          "Id": 2795,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - EOB",
          "SubClient_Name_Id": "11076-9"
        },
        {
          "Id": 2796,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - Medical Record",
          "SubClient_Name_Id": "11076-10"
        },
        {
          "Id": 2797,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - Payment Posting",
          "Client_Name_ID": "11076",
          "SubClient_Name": "PMDS: SVMG - Payment Posting - EDI Secondary COB",
          "SubClient_Name_Id": "11076-11"
        },
        {
          "Id": 2798,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - AR Follow up (wind-down project)",
          "Client_Name_ID": "11075",
          "SubClient_Name": "PMDS: SVMG - AR Follow up (wind-down project)",
          "SubClient_Name_Id": "11075"
        },
        {
          "Id": 2799,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: SVMG - AR Follow up (wind-down project)",
          "Client_Name_ID": "11075",
          "SubClient_Name": "PMDS: SVMG - AR Follow up (wind-down project)",
          "SubClient_Name_Id": "11075"
        },
        {
          "Id": 2800,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing LMG - EOB",
          "SubClient_Name_Id": "10922-29"
        },
        {
          "Id": 2801,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing LMG - Claim Form",
          "SubClient_Name_Id": "10922-26"
        },
        {
          "Id": 2802,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: End to End Revenue cycle management services : CMC",
          "Client_Name_ID": "10922",
          "SubClient_Name": "PMDS: End to End Revenue cycle management services : CMC - Paper Printing LMG - Claim Form",
          "SubClient_Name_Id": "10922-26"
        },
        {
          "Id": 2803,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Hospitalist Coding",
          "Client_Name_ID": "11284",
          "SubClient_Name": "PMDS: Hospitalist Coding",
          "SubClient_Name_Id": "11284"
        },
        {
          "Id": 2804,
          "Original_Client_Name": "Pacific Medical Data Solutions, Inc.",
          "Original_Client_Name_ID": "99053",
          "Client_Name": "PMDS: Hospitalist Coding",
          "Client_Name_ID": "11284",
          "SubClient_Name": "PMDS: Hospitalist Coding",
          "SubClient_Name_Id": "11284"
        },
        {
          "Id": 2805,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable",
          "SubClient_Name_Id": "10924"
        },
        {
          "Id": 2806,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable",
          "SubClient_Name_Id": "10924"
        },
        {
          "Id": 2807,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - SCOP",
          "SubClient_Name_Id": "10924-3"
        },
        {
          "Id": 2808,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - LaserFische - Appeals",
          "SubClient_Name_Id": "10924-4"
        },
        {
          "Id": 2809,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - SCOP",
          "SubClient_Name_Id": "10924-3"
        },
        {
          "Id": 2810,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - LaserFische - Appeals",
          "SubClient_Name_Id": "10924-4"
        },
        {
          "Id": 2811,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - LaserFische",
          "SubClient_Name_Id": "10924-1"
        },
        {
          "Id": 2812,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - Office Based Practice",
          "SubClient_Name_Id": "10924-2"
        },
        {
          "Id": 2813,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - LaserFische",
          "SubClient_Name_Id": "10924-1"
        },
        {
          "Id": 2814,
          "Original_Client_Name": "Pacific Medical Management Services",
          "Original_Client_Name_ID": "99054",
          "Client_Name": "PMMS: Account Receivable",
          "Client_Name_ID": "10924",
          "SubClient_Name": "PMMS: Account Receivable - Office Based Practice",
          "SubClient_Name_Id": "10924-2"
        },
        {
          "Id": 2815,
          "Original_Client_Name": "Payer- Unallocated",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject Unallocated",
          "Client_Name_ID": "21013",
          "SubClient_Name": "NonProject Unallocated",
          "SubClient_Name_Id": "21013"
        },
        {
          "Id": 2816,
          "Original_Client_Name": "Payer- Unallocated",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject Unallocated",
          "Client_Name_ID": "21013",
          "SubClient_Name": "NonProject Unallocated",
          "SubClient_Name_Id": "21013"
        },
        {
          "Id": 2817,
          "Original_Client_Name": "Penn Medicine",
          "Original_Client_Name_ID": "99110",
          "Client_Name": "Penn Medicine : Inpatient E&M",
          "Client_Name_ID": "11495",
          "SubClient_Name": "Penn Medicine : Inpatient E&M",
          "SubClient_Name_Id": "11495"
        },
        {
          "Id": 2818,
          "Original_Client_Name": "Penn Medicine",
          "Original_Client_Name_ID": "99110",
          "Client_Name": "Penn Medicine : Inpatient E&M",
          "Client_Name_ID": "11495",
          "SubClient_Name": "Penn Medicine : Inpatient E&M",
          "SubClient_Name_Id": "11495"
        },
        {
          "Id": 2819,
          "Original_Client_Name": "Penn Medicine",
          "Original_Client_Name_ID": "99110",
          "Client_Name": "Penn Medicine : ER(Pro/tech)",
          "Client_Name_ID": "11496",
          "SubClient_Name": "Penn Medicine : ER(Pro/tech)",
          "SubClient_Name_Id": "11496"
        },
        {
          "Id": 2820,
          "Original_Client_Name": "Penn Medicine",
          "Original_Client_Name_ID": "99110",
          "Client_Name": "Penn Medicine : ER(Pro/tech)",
          "Client_Name_ID": "11496",
          "SubClient_Name": "Penn Medicine : ER(Pro/tech)",
          "SubClient_Name_Id": "11496"
        },
        {
          "Id": 2821,
          "Original_Client_Name": "Performant Recovery, Inc.",
          "Original_Client_Name_ID": "99057",
          "Client_Name": "Performant: Global Outpatient",
          "Client_Name_ID": "10915",
          "SubClient_Name": "Performant: Global Outpatient",
          "SubClient_Name_Id": "10915"
        },
        {
          "Id": 2822,
          "Original_Client_Name": "Performant Recovery, Inc.",
          "Original_Client_Name_ID": "99057",
          "Client_Name": "Performant: Global Outpatient",
          "Client_Name_ID": "10915",
          "SubClient_Name": "Performant: Global Outpatient",
          "SubClient_Name_Id": "10915"
        },
        {
          "Id": 2823,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Credit Balance",
          "Client_Name_ID": "10885",
          "SubClient_Name": "PAHS: HUH: Credit Balance - Insurance Refund",
          "SubClient_Name_Id": "10885-1"
        },
        {
          "Id": 2824,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Credit Balance",
          "Client_Name_ID": "10885",
          "SubClient_Name": "PAHS: HUH: Credit Balance - Patient Refund",
          "SubClient_Name_Id": "10885-2"
        },
        {
          "Id": 2825,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Credit Balance",
          "Client_Name_ID": "10890",
          "SubClient_Name": "PAHS: St Chris: Credit Balance - Insurance Refund",
          "SubClient_Name_Id": "10890-1"
        },
        {
          "Id": 2826,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Credit Balance",
          "Client_Name_ID": "10890",
          "SubClient_Name": "PAHS: St Chris: Credit Balance - Patient Refund",
          "SubClient_Name_Id": "10890-2"
        },
        {
          "Id": 2827,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Credit Balance",
          "Client_Name_ID": "10885",
          "SubClient_Name": "PAHS: HUH: Credit Balance - Insurance Refund",
          "SubClient_Name_Id": "10885-1"
        },
        {
          "Id": 2828,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Credit Balance",
          "Client_Name_ID": "10885",
          "SubClient_Name": "PAHS: HUH: Credit Balance - Patient Refund",
          "SubClient_Name_Id": "10885-2"
        },
        {
          "Id": 2829,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Credit Balance",
          "Client_Name_ID": "10890",
          "SubClient_Name": "PAHS: St Chris: Credit Balance - Insurance Refund",
          "SubClient_Name_Id": "10890-1"
        },
        {
          "Id": 2830,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Credit Balance",
          "Client_Name_ID": "10890",
          "SubClient_Name": "PAHS: St Chris: Credit Balance - Patient Refund",
          "SubClient_Name_Id": "10890-2"
        },
        {
          "Id": 2831,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: No Response AR Follow up",
          "Client_Name_ID": "10886",
          "SubClient_Name": "PAHS: HUH: No Response AR Follow up",
          "SubClient_Name_Id": "10886"
        },
        {
          "Id": 2832,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC.",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: No Response AR Follow up",
          "Client_Name_ID": "10886",
          "SubClient_Name": "PAHS: HUH: No Response AR Follow up",
          "SubClient_Name_Id": "10886"
        },
        {
          "Id": 2833,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Payment Posting",
          "Client_Name_ID": "10893",
          "SubClient_Name": "PAHS: St Chris: Payment Posting",
          "SubClient_Name_Id": "10893"
        },
        {
          "Id": 2834,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Claim edits",
          "Client_Name_ID": "10889",
          "SubClient_Name": "PAHS: St Chris: Claim edits",
          "SubClient_Name_Id": "10889"
        },
        {
          "Id": 2835,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Claim edits",
          "Client_Name_ID": "10884",
          "SubClient_Name": "PAHS: HUH: Claim edits",
          "SubClient_Name_Id": "10884"
        },
        {
          "Id": 2836,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Payment Posting",
          "Client_Name_ID": "10888",
          "SubClient_Name": "PAHS: HUH: Payment Posting",
          "SubClient_Name_Id": "10888"
        },
        {
          "Id": 2837,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Payment Posting",
          "Client_Name_ID": "10893",
          "SubClient_Name": "PAHS: St Chris: Payment Posting",
          "SubClient_Name_Id": "10893"
        },
        {
          "Id": 2838,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: St Chris: Claim edits",
          "Client_Name_ID": "10889",
          "SubClient_Name": "PAHS: St Chris: Claim edits",
          "SubClient_Name_Id": "10889"
        },
        {
          "Id": 2839,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Claim edits",
          "Client_Name_ID": "10884",
          "SubClient_Name": "PAHS: HUH: Claim edits",
          "SubClient_Name_Id": "10884"
        },
        {
          "Id": 2840,
          "Original_Client_Name": "Philadelphia Academic Health System, LLC. - Aurangabad",
          "Original_Client_Name_ID": "99058",
          "Client_Name": "PAHS: HUH: Payment Posting",
          "Client_Name_ID": "10888",
          "SubClient_Name": "PAHS: HUH: Payment Posting",
          "SubClient_Name_Id": "10888"
        },
        {
          "Id": 2841,
          "Original_Client_Name": "Process Excellence",
          "Original_Client_Name_ID": "NA",
          "Client_Name": "Process Excellence",
          "Client_Name_ID": "10135",
          "SubClient_Name": "Process Excellence",
          "SubClient_Name_Id": "10135"
        },
        {
          "Id": 2842,
          "Original_Client_Name": "Process Trainer",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Trainers",
          "Client_Name_ID": "21014",
          "SubClient_Name": "NonProject: Trainers",
          "SubClient_Name_Id": "21014"
        },
        {
          "Id": 2843,
          "Original_Client_Name": "Process Trainer",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Trainers",
          "Client_Name_ID": "21014",
          "SubClient_Name": "NonProject: Trainers",
          "SubClient_Name_Id": "21014"
        },
        {
          "Id": 2844,
          "Original_Client_Name": "Process Trainer",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Trainers",
          "Client_Name_ID": "21014",
          "SubClient_Name": "NonProject: Trainers",
          "SubClient_Name_Id": "21014"
        },
        {
          "Id": 2845,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: AR Follow:up",
          "Client_Name_ID": "10929",
          "SubClient_Name": "Prospect: Alta: AR Follow:up",
          "SubClient_Name_Id": "10929"
        },
        {
          "Id": 2846,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Culver City: AR Follow-up",
          "Client_Name_ID": "11044",
          "SubClient_Name": "Prospect: Culver City: AR Follow-up",
          "SubClient_Name_Id": "11044"
        },
        {
          "Id": 2847,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: AR Follow:up",
          "Client_Name_ID": "10929",
          "SubClient_Name": "Prospect: Alta: AR Follow:up",
          "SubClient_Name_Id": "10929"
        },
        {
          "Id": 2848,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Culver City: AR Follow-up",
          "Client_Name_ID": "11044",
          "SubClient_Name": "Prospect: Culver City: AR Follow-up",
          "SubClient_Name_Id": "11044"
        },
        {
          "Id": 2849,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up - Code Helpdesk",
          "SubClient_Name_Id": "10928-2"
        },
        {
          "Id": 2850,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: Coding Modifier/billing edits",
          "Client_Name_ID": "10930",
          "SubClient_Name": "Prospect: Alta: Coding Modifier/billing edits",
          "SubClient_Name_Id": "10930"
        },
        {
          "Id": 2851,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "SubClient_Name_Id": "10928"
        },
        {
          "Id": 2852,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: Coding Modifier/billing edits",
          "Client_Name_ID": "10930",
          "SubClient_Name": "Prospect: Alta: Coding Modifier/billing edits",
          "SubClient_Name_Id": "10930"
        },
        {
          "Id": 2853,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Culver City: AR Follow-up",
          "Client_Name_ID": "11044",
          "SubClient_Name": "Prospect: Culver City: AR Follow-up - Appeals/Rebill",
          "SubClient_Name_Id": "11044-1"
        },
        {
          "Id": 2854,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up - Appeals/Rebil",
          "SubClient_Name_Id": "10928-1"
        },
        {
          "Id": 2855,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Culver City: AR Follow-up",
          "Client_Name_ID": "11044",
          "SubClient_Name": "Prospect: Culver City: AR Follow-up - Appeals/Rebill",
          "SubClient_Name_Id": "11044-1"
        },
        {
          "Id": 2856,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up - Appeals/Rebil",
          "SubClient_Name_Id": "10928-1"
        },
        {
          "Id": 2857,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Crozer: AR Follow up",
          "Client_Name_ID": "11129",
          "SubClient_Name": "Prospect: Crozer: AR Follow up",
          "SubClient_Name_Id": "11129"
        },
        {
          "Id": 2858,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Crozer: AR Follow up",
          "Client_Name_ID": "11129",
          "SubClient_Name": "Prospect: Crozer: AR Follow up",
          "SubClient_Name_Id": "11129"
        },
        {
          "Id": 2859,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up - Code Helpdesk",
          "SubClient_Name_Id": "10928-2"
        },
        {
          "Id": 2860,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Texas: AR Follow up",
          "Client_Name_ID": "11494",
          "SubClient_Name": "Prospect: Texas: AR Follow up",
          "SubClient_Name_Id": "11494"
        },
        {
          "Id": 2861,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Texas: AR Follow up",
          "Client_Name_ID": "11494",
          "SubClient_Name": "Prospect: Texas: AR Follow up",
          "SubClient_Name_Id": "11494"
        },
        {
          "Id": 2862,
          "Original_Client_Name": "Prospect Hospital Holdings LLC.",
          "Original_Client_Name_ID": "99061",
          "Client_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "Client_Name_ID": "10928",
          "SubClient_Name": "Prospect: Alta: 180+ days AR Follow:up",
          "SubClient_Name_Id": "10928"
        },
        {
          "Id": 2863,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "SubClient_Name_Id": "11285"
        },
        {
          "Id": 2864,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts 50 - 100 Pages)",
          "Client_Name_ID": "11286",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts 50 - 100 Pages)",
          "SubClient_Name_Id": "11286"
        },
        {
          "Id": 2865,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts over 100 Pages)",
          "Client_Name_ID": "11287",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts over 100 Pages)",
          "SubClient_Name_Id": "11287"
        },
        {
          "Id": 2866,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "SubClient_Name_Id": "11285"
        },
        {
          "Id": 2867,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts 50 - 100 Pages)",
          "Client_Name_ID": "11286",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts 50 - 100 Pages)",
          "SubClient_Name_Id": "11286"
        },
        {
          "Id": 2868,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts over 100 Pages)",
          "Client_Name_ID": "11287",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts over 100 Pages)",
          "SubClient_Name_Id": "11287"
        },
        {
          "Id": 2869,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - Intake",
          "SubClient_Name_Id": "11285-1"
        },
        {
          "Id": 2870,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - Record QA",
          "SubClient_Name_Id": "11285-2"
        },
        {
          "Id": 2871,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - HCC Coding",
          "SubClient_Name_Id": "11285-3"
        },
        {
          "Id": 2872,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - Intake",
          "SubClient_Name_Id": "11285-1"
        },
        {
          "Id": 2873,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - Record QA",
          "SubClient_Name_Id": "11285-2"
        },
        {
          "Id": 2874,
          "Original_Client_Name": "Prospect Medical System, Inc.",
          "Original_Client_Name_ID": "99094",
          "Client_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages)",
          "Client_Name_ID": "11285",
          "SubClient_Name": "Prospect Medical: MA HCC/RxHCC (Charts under 50 Pages) - HCC Coding",
          "SubClient_Name_Id": "11285-3"
        },
        {
          "Id": 2875,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: PPA Worklist Management and Data Entry",
          "Client_Name_ID": "11484",
          "SubClient_Name": "Quadax: PPA Worklist Management and Data Entry",
          "SubClient_Name_Id": "11484"
        },
        {
          "Id": 2876,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: PPA Worklist Management and Data Entry",
          "Client_Name_ID": "11484",
          "SubClient_Name": "Quadax: PPA Worklist Management and Data Entry",
          "SubClient_Name_Id": "11484"
        },
        {
          "Id": 2877,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11424",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up",
          "SubClient_Name_Id": "11424"
        },
        {
          "Id": 2878,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11424",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up",
          "SubClient_Name_Id": "11424"
        },
        {
          "Id": 2879,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11008",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up - Priority, Appeals & Escalated Calls",
          "SubClient_Name_Id": "11008-1"
        },
        {
          "Id": 2880,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11008",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up - Insurance Follow-up",
          "SubClient_Name_Id": "11008-2"
        },
        {
          "Id": 2881,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11008",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up - Priority, Appeals & Escalated Calls",
          "SubClient_Name_Id": "11008-1"
        },
        {
          "Id": 2882,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Claims & Appeals Follow Up",
          "Client_Name_ID": "11008",
          "SubClient_Name": "Quadax: Claims & Appeals Follow Up - Insurance Follow-up",
          "SubClient_Name_Id": "11008-2"
        },
        {
          "Id": 2883,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Receipt Posting",
          "Client_Name_ID": "11451",
          "SubClient_Name": "Quadax: Receipt Posting",
          "SubClient_Name_Id": "11451"
        },
        {
          "Id": 2884,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Review Response",
          "Client_Name_ID": "11452",
          "SubClient_Name": "Quadax: Review Response",
          "SubClient_Name_Id": "11452"
        },
        {
          "Id": 2885,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Data Verification",
          "Client_Name_ID": "11448",
          "SubClient_Name": "Quadax: Data Verification",
          "SubClient_Name_Id": "11448"
        },
        {
          "Id": 2886,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Receipt Posting",
          "Client_Name_ID": "11451",
          "SubClient_Name": "Quadax: Receipt Posting",
          "SubClient_Name_Id": "11451"
        },
        {
          "Id": 2887,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Review Response",
          "Client_Name_ID": "11452",
          "SubClient_Name": "Quadax: Review Response",
          "SubClient_Name_Id": "11452"
        },
        {
          "Id": 2888,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Data Verification",
          "Client_Name_ID": "11448",
          "SubClient_Name": "Quadax: Data Verification",
          "SubClient_Name_Id": "11448"
        },
        {
          "Id": 2889,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Correspondence, Indexing & Processing",
          "Client_Name_ID": "11007",
          "SubClient_Name": "Quadax: Correspondence, Indexing & Processing",
          "SubClient_Name_Id": "11007"
        },
        {
          "Id": 2890,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Correspondence, Indexing & Processing",
          "Client_Name_ID": "11007",
          "SubClient_Name": "Quadax: Correspondence, Indexing & Processing",
          "SubClient_Name_Id": "11007"
        },
        {
          "Id": 2891,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : PPA: PAS to Glidian",
          "Client_Name_ID": "11541",
          "SubClient_Name": "Quadax : PPA: PAS to Glidian",
          "SubClient_Name_Id": "11541"
        },
        {
          "Id": 2892,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : PPA: PAS to Glidian",
          "Client_Name_ID": "11541",
          "SubClient_Name": "Quadax : PPA: PAS to Glidian",
          "SubClient_Name_Id": "11541"
        },
        {
          "Id": 2893,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : PPA: Glidian to PAS",
          "Client_Name_ID": "11542",
          "SubClient_Name": "Quadax : PPA: Glidian to PAS",
          "SubClient_Name_Id": "11542"
        },
        {
          "Id": 2894,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : PPA: Glidian to PAS",
          "Client_Name_ID": "11542",
          "SubClient_Name": "Quadax : PPA: Glidian to PAS",
          "SubClient_Name_Id": "11542"
        },
        {
          "Id": 2895,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Data Verification-COVID Testing",
          "Client_Name_ID": "11543",
          "SubClient_Name": "Quadax : Data Verification-COVID Testing",
          "SubClient_Name_Id": "11543"
        },
        {
          "Id": 2896,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Data Verification-COVID Testing",
          "Client_Name_ID": "11543",
          "SubClient_Name": "Quadax : Data Verification-COVID Testing",
          "SubClient_Name_Id": "11543"
        },
        {
          "Id": 2897,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Review Response-COVID Testing",
          "Client_Name_ID": "11544",
          "SubClient_Name": "Quadax : Review Response-COVID Testing",
          "SubClient_Name_Id": "11544"
        },
        {
          "Id": 2898,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Review Response-COVID Testing",
          "Client_Name_ID": "11544",
          "SubClient_Name": "Quadax : Review Response-COVID Testing",
          "SubClient_Name_Id": "11544"
        },
        {
          "Id": 2899,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : AR Follow-up via Web Portals",
          "Client_Name_ID": "11545",
          "SubClient_Name": "Quadax : AR Follow-up via Web Portals",
          "SubClient_Name_Id": "11545"
        },
        {
          "Id": 2900,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : AR Follow-up via Web Portals",
          "Client_Name_ID": "11545",
          "SubClient_Name": "Quadax : AR Follow-up via Web Portals",
          "SubClient_Name_Id": "11545"
        },
        {
          "Id": 2901,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : AR Follow-up via Phone",
          "Client_Name_ID": "11546",
          "SubClient_Name": "Quadax : AR Follow-up via Phone",
          "SubClient_Name_Id": "11546"
        },
        {
          "Id": 2902,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : AR Follow-up via Phone",
          "Client_Name_ID": "11546",
          "SubClient_Name": "Quadax : AR Follow-up via Phone",
          "SubClient_Name_Id": "11546"
        },
        {
          "Id": 2903,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Indexing",
          "Client_Name_ID": "11454",
          "SubClient_Name": "Quadax: Indexing",
          "SubClient_Name_Id": "11454"
        },
        {
          "Id": 2904,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Indexing",
          "Client_Name_ID": "11454",
          "SubClient_Name": "Quadax: Indexing",
          "SubClient_Name_Id": "11454"
        },
        {
          "Id": 2905,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Correspondence",
          "Client_Name_ID": "11450",
          "SubClient_Name": "Quadax: Correspondence",
          "SubClient_Name_Id": "11450"
        },
        {
          "Id": 2906,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Correspondence",
          "Client_Name_ID": "11450",
          "SubClient_Name": "Quadax: Correspondence",
          "SubClient_Name_Id": "11450"
        },
        {
          "Id": 2907,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Quick Errors",
          "Client_Name_ID": "11626",
          "SubClient_Name": "Quadax: Quick Errors",
          "SubClient_Name_Id": "11626"
        },
        {
          "Id": 2908,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Quick Errors",
          "Client_Name_ID": "11626",
          "SubClient_Name": "Quadax: Quick Errors",
          "SubClient_Name_Id": "11626"
        },
        {
          "Id": 2909,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Charge Repository",
          "Client_Name_ID": "11688",
          "SubClient_Name": "Quadax: Charge Repository",
          "SubClient_Name_Id": "11688"
        },
        {
          "Id": 2910,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Charge Repository",
          "Client_Name_ID": "11688",
          "SubClient_Name": "Quadax: Charge Repository",
          "SubClient_Name_Id": "11688"
        },
        {
          "Id": 2911,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Curative: Denials & Correspondence",
          "Client_Name_ID": "11740",
          "SubClient_Name": "Quadax: Curative: Denials & Correspondence",
          "SubClient_Name_Id": "11740"
        },
        {
          "Id": 2912,
          "Original_Client_Name": "Quadax, Inc.",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Curative: Denials & Correspondence",
          "Client_Name_ID": "11740",
          "SubClient_Name": "Quadax: Curative: Denials & Correspondence",
          "SubClient_Name_Id": "11740"
        },
        {
          "Id": 2913,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Insurance Data Entry",
          "Client_Name_ID": "11665",
          "SubClient_Name": "Quadax: Insurance Data Entry",
          "SubClient_Name_Id": "11665"
        },
        {
          "Id": 2914,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Insurance Data Entry",
          "Client_Name_ID": "11665",
          "SubClient_Name": "Quadax: Insurance Data Entry",
          "SubClient_Name_Id": "11665"
        },
        {
          "Id": 2915,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Demo Data Entry",
          "Client_Name_ID": "11613",
          "SubClient_Name": "Quadax: Demo Data Entry",
          "SubClient_Name_Id": "11613"
        },
        {
          "Id": 2916,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Demo Data Entry",
          "Client_Name_ID": "11613",
          "SubClient_Name": "Quadax: Demo Data Entry",
          "SubClient_Name_Id": "11613"
        },
        {
          "Id": 2917,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Review Response",
          "Client_Name_ID": "11452",
          "SubClient_Name": "Quadax: Review Response",
          "SubClient_Name_Id": "11452"
        },
        {
          "Id": 2918,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Review Response",
          "Client_Name_ID": "11452",
          "SubClient_Name": "Quadax: Review Response",
          "SubClient_Name_Id": "11452"
        },
        {
          "Id": 2919,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Data Verification",
          "Client_Name_ID": "11448",
          "SubClient_Name": "Quadax: Data Verification",
          "SubClient_Name_Id": "11448"
        },
        {
          "Id": 2920,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax: Data Verification",
          "Client_Name_ID": "11448",
          "SubClient_Name": "Quadax: Data Verification",
          "SubClient_Name_Id": "11448"
        },
        {
          "Id": 2921,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Data Verification-COVID Testing",
          "Client_Name_ID": "11543",
          "SubClient_Name": "Quadax : Data Verification-COVID Testing",
          "SubClient_Name_Id": "11543"
        },
        {
          "Id": 2922,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Data Verification-COVID Testing",
          "Client_Name_ID": "11543",
          "SubClient_Name": "Quadax : Data Verification-COVID Testing",
          "SubClient_Name_Id": "11543"
        },
        {
          "Id": 2923,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Review Response-COVID Testing",
          "Client_Name_ID": "11544",
          "SubClient_Name": "Quadax : Review Response-COVID Testing",
          "SubClient_Name_Id": "11544"
        },
        {
          "Id": 2924,
          "Original_Client_Name": "Quadax, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99078",
          "Client_Name": "Quadax : Review Response-COVID Testing",
          "Client_Name_ID": "11544",
          "SubClient_Name": "Quadax : Review Response-COVID Testing",
          "SubClient_Name_Id": "11544"
        },
        {
          "Id": 2925,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Payment Posting Services",
          "Client_Name_ID": "10932",
          "SubClient_Name": "Radiology Ltd.: Payment Posting Services",
          "SubClient_Name_Id": "10932"
        },
        {
          "Id": 2926,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "Client_Name_ID": "10931",
          "SubClient_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "SubClient_Name_Id": "10931"
        },
        {
          "Id": 2927,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "Client_Name_ID": "10931",
          "SubClient_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "SubClient_Name_Id": "10931"
        },
        {
          "Id": 2928,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: AR Follow up services",
          "Client_Name_ID": "11261",
          "SubClient_Name": "Radiology Ltd.: AR Follow up services",
          "SubClient_Name_Id": "11261"
        },
        {
          "Id": 2929,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: AR Follow up services",
          "Client_Name_ID": "11261",
          "SubClient_Name": "Radiology Ltd.: AR Follow up services",
          "SubClient_Name_Id": "11261"
        },
        {
          "Id": 2930,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Claim Correction",
          "Client_Name_ID": "11289",
          "SubClient_Name": "Radiology Ltd.: Claim Correction",
          "SubClient_Name_Id": "11289"
        },
        {
          "Id": 2931,
          "Original_Client_Name": "Radiology Ltd.",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Claim Correction",
          "Client_Name_ID": "11289",
          "SubClient_Name": "Radiology Ltd.: Claim Correction",
          "SubClient_Name_Id": "11289"
        },
        {
          "Id": 2932,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Claim Correction",
          "Client_Name_ID": "11289",
          "SubClient_Name": "Radiology Ltd.: Claim Correction",
          "SubClient_Name_Id": "11289"
        },
        {
          "Id": 2933,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Claim Correction",
          "Client_Name_ID": "11289",
          "SubClient_Name": "Radiology Ltd.: Claim Correction",
          "SubClient_Name_Id": "11289"
        },
        {
          "Id": 2934,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Payment Posting Services",
          "Client_Name_ID": "10932",
          "SubClient_Name": "Radiology Ltd.: Payment Posting Services",
          "SubClient_Name_Id": "10932"
        },
        {
          "Id": 2935,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Payment Posting Services",
          "Client_Name_ID": "10932",
          "SubClient_Name": "Radiology Ltd.: Payment Posting Services",
          "SubClient_Name_Id": "10932"
        },
        {
          "Id": 2936,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Payment Posting Services",
          "Client_Name_ID": "10932",
          "SubClient_Name": "Radiology Ltd.: Payment Posting Services",
          "SubClient_Name_Id": "10932"
        },
        {
          "Id": 2937,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Payment Posting Services",
          "Client_Name_ID": "10932",
          "SubClient_Name": "Radiology Ltd.: Payment Posting Services",
          "SubClient_Name_Id": "10932"
        },
        {
          "Id": 2938,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "Client_Name_ID": "10931",
          "SubClient_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "SubClient_Name_Id": "10931"
        },
        {
          "Id": 2939,
          "Original_Client_Name": "Radiology Ltd. - Aurangabad",
          "Original_Client_Name_ID": "99062",
          "Client_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "Client_Name_ID": "10931",
          "SubClient_Name": "Radiology Ltd.: Medical Coding for Diagnostic Radiology",
          "SubClient_Name_Id": "10931"
        },
        {
          "Id": 2940,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Manual Payment Posting",
          "Client_Name_ID": "11669",
          "SubClient_Name": "RadPartners: Manual Payment Posting",
          "SubClient_Name_Id": "11669"
        },
        {
          "Id": 2941,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Manual Payment Posting",
          "Client_Name_ID": "11669",
          "SubClient_Name": "RadPartners: Manual Payment Posting",
          "SubClient_Name_Id": "11669"
        },
        {
          "Id": 2942,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: EOB Posting",
          "Client_Name_ID": "11670",
          "SubClient_Name": "RadPartners: EOB Posting",
          "SubClient_Name_Id": "11670"
        },
        {
          "Id": 2943,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: EOB Posting",
          "Client_Name_ID": "11670",
          "SubClient_Name": "RadPartners: EOB Posting",
          "SubClient_Name_Id": "11670"
        },
        {
          "Id": 2944,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "Client_Name_ID": "11671",
          "SubClient_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "SubClient_Name_Id": "11671"
        },
        {
          "Id": 2945,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "Client_Name_ID": "11671",
          "SubClient_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "SubClient_Name_Id": "11671"
        },
        {
          "Id": 2946,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Posting (In ERS Central)",
          "Client_Name_ID": "11672",
          "SubClient_Name": "RadPartners: ERS Posting (In ERS Central)",
          "SubClient_Name_Id": "11672"
        },
        {
          "Id": 2947,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Posting (In ERS Central)",
          "Client_Name_ID": "11672",
          "SubClient_Name": "RadPartners: ERS Posting (In ERS Central)",
          "SubClient_Name_Id": "11672"
        },
        {
          "Id": 2948,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS/Payor Rules Mapping",
          "Client_Name_ID": "11673",
          "SubClient_Name": "RadPartners: ERS/Payor Rules Mapping",
          "SubClient_Name_Id": "11673"
        },
        {
          "Id": 2949,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS/Payor Rules Mapping",
          "Client_Name_ID": "11673",
          "SubClient_Name": "RadPartners: ERS/Payor Rules Mapping",
          "SubClient_Name_Id": "11673"
        },
        {
          "Id": 2950,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: AR Follow up Services",
          "Client_Name_ID": "11663",
          "SubClient_Name": "RadPartners: AR Follow up Services",
          "SubClient_Name_Id": "11663"
        },
        {
          "Id": 2951,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: AR Follow up Services",
          "Client_Name_ID": "11663",
          "SubClient_Name": "RadPartners: AR Follow up Services",
          "SubClient_Name_Id": "11663"
        },
        {
          "Id": 2952,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Contract Variance Services",
          "Client_Name_ID": "11664",
          "SubClient_Name": "RadPartners: Contract Variance Services",
          "SubClient_Name_Id": "11664"
        },
        {
          "Id": 2953,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Contract Variance Services",
          "Client_Name_ID": "11664",
          "SubClient_Name": "RadPartners: Contract Variance Services",
          "SubClient_Name_Id": "11664"
        },
        {
          "Id": 2954,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Charge Correction",
          "Client_Name_ID": "11739",
          "SubClient_Name": "RadPartners: Charge Correction",
          "SubClient_Name_Id": "11739"
        },
        {
          "Id": 2955,
          "Original_Client_Name": "RadPartners LLC",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Charge Correction",
          "Client_Name_ID": "11739",
          "SubClient_Name": "RadPartners: Charge Correction",
          "SubClient_Name_Id": "11739"
        },
        {
          "Id": 2956,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Production Control",
          "Client_Name_ID": "11668",
          "SubClient_Name": "RadPartners: Production Control",
          "SubClient_Name_Id": "11668"
        },
        {
          "Id": 2957,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Production Control",
          "Client_Name_ID": "11668",
          "SubClient_Name": "RadPartners: Production Control",
          "SubClient_Name_Id": "11668"
        },
        {
          "Id": 2958,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Manual Payment Posting",
          "Client_Name_ID": "11669",
          "SubClient_Name": "RadPartners: Manual Payment Posting",
          "SubClient_Name_Id": "11669"
        },
        {
          "Id": 2959,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: Manual Payment Posting",
          "Client_Name_ID": "11669",
          "SubClient_Name": "RadPartners: Manual Payment Posting",
          "SubClient_Name_Id": "11669"
        },
        {
          "Id": 2960,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: EOB Posting",
          "Client_Name_ID": "11670",
          "SubClient_Name": "RadPartners: EOB Posting",
          "SubClient_Name_Id": "11670"
        },
        {
          "Id": 2961,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: EOB Posting",
          "Client_Name_ID": "11670",
          "SubClient_Name": "RadPartners: EOB Posting",
          "SubClient_Name_Id": "11670"
        },
        {
          "Id": 2962,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "Client_Name_ID": "11671",
          "SubClient_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "SubClient_Name_Id": "11671"
        },
        {
          "Id": 2963,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "Client_Name_ID": "11671",
          "SubClient_Name": "RadPartners: ERS Exceptions/Finding Missing Items",
          "SubClient_Name_Id": "11671"
        },
        {
          "Id": 2964,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Posting (In ERS Central)",
          "Client_Name_ID": "11672",
          "SubClient_Name": "RadPartners: ERS Posting (In ERS Central)",
          "SubClient_Name_Id": "11672"
        },
        {
          "Id": 2965,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS Posting (In ERS Central)",
          "Client_Name_ID": "11672",
          "SubClient_Name": "RadPartners: ERS Posting (In ERS Central)",
          "SubClient_Name_Id": "11672"
        },
        {
          "Id": 2966,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS/Payor Rules Mapping",
          "Client_Name_ID": "11673",
          "SubClient_Name": "RadPartners: ERS/Payor Rules Mapping",
          "SubClient_Name_Id": "11673"
        },
        {
          "Id": 2967,
          "Original_Client_Name": "RadPartners LLC - Aurangabad",
          "Original_Client_Name_ID": "99125",
          "Client_Name": "RadPartners: ERS/Payor Rules Mapping",
          "Client_Name_ID": "11673",
          "SubClient_Name": "RadPartners: ERS/Payor Rules Mapping",
          "SubClient_Name_Id": "11673"
        },
        {
          "Id": 2968,
          "Original_Client_Name": "RCMcLean & Associates, Inc.",
          "Original_Client_Name_ID": "99063",
          "Client_Name": "RCMcLean: Anesthesia Coding",
          "Client_Name_ID": "10933",
          "SubClient_Name": "RCMcLean: Anesthesia Coding",
          "SubClient_Name_Id": "10933"
        },
        {
          "Id": 2969,
          "Original_Client_Name": "RCMcLean & Associates, Inc.",
          "Original_Client_Name_ID": "99063",
          "Client_Name": "RCMcLean: Anesthesia Coding",
          "Client_Name_ID": "10933",
          "SubClient_Name": "RCMcLean: Anesthesia Coding",
          "SubClient_Name_Id": "10933"
        },
        {
          "Id": 2970,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: AR Follow:Up Services",
          "Client_Name_ID": "10935",
          "SubClient_Name": "Results: AR Follow:Up Services",
          "SubClient_Name_Id": "10935"
        },
        {
          "Id": 2971,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: AR Follow:Up Services",
          "Client_Name_ID": "10935",
          "SubClient_Name": "Results: AR Follow:Up Services",
          "SubClient_Name_Id": "10935"
        },
        {
          "Id": 2972,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Additional Page (EOB/Medical record)",
          "Client_Name_ID": "10934",
          "SubClient_Name": "Results: Additional Page (EOB/Medical record)",
          "SubClient_Name_Id": "10934"
        },
        {
          "Id": 2973,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Credit Balance",
          "Client_Name_ID": "10936",
          "SubClient_Name": "Results: Credit Balance",
          "SubClient_Name_Id": "10936"
        },
        {
          "Id": 2974,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: HCFA",
          "Client_Name_ID": "10938",
          "SubClient_Name": "Results: HCFA",
          "SubClient_Name_Id": "10938"
        },
        {
          "Id": 2975,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting",
          "SubClient_Name_Id": "10939"
        },
        {
          "Id": 2976,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Credit Balance",
          "Client_Name_ID": "10936",
          "SubClient_Name": "Results: Credit Balance",
          "SubClient_Name_Id": "10936"
        },
        {
          "Id": 2977,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting",
          "SubClient_Name_Id": "10939"
        },
        {
          "Id": 2978,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - ERA",
          "SubClient_Name_Id": "10939-1"
        },
        {
          "Id": 2979,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - Manual",
          "SubClient_Name_Id": "10939-2"
        },
        {
          "Id": 2980,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - OTC",
          "SubClient_Name_Id": "10939-3"
        },
        {
          "Id": 2981,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - ERA",
          "SubClient_Name_Id": "10939-1"
        },
        {
          "Id": 2982,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - Manual",
          "SubClient_Name_Id": "10939-2"
        },
        {
          "Id": 2983,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Posting",
          "Client_Name_ID": "10939",
          "SubClient_Name": "Results: Payment Posting - OTC",
          "SubClient_Name_Id": "10939-3"
        },
        {
          "Id": 2984,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Plan",
          "Client_Name_ID": "10937",
          "SubClient_Name": "Results: Payment Plan",
          "SubClient_Name_Id": "10937"
        },
        {
          "Id": 2985,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Payment Plan",
          "Client_Name_ID": "10937",
          "SubClient_Name": "Results: Payment Plan",
          "SubClient_Name_Id": "10937"
        },
        {
          "Id": 2986,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: AR Follow:Up Services",
          "Client_Name_ID": "10935",
          "SubClient_Name": "Results: AR Follow:Up Services - DenialManagement&Rejections",
          "SubClient_Name_Id": "10935-1"
        },
        {
          "Id": 2987,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Credit balance Double discount",
          "Client_Name_ID": "11148",
          "SubClient_Name": "Results: Credit balance Double discount",
          "SubClient_Name_Id": "11148"
        },
        {
          "Id": 2988,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Credit balance Double discount",
          "Client_Name_ID": "11148",
          "SubClient_Name": "Results: Credit balance Double discount",
          "SubClient_Name_Id": "11148"
        },
        {
          "Id": 2989,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Coding Denials",
          "Client_Name_ID": "11170",
          "SubClient_Name": "Results: Coding Denials",
          "SubClient_Name_Id": "11170"
        },
        {
          "Id": 2990,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Coding Denials",
          "Client_Name_ID": "11170",
          "SubClient_Name": "Results: Coding Denials",
          "SubClient_Name_Id": "11170"
        },
        {
          "Id": 2991,
          "Original_Client_Name": "Results Physiotherapy",
          "Original_Client_Name_ID": "99064",
          "Client_Name": "Results: Quality Analyst",
          "Client_Name_ID": "11188",
          "SubClient_Name": "Results: Quality Analyst",
          "SubClient_Name_Id": "11188"
        },
        {
          "Id": 2992,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services - Priority Follow up",
          "SubClient_Name_Id": "10940-1"
        },
        {
          "Id": 2993,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services - Priority Follow up",
          "SubClient_Name_Id": "10940-1"
        },
        {
          "Id": 2994,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services - Adjustments/NORSC Follow Ups",
          "SubClient_Name_Id": "10940-2"
        },
        {
          "Id": 2995,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services - Adjustments/NORSC Follow Ups",
          "SubClient_Name_Id": "10940-2"
        },
        {
          "Id": 2996,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services",
          "SubClient_Name_Id": "10940"
        },
        {
          "Id": 2997,
          "Original_Client_Name": "Rev-Ignition Corporation",
          "Original_Client_Name_ID": "99065",
          "Client_Name": "Rev-Ignition: AR Follow up services",
          "Client_Name_ID": "10940",
          "SubClient_Name": "Rev-Ignition: AR Follow up services",
          "SubClient_Name_Id": "10940"
        },
        {
          "Id": 2998,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Professional Multi-Specialty - E&M and CPT",
          "Client_Name_ID": "11045",
          "SubClient_Name": "SaintAnthony: Professional Multi-Specialty - E&M and CPT",
          "SubClient_Name_Id": "11045"
        },
        {
          "Id": 2999,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Clinic",
          "Client_Name_ID": "10941",
          "SubClient_Name": "SaintAnthony: Clinic",
          "SubClient_Name_Id": "10941"
        },
        {
          "Id": 3000,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Reoccurring",
          "Client_Name_ID": "10946",
          "SubClient_Name": "SaintAnthony: Reoccurring",
          "SubClient_Name_Id": "10946"
        },
        {
          "Id": 3001,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Outpatient Ancillary",
          "Client_Name_ID": "10944",
          "SubClient_Name": "SaintAnthony: Outpatient Ancillary",
          "SubClient_Name_Id": "10944"
        },
        {
          "Id": 3002,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Emergency Department",
          "Client_Name_ID": "10942",
          "SubClient_Name": "SaintAnthony: Emergency Department",
          "SubClient_Name_Id": "10942"
        },
        {
          "Id": 3003,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Inpatient MS:DRG",
          "Client_Name_ID": "10943",
          "SubClient_Name": "SaintAnthony: Inpatient MS:DRG",
          "SubClient_Name_Id": "10943"
        },
        {
          "Id": 3004,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Professional Multi-Specialty - E&M and CPT",
          "Client_Name_ID": "11045",
          "SubClient_Name": "SaintAnthony: Professional Multi-Specialty - E&M and CPT",
          "SubClient_Name_Id": "11045"
        },
        {
          "Id": 3005,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Clinic",
          "Client_Name_ID": "10941",
          "SubClient_Name": "SaintAnthony: Clinic",
          "SubClient_Name_Id": "10941"
        },
        {
          "Id": 3006,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Reoccurring",
          "Client_Name_ID": "10946",
          "SubClient_Name": "SaintAnthony: Reoccurring",
          "SubClient_Name_Id": "10946"
        },
        {
          "Id": 3007,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Outpatient Ancillary",
          "Client_Name_ID": "10944",
          "SubClient_Name": "SaintAnthony: Outpatient Ancillary",
          "SubClient_Name_Id": "10944"
        },
        {
          "Id": 3008,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Emergency Department",
          "Client_Name_ID": "10942",
          "SubClient_Name": "SaintAnthony: Emergency Department",
          "SubClient_Name_Id": "10942"
        },
        {
          "Id": 3009,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Inpatient MS:DRG",
          "Client_Name_ID": "10943",
          "SubClient_Name": "SaintAnthony: Inpatient MS:DRG",
          "SubClient_Name_Id": "10943"
        },
        {
          "Id": 3010,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Observation/Outpatient Surgery",
          "Client_Name_ID": "11313",
          "SubClient_Name": "SaintAnthony: Observation/Outpatient Surgery",
          "SubClient_Name_Id": "11313"
        },
        {
          "Id": 3011,
          "Original_Client_Name": "Saint Anthony Hospital",
          "Original_Client_Name_ID": "99066",
          "Client_Name": "SaintAnthony: Observation/Outpatient Surgery",
          "Client_Name_ID": "11313",
          "SubClient_Name": "SaintAnthony: Observation/Outpatient Surgery",
          "SubClient_Name_Id": "11313"
        },
        {
          "Id": 3012,
          "Original_Client_Name": "Sight Partners, LLC.",
          "Original_Client_Name_ID": "99128",
          "Client_Name": "Sight: Ophthalmology services",
          "Client_Name_ID": "11713",
          "SubClient_Name": "Sight: Ophthalmology services",
          "SubClient_Name_Id": "11713"
        },
        {
          "Id": 3013,
          "Original_Client_Name": "Sight Partners, LLC.",
          "Original_Client_Name_ID": "99128",
          "Client_Name": "Sight: Ophthalmology services",
          "Client_Name_ID": "11713",
          "SubClient_Name": "Sight: Ophthalmology services",
          "SubClient_Name_Id": "11713"
        },
        {
          "Id": 3014,
          "Original_Client_Name": "Sight Partners, LLC.",
          "Original_Client_Name_ID": "99128",
          "Client_Name": "Sight: Payment Posting",
          "Client_Name_ID": "11701",
          "SubClient_Name": "Sight: Payment Posting",
          "SubClient_Name_Id": "11701"
        },
        {
          "Id": 3015,
          "Original_Client_Name": "Sight Partners, LLC.",
          "Original_Client_Name_ID": "99128",
          "Client_Name": "Sight: Payment Posting",
          "Client_Name_ID": "11701",
          "SubClient_Name": "Sight: Payment Posting",
          "SubClient_Name_Id": "11701"
        },
        {
          "Id": 3016,
          "Original_Client_Name": "Skill Upgrade (20) - IP Batch 1 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3017,
          "Original_Client_Name": "Skill Upgrade (21) - IP Batch 9 - MS",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3018,
          "Original_Client_Name": "Skill Upgrade (22) - IP Batch 2 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3019,
          "Original_Client_Name": "Skill Upgrade (23) - IP Batch 3 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3020,
          "Original_Client_Name": "Skill Upgrade (23) - IP Batch 3 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3021,
          "Original_Client_Name": "Skill Upgrade ED Clinic - Batch 2 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3022,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "SubClient_Name_Id": "10949"
        },
        {
          "Id": 3023,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "Client_Name_ID": "10950",
          "SubClient_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "SubClient_Name_Id": "10950"
        },
        {
          "Id": 3024,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "Client_Name_ID": "10950",
          "SubClient_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "SubClient_Name_Id": "10950"
        },
        {
          "Id": 3025,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular - Non Vascular - Extraction",
          "SubClient_Name_Id": "10949-1"
        },
        {
          "Id": 3026,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular - Non Vascular - Extraction",
          "SubClient_Name_Id": "10949-1"
        },
        {
          "Id": 3027,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "SubClient_Name_Id": "10949"
        },
        {
          "Id": 3028,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "Client_Name_ID": "10950",
          "SubClient_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "SubClient_Name_Id": "10950"
        },
        {
          "Id": 3029,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "SubClient_Name_Id": "10949"
        },
        {
          "Id": 3030,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "Client_Name_ID": "10950",
          "SubClient_Name": "Strategic Admin: Medical Coding for diagnostic radiology report",
          "SubClient_Name_Id": "10950"
        },
        {
          "Id": 3031,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular - Vascular",
          "SubClient_Name_Id": "10949-1"
        },
        {
          "Id": 3032,
          "Original_Client_Name": "Strategic Administrative and Reimbursement Services - Aurangabad",
          "Original_Client_Name_ID": "99068",
          "Client_Name": "Strategic Admin: Interventional Radiology- Non Vascular",
          "Client_Name_ID": "10949",
          "SubClient_Name": "Strategic Admin: Interventional Radiology- Non Vascular - Vascular",
          "SubClient_Name_Id": "10949-1"
        },
        {
          "Id": 3033,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Holy Cross: ED Coding Services",
          "Client_Name_ID": "10961",
          "SubClient_Name": "Synergistic: Holy Cross: ED Coding Services",
          "SubClient_Name_Id": "10961"
        },
        {
          "Id": 3034,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Holy Cross: ED Coding Services",
          "Client_Name_ID": "10961",
          "SubClient_Name": "Synergistic: Holy Cross: ED Coding Services",
          "SubClient_Name_Id": "10961"
        },
        {
          "Id": 3035,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services",
          "SubClient_Name_Id": "10960"
        },
        {
          "Id": 3036,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services",
          "SubClient_Name_Id": "10960"
        },
        {
          "Id": 3037,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Non-codable reports need to no-charged",
          "Client_Name_ID": "11507",
          "SubClient_Name": "Synergistic: Non-codable reports need to no-charged",
          "SubClient_Name_Id": "11507"
        },
        {
          "Id": 3038,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Non-codable reports need to no-charged",
          "Client_Name_ID": "11507",
          "SubClient_Name": "Synergistic: Non-codable reports need to no-charged",
          "SubClient_Name_Id": "11507"
        },
        {
          "Id": 3039,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - TAOS",
          "SubClient_Name_Id": "10960-1"
        },
        {
          "Id": 3040,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - TAOS",
          "SubClient_Name_Id": "10960-1"
        },
        {
          "Id": 3041,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Hunterdon",
          "SubClient_Name_Id": "10960-2"
        },
        {
          "Id": 3042,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Hunterdon",
          "SubClient_Name_Id": "10960-2"
        },
        {
          "Id": 3043,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Yakima",
          "SubClient_Name_Id": "10960-3"
        },
        {
          "Id": 3044,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Yakima",
          "SubClient_Name_Id": "10960-3"
        },
        {
          "Id": 3045,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Norwalk",
          "SubClient_Name_Id": "10960-4"
        },
        {
          "Id": 3046,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Norwalk",
          "SubClient_Name_Id": "10960-4"
        },
        {
          "Id": 3047,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Torrance",
          "SubClient_Name_Id": "10960-5"
        },
        {
          "Id": 3048,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Torrance",
          "SubClient_Name_Id": "10960-5"
        },
        {
          "Id": 3049,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Pathology",
          "SubClient_Name_Id": "10960-6"
        },
        {
          "Id": 3050,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: ED Coding Services",
          "Client_Name_ID": "10960",
          "SubClient_Name": "Synergistic: ED Coding Services - Pathology",
          "SubClient_Name_Id": "10960-6"
        },
        {
          "Id": 3051,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Holy Cross: ED Coding Services",
          "Client_Name_ID": "10961",
          "SubClient_Name": "Synergistic: Holy Cross: ED Coding Services - TAOS",
          "SubClient_Name_Id": "10961-1"
        },
        {
          "Id": 3052,
          "Original_Client_Name": "Synergistic System, LLC",
          "Original_Client_Name_ID": "99070",
          "Client_Name": "Synergistic: Holy Cross: ED Coding Services",
          "Client_Name_ID": "10961",
          "SubClient_Name": "Synergistic: Holy Cross: ED Coding Services - TAOS",
          "SubClient_Name_Id": "10961-1"
        },
        {
          "Id": 3053,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Diagnostic Radiology",
          "Client_Name_ID": "11599",
          "SubClient_Name": "Technology: RadPartners: Diagnostic Radiology",
          "SubClient_Name_Id": "11599"
        },
        {
          "Id": 3054,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Non Vascular: Interventional Radiology",
          "Client_Name_ID": "11600",
          "SubClient_Name": "Technology: RadPartners: Non Vascular: Interventional Radiology",
          "SubClient_Name_Id": "11600"
        },
        {
          "Id": 3055,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Diagnostic Radiology",
          "Client_Name_ID": "11599",
          "SubClient_Name": "Technology: RadPartners: Diagnostic Radiology",
          "SubClient_Name_Id": "11599"
        },
        {
          "Id": 3056,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Non Vascular: Interventional Radiology",
          "Client_Name_ID": "11600",
          "SubClient_Name": "Technology: RadPartners: Non Vascular: Interventional Radiology",
          "SubClient_Name_Id": "11600"
        },
        {
          "Id": 3057,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: Fathom Health: Diagnostic Radiology",
          "Client_Name_ID": "11627",
          "SubClient_Name": "Technology: Fathom Health: Diagnostic Radiology-Rework files",
          "SubClient_Name_Id": "11627-1"
        },
        {
          "Id": 3058,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Charge Verification",
          "Client_Name_ID": "11714",
          "SubClient_Name": "Technology: RadPartners: Charge Verification",
          "SubClient_Name_Id": "11714"
        },
        {
          "Id": 3059,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: RadPartners: Charge Verification",
          "Client_Name_ID": "11714",
          "SubClient_Name": "Technology: RadPartners: Charge Verification",
          "SubClient_Name_Id": "11714"
        },
        {
          "Id": 3060,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: Fathom Health: Diagnostic Radiology",
          "Client_Name_ID": "11627",
          "SubClient_Name": "Technology: Fathom Health: Diagnostic Radiology",
          "SubClient_Name_Id": "11627"
        },
        {
          "Id": 3061,
          "Original_Client_Name": "Technology Partners LLC. - Aurangabad",
          "Original_Client_Name_ID": "99118",
          "Client_Name": "Technology: Fathom Health: Diagnostic Radiology",
          "Client_Name_ID": "11627",
          "SubClient_Name": "Technology: Fathom Health: Diagnostic Radiology",
          "SubClient_Name_Id": "11627"
        },
        {
          "Id": 3062,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: PB Credit Balance Resolution",
          "Client_Name_ID": "11352",
          "SubClient_Name": "UTSW: PB Credit Balance Resolution",
          "SubClient_Name_Id": "11352"
        },
        {
          "Id": 3063,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: PB Credit Balance Resolution",
          "Client_Name_ID": "11352",
          "SubClient_Name": "UTSW: PB Credit Balance Resolution",
          "SubClient_Name_Id": "11352"
        },
        {
          "Id": 3064,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: Technical Denials Management/Variances",
          "Client_Name_ID": "11357",
          "SubClient_Name": "UTSW: Technical Denials Management/Variances",
          "SubClient_Name_Id": "11357"
        },
        {
          "Id": 3065,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: HB - Clinical Denials Management",
          "Client_Name_ID": "11358",
          "SubClient_Name": "UTSW: HB - Clinical Denials Management",
          "SubClient_Name_Id": "11358"
        },
        {
          "Id": 3066,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: Technical Denials Management/Variances",
          "Client_Name_ID": "11357",
          "SubClient_Name": "UTSW: Technical Denials Management/Variances",
          "SubClient_Name_Id": "11357"
        },
        {
          "Id": 3067,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: HB - Clinical Denials Management",
          "Client_Name_ID": "11358",
          "SubClient_Name": "UTSW: HB - Clinical Denials Management",
          "SubClient_Name_Id": "11358"
        },
        {
          "Id": 3068,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: HB Credit balance resolution",
          "Client_Name_ID": "11356",
          "SubClient_Name": "UTSW: HB Credit balance resolution",
          "SubClient_Name_Id": "11356"
        },
        {
          "Id": 3069,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: HB Credit balance resolution",
          "Client_Name_ID": "11356",
          "SubClient_Name": "UTSW: HB Credit balance resolution",
          "SubClient_Name_Id": "11356"
        },
        {
          "Id": 3070,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: Payment Posting",
          "Client_Name_ID": "11146",
          "SubClient_Name": "UTSW: Payment Posting",
          "SubClient_Name_Id": "11146"
        },
        {
          "Id": 3071,
          "Original_Client_Name": "The University of Texas Southwestern Medical Center",
          "Original_Client_Name_ID": "99085",
          "Client_Name": "UTSW: Payment Posting",
          "Client_Name_ID": "11146",
          "SubClient_Name": "UTSW: Payment Posting",
          "SubClient_Name_Id": "11146"
        },
        {
          "Id": 3072,
          "Original_Client_Name": "Training Batch (154)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3073,
          "Original_Client_Name": "Training Batch (155)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3074,
          "Original_Client_Name": "Training Batch (156)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3075,
          "Original_Client_Name": "Training Batch (156)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3076,
          "Original_Client_Name": "Training Batch (157)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3077,
          "Original_Client_Name": "Training Batch (157)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3078,
          "Original_Client_Name": "Training Batch (158)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3079,
          "Original_Client_Name": "Training Batch (158)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3080,
          "Original_Client_Name": "Training Batch (159)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3081,
          "Original_Client_Name": "Training Batch (159)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3082,
          "Original_Client_Name": "Training Batch (16) - MS - 16",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3083,
          "Original_Client_Name": "Training Batch (160)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3084,
          "Original_Client_Name": "Training Batch (160)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3085,
          "Original_Client_Name": "Training Batch (161)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3086,
          "Original_Client_Name": "Training Batch (161)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3087,
          "Original_Client_Name": "Training Batch (162)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3088,
          "Original_Client_Name": "Training Batch (162)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3089,
          "Original_Client_Name": "Training Batch (163)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3090,
          "Original_Client_Name": "Training Batch (164)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3091,
          "Original_Client_Name": "Training Batch (165)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3092,
          "Original_Client_Name": "Training Batch (166)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3093,
          "Original_Client_Name": "Training Batch (167)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3094,
          "Original_Client_Name": "Training Batch (168)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3095,
          "Original_Client_Name": "Training Batch (169)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3096,
          "Original_Client_Name": "Training Batch (17) - AND - 1",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3097,
          "Original_Client_Name": "Training Batch (170)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3098,
          "Original_Client_Name": "Training Batch (178) - AND - 02",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3099,
          "Original_Client_Name": "Training Batch (179) - ARG - 17",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3100,
          "Original_Client_Name": "Training Batch (18) - MS - 17",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3101,
          "Original_Client_Name": "Training Batch (180) - AND - 03",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3102,
          "Original_Client_Name": "Training Batch (181) - ARG - 18",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3103,
          "Original_Client_Name": "Training Batch (182) - MS - 163",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3104,
          "Original_Client_Name": "Training Batch (183) - ARG - 19",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3105,
          "Original_Client_Name": "Training Batch (184) - MS - 164",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3106,
          "Original_Client_Name": "Training Batch (185) - AND - 04",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "2218",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3107,
          "Original_Client_Name": "Training Batch (186) - AND - 05",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "2218",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3108,
          "Original_Client_Name": "Training Batch (187) - MS - 165",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3109,
          "Original_Client_Name": "Training Batch (188) - MS - 166",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3110,
          "Original_Client_Name": "Training Batch (189) - ARG - 20",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3111,
          "Original_Client_Name": "Training Batch (19) - ARG - 1",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3112,
          "Original_Client_Name": "Training Batch (190) - MS - 167",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3113,
          "Original_Client_Name": "Training Batch (191) - MS - 168",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3114,
          "Original_Client_Name": "Training Batch (20) - AND - 2",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3115,
          "Original_Client_Name": "Training Batch (205) - MS - 171",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3116,
          "Original_Client_Name": "Training Batch (206) - MS - 172",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3117,
          "Original_Client_Name": "Training Batch (207) - ARG - 35",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3118,
          "Original_Client_Name": "Training Batch (208) - ARG - 36",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3119,
          "Original_Client_Name": "Training Batch (209) - MS - 173",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3120,
          "Original_Client_Name": "Training Batch (210) - ARG - 37",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3121,
          "Original_Client_Name": "Training Batch (211) - ARG - 38",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3122,
          "Original_Client_Name": "Training Batch (212) - ARG - 39",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3123,
          "Original_Client_Name": "Training Batch (213) - MS - 174",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3124,
          "Original_Client_Name": "Training Batch (214) - ARG - 40",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3125,
          "Original_Client_Name": "Training Batch (215) - MS - 175",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3126,
          "Original_Client_Name": "Training Batch (216) - ARG - 41",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3127,
          "Original_Client_Name": "Training Batch (217) - MS - 176",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3128,
          "Original_Client_Name": "Training Batch (218) - MS - 177",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3129,
          "Original_Client_Name": "Training Batch (219) - MS - 178",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3130,
          "Original_Client_Name": "Training Batch (220) - AND - 1",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3131,
          "Original_Client_Name": "Training Batch (221) - MS - 179",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3132,
          "Original_Client_Name": "Training Batch (222) - AND - 2",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3133,
          "Original_Client_Name": "Training Batch (223) - ARG - 42",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3134,
          "Original_Client_Name": "Training Batch (224) - ARG - 43",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3135,
          "Original_Client_Name": "Training Batch (225) - AND - 3",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3136,
          "Original_Client_Name": "Training Batch (226) - AND - 4",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3137,
          "Original_Client_Name": "Training Batch (227) - MS - 180",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3138,
          "Original_Client_Name": "Training Batch (228) - ARG - 44",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3139,
          "Original_Client_Name": "Training Batch (229) - AND - 5",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3140,
          "Original_Client_Name": "Training Batch (230) - AND - 6",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3141,
          "Original_Client_Name": "Training Batch (231) - ARG - 45",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3142,
          "Original_Client_Name": "Training Batch (232) - ARG - 46",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3143,
          "Original_Client_Name": "Training Batch (233) - MS - 181",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3144,
          "Original_Client_Name": "Training Batch (233) - MS - 181 - HCC",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3145,
          "Original_Client_Name": "Training Batch (234) - AND - 7",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3146,
          "Original_Client_Name": "Training Batch (235) - MS - 182",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3147,
          "Original_Client_Name": "Training Batch (235) - MS - 182 - HCC",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "CODTRN",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "CODTRN"
        },
        {
          "Id": 3148,
          "Original_Client_Name": "Training Batch (236) - AND - 8",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3149,
          "Original_Client_Name": "Training Batch (237) -  ARG - 47",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3150,
          "Original_Client_Name": "Training Batch (238) - ARG - 48",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3151,
          "Original_Client_Name": "Training Batch (239) - AND - 9",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3152,
          "Original_Client_Name": "Training Batch (240) - AND - 10",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3153,
          "Original_Client_Name": "Training Batch (241) - MS - 183",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3154,
          "Original_Client_Name": "Training Batch (242) - ARG - 49",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3155,
          "Original_Client_Name": "Training Batch (243) - ARG - 50",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3156,
          "Original_Client_Name": "Training Batch (244) - MS - 184",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3157,
          "Original_Client_Name": "Training Batch (245) - MS - 185",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3158,
          "Original_Client_Name": "Training Batch (246) - ARG - 51",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3159,
          "Original_Client_Name": "Training Batch (247) - MS - 186",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3160,
          "Original_Client_Name": "Training Batch (248) - ARG - 52",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3161,
          "Original_Client_Name": "Training Batch (249) - MS - 187",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3162,
          "Original_Client_Name": "Training Batch (482)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3163,
          "Original_Client_Name": "Training Batch (483)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3164,
          "Original_Client_Name": "Training Batch (485)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3165,
          "Original_Client_Name": "Training Batch (489)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3166,
          "Original_Client_Name": "Training Batch (518)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3167,
          "Original_Client_Name": "Training Batch (543)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3168,
          "Original_Client_Name": "Training Batch (544)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3169,
          "Original_Client_Name": "Training Batch (564)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3170,
          "Original_Client_Name": "Training Batch (568)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3171,
          "Original_Client_Name": "Training Batch (570)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3172,
          "Original_Client_Name": "Training Batch (572)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3173,
          "Original_Client_Name": "Training Batch (573)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3174,
          "Original_Client_Name": "Training Batch (579)",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3175,
          "Original_Client_Name": "Training Batch (585) - MS - 583",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3176,
          "Original_Client_Name": "Training Batch (605) - MS - 594",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3177,
          "Original_Client_Name": "Training Batch (606) - MS - 595",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3178,
          "Original_Client_Name": "Training Batch (607) - AND 18",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3179,
          "Original_Client_Name": "Training Batch (608) - AND 19",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3180,
          "Original_Client_Name": "Training Batch (609) - MS - 596",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3181,
          "Original_Client_Name": "Training Batch (610) - AND 20",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3182,
          "Original_Client_Name": "Training Batch (611) - AND 21",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3183,
          "Original_Client_Name": "Training Batch (612) - MS - 597",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3184,
          "Original_Client_Name": "Training Batch (612) - MS - 597",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3185,
          "Original_Client_Name": "Training Batch (613) - AND - 02",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "PMDETRN",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "PMDETRN"
        },
        {
          "Id": 3186,
          "Original_Client_Name": "Training Batch (613) - MS - 598",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3187,
          "Original_Client_Name": "Training Batch (613) - MS - 598",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3188,
          "Original_Client_Name": "Training Batch (614) - MS - 599",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3189,
          "Original_Client_Name": "Training Batch (614) - MS - 599",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3190,
          "Original_Client_Name": "Training Batch (615) - MS - 600",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3191,
          "Original_Client_Name": "Training Batch (616) - MS - 601",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3192,
          "Original_Client_Name": "Training Batch (617) - SEEPZ - 02",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3193,
          "Original_Client_Name": "Training Batch (618) - MS - 602",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3194,
          "Original_Client_Name": "Training Batch (619) - MS - 603",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3195,
          "Original_Client_Name": "Training Batch (620) - AND 22",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3196,
          "Original_Client_Name": "Training Batch (621) - MS - 604",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3197,
          "Original_Client_Name": "Training Batch (622) - MS - 605",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3198,
          "Original_Client_Name": "Training Batch (623) - MS - 606",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3199,
          "Original_Client_Name": "Training Batch (624) - MS - 607",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3200,
          "Original_Client_Name": "Training Batch (625) - MS - 608",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3201,
          "Original_Client_Name": "Training Batch (626) - MS - 609",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3202,
          "Original_Client_Name": "Training Batch (627) - AND 23",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3203,
          "Original_Client_Name": "Training Batch (628) - AND 24",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3204,
          "Original_Client_Name": "Training Batch (629) - MS - 610",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3205,
          "Original_Client_Name": "Training Batch (630) - MS - 611",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3206,
          "Original_Client_Name": "Training Batch (631) - MS - 612",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3207,
          "Original_Client_Name": "Training Batch (632) - MS - 613",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3208,
          "Original_Client_Name": "Training Batch (632) - MS - 613",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3209,
          "Original_Client_Name": "Training Batch (633) - MS - 614",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3210,
          "Original_Client_Name": "Training Batch (633) - MS - 614",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3211,
          "Original_Client_Name": "Training Batch (634) - AND 25",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3212,
          "Original_Client_Name": "Training Batch (635) - AND 26",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3213,
          "Original_Client_Name": "Training Batch (636) - AND 27",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3214,
          "Original_Client_Name": "Training Batch (637) - MS - 615",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3215,
          "Original_Client_Name": "Training Batch (638) - MS - 616",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3216,
          "Original_Client_Name": "Training Batch (639) - MS - 617",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3217,
          "Original_Client_Name": "Training Batch (639) - MS - 617",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3218,
          "Original_Client_Name": "Training Batch (640) - MS - 618",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3219,
          "Original_Client_Name": "Training Batch (641) - MS - 619",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3220,
          "Original_Client_Name": "Training Batch (642) - MS - 620",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3221,
          "Original_Client_Name": "Training Batch (643) - AND 28",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3222,
          "Original_Client_Name": "Training Batch (644) - AND 29",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3223,
          "Original_Client_Name": "Training Batch (645) - MS - 621",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3224,
          "Original_Client_Name": "Training Batch (646) - MS - 622",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3225,
          "Original_Client_Name": "Training Batch (647) - AND 30",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3226,
          "Original_Client_Name": "Training Batch (648) - AND 31",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3227,
          "Original_Client_Name": "Training Batch (649) - MS - 623",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3228,
          "Original_Client_Name": "Training Batch (650) - MS - 624",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3229,
          "Original_Client_Name": "Training Batch (651) - AND 32",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3230,
          "Original_Client_Name": "Training Batch (652) - AND 33",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3231,
          "Original_Client_Name": "Training Batch (653) - MS - 625",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3232,
          "Original_Client_Name": "Training Batch (653) - MS - 625",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3233,
          "Original_Client_Name": "Training Batch (654) - MS - 626",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3234,
          "Original_Client_Name": "Training Batch (655) - AND 34",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3235,
          "Original_Client_Name": "Training Batch (656) - AND 35",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3236,
          "Original_Client_Name": "Training Batch (657) - MS - 627",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3237,
          "Original_Client_Name": "Training Batch (658) - MS - 628",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3238,
          "Original_Client_Name": "Training Batch (659) - AND 36",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3239,
          "Original_Client_Name": "Training Batch (660) - AND 37",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3240,
          "Original_Client_Name": "Training Batch (661) - MS - 629",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3241,
          "Original_Client_Name": "Training Batch (662) - MS - 630",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3242,
          "Original_Client_Name": "Training Batch (662) - MS - 630",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3243,
          "Original_Client_Name": "Training Batch (663) - MS - 631",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3244,
          "Original_Client_Name": "Training Batch (664) - AND 38",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3245,
          "Original_Client_Name": "Training Batch (665) - AND 39",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3246,
          "Original_Client_Name": "Training Batch (666) - MS - 632",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3247,
          "Original_Client_Name": "Training Batch (667) - MS - 633",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3248,
          "Original_Client_Name": "Training Batch (668) - AND 40",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3249,
          "Original_Client_Name": "Training Batch (669) - AND 41",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3250,
          "Original_Client_Name": "Training Batch (670) - MS - 634",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3251,
          "Original_Client_Name": "Training Batch (671) - MS - 635",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3252,
          "Original_Client_Name": "Training Batch (672) - AND 42",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3253,
          "Original_Client_Name": "Training Batch (673) - AND 43",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3254,
          "Original_Client_Name": "Training Batch (674) - MS - 636",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3255,
          "Original_Client_Name": "Training Batch (675) - MS - 637",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3256,
          "Original_Client_Name": "Training Batch (676) - AND 44",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3257,
          "Original_Client_Name": "Training Batch (677) - AND 45",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3258,
          "Original_Client_Name": "Training Batch (678) - AND 46",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3259,
          "Original_Client_Name": "Training Batch (679) - AND 47",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3260,
          "Original_Client_Name": "Training Batch (680) - MS - 638",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3261,
          "Original_Client_Name": "Training Batch (681) - MS - 639",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3262,
          "Original_Client_Name": "Training Batch (682) - MS - 640",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3263,
          "Original_Client_Name": "Training Batch (683) - MS - 641",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3264,
          "Original_Client_Name": "Training Batch (684) - AND 48",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3265,
          "Original_Client_Name": "Training Batch (685) - AND 49",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3266,
          "Original_Client_Name": "Training Batch (686) - MS - 642",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3267,
          "Original_Client_Name": "Training Batch (687) - MS - 643",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3268,
          "Original_Client_Name": "Training Batch (688) - AND 50",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3269,
          "Original_Client_Name": "Training Batch (689) - AND 51",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3270,
          "Original_Client_Name": "Training Batch (690) - MS - 644",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3271,
          "Original_Client_Name": "Training Batch (691) - MS - 645",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3272,
          "Original_Client_Name": "Training Batch (692) - AND 52",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3273,
          "Original_Client_Name": "Training Batch (693) - AND 53",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3274,
          "Original_Client_Name": "Training Batch (694) - MS - 646",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3275,
          "Original_Client_Name": "Training Batch (695) - MS - 647",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3276,
          "Original_Client_Name": "Training Batch (696) - MS - 648",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3277,
          "Original_Client_Name": "Training Batch (697) - AND - 54",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3278,
          "Original_Client_Name": "Training Batch (698) - AND - 55",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3279,
          "Original_Client_Name": "Training Batch (699) - MS - 649",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3280,
          "Original_Client_Name": "Training Batch (700) - AND 56",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3281,
          "Original_Client_Name": "Training Batch (701) - AND 57",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3282,
          "Original_Client_Name": "Training Batch (702) - AND 58",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3283,
          "Original_Client_Name": "Training Batch (703) - MS - 650",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3284,
          "Original_Client_Name": "Training Batch (704) - AND - 59",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3285,
          "Original_Client_Name": "Training Batch (705) - MS - 651",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3286,
          "Original_Client_Name": "Training Batch (706) - AND - 60",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3287,
          "Original_Client_Name": "Training Batch (707) - MS - 652",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3288,
          "Original_Client_Name": "Training Batch (708) - MS - 653",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3289,
          "Original_Client_Name": "Training Batch (709) - AND - 61",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3290,
          "Original_Client_Name": "Training Batch - 12 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3291,
          "Original_Client_Name": "Training Batch - 13 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3292,
          "Original_Client_Name": "Training Batch - 14 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3293,
          "Original_Client_Name": "Training Batch - 15 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3294,
          "Original_Client_Name": "Training Batch - 16 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3295,
          "Original_Client_Name": "Training Batch - 25 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3296,
          "Original_Client_Name": "Training Batch - 26 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3297,
          "Original_Client_Name": "Training Batch - 27 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3298,
          "Original_Client_Name": "Training Batch - 28 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3299,
          "Original_Client_Name": "Training Batch - 29 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3300,
          "Original_Client_Name": "Training Batch - 30 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3301,
          "Original_Client_Name": "Training Batch - 31 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3302,
          "Original_Client_Name": "Training Batch - 32 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3303,
          "Original_Client_Name": "Training Batch - 33 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3304,
          "Original_Client_Name": "Training Batch - 34 - Aurangabad",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3305,
          "Original_Client_Name": "Training Batch - Integris Health Inc. - AND",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3306,
          "Original_Client_Name": "Training Batch - Netsmart - AND",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3307,
          "Original_Client_Name": "Training Batch 15",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3308,
          "Original_Client_Name": "Training Batch HHC - 1 ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3309,
          "Original_Client_Name": "Training Batch HHC - 1 ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3310,
          "Original_Client_Name": "Training CT - 1 - ED - 1 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3311,
          "Original_Client_Name": "Training CT - 10 - EM -1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3312,
          "Original_Client_Name": "Training CT - 11 - Denials -1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3313,
          "Original_Client_Name": "Training CT - 12 - HCC - 2 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3314,
          "Original_Client_Name": "Training CT - 13 - HCC - 3 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3315,
          "Original_Client_Name": "Training CT - 14 - HCC - 4 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3316,
          "Original_Client_Name": "Training CT - 15 - HCC - 5 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3317,
          "Original_Client_Name": "Training CT - 16 - HCC - 6 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3318,
          "Original_Client_Name": "Training CT - 17 - HCC - 7 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3319,
          "Original_Client_Name": "Training CT - 18 - HCC - 1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3320,
          "Original_Client_Name": "Training CT - 19 - HCC - 2 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3321,
          "Original_Client_Name": "Training CT - 2 -RAD - 1 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3322,
          "Original_Client_Name": "Training CT - 20 - HCC - 8 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3323,
          "Original_Client_Name": "Training CT - 21 - HCC - 9 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3324,
          "Original_Client_Name": "Training CT - 22 - EM_HCC - 1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3325,
          "Original_Client_Name": "Training CT - 23 - EM_HCC - 1 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3326,
          "Original_Client_Name": "Training CT - 24 - EM_HCC - 2 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3327,
          "Original_Client_Name": "Training CT - 25 - HCC - 3 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3328,
          "Original_Client_Name": "Training CT - 26 - HCC - 4 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3329,
          "Original_Client_Name": "Training CT - 27 - RAD - 4 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3330,
          "Original_Client_Name": "Training CT - 28 - HCC - 5 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3331,
          "Original_Client_Name": "Training CT - 29 - HCC - 6 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3332,
          "Original_Client_Name": "Training CT - 3 - IR - 2 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3333,
          "Original_Client_Name": "Training CT - 30 - HCC - 7 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3334,
          "Original_Client_Name": "Training CT - 31 - HCC - 10 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3335,
          "Original_Client_Name": "Training CT - 32 - HCC - 8 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3336,
          "Original_Client_Name": "Training CT - 33 - HCC - 9 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3337,
          "Original_Client_Name": "Training CT - 34 - HCC - 10 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3338,
          "Original_Client_Name": "Training CT - 35 - HCC - 11 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3339,
          "Original_Client_Name": "Training CT - 36 - HCC - 12 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3340,
          "Original_Client_Name": "Training CT - 37 - HCC - 13 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3341,
          "Original_Client_Name": "Training CT - 38 - HCC - 14 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3342,
          "Original_Client_Name": "Training CT - 39 - HCC - 11 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3343,
          "Original_Client_Name": "Training CT - 4 - HCC - 1 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3344,
          "Original_Client_Name": "Training CT - 40 - RAD - 5 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3345,
          "Original_Client_Name": "Training CT - 41 - ED - 2 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3346,
          "Original_Client_Name": "Training CT - 42 - Ophthalmology - 1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3347,
          "Original_Client_Name": "Training CT - 5 - EM, ED - 1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3348,
          "Original_Client_Name": "Training CT - 5 - EM, ED - 1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3349,
          "Original_Client_Name": "Training CT - 6 - EM, ED - 2 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3350,
          "Original_Client_Name": "Training CT - 6 - EM, ED - 2 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3351,
          "Original_Client_Name": "Training CT - 7 - EM, ED - 3 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3352,
          "Original_Client_Name": "Training CT - 7 - EM, ED - 3 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3353,
          "Original_Client_Name": "Training CT - 8 - RAD - 2 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3354,
          "Original_Client_Name": "Training CT - 9 - RAD - 3 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3355,
          "Original_Client_Name": "Training Dropout 1st Day",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Fresher Training",
          "Client_Name_ID": "21009",
          "SubClient_Name": "NonProject: Fresher Training",
          "SubClient_Name_Id": "21009"
        },
        {
          "Id": 3356,
          "Original_Client_Name": "Training Upskill-10 - Denial-1 - MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3357,
          "Original_Client_Name": "Training Upskill-9 - ED-5 - ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3358,
          "Original_Client_Name": "TrainingUpskill-26-ED-5-ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3359,
          "Original_Client_Name": "TrainingUpskill-27-ED-5-MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3360,
          "Original_Client_Name": "TrainingUpskill-28-ED-6-ARG",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3361,
          "Original_Client_Name": "TrainingUpskill-29-SDS-1-MUM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "NonProject: Skill Upgrade Training",
          "Client_Name_ID": "21012",
          "SubClient_Name": "NonProject: Skill Upgrade Training",
          "SubClient_Name_Id": "21012"
        },
        {
          "Id": 3362,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: APC Edits",
          "Client_Name_ID": "10962",
          "SubClient_Name": "UHS: APC Edits",
          "SubClient_Name_Id": "10962"
        },
        {
          "Id": 3363,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: APC Edits",
          "Client_Name_ID": "10962",
          "SubClient_Name": "UHS: APC Edits",
          "SubClient_Name_Id": "10962"
        },
        {
          "Id": 3364,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Pacific: Credit Balance Services",
          "Client_Name_ID": "10972",
          "SubClient_Name": "UHS: Pacific: Credit Balance Services - Insurance",
          "SubClient_Name_Id": "10972-1"
        },
        {
          "Id": 3365,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Pacific: Credit Balance Services",
          "Client_Name_ID": "10972",
          "SubClient_Name": "UHS: Pacific: Credit Balance Services - Insurance",
          "SubClient_Name_Id": "10972-1"
        },
        {
          "Id": 3366,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Medicaid Follow up",
          "SubClient_Name_Id": "10963-1"
        },
        {
          "Id": 3367,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Special Assignment",
          "SubClient_Name_Id": "10963-2"
        },
        {
          "Id": 3368,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Billing",
          "SubClient_Name_Id": "10963-3"
        },
        {
          "Id": 3369,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Appeals",
          "SubClient_Name_Id": "10963-4"
        },
        {
          "Id": 3370,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - AR Payment Audit",
          "SubClient_Name_Id": "10963-5"
        },
        {
          "Id": 3371,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Medicaid Secondary claims TX",
          "SubClient_Name_Id": "10963-6"
        },
        {
          "Id": 3372,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - AR Denials Followup_Non Voice",
          "SubClient_Name_Id": "10963-7"
        },
        {
          "Id": 3373,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days",
          "SubClient_Name_Id": "10963"
        },
        {
          "Id": 3374,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Medicaid Follow up",
          "SubClient_Name_Id": "10963-1"
        },
        {
          "Id": 3375,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Special Assignment",
          "SubClient_Name_Id": "10963-2"
        },
        {
          "Id": 3376,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Billing",
          "SubClient_Name_Id": "10963-3"
        },
        {
          "Id": 3377,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Appeals",
          "SubClient_Name_Id": "10963-4"
        },
        {
          "Id": 3378,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - AR Payment Audit",
          "SubClient_Name_Id": "10963-5"
        },
        {
          "Id": 3379,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - Medicaid Secondary claims TX",
          "SubClient_Name_Id": "10963-6"
        },
        {
          "Id": 3380,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days - AR Denials Followup_Non Voice",
          "SubClient_Name_Id": "10963-7"
        },
        {
          "Id": 3381,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: IPM: Billing Process",
          "Client_Name_ID": "10968",
          "SubClient_Name": "UHS: IPM: Billing Process",
          "SubClient_Name_Id": "10968"
        },
        {
          "Id": 3382,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: IPM: Billing Process",
          "Client_Name_ID": "10968",
          "SubClient_Name": "UHS: IPM: Billing Process",
          "SubClient_Name_Id": "10968"
        },
        {
          "Id": 3383,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: IPM: Credit Balance",
          "Client_Name_ID": "10969",
          "SubClient_Name": "UHS: IPM: Credit Balance",
          "SubClient_Name_Id": "10969"
        },
        {
          "Id": 3384,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Insurance Balance AR Follow up and Denial management",
          "Client_Name_ID": "10967",
          "SubClient_Name": "UHS: Insurance Balance AR Follow up and Denial management",
          "SubClient_Name_Id": "10967"
        },
        {
          "Id": 3385,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: IPM: Credit Balance",
          "Client_Name_ID": "10969",
          "SubClient_Name": "UHS: IPM: Credit Balance",
          "SubClient_Name_Id": "10969"
        },
        {
          "Id": 3386,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_Appeals Follow up",
          "SubClient_Name_Id": "10963-1"
        },
        {
          "Id": 3387,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_Appeals",
          "SubClient_Name_Id": "10963-3"
        },
        {
          "Id": 3388,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_AR Denials Followup_Non Voice",
          "SubClient_Name_Id": "10963-1"
        },
        {
          "Id": 3389,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_AR Denials Followup",
          "SubClient_Name_Id": "10963-2"
        },
        {
          "Id": 3390,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_Appeals",
          "SubClient_Name_Id": "10963-3"
        },
        {
          "Id": 3391,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_Special Assignment",
          "SubClient_Name_Id": "10963-4"
        },
        {
          "Id": 3392,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days_UHS_Pacific_AR Denials Followup",
          "SubClient_Name_Id": "10963-2"
        },
        {
          "Id": 3393,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Insurance Balance AR Follow up and Denial management",
          "Client_Name_ID": "10967",
          "SubClient_Name": "UHS: Insurance Balance AR Follow up and Denial management",
          "SubClient_Name_Id": "10967"
        },
        {
          "Id": 3394,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Medicaid Secondary claims TX",
          "Client_Name_ID": "10970",
          "SubClient_Name": "UHS: Medicaid Secondary claims TX",
          "SubClient_Name_Id": "10970"
        },
        {
          "Id": 3395,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days",
          "SubClient_Name_Id": "10963"
        },
        {
          "Id": 3396,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: Medicaid Secondary claims TX",
          "Client_Name_ID": "10970",
          "SubClient_Name": "UHS: Medicaid Secondary claims TX",
          "SubClient_Name_Id": "10970"
        },
        {
          "Id": 3397,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: APC Edits",
          "Client_Name_ID": "10962",
          "SubClient_Name": "UHS: APC Edits",
          "SubClient_Name_Id": "10962"
        },
        {
          "Id": 3398,
          "Original_Client_Name": "UHS of Delaware, Inc",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: APC Edits",
          "Client_Name_ID": "10962",
          "SubClient_Name": "UHS: APC Edits",
          "SubClient_Name_Id": "10962"
        },
        {
          "Id": 3399,
          "Original_Client_Name": "UHS of Delaware, Inc - Aurangabad",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days",
          "SubClient_Name_Id": "10963"
        },
        {
          "Id": 3400,
          "Original_Client_Name": "UHS of Delaware, Inc - Aurangabad",
          "Original_Client_Name_ID": "99071",
          "Client_Name": "UHS: AR Follow up over 30 days",
          "Client_Name_ID": "10963",
          "SubClient_Name": "UHS: AR Follow up over 30 days",
          "SubClient_Name_Id": "10963"
        },
        {
          "Id": 3401,
          "Original_Client_Name": "Unallocated",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "AROTH",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "AROTH"
        },
        {
          "Id": 3402,
          "Original_Client_Name": "Unallocated",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "AROTH",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "AROTH"
        },
        {
          "Id": 3403,
          "Original_Client_Name": "United Medical Solutions, Inc.",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Demographic Entry",
          "Client_Name_ID": "10976",
          "SubClient_Name": "UMS: Demographic Entry",
          "SubClient_Name_Id": "10976"
        },
        {
          "Id": 3404,
          "Original_Client_Name": "United Medical Solutions, Inc.",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Demographic Entry",
          "Client_Name_ID": "10976",
          "SubClient_Name": "UMS: Demographic Entry",
          "SubClient_Name_Id": "10976"
        },
        {
          "Id": 3405,
          "Original_Client_Name": "United Medical Solutions, Inc.",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS.: AR Follow up and ECS Rejections",
          "Client_Name_ID": "10975",
          "SubClient_Name": "UMS.: AR Follow up and ECS Rejections",
          "SubClient_Name_Id": "10975"
        },
        {
          "Id": 3406,
          "Original_Client_Name": "United Medical Solutions, Inc.",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS.: AR Follow up and ECS Rejections",
          "Client_Name_ID": "10975",
          "SubClient_Name": "UMS.: AR Follow up and ECS Rejections",
          "SubClient_Name_Id": "10975"
        },
        {
          "Id": 3407,
          "Original_Client_Name": "United Medical Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Demographic Entry",
          "Client_Name_ID": "10976",
          "SubClient_Name": "UMS: Demographic Entry",
          "SubClient_Name_Id": "10976"
        },
        {
          "Id": 3408,
          "Original_Client_Name": "United Medical Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Demographic Entry",
          "Client_Name_ID": "10976",
          "SubClient_Name": "UMS: Demographic Entry",
          "SubClient_Name_Id": "10976"
        },
        {
          "Id": 3409,
          "Original_Client_Name": "United Medical Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Charge Entry",
          "Client_Name_ID": "11250",
          "SubClient_Name": "UMS: Charge Entry",
          "SubClient_Name_Id": "11250"
        },
        {
          "Id": 3410,
          "Original_Client_Name": "United Medical Solutions, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99072",
          "Client_Name": "UMS: Charge Entry",
          "Client_Name_ID": "11250",
          "SubClient_Name": "UMS: Charge Entry",
          "SubClient_Name_Id": "11250"
        },
        {
          "Id": 3411,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code",
          "Client_Name_ID": "11031",
          "SubClient_Name": "Universal American: HCC Chart Review Code",
          "SubClient_Name_Id": "11031"
        },
        {
          "Id": 3412,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code",
          "Client_Name_ID": "11031",
          "SubClient_Name": "Universal American: HCC Chart Review Code",
          "SubClient_Name_Id": "11031"
        },
        {
          "Id": 3413,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code - Special Project",
          "Client_Name_ID": "11032",
          "SubClient_Name": "Universal American: HCC Chart Review Code - Special Project",
          "SubClient_Name_Id": "11032"
        },
        {
          "Id": 3414,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code - Special Project",
          "Client_Name_ID": "11032",
          "SubClient_Name": "Universal American: HCC Chart Review Code - Special Project",
          "SubClient_Name_Id": "11032"
        },
        {
          "Id": 3415,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code - Special Project",
          "Client_Name_ID": "11032",
          "SubClient_Name": "Universal American: HCC Chart Review Code - Special Project",
          "SubClient_Name_Id": "11032"
        },
        {
          "Id": 3416,
          "Original_Client_Name": "Universal American Financial Services,Inc",
          "Original_Client_Name_ID": "99073",
          "Client_Name": "Universal American: HCC Chart Review Code - Special Project",
          "Client_Name_ID": "11032",
          "SubClient_Name": "Universal American: HCC Chart Review Code - Special Project",
          "SubClient_Name_Id": "11032"
        },
        {
          "Id": 3417,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding",
          "SubClient_Name_Id": "10977"
        },
        {
          "Id": 3418,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding",
          "SubClient_Name_Id": "10977"
        },
        {
          "Id": 3419,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Review Audit",
          "SubClient_Name_Id": "10977-3"
        },
        {
          "Id": 3420,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Review Audit",
          "SubClient_Name_Id": "10977-3"
        },
        {
          "Id": 3421,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Focused Review Audit",
          "SubClient_Name_Id": "10977-2"
        },
        {
          "Id": 3422,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Focused Review Audit",
          "SubClient_Name_Id": "10977-2"
        },
        {
          "Id": 3423,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Live Audit",
          "SubClient_Name_Id": "10977-1"
        },
        {
          "Id": 3424,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Observation",
          "SubClient_Name_Id": "10977-5"
        },
        {
          "Id": 3425,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - Observation",
          "SubClient_Name_Id": "10977-5"
        },
        {
          "Id": 3426,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - ED coding",
          "SubClient_Name_Id": "10977-4"
        },
        {
          "Id": 3427,
          "Original_Client_Name": "USACS Management Group, LTD.",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding - ED coding",
          "SubClient_Name_Id": "10977-4"
        },
        {
          "Id": 3428,
          "Original_Client_Name": "USACS Management Group, LTD. - Aurangabad",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding",
          "SubClient_Name_Id": "10977"
        },
        {
          "Id": 3429,
          "Original_Client_Name": "USACS Management Group, LTD. - Aurangabad",
          "Original_Client_Name_ID": "99075",
          "Client_Name": "USACS: ED Professional Coding",
          "Client_Name_ID": "10977",
          "SubClient_Name": "USACS: ED Professional Coding",
          "SubClient_Name_Id": "10977"
        },
        {
          "Id": 3430,
          "Original_Client_Name": "Vera Whole Health, Inc.",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: RCM Services",
          "Client_Name_ID": "11705",
          "SubClient_Name": "Vera: RCM Services",
          "SubClient_Name_Id": "11705"
        },
        {
          "Id": 3431,
          "Original_Client_Name": "Vera Whole Health, Inc.",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: RCM Services",
          "Client_Name_ID": "11705",
          "SubClient_Name": "Vera: RCM Services",
          "SubClient_Name_Id": "11705"
        },
        {
          "Id": 3432,
          "Original_Client_Name": "Vera Whole Health, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: NextGen: Concurrent HCC coding",
          "Client_Name_ID": "11649",
          "SubClient_Name": "Vera: NextGen: Concurrent HCC coding",
          "SubClient_Name_Id": "11649"
        },
        {
          "Id": 3433,
          "Original_Client_Name": "Vera Whole Health, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: NextGen: Concurrent HCC coding",
          "Client_Name_ID": "11649",
          "SubClient_Name": "Vera: NextGen: Concurrent HCC coding",
          "SubClient_Name_Id": "11649"
        },
        {
          "Id": 3434,
          "Original_Client_Name": "Vera Whole Health, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: Athena: Retrospective: HCC coding",
          "Client_Name_ID": "11650",
          "SubClient_Name": "Vera: Athena: Retrospective: HCC coding",
          "SubClient_Name_Id": "11650"
        },
        {
          "Id": 3435,
          "Original_Client_Name": "Vera Whole Health, Inc. - Aurangabad",
          "Original_Client_Name_ID": "99121",
          "Client_Name": "Vera: Athena: Retrospective: HCC coding",
          "Client_Name_ID": "11650",
          "SubClient_Name": "Vera: Athena: Retrospective: HCC coding",
          "SubClient_Name_Id": "11650"
        },
        {
          "Id": 3436,
          "Original_Client_Name": "VP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "BE HO",
          "Client_Name_ID": "10132",
          "SubClient_Name": "BE HO",
          "SubClient_Name_Id": "10132"
        },
        {
          "Id": 3437,
          "Original_Client_Name": "VP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 3438,
          "Original_Client_Name": "VP",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "Non Project",
          "Client_Name_ID": "General",
          "SubClient_Name": "Non Project",
          "SubClient_Name_Id": "General"
        },
        {
          "Id": 3439,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Index Processing",
          "Client_Name_ID": "10572",
          "SubClient_Name": "WebPT: Index Processing",
          "SubClient_Name_Id": "10572"
        },
        {
          "Id": 3440,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Minnesota: Payment Posting Services",
          "Client_Name_ID": "10573",
          "SubClient_Name": "WebPT: Minnesota: Payment Posting Services",
          "SubClient_Name_Id": "10573"
        },
        {
          "Id": 3441,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Upland: Payment Posting Services",
          "Client_Name_ID": "10574",
          "SubClient_Name": "WebPT: Upland: Payment Posting Services",
          "SubClient_Name_Id": "10574"
        },
        {
          "Id": 3442,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Index Processing",
          "Client_Name_ID": "10572",
          "SubClient_Name": "WebPT: Index Processing",
          "SubClient_Name_Id": "10572"
        },
        {
          "Id": 3443,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Minnesota: Payment Posting Services",
          "Client_Name_ID": "10573",
          "SubClient_Name": "WebPT: Minnesota: Payment Posting Services",
          "SubClient_Name_Id": "10573"
        },
        {
          "Id": 3444,
          "Original_Client_Name": "WebPT Inc. - Aurangabad",
          "Original_Client_Name_ID": "99013",
          "Client_Name": "WebPT: Upland: Payment Posting Services",
          "Client_Name_ID": "10574",
          "SubClient_Name": "WebPT: Upland: Payment Posting Services",
          "SubClient_Name_Id": "10574"
        },
        {
          "Id": 3445,
          "Original_Client_Name": "WFM",
          "Original_Client_Name_ID": "Oth",
          "Client_Name": "WFM",
          "Client_Name_ID": "10136",
          "SubClient_Name": "WFM",
          "SubClient_Name_Id": "10136"
        },
        {
          "Id": 3446,
          "Original_Client_Name": "Whittier Medical Management Associates",
          "Original_Client_Name_ID": "99076",
          "Client_Name": "Whittier: Account Receivable Follow up",
          "Client_Name_ID": "10978",
          "SubClient_Name": "Whittier: Account Receivable Follow up",
          "SubClient_Name_Id": "10978"
        },
        {
          "Id": 3447,
          "Original_Client_Name": "Whittier Medical Management Associates",
          "Original_Client_Name_ID": "99076",
          "Client_Name": "Whittier: Account Receivable Follow up",
          "Client_Name_ID": "10978",
          "SubClient_Name": "Whittier: Account Receivable Follow up",
          "SubClient_Name_Id": "10978"
        },
        {
          "Id": 3448,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Standalone EKGs (SMG)",
          "Client_Name_ID": "11269",
          "SubClient_Name": "Xtend: Standalone EKGs (SMG)",
          "SubClient_Name_Id": "11269"
        },
        {
          "Id": 3449,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Standalone EKGs (SMG)",
          "Client_Name_ID": "11269",
          "SubClient_Name": "Xtend: Standalone EKGs (SMG)",
          "SubClient_Name_Id": "11269"
        },
        {
          "Id": 3450,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Family Medicine",
          "Client_Name_ID": "11309",
          "SubClient_Name": "Xtend: E/M Family Medicine",
          "SubClient_Name_Id": "11309"
        },
        {
          "Id": 3451,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn",
          "Client_Name_ID": "11310",
          "SubClient_Name": "Xtend: OB-Gyn",
          "SubClient_Name_Id": "11310"
        },
        {
          "Id": 3452,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Family Medicine",
          "Client_Name_ID": "11309",
          "SubClient_Name": "Xtend: E/M Family Medicine",
          "SubClient_Name_Id": "11309"
        },
        {
          "Id": 3453,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn",
          "Client_Name_ID": "11310",
          "SubClient_Name": "Xtend: OB-Gyn",
          "SubClient_Name_Id": "11310"
        },
        {
          "Id": 3454,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Allergy Shots (Bainbridge)",
          "Client_Name_ID": "11373",
          "SubClient_Name": "Xtend: E/M Allergy Shots (Bainbridge)",
          "SubClient_Name_Id": "11373"
        },
        {
          "Id": 3455,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Allergy Shots (Bainbridge)",
          "Client_Name_ID": "11373",
          "SubClient_Name": "Xtend: E/M Allergy Shots (Bainbridge)",
          "SubClient_Name_Id": "11373"
        },
        {
          "Id": 3456,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Nursing Home (Bainbridge)",
          "Client_Name_ID": "11374",
          "SubClient_Name": "Xtend: E/M Nursing Home (Bainbridge)",
          "SubClient_Name_Id": "11374"
        },
        {
          "Id": 3457,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Nursing Home (Bainbridge)",
          "Client_Name_ID": "11374",
          "SubClient_Name": "Xtend: E/M Nursing Home (Bainbridge)",
          "SubClient_Name_Id": "11374"
        },
        {
          "Id": 3458,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M General surgeons (Bainbridge)",
          "Client_Name_ID": "11375",
          "SubClient_Name": "Xtend: E/M General surgeons (Bainbridge)",
          "SubClient_Name_Id": "11375"
        },
        {
          "Id": 3459,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M General surgeons (Bainbridge)",
          "Client_Name_ID": "11375",
          "SubClient_Name": "Xtend: E/M General surgeons (Bainbridge)",
          "SubClient_Name_Id": "11375"
        },
        {
          "Id": 3460,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M HCH Internal Medicine (SMG)",
          "Client_Name_ID": "11376",
          "SubClient_Name": "Xtend: E/M HCH Internal Medicine (SMG)",
          "SubClient_Name_Id": "11376"
        },
        {
          "Id": 3461,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M HCH Internal Medicine (SMG)",
          "Client_Name_ID": "11376",
          "SubClient_Name": "Xtend: E/M HCH Internal Medicine (SMG)",
          "SubClient_Name_Id": "11376"
        },
        {
          "Id": 3462,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Infectious Disease (SMG)",
          "Client_Name_ID": "11377",
          "SubClient_Name": "Xtend: E/M Infectious Disease (SMG)",
          "SubClient_Name_Id": "11377"
        },
        {
          "Id": 3463,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Infectious Disease (SMG)",
          "Client_Name_ID": "11377",
          "SubClient_Name": "Xtend: E/M Infectious Disease (SMG)",
          "SubClient_Name_Id": "11377"
        },
        {
          "Id": 3464,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Nephrology (SMG)",
          "Client_Name_ID": "11378",
          "SubClient_Name": "Xtend: E/M Nephrology (SMG)",
          "SubClient_Name_Id": "11378"
        },
        {
          "Id": 3465,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Nephrology (SMG)",
          "Client_Name_ID": "11378",
          "SubClient_Name": "Xtend: E/M Nephrology (SMG)",
          "SubClient_Name_Id": "11378"
        },
        {
          "Id": 3466,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Profee-OPTH (SMG)",
          "Client_Name_ID": "11379",
          "SubClient_Name": "Xtend: E/M Profee-OPTH (SMG)",
          "SubClient_Name_Id": "11379"
        },
        {
          "Id": 3467,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Profee-OPTH (SMG)",
          "Client_Name_ID": "11379",
          "SubClient_Name": "Xtend: E/M Profee-OPTH (SMG)",
          "SubClient_Name_Id": "11379"
        },
        {
          "Id": 3468,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Rheumatology (SMG)",
          "Client_Name_ID": "11380",
          "SubClient_Name": "Xtend: E/M Rheumatology (SMG)",
          "SubClient_Name_Id": "11380"
        },
        {
          "Id": 3469,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Rheumatology (SMG)",
          "Client_Name_ID": "11380",
          "SubClient_Name": "Xtend: E/M Rheumatology (SMG)",
          "SubClient_Name_Id": "11380"
        },
        {
          "Id": 3470,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Family Medicine (SMG)",
          "Client_Name_ID": "11334",
          "SubClient_Name": "Xtend: E/M Family Medicine (SMG)",
          "SubClient_Name_Id": "11334"
        },
        {
          "Id": 3471,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn (SMG)",
          "Client_Name_ID": "11335",
          "SubClient_Name": "Xtend: OB-Gyn (SMG)",
          "SubClient_Name_Id": "11335"
        },
        {
          "Id": 3472,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn (BainBridge)",
          "Client_Name_ID": "11336",
          "SubClient_Name": "Xtend: OB-Gyn (BainBridge)",
          "SubClient_Name_Id": "11336"
        },
        {
          "Id": 3473,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Family Medicine (SMG)",
          "Client_Name_ID": "11334",
          "SubClient_Name": "Xtend: E/M Family Medicine (SMG)",
          "SubClient_Name_Id": "11334"
        },
        {
          "Id": 3474,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn (SMG)",
          "Client_Name_ID": "11335",
          "SubClient_Name": "Xtend: OB-Gyn (SMG)",
          "SubClient_Name_Id": "11335"
        },
        {
          "Id": 3475,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OB-Gyn (BainBridge)",
          "Client_Name_ID": "11336",
          "SubClient_Name": "Xtend: OB-Gyn (BainBridge)",
          "SubClient_Name_Id": "11336"
        },
        {
          "Id": 3476,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (BainBridge)",
          "Client_Name_ID": "11207",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (BainBridge)",
          "SubClient_Name_Id": "11207"
        },
        {
          "Id": 3477,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "Client_Name_ID": "11208",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "SubClient_Name_Id": "11208"
        },
        {
          "Id": 3478,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Family Medicine (BainBridge)",
          "Client_Name_ID": "11209",
          "SubClient_Name": "Xtend: Family Medicine (BainBridge)",
          "SubClient_Name_Id": "11209"
        },
        {
          "Id": 3479,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pediatrics (BainBridge)",
          "Client_Name_ID": "11210",
          "SubClient_Name": "Xtend: Pediatrics (BainBridge)",
          "SubClient_Name_Id": "11210"
        },
        {
          "Id": 3480,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Cardiology E&M (SMG)",
          "Client_Name_ID": "11211",
          "SubClient_Name": "Xtend: Cardiology E&M (SMG)",
          "SubClient_Name_Id": "11211"
        },
        {
          "Id": 3481,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Emergency Medicine (Pro-fee) (BainBridge)",
          "Client_Name_ID": "11212",
          "SubClient_Name": "Xtend: Emergency Medicine (Pro-fee) (BainBridge)",
          "SubClient_Name_Id": "11212"
        },
        {
          "Id": 3482,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pathology (SMG)",
          "Client_Name_ID": "11213",
          "SubClient_Name": "Xtend: Pathology (SMG)",
          "SubClient_Name_Id": "11213"
        },
        {
          "Id": 3483,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Diagnostic Radiology (SMG)",
          "Client_Name_ID": "11214",
          "SubClient_Name": "Xtend: Diagnostic Radiology (SMG)",
          "SubClient_Name_Id": "11214"
        },
        {
          "Id": 3484,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Denial Coding Review (SMG)",
          "Client_Name_ID": "11215",
          "SubClient_Name": "Xtend: Denial Coding Review (SMG)",
          "SubClient_Name_Id": "11215"
        },
        {
          "Id": 3485,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Anesthesia (SMG)",
          "Client_Name_ID": "11216",
          "SubClient_Name": "Xtend: Anesthesia (SMG)",
          "SubClient_Name_Id": "11216"
        },
        {
          "Id": 3486,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (BainBridge)",
          "Client_Name_ID": "11207",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (BainBridge)",
          "SubClient_Name_Id": "11207"
        },
        {
          "Id": 3487,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "Client_Name_ID": "11208",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "SubClient_Name_Id": "11208"
        },
        {
          "Id": 3488,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Family Medicine (BainBridge)",
          "Client_Name_ID": "11209",
          "SubClient_Name": "Xtend: Family Medicine (BainBridge)",
          "SubClient_Name_Id": "11209"
        },
        {
          "Id": 3489,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pediatrics (BainBridge)",
          "Client_Name_ID": "11210",
          "SubClient_Name": "Xtend: Pediatrics (BainBridge)",
          "SubClient_Name_Id": "11210"
        },
        {
          "Id": 3490,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Cardiology E&M (SMG)",
          "Client_Name_ID": "11211",
          "SubClient_Name": "Xtend: Cardiology E&M (SMG)",
          "SubClient_Name_Id": "11211"
        },
        {
          "Id": 3491,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Emergency Medicine (Pro-fee) (BainBridge)",
          "Client_Name_ID": "11212",
          "SubClient_Name": "Xtend: Emergency Medicine (Pro-fee) (BainBridge)",
          "SubClient_Name_Id": "11212"
        },
        {
          "Id": 3492,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pathology (SMG)",
          "Client_Name_ID": "11213",
          "SubClient_Name": "Xtend: Pathology (SMG)",
          "SubClient_Name_Id": "11213"
        },
        {
          "Id": 3493,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Diagnostic Radiology (SMG)",
          "Client_Name_ID": "11214",
          "SubClient_Name": "Xtend: Diagnostic Radiology (SMG)",
          "SubClient_Name_Id": "11214"
        },
        {
          "Id": 3494,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Denial Coding Review (SMG)",
          "Client_Name_ID": "11215",
          "SubClient_Name": "Xtend: Denial Coding Review (SMG)",
          "SubClient_Name_Id": "11215"
        },
        {
          "Id": 3495,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Anesthesia (SMG)",
          "Client_Name_ID": "11216",
          "SubClient_Name": "Xtend: Anesthesia (SMG)",
          "SubClient_Name_Id": "11216"
        },
        {
          "Id": 3496,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Outpatient ED (Facility) (BainBridge)",
          "Client_Name_ID": "11223",
          "SubClient_Name": "Xtend: Outpatient ED (Facility) (BainBridge)",
          "SubClient_Name_Id": "11223"
        },
        {
          "Id": 3497,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Outpatient ED (Facility) (BainBridge)",
          "Client_Name_ID": "11223",
          "SubClient_Name": "Xtend: Outpatient ED (Facility) (BainBridge)",
          "SubClient_Name_Id": "11223"
        },
        {
          "Id": 3498,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gen Surg (E/M) (SMG)",
          "Client_Name_ID": "11585",
          "SubClient_Name": "Xtend: Gen Surg (E/M) (SMG)",
          "SubClient_Name_Id": "11585"
        },
        {
          "Id": 3499,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gen Surg (E/M) (SMG)",
          "Client_Name_ID": "11585",
          "SubClient_Name": "Xtend: Gen Surg (E/M) (SMG)",
          "SubClient_Name_Id": "11585"
        },
        {
          "Id": 3500,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC: Credit balance: Patient Credits",
          "Client_Name_ID": "11607",
          "SubClient_Name": "Xtend: SEARHC: Credit balance: Patient Credits",
          "SubClient_Name_Id": "11607"
        },
        {
          "Id": 3501,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC: Credit balance: Patient Credits",
          "Client_Name_ID": "11607",
          "SubClient_Name": "Xtend: SEARHC: Credit balance: Patient Credits",
          "SubClient_Name_Id": "11607"
        },
        {
          "Id": 3502,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC: Credit Balance: Insurance Credits",
          "Client_Name_ID": "11608",
          "SubClient_Name": "Xtend: SEARHC: Credit Balance: Insurance Credits",
          "SubClient_Name_Id": "11608"
        },
        {
          "Id": 3503,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC: Credit Balance: Insurance Credits",
          "Client_Name_ID": "11608",
          "SubClient_Name": "Xtend: SEARHC: Credit Balance: Insurance Credits",
          "SubClient_Name_Id": "11608"
        },
        {
          "Id": 3504,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "Client_Name_ID": "11609",
          "SubClient_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "SubClient_Name_Id": "11609"
        },
        {
          "Id": 3505,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "Client_Name_ID": "11609",
          "SubClient_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "SubClient_Name_Id": "11609"
        },
        {
          "Id": 3506,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit Balance: Insurance Credits",
          "Client_Name_ID": "11610",
          "SubClient_Name": "Xtend: Sinai: Credit Balance: Insurance Credits",
          "SubClient_Name_Id": "11610"
        },
        {
          "Id": 3507,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit Balance: Insurance Credits",
          "Client_Name_ID": "11610",
          "SubClient_Name": "Xtend: Sinai: Credit Balance: Insurance Credits",
          "SubClient_Name_Id": "11610"
        },
        {
          "Id": 3508,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: A/R Services",
          "Client_Name_ID": "11515",
          "SubClient_Name": "Xtend: A/R Services - Code Helpdesk",
          "SubClient_Name_Id": "11515-1"
        },
        {
          "Id": 3509,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: A/R Services",
          "Client_Name_ID": "11515",
          "SubClient_Name": "Xtend: A/R Services - Code Helpdesk",
          "SubClient_Name_Id": "11515-1"
        },
        {
          "Id": 3510,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai Hospital Scope: A/R Services",
          "Client_Name_ID": "11602",
          "SubClient_Name": "Xtend: Sinai Hospital Scope: A/R Services",
          "SubClient_Name_Id": "11602"
        },
        {
          "Id": 3511,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC Hospital Scope: A/R Services",
          "Client_Name_ID": "11603",
          "SubClient_Name": "Xtend: SEARHC Hospital Scope: A/R Services",
          "SubClient_Name_Id": "11603"
        },
        {
          "Id": 3512,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai Physician Scope: A/R Services",
          "Client_Name_ID": "11604",
          "SubClient_Name": "Xtend: Sinai Physician Scope: A/R Services",
          "SubClient_Name_Id": "11604"
        },
        {
          "Id": 3513,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai Hospital Scope: A/R Services",
          "Client_Name_ID": "11602",
          "SubClient_Name": "Xtend: Sinai Hospital Scope: A/R Services",
          "SubClient_Name_Id": "11602"
        },
        {
          "Id": 3514,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: SEARHC Hospital Scope: A/R Services",
          "Client_Name_ID": "11603",
          "SubClient_Name": "Xtend: SEARHC Hospital Scope: A/R Services",
          "SubClient_Name_Id": "11603"
        },
        {
          "Id": 3515,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai Physician Scope: A/R Services",
          "Client_Name_ID": "11604",
          "SubClient_Name": "Xtend: Sinai Physician Scope: A/R Services",
          "SubClient_Name_Id": "11604"
        },
        {
          "Id": 3516,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Adjustment posting",
          "Client_Name_ID": "11584",
          "SubClient_Name": "Xtend: Adjustment posting",
          "SubClient_Name_Id": "11584"
        },
        {
          "Id": 3517,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Adjustment posting",
          "Client_Name_ID": "11584",
          "SubClient_Name": "Xtend: Adjustment posting",
          "SubClient_Name_Id": "11584"
        },
        {
          "Id": 3518,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "Client_Name_ID": "11609",
          "SubClient_Name": "Xtend: Sinai: Credit balance: Patient Credits - Daily Placement",
          "SubClient_Name_Id": "11609-1"
        },
        {
          "Id": 3519,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Sinai: Credit balance: Patient Credits",
          "Client_Name_ID": "11609",
          "SubClient_Name": "Xtend: Sinai: Credit balance: Patient Credits - Daily Placement",
          "SubClient_Name_Id": "11609-1"
        },
        {
          "Id": 3520,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Bainbridge: A/R Services",
          "Client_Name_ID": "11700",
          "SubClient_Name": "Xtend: Bainbridge: A/R Services",
          "SubClient_Name_Id": "11700"
        },
        {
          "Id": 3521,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Bainbridge: A/R Services",
          "Client_Name_ID": "11700",
          "SubClient_Name": "Xtend: Bainbridge: A/R Services",
          "SubClient_Name_Id": "11700"
        },
        {
          "Id": 3522,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Cardiothoracic (SMG)",
          "Client_Name_ID": "11565",
          "SubClient_Name": "Xtend: Cardiothoracic (SMG)",
          "SubClient_Name_Id": "11565"
        },
        {
          "Id": 3523,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Cardiothoracic (SMG)",
          "Client_Name_ID": "11565",
          "SubClient_Name": "Xtend: Cardiothoracic (SMG)",
          "SubClient_Name_Id": "11565"
        },
        {
          "Id": 3524,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Dermatology (SMG)",
          "Client_Name_ID": "11566",
          "SubClient_Name": "Xtend: Dermatology (SMG)",
          "SubClient_Name_Id": "11566"
        },
        {
          "Id": 3525,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Dermatology (SMG)",
          "Client_Name_ID": "11566",
          "SubClient_Name": "Xtend: Dermatology (SMG)",
          "SubClient_Name_Id": "11566"
        },
        {
          "Id": 3526,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: ENT (SMG)",
          "Client_Name_ID": "11567",
          "SubClient_Name": "Xtend: ENT (SMG)",
          "SubClient_Name_Id": "11567"
        },
        {
          "Id": 3527,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: ENT (SMG)",
          "Client_Name_ID": "11567",
          "SubClient_Name": "Xtend: ENT (SMG)",
          "SubClient_Name_Id": "11567"
        },
        {
          "Id": 3528,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gertatrics (SMG)",
          "Client_Name_ID": "11568",
          "SubClient_Name": "Xtend: Gertatrics (SMG)",
          "SubClient_Name_Id": "11568"
        },
        {
          "Id": 3529,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gertatrics (SMG)",
          "Client_Name_ID": "11568",
          "SubClient_Name": "Xtend: Gertatrics (SMG)",
          "SubClient_Name_Id": "11568"
        },
        {
          "Id": 3530,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gastroentrology (SMG)",
          "Client_Name_ID": "11569",
          "SubClient_Name": "Xtend: Gastroentrology (SMG)",
          "SubClient_Name_Id": "11569"
        },
        {
          "Id": 3531,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Gastroentrology (SMG)",
          "Client_Name_ID": "11569",
          "SubClient_Name": "Xtend: Gastroentrology (SMG)",
          "SubClient_Name_Id": "11569"
        },
        {
          "Id": 3532,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Urology (SMG)",
          "Client_Name_ID": "11570",
          "SubClient_Name": "Xtend: Urology (SMG)",
          "SubClient_Name_Id": "11570"
        },
        {
          "Id": 3533,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Urology (SMG)",
          "Client_Name_ID": "11570",
          "SubClient_Name": "Xtend: Urology (SMG)",
          "SubClient_Name_Id": "11570"
        },
        {
          "Id": 3534,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Neurosurgery (SMG)",
          "Client_Name_ID": "11571",
          "SubClient_Name": "Xtend: Neurosurgery (SMG)",
          "SubClient_Name_Id": "11571"
        },
        {
          "Id": 3535,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Neurosurgery (SMG)",
          "Client_Name_ID": "11571",
          "SubClient_Name": "Xtend: Neurosurgery (SMG)",
          "SubClient_Name_Id": "11571"
        },
        {
          "Id": 3536,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OpthaImology (SMG)",
          "Client_Name_ID": "11572",
          "SubClient_Name": "Xtend: OpthaImology (SMG)",
          "SubClient_Name_Id": "11572"
        },
        {
          "Id": 3537,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: OpthaImology (SMG)",
          "Client_Name_ID": "11572",
          "SubClient_Name": "Xtend: OpthaImology (SMG)",
          "SubClient_Name_Id": "11572"
        },
        {
          "Id": 3538,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Orthopedics (SMG)",
          "Client_Name_ID": "11573",
          "SubClient_Name": "Xtend: Orthopedics (SMG)",
          "SubClient_Name_Id": "11573"
        },
        {
          "Id": 3539,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Orthopedics (SMG)",
          "Client_Name_ID": "11573",
          "SubClient_Name": "Xtend: Orthopedics (SMG)",
          "SubClient_Name_Id": "11573"
        },
        {
          "Id": 3540,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ped-Cardiology (SMG)",
          "Client_Name_ID": "11574",
          "SubClient_Name": "Xtend: Ped-Cardiology (SMG)",
          "SubClient_Name_Id": "11574"
        },
        {
          "Id": 3541,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ped-Cardiology (SMG)",
          "Client_Name_ID": "11574",
          "SubClient_Name": "Xtend: Ped-Cardiology (SMG)",
          "SubClient_Name_Id": "11574"
        },
        {
          "Id": 3542,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ped-General Surgery (SMG)",
          "Client_Name_ID": "11575",
          "SubClient_Name": "Xtend: Ped-General Surgery (SMG)",
          "SubClient_Name_Id": "11575"
        },
        {
          "Id": 3543,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ped-General Surgery (SMG)",
          "Client_Name_ID": "11575",
          "SubClient_Name": "Xtend: Ped-General Surgery (SMG)",
          "SubClient_Name_Id": "11575"
        },
        {
          "Id": 3544,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pediatrics (SMG)",
          "Client_Name_ID": "11576",
          "SubClient_Name": "Xtend: Pediatrics (SMG)",
          "SubClient_Name_Id": "11576"
        },
        {
          "Id": 3545,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Pediatrics (SMG)",
          "Client_Name_ID": "11576",
          "SubClient_Name": "Xtend: Pediatrics (SMG)",
          "SubClient_Name_Id": "11576"
        },
        {
          "Id": 3546,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Plastics (SMG)",
          "Client_Name_ID": "11577",
          "SubClient_Name": "Xtend: Plastics (SMG)",
          "SubClient_Name_Id": "11577"
        },
        {
          "Id": 3547,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Plastics (SMG)",
          "Client_Name_ID": "11577",
          "SubClient_Name": "Xtend: Plastics (SMG)",
          "SubClient_Name_Id": "11577"
        },
        {
          "Id": 3548,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Podiatry (SMG)",
          "Client_Name_ID": "11578",
          "SubClient_Name": "Xtend: Podiatry (SMG)",
          "SubClient_Name_Id": "11578"
        },
        {
          "Id": 3549,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Podiatry (SMG)",
          "Client_Name_ID": "11578",
          "SubClient_Name": "Xtend: Podiatry (SMG)",
          "SubClient_Name_Id": "11578"
        },
        {
          "Id": 3550,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Trauma (SMG)",
          "Client_Name_ID": "11579",
          "SubClient_Name": "Xtend: Trauma (SMG)",
          "SubClient_Name_Id": "11579"
        },
        {
          "Id": 3551,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Trauma (SMG)",
          "Client_Name_ID": "11579",
          "SubClient_Name": "Xtend: Trauma (SMG)",
          "SubClient_Name_Id": "11579"
        },
        {
          "Id": 3552,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Vascular (SMG)",
          "Client_Name_ID": "11580",
          "SubClient_Name": "Xtend: Vascular (SMG)",
          "SubClient_Name_Id": "11580"
        },
        {
          "Id": 3553,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Vascular (SMG)",
          "Client_Name_ID": "11580",
          "SubClient_Name": "Xtend: Vascular (SMG)",
          "SubClient_Name_Id": "11580"
        },
        {
          "Id": 3554,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Interventional Cardiology (Cath) (SMG)",
          "Client_Name_ID": "11581",
          "SubClient_Name": "Xtend: Interventional Cardiology (Cath) (SMG)",
          "SubClient_Name_Id": "11581"
        },
        {
          "Id": 3555,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Interventional Cardiology (Cath) (SMG)",
          "Client_Name_ID": "11581",
          "SubClient_Name": "Xtend: Interventional Cardiology (Cath) (SMG)",
          "SubClient_Name_Id": "11581"
        },
        {
          "Id": 3556,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: A/R Services",
          "Client_Name_ID": "11515",
          "SubClient_Name": "Xtend: A/R Services",
          "SubClient_Name_Id": "11515"
        },
        {
          "Id": 3557,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: A/R Services",
          "Client_Name_ID": "11515",
          "SubClient_Name": "Xtend: A/R Services",
          "SubClient_Name_Id": "11515"
        },
        {
          "Id": 3558,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Emergency Medicine (Pro-fee) : ER Coding (MSH)",
          "Client_Name_ID": "11516",
          "SubClient_Name": "Xtend: Emergency Medicine (Pro-fee) : ER Coding (MSH)",
          "SubClient_Name_Id": "11516"
        },
        {
          "Id": 3559,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Emergency Medicine (Pro-fee) : ER Coding (MSH)",
          "Client_Name_ID": "11516",
          "SubClient_Name": "Xtend: Emergency Medicine (Pro-fee) : ER Coding (MSH)",
          "SubClient_Name_Id": "11516"
        },
        {
          "Id": 3560,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Rehabilitation (SMG)",
          "Client_Name_ID": "11466",
          "SubClient_Name": "Xtend: Rehabilitation (SMG)",
          "SubClient_Name_Id": "11466"
        },
        {
          "Id": 3561,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Rehabilitation (SMG)",
          "Client_Name_ID": "11466",
          "SubClient_Name": "Xtend: Rehabilitation (SMG)",
          "SubClient_Name_Id": "11466"
        },
        {
          "Id": 3562,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend : Critical Care (SMG)",
          "Client_Name_ID": "11505",
          "SubClient_Name": "Xtend : Critical Care (SMG)",
          "SubClient_Name_Id": "11505"
        },
        {
          "Id": 3563,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend : Critical Care (SMG)",
          "Client_Name_ID": "11505",
          "SubClient_Name": "Xtend : Critical Care (SMG)",
          "SubClient_Name_Id": "11505"
        },
        {
          "Id": 3564,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Endocrinology (SMG)",
          "Client_Name_ID": "11446",
          "SubClient_Name": "Xtend: E/M Endocrinology (SMG)",
          "SubClient_Name_Id": "11446"
        },
        {
          "Id": 3565,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: E/M Endocrinology (SMG)",
          "Client_Name_ID": "11446",
          "SubClient_Name": "Xtend: E/M Endocrinology (SMG)",
          "SubClient_Name_Id": "11446"
        },
        {
          "Id": 3566,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: HCH Hospitalist (SMG)",
          "Client_Name_ID": "11460",
          "SubClient_Name": "Xtend: HCH Hospitalist (SMG)",
          "SubClient_Name_Id": "11460"
        },
        {
          "Id": 3567,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: HCH Hospitalist (SMG)",
          "Client_Name_ID": "11460",
          "SubClient_Name": "Xtend: HCH Hospitalist (SMG)",
          "SubClient_Name_Id": "11460"
        },
        {
          "Id": 3568,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Internal Medicine (SMG)",
          "Client_Name_ID": "11461",
          "SubClient_Name": "Xtend: Internal Medicine (SMG)",
          "SubClient_Name_Id": "11461"
        },
        {
          "Id": 3569,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Internal Medicine (SMG)",
          "Client_Name_ID": "11461",
          "SubClient_Name": "Xtend: Internal Medicine (SMG)",
          "SubClient_Name_Id": "11461"
        },
        {
          "Id": 3570,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Neurology (SMG)",
          "Client_Name_ID": "11462",
          "SubClient_Name": "Xtend: Neurology (SMG)",
          "SubClient_Name_Id": "11462"
        },
        {
          "Id": 3571,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Neurology (SMG)",
          "Client_Name_ID": "11462",
          "SubClient_Name": "Xtend: Neurology (SMG)",
          "SubClient_Name_Id": "11462"
        },
        {
          "Id": 3572,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: NICU (SMG)",
          "Client_Name_ID": "11463",
          "SubClient_Name": "Xtend: NICU (SMG)",
          "SubClient_Name_Id": "11463"
        },
        {
          "Id": 3573,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: NICU (SMG)",
          "Client_Name_ID": "11463",
          "SubClient_Name": "Xtend: NICU (SMG)",
          "SubClient_Name_Id": "11463"
        },
        {
          "Id": 3574,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Psychiatry (SMG)",
          "Client_Name_ID": "11464",
          "SubClient_Name": "Xtend: Psychiatry (SMG)",
          "SubClient_Name_Id": "11464"
        },
        {
          "Id": 3575,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Psychiatry (SMG)",
          "Client_Name_ID": "11464",
          "SubClient_Name": "Xtend: Psychiatry (SMG)",
          "SubClient_Name_Id": "11464"
        },
        {
          "Id": 3576,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Oncology/Hematology (SMG)",
          "Client_Name_ID": "11465",
          "SubClient_Name": "Xtend: Oncology/Hematology (SMG)",
          "SubClient_Name_Id": "11465"
        },
        {
          "Id": 3577,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Oncology/Hematology (SMG)",
          "Client_Name_ID": "11465",
          "SubClient_Name": "Xtend: Oncology/Hematology (SMG)",
          "SubClient_Name_Id": "11465"
        },
        {
          "Id": 3578,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Hospitalist (SMG)",
          "Client_Name_ID": "11467",
          "SubClient_Name": "Xtend: Hospitalist (SMG)",
          "SubClient_Name_Id": "11467"
        },
        {
          "Id": 3579,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Hospitalist (SMG)",
          "Client_Name_ID": "11467",
          "SubClient_Name": "Xtend: Hospitalist (SMG)",
          "SubClient_Name_Id": "11467"
        },
        {
          "Id": 3580,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Electro physiology (SMG)",
          "Client_Name_ID": "11384",
          "SubClient_Name": "Xtend: Electro physiology (SMG)",
          "SubClient_Name_Id": "11384"
        },
        {
          "Id": 3581,
          "Original_Client_Name": "Xtend Healthcare LLC",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Electro physiology (SMG)",
          "Client_Name_ID": "11384",
          "SubClient_Name": "Xtend: Electro physiology (SMG)",
          "SubClient_Name_Id": "11384"
        },
        {
          "Id": 3582,
          "Original_Client_Name": "Xtend Healthcare LLC - Aurangabad",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "Client_Name_ID": "11208",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "SubClient_Name_Id": "11208"
        },
        {
          "Id": 3583,
          "Original_Client_Name": "Xtend Healthcare LLC - Aurangabad",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Diagnostic Radiology (SMG)",
          "Client_Name_ID": "11214",
          "SubClient_Name": "Xtend: Diagnostic Radiology (SMG)",
          "SubClient_Name_Id": "11214"
        },
        {
          "Id": 3584,
          "Original_Client_Name": "Xtend Healthcare LLC - Aurangabad",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "Client_Name_ID": "11208",
          "SubClient_Name": "Xtend: Ancillary/Diagnostic (MSH)",
          "SubClient_Name_Id": "11208"
        },
        {
          "Id": 3585,
          "Original_Client_Name": "Xtend Healthcare LLC - Aurangabad",
          "Original_Client_Name_ID": "99090",
          "Client_Name": "Xtend: Diagnostic Radiology (SMG)",
          "Client_Name_ID": "11214",
          "SubClient_Name": "Xtend: Diagnostic Radiology (SMG)",
          "SubClient_Name_Id": "11214"
        },
        {
          "Id": 3586,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: OB/GYN",
          "Client_Name_ID": "11396",
          "SubClient_Name": "Zotec: OB/GYN",
          "SubClient_Name_Id": "11396"
        },
        {
          "Id": 3587,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: OB/GYN",
          "Client_Name_ID": "11396",
          "SubClient_Name": "Zotec: OB/GYN",
          "SubClient_Name_Id": "11396"
        },
        {
          "Id": 3588,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Neonatology",
          "Client_Name_ID": "11397",
          "SubClient_Name": "Zotec: Neonatology",
          "SubClient_Name_Id": "11397"
        },
        {
          "Id": 3589,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Neonatology",
          "Client_Name_ID": "11397",
          "SubClient_Name": "Zotec: Neonatology",
          "SubClient_Name_Id": "11397"
        },
        {
          "Id": 3590,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Hospital Medicine",
          "Client_Name_ID": "11398",
          "SubClient_Name": "Zotec: Hospital Medicine",
          "SubClient_Name_Id": "11398"
        },
        {
          "Id": 3591,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Hospital Medicine",
          "Client_Name_ID": "11398",
          "SubClient_Name": "Zotec: Hospital Medicine",
          "SubClient_Name_Id": "11398"
        },
        {
          "Id": 3592,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: General Surgery",
          "Client_Name_ID": "11399",
          "SubClient_Name": "Zotec: General Surgery",
          "SubClient_Name_Id": "11399"
        },
        {
          "Id": 3593,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: General Surgery",
          "Client_Name_ID": "11399",
          "SubClient_Name": "Zotec: General Surgery",
          "SubClient_Name_Id": "11399"
        },
        {
          "Id": 3594,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charge Verification",
          "Client_Name_ID": "10980",
          "SubClient_Name": "Zotec: Charge Verification",
          "SubClient_Name_Id": "10980"
        },
        {
          "Id": 3595,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charges Entry",
          "Client_Name_ID": "10981",
          "SubClient_Name": "Zotec: Charges Entry",
          "SubClient_Name_Id": "10981"
        },
        {
          "Id": 3596,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo Update",
          "Client_Name_ID": "10994",
          "SubClient_Name": "Zotec: Demo Update",
          "SubClient_Name_Id": "10994"
        },
        {
          "Id": 3597,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo New",
          "Client_Name_ID": "10990",
          "SubClient_Name": "Zotec: Demo New",
          "SubClient_Name_Id": "10990"
        },
        {
          "Id": 3598,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo New",
          "Client_Name_ID": "10990",
          "SubClient_Name": "Zotec: Demo New",
          "SubClient_Name_Id": "10990"
        },
        {
          "Id": 3599,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED edits from TBT queue",
          "Client_Name_ID": "10999",
          "SubClient_Name": "Zotec: ED edits from TBT queue",
          "SubClient_Name_Id": "10999"
        },
        {
          "Id": 3600,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED edits from TBT queue",
          "Client_Name_ID": "10999",
          "SubClient_Name": "Zotec: ED edits from TBT queue",
          "SubClient_Name_Id": "10999"
        },
        {
          "Id": 3601,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work",
          "SubClient_Name_Id": "10983"
        },
        {
          "Id": 3602,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR",
          "SubClient_Name_Id": "10985"
        },
        {
          "Id": 3603,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR",
          "SubClient_Name_Id": "10985"
        },
        {
          "Id": 3604,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "SubClient_Name_Id": "10987"
        },
        {
          "Id": 3605,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "SubClient_Name_Id": "10987"
        },
        {
          "Id": 3606,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician",
          "SubClient_Name_Id": "10998"
        },
        {
          "Id": 3607,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician",
          "SubClient_Name_Id": "10998"
        },
        {
          "Id": 3608,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work",
          "SubClient_Name_Id": "10983"
        },
        {
          "Id": 3609,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - CFV",
          "SubClient_Name_Id": "10998-2"
        },
        {
          "Id": 3610,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - CFV",
          "SubClient_Name_Id": "10998-2"
        },
        {
          "Id": 3611,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - XBN",
          "SubClient_Name_Id": "10998-3"
        },
        {
          "Id": 3612,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - XBN",
          "SubClient_Name_Id": "10998-3"
        },
        {
          "Id": 3613,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - PQRS",
          "SubClient_Name_Id": "11003-2"
        },
        {
          "Id": 3614,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - PQRS",
          "SubClient_Name_Id": "11003-2"
        },
        {
          "Id": 3615,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work - CI",
          "SubClient_Name_Id": "10983-1"
        },
        {
          "Id": 3616,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work - CI",
          "SubClient_Name_Id": "10983-1"
        },
        {
          "Id": 3617,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - Data Capture - TBC",
          "SubClient_Name_Id": "11003-1"
        },
        {
          "Id": 3618,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - Data Capture - TBC",
          "SubClient_Name_Id": "11003-1"
        },
        {
          "Id": 3619,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 3",
          "SubClient_Name_Id": "10985-1"
        },
        {
          "Id": 3620,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 3",
          "SubClient_Name_Id": "10985-1"
        },
        {
          "Id": 3621,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)g - Workfile - TBC",
          "SubClient_Name_Id": "10987-1"
        },
        {
          "Id": 3622,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)g - Workfile - TBC",
          "SubClient_Name_Id": "10987-1"
        },
        {
          "Id": 3623,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - SLMD",
          "SubClient_Name_Id": "10998-1"
        },
        {
          "Id": 3624,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - SLMD",
          "SubClient_Name_Id": "10998-1"
        },
        {
          "Id": 3625,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - IR NON-Vascular",
          "SubClient_Name_Id": "10985-2"
        },
        {
          "Id": 3626,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 1",
          "SubClient_Name_Id": "10985-3"
        },
        {
          "Id": 3627,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 2",
          "SubClient_Name_Id": "10985-4"
        },
        {
          "Id": 3628,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - IR NON-Vascular",
          "SubClient_Name_Id": "10985-2"
        },
        {
          "Id": 3629,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 1",
          "SubClient_Name_Id": "10985-3"
        },
        {
          "Id": 3630,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 2",
          "SubClient_Name_Id": "10985-4"
        },
        {
          "Id": 3631,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding) - Data Capture - TBC - releaser",
          "SubClient_Name_Id": "10987-2"
        },
        {
          "Id": 3632,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding) - Data Capture - TBC - releaser",
          "SubClient_Name_Id": "10987-2"
        },
        {
          "Id": 3633,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: COH Issue Resolution",
          "Client_Name_ID": "10989",
          "SubClient_Name": "Zotec: COH Issue Resolution",
          "SubClient_Name_Id": "10989"
        },
        {
          "Id": 3634,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: COH Issue Resolution",
          "Client_Name_ID": "10989",
          "SubClient_Name": "Zotec: COH Issue Resolution",
          "SubClient_Name_Id": "10989"
        },
        {
          "Id": 3635,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: TBT DC Issue Resolution",
          "Client_Name_ID": "11005",
          "SubClient_Name": "Zotec: TBT DC Issue Resolution",
          "SubClient_Name_Id": "11005"
        },
        {
          "Id": 3636,
          "Original_Client_Name": "Zotec Partners, LLc",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: TBT DC Issue Resolution",
          "Client_Name_ID": "11005",
          "SubClient_Name": "Zotec: TBT DC Issue Resolution",
          "SubClient_Name_Id": "11005"
        },
        {
          "Id": 3637,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - SLMD",
          "SubClient_Name_Id": "10998-1"
        },
        {
          "Id": 3638,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - SLMD",
          "SubClient_Name_Id": "10998-1"
        },
        {
          "Id": 3639,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - Data Capture - TBC",
          "SubClient_Name_Id": "11003-1"
        },
        {
          "Id": 3640,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - Data Capture - TBC",
          "SubClient_Name_Id": "11003-1"
        },
        {
          "Id": 3641,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - PQRS",
          "SubClient_Name_Id": "11003-2"
        },
        {
          "Id": 3642,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created - PQRS",
          "SubClient_Name_Id": "11003-2"
        },
        {
          "Id": 3643,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - XBN",
          "SubClient_Name_Id": "10998-3"
        },
        {
          "Id": 3644,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - XBN",
          "SubClient_Name_Id": "10998-3"
        },
        {
          "Id": 3645,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)g - Workfile - TBC",
          "SubClient_Name_Id": "10987-2"
        },
        {
          "Id": 3646,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)g - Workfile - TBC",
          "SubClient_Name_Id": "10987-2"
        },
        {
          "Id": 3647,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - CFV",
          "SubClient_Name_Id": "10998-2"
        },
        {
          "Id": 3648,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician - Coding Emergency Room - Physician - CFV",
          "SubClient_Name_Id": "10998-2"
        },
        {
          "Id": 3649,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - IR NON-Vascular",
          "SubClient_Name_Id": "10985-1"
        },
        {
          "Id": 3650,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 1",
          "SubClient_Name_Id": "10985-2"
        },
        {
          "Id": 3651,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 2",
          "SubClient_Name_Id": "10985-3"
        },
        {
          "Id": 3652,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 3",
          "SubClient_Name_Id": "10985-4"
        },
        {
          "Id": 3653,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - IR NON-Vascular",
          "SubClient_Name_Id": "10985-1"
        },
        {
          "Id": 3654,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 1",
          "SubClient_Name_Id": "10985-2"
        },
        {
          "Id": 3655,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 2",
          "SubClient_Name_Id": "10985-3"
        },
        {
          "Id": 3656,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR - Vascular Level 3",
          "SubClient_Name_Id": "10985-4"
        },
        {
          "Id": 3657,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician",
          "SubClient_Name_Id": "10998"
        },
        {
          "Id": 3658,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED Coding Emergency Room Physician",
          "Client_Name_ID": "10998",
          "SubClient_Name": "Zotec: ED Coding Emergency Room Physician",
          "SubClient_Name_Id": "10998"
        },
        {
          "Id": 3659,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED edits from TBT queue",
          "Client_Name_ID": "10999",
          "SubClient_Name": "Zotec: ED edits from TBT queue",
          "SubClient_Name_Id": "10999"
        },
        {
          "Id": 3660,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: ED edits from TBT queue",
          "Client_Name_ID": "10999",
          "SubClient_Name": "Zotec: ED edits from TBT queue",
          "SubClient_Name_Id": "10999"
        },
        {
          "Id": 3661,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Manual Coding : Image Based Coding",
          "Client_Name_ID": "11000",
          "SubClient_Name": "Zotec: Manual Coding : Image Based Coding - Workfile",
          "SubClient_Name_Id": "11000-1"
        },
        {
          "Id": 3662,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Manual Coding : Image Based Coding",
          "Client_Name_ID": "11000",
          "SubClient_Name": "Zotec: Manual Coding : Image Based Coding - Workfile",
          "SubClient_Name_Id": "11000-1"
        },
        {
          "Id": 3663,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: COH Issue Resolution",
          "Client_Name_ID": "10989",
          "SubClient_Name": "Zotec: COH Issue Resolution",
          "SubClient_Name_Id": "10989"
        },
        {
          "Id": 3664,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "SubClient_Name_Id": "10987"
        },
        {
          "Id": 3665,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "SubClient_Name_Id": "10987"
        },
        {
          "Id": 3666,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR",
          "SubClient_Name_Id": "10985"
        },
        {
          "Id": 3667,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR",
          "Client_Name_ID": "10985",
          "SubClient_Name": "Zotec: Coding IVR",
          "SubClient_Name_Id": "10985"
        },
        {
          "Id": 3668,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: RFIs Created",
          "Client_Name_ID": "11003",
          "SubClient_Name": "Zotec: RFIs Created",
          "SubClient_Name_Id": "11003"
        },
        {
          "Id": 3669,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: COH Issue Resolution",
          "Client_Name_ID": "10989",
          "SubClient_Name": "Zotec: COH Issue Resolution",
          "SubClient_Name_Id": "10989"
        },
        {
          "Id": 3670,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work",
          "SubClient_Name_Id": "10983"
        },
        {
          "Id": 3671,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charges Entry",
          "Client_Name_ID": "10981",
          "SubClient_Name": "Zotec: Charges Entry",
          "SubClient_Name_Id": "10981"
        },
        {
          "Id": 3672,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charges Entry",
          "Client_Name_ID": "10981",
          "SubClient_Name": "Zotec: Charges Entry",
          "SubClient_Name_Id": "10981"
        },
        {
          "Id": 3673,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charge Verification",
          "Client_Name_ID": "10980",
          "SubClient_Name": "Zotec: Charge Verification",
          "SubClient_Name_Id": "10980"
        },
        {
          "Id": 3674,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Charge Verification",
          "Client_Name_ID": "10980",
          "SubClient_Name": "Zotec: Charge Verification",
          "SubClient_Name_Id": "10980"
        },
        {
          "Id": 3675,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo New",
          "Client_Name_ID": "10990",
          "SubClient_Name": "Zotec: Demo New",
          "SubClient_Name_Id": "10990"
        },
        {
          "Id": 3676,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo New",
          "Client_Name_ID": "10990",
          "SubClient_Name": "Zotec: Demo New",
          "SubClient_Name_Id": "10990"
        },
        {
          "Id": 3677,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo Update",
          "Client_Name_ID": "10994",
          "SubClient_Name": "Zotec: Demo Update",
          "SubClient_Name_Id": "10994"
        },
        {
          "Id": 3678,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo Update",
          "Client_Name_ID": "10994",
          "SubClient_Name": "Zotec: Demo Update",
          "SubClient_Name_Id": "10994"
        },
        {
          "Id": 3679,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo Update : IMS1",
          "Client_Name_ID": "10996",
          "SubClient_Name": "Zotec: Demo Update : IMS1",
          "SubClient_Name_Id": "10996"
        },
        {
          "Id": 3680,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Demo New : IMS1",
          "Client_Name_ID": "10992",
          "SubClient_Name": "Zotec: Demo New : IMS1",
          "SubClient_Name_Id": "10992"
        },
        {
          "Id": 3681,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Manual Coding : Image Based Coding",
          "Client_Name_ID": "11000",
          "SubClient_Name": "Zotec: Manual Coding : Image Based Coding",
          "SubClient_Name_Id": "11000"
        },
        {
          "Id": 3682,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding:Diagnostic (Auto Coding)",
          "Client_Name_ID": "10987",
          "SubClient_Name": "Zotec: Coding:Diagnostic (Auto Coding) - Data Capture - TBC - releaser",
          "SubClient_Name_Id": "10987-1"
        },
        {
          "Id": 3683,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding Investigation (Denial) work",
          "Client_Name_ID": "10983",
          "SubClient_Name": "Zotec: Coding Investigation (Denial) work",
          "SubClient_Name_Id": "10983"
        },
        {
          "Id": 3684,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: TBT DC Issue Resolution",
          "Client_Name_ID": "11005",
          "SubClient_Name": "Zotec: TBT DC Issue Resolution",
          "SubClient_Name_Id": "11005"
        },
        {
          "Id": 3685,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: TBT DC Issue Resolution",
          "Client_Name_ID": "11005",
          "SubClient_Name": "Zotec: TBT DC Issue Resolution",
          "SubClient_Name_Id": "11005"
        },
        {
          "Id": 3686,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR New",
          "Client_Name_ID": "11308",
          "SubClient_Name": "Zotec: Coding IVR New",
          "SubClient_Name_Id": "11308"
        },
        {
          "Id": 3687,
          "Original_Client_Name": "Zotec Partners, LLc - Aurangabad",
          "Original_Client_Name_ID": "99077",
          "Client_Name": "Zotec: Coding IVR New",
          "Client_Name_ID": "11308",
          "SubClient_Name": "Zotec: Coding IVR New",
          "SubClient_Name_Id": "11308"
        }
      ]
    }
  };
  constructor(private http: HttpClient) { }

  getClient(id):any {
    return this.http.get(environment.ApiUrl + '/api/client/' + id)
  }

  getClientAdministrator():any {
    return this.http.get(environment.ApiUrl + '/api/client-administrator')
  }

  getClientList():any {
        return this.http.get(environment.ApiUrl + '/api/client-administrator');

  }

  updateClient(accessToken, client):any {
    let headers: any = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access_Token': accessToken
    });
    return this.http.put(environment.ApiUrl + '/api/client', client, {headers: headers})
  }
  saveClient(client):any {
        return this.http.post(environment.ApiUrl + '/api/client', client)
  }

  getClientProductivityReport(clientId, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/productivity-report/' + clientId + '/' + startDate + '/' + endDate).pipe(map(res => res));
  }

  getManagerProductivityReport(clientId, managerId, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/productivity-report/' + clientId + '/' + managerId + '/' + startDate + '/' + endDate).pipe(map(res => res));
  }

  getSupervisorProductivityReport(clientId, managerId, supervisorId, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/productivity-report/' + clientId + '/' + managerId + '/' + supervisorId + '/' + startDate + '/' + endDate).pipe(map(res => res));
  }

  getAgentProductivityReport(clientId, managerId, supervisorId, agentId, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/productivity-report/' + clientId + '/' + managerId + '/' + supervisorId + '/' + agentId + '/' + startDate + '/' + endDate)
      .pipe(map(res => res));
  }


  getAgentReportByDate(clientId, managerId, supervisorId, agentId, dateRange, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/productivity-report/' + clientId + '/' + managerId + '/' + supervisorId + '/' + agentId + '/' + dateRange + '/' + startDate + '/' + endDate)
      .pipe(map(res => res));
  }

  getSingleAgentProductivityReport(clientId, agentId, startDate, endDate):any {
        return this.http.get(environment.ApiUrl + '/api/agent-productivity-report/' + clientId + '/' + agentId + '/' + startDate + '/' + endDate)
      .pipe(map(res => res));
  }

  clientUserMapping():any {
        return this.http.get(environment.ApiUrl + '/api/Mapping_CRUD_')
      .pipe(map(res => res));
  }

  addClientUserMapping(userObj):any {
        return this.http.post(environment.ApiUrl + '/api/Mapping_CRUD_', userObj)
      .pipe(map(res => res));
  }

  updateClientUserMapping(userObj):any {
        return this.http.put(environment.ApiUrl + '/api/Mapping_CRUD_', userObj).pipe(map(res => res));
  }

  deleteECNUser(activeUser, user, isActive):any {
    const body = {
      "modifiedBy": activeUser.UserId,
      "ClientUserMappingManagement_Id": user.ClientUserMappingManagement_Id,
      "isActive": isActive
    }
    return this.http.post(environment.ApiUrl + '/api/Delete_ClientUserMapping_Data_', body)
      .pipe(map(res => res));
  }

  getECNInfo(ECN):any {
        return this.http.get(environment.ApiUrl + '/api/Get_PopUp_Data/' + ECN)
      .pipe(map(res => res));
  }

  manageClientList():any {
    console.log('this.clientLIst : ', this.clientLIst);
    let clientList = [], originalClientLIst = [], subClientList = [];
    this.clientLIst.Data.Client_Name_Lookup.forEach(clientObj => {
      clientList.push({
        Client_Name: clientObj.Client_Name,
        Client_Name_ID: clientObj.Client_Name_ID
        // clientObj
      });

      originalClientLIst.push({
        Client_Name: clientObj.Client_Name,
        Client_Name_ID: clientObj.Client_Name_ID,
        Original_Client_Name_ID: clientObj.Original_Client_Name_ID
        // clientObj
      });

      subClientList.push({
        SubClient_Name: clientObj.SubClient_Name,
        SubClient_Name_Id: clientObj.SubClient_Name_Id
        // clientObj
      });
    });
    clientList = _.uniqBy(clientList, 'Client_Name_ID');
    originalClientLIst = _.uniqBy(originalClientLIst, 'Original_Client_Name_ID');
    subClientList = _.uniqBy(subClientList, 'SubClient_Name_Id');
    // console.log(' clientList , originalClientLIst , subClientList : ', clientList, originalClientLIst, subClientList)
    return {
      clientList: clientList,
      originalClientLIst: originalClientLIst,
      subClientList: subClientList,
    }
  }
}
